/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reBuilder = __webpack_require__(472);
	
	var _reBuilder2 = _interopRequireDefault(_reBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = jQuery; //import Redrag from './redrag';
	
	(0, _reBuilder2.default)();
	$('[data-toggle="tooltip"]').tooltip({
	  trigger: 'hover'
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var ReactChildren = __webpack_require__(4);
	var ReactComponent = __webpack_require__(16);
	var ReactPureComponent = __webpack_require__(19);
	var ReactClass = __webpack_require__(20);
	var ReactDOMFactories = __webpack_require__(25);
	var ReactElement = __webpack_require__(8);
	var ReactPropTypes = __webpack_require__(27);
	var ReactVersion = __webpack_require__(29);
	
	var onlyChild = __webpack_require__(30);
	var warning = __webpack_require__(10);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(5);
	var ReactElement = __webpack_require__(8);
	
	var emptyFunction = __webpack_require__(11);
	var traverseAllChildren = __webpack_require__(13);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(9);
	
	var warning = __webpack_require__(10);
	var canDefineProperty = __webpack_require__(12);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.createElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	
	    // Create dummy `key` and `ref` property to `props` to warn users against its use
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingKey.isReactWarning = true;
	
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingRef.isReactWarning = true;
	
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: warnAboutAccessingKey,
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: warnAboutAccessingRef,
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.cloneElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(11);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(9);
	var ReactElement = __webpack_require__(8);
	
	var getIteratorFn = __webpack_require__(14);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(15);
	var warning = __webpack_require__(10);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactNoopUpdateQueue = __webpack_require__(17);
	
	var canDefineProperty = __webpack_require__(12);
	var emptyObject = __webpack_require__(18);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(10);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var ReactComponent = __webpack_require__(16);
	var ReactNoopUpdateQueue = __webpack_require__(17);
	
	var emptyObject = __webpack_require__(18);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var ReactComponent = __webpack_require__(16);
	var ReactElement = __webpack_require__(8);
	var ReactPropTypeLocations = __webpack_require__(21);
	var ReactPropTypeLocationNames = __webpack_require__(23);
	var ReactNoopUpdateQueue = __webpack_require__(17);
	
	var emptyObject = __webpack_require__(18);
	var invariant = __webpack_require__(7);
	var keyMirror = __webpack_require__(22);
	var keyOf = __webpack_require__(24);
	var warning = __webpack_require__(10);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(22);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(8);
	
	var mapObject = __webpack_require__(26);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    var ReactElementValidator = require('./ReactElementValidator');
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(8);
	var ReactPropTypeLocationNames = __webpack_require__(23);
	var ReactPropTypesSecret = __webpack_require__(28);
	
	var emptyFunction = __webpack_require__(11);
	var getIteratorFn = __webpack_require__(14);
	var warning = __webpack_require__(10);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.0';

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactElement = __webpack_require__(8);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : _prodInvariant('23') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(32);


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDefaultInjection = __webpack_require__(36);
	var ReactMount = __webpack_require__(157);
	var ReactReconciler = __webpack_require__(56);
	var ReactUpdates = __webpack_require__(53);
	var ReactVersion = __webpack_require__(29);
	
	var findDOMNode = __webpack_require__(162);
	var getHostComponentFromComposite = __webpack_require__(163);
	var renderSubtreeIntoContainer = __webpack_require__(164);
	var warning = __webpack_require__(10);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = ReactDOM;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMProperty = __webpack_require__(34);
	var ReactDOMComponentFlags = __webpack_require__(35);
	
	var invariant = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(37);
	var ChangeEventPlugin = __webpack_require__(52);
	var DefaultEventPluginOrder = __webpack_require__(64);
	var EnterLeaveEventPlugin = __webpack_require__(65);
	var HTMLDOMPropertyConfig = __webpack_require__(70);
	var ReactComponentBrowserEnvironment = __webpack_require__(71);
	var ReactDOMComponent = __webpack_require__(85);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMEmptyComponent = __webpack_require__(128);
	var ReactDOMTreeTraversal = __webpack_require__(129);
	var ReactDOMTextComponent = __webpack_require__(130);
	var ReactDefaultBatchingStrategy = __webpack_require__(131);
	var ReactEventListener = __webpack_require__(132);
	var ReactInjection = __webpack_require__(135);
	var ReactReconcileTransaction = __webpack_require__(136);
	var SVGDOMPropertyConfig = __webpack_require__(144);
	var SelectEventPlugin = __webpack_require__(145);
	var SimpleEventPlugin = __webpack_require__(146);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(38);
	var EventPropagators = __webpack_require__(39);
	var ExecutionEnvironment = __webpack_require__(46);
	var FallbackCompositionState = __webpack_require__(47);
	var SyntheticCompositionEvent = __webpack_require__(49);
	var SyntheticInputEvent = __webpack_require__(51);
	
	var keyOf = __webpack_require__(24);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(22);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(38);
	var EventPluginHub = __webpack_require__(40);
	var EventPluginUtils = __webpack_require__(42);
	
	var accumulateInto = __webpack_require__(44);
	var forEachAccumulated = __webpack_require__(45);
	var warning = __webpack_require__(10);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(41);
	var EventPluginUtils = __webpack_require__(42);
	var ReactErrorUtils = __webpack_require__(43);
	
	var accumulateInto = __webpack_require__(44);
	var forEachAccumulated = __webpack_require__(45);
	var invariant = __webpack_require__(7);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventConstants = __webpack_require__(38);
	var ReactErrorUtils = __webpack_require__(43);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var PooledClass = __webpack_require__(5);
	
	var getTextContentAccessor = __webpack_require__(48);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(46);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(50);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var PooledClass = __webpack_require__(5);
	
	var emptyFunction = __webpack_require__(11);
	var warning = __webpack_require__(10);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(50);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(38);
	var EventPluginHub = __webpack_require__(40);
	var EventPropagators = __webpack_require__(39);
	var ExecutionEnvironment = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(53);
	var SyntheticEvent = __webpack_require__(50);
	
	var getEventTarget = __webpack_require__(61);
	var isEventSupported = __webpack_require__(62);
	var isTextInputElement = __webpack_require__(63);
	var keyOf = __webpack_require__(24);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var CallbackQueue = __webpack_require__(54);
	var PooledClass = __webpack_require__(5);
	var ReactFeatureFlags = __webpack_require__(55);
	var ReactReconciler = __webpack_require__(56);
	var Transaction = __webpack_require__(60);
	
	var invariant = __webpack_require__(7);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var PooledClass = __webpack_require__(5);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 55 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(57);
	var ReactInstrumentation = __webpack_require__(59);
	
	var warning = __webpack_require__(10);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'mountComponent');
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'mountComponent');
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(58);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(46);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(24);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(38);
	var EventPropagators = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(33);
	var SyntheticMouseEvent = __webpack_require__(66);
	
	var keyOf = __webpack_require__(24);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(67);
	var ViewportMetrics = __webpack_require__(68);
	
	var getEventModifierState = __webpack_require__(69);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(50);
	
	var getEventTarget = __webpack_require__(61);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 68 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(34);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(72);
	var ReactDOMIDOperations = __webpack_require__(84);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(73);
	var Danger = __webpack_require__(79);
	var ReactMultiChildUpdateTypes = __webpack_require__(83);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstrumentation = __webpack_require__(59);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);
	var setInnerHTML = __webpack_require__(75);
	var setTextContent = __webpack_require__(77);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(74);
	var setInnerHTML = __webpack_require__(75);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);
	var setTextContent = __webpack_require__(77);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(46);
	var DOMNamespaces = __webpack_require__(74);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(76);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var newNodes = reusableSVGContainer.firstChild.childNodes;
	    for (var i = 0; i < newNodes.length; i++) {
	      node.appendChild(newNodes[i]);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(46);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var setInnerHTML = __webpack_require__(75);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(46);
	
	var createNodesFromMarkup = __webpack_require__(80);
	var emptyFunction = __webpack_require__(11);
	var invariant = __webpack_require__(7);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(46);
	
	var createArrayFromMixed = __webpack_require__(81);
	var getMarkupWrap = __webpack_require__(82);
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(46);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(22);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(72);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var AutoFocusUtils = __webpack_require__(86);
	var CSSPropertyOperations = __webpack_require__(88);
	var DOMLazyTree = __webpack_require__(73);
	var DOMNamespaces = __webpack_require__(74);
	var DOMProperty = __webpack_require__(34);
	var DOMPropertyOperations = __webpack_require__(96);
	var EventConstants = __webpack_require__(38);
	var EventPluginHub = __webpack_require__(40);
	var EventPluginRegistry = __webpack_require__(41);
	var ReactBrowserEventEmitter = __webpack_require__(99);
	var ReactComponentBrowserEnvironment = __webpack_require__(71);
	var ReactDOMButton = __webpack_require__(102);
	var ReactDOMComponentFlags = __webpack_require__(35);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMInput = __webpack_require__(104);
	var ReactDOMOption = __webpack_require__(106);
	var ReactDOMSelect = __webpack_require__(107);
	var ReactDOMTextarea = __webpack_require__(108);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactMultiChild = __webpack_require__(109);
	var ReactServerRenderingTransaction = __webpack_require__(124);
	
	var emptyFunction = __webpack_require__(11);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(7);
	var isEventSupported = __webpack_require__(62);
	var keyOf = __webpack_require__(24);
	var shallowEqual = __webpack_require__(119);
	var validateDOMNesting = __webpack_require__(127);
	var warning = __webpack_require__(10);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setContentChildForInstrumentation = emptyFunction;
	if (false) {
	  setContentChildForInstrumentation = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    var contentDebugID = debugID + '#text';
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    this._contentDebugID = contentDebugID;
	    var text = '' + content;
	
	    ReactInstrumentation.debugTool.onSetDisplayName(contentDebugID, '#text');
	    ReactInstrumentation.debugTool.onSetParent(contentDebugID, debugID);
	    ReactInstrumentation.debugTool.onSetText(contentDebugID, text);
	
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setContentChildForInstrumentation.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasMounted(_this._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var _this2 = this;
	
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasUpdated(_this2._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setContentChildForInstrumentation.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	
	    if (false) {
	      setContentChildForInstrumentation.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var focusNode = __webpack_require__(87);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 87 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(89);
	var ExecutionEnvironment = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(59);
	
	var camelizeStyleName = __webpack_require__(90);
	var dangerousStyleValue = __webpack_require__(92);
	var hyphenateStyleName = __webpack_require__(93);
	var memoizeStringOnly = __webpack_require__(95);
	var warning = __webpack_require__(10);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(91);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 91 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(89);
	var warning = __webpack_require__(10);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(94);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(34);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMInstrumentation = __webpack_require__(97);
	var ReactInstrumentation = __webpack_require__(59);
	
	var quoteAttributeValueForBrowser = __webpack_require__(98);
	var warning = __webpack_require__(10);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDOMDebugTool = require('./ReactDOMDebugTool');
	  debugTool = ReactDOMDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var EventConstants = __webpack_require__(38);
	var EventPluginRegistry = __webpack_require__(41);
	var ReactEventEmitterMixin = __webpack_require__(100);
	var ViewportMetrics = __webpack_require__(68);
	
	var getVendorPrefixedEventName = __webpack_require__(101);
	var isEventSupported = __webpack_require__(62);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(40);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(46);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(103);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var DisabledInputUtils = __webpack_require__(103);
	var DOMPropertyOperations = __webpack_require__(96);
	var LinkedValueUtils = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(53);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked !== undefined : props.value !== undefined;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	    if (props.type !== 'submit' && props.type !== 'reset') {
	      node.value = node.value;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactPropTypes = __webpack_require__(27);
	var ReactPropTypeLocations = __webpack_require__(21);
	var ReactPropTypesSecret = __webpack_require__(28);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var ReactChildren = __webpack_require__(4);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMSelect = __webpack_require__(107);
	
	var warning = __webpack_require__(10);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var DisabledInputUtils = __webpack_require__(103);
	var LinkedValueUtils = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(53);
	
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var DisabledInputUtils = __webpack_require__(103);
	var LinkedValueUtils = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(53);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(110);
	var ReactInstanceMap = __webpack_require__(111);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactMultiChildUpdateTypes = __webpack_require__(83);
	
	var ReactCurrentOwner = __webpack_require__(9);
	var ReactReconciler = __webpack_require__(56);
	var ReactChildReconciler = __webpack_require__(112);
	
	var emptyFunction = __webpack_require__(11);
	var flattenChildren = __webpack_require__(123);
	var invariant = __webpack_require__(7);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setParentForInstrumentation = emptyFunction;
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setParentForInstrumentation = function (child) {
	    if (child._debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetParent(child._debugID, getDebugID(this));
	    }
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          if (false) {
	            setParentForInstrumentation.call(this, child);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(56);
	
	var instantiateReactComponent = __webpack_require__(114);
	var KeyEscapeUtils = __webpack_require__(15);
	var shouldUpdateReactComponent = __webpack_require__(120);
	var traverseAllChildren = __webpack_require__(13);
	var warning = __webpack_require__(10);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(118);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeDevtool) {
	      ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	    }
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // __DEV__ only
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(113)))

/***/ },
/* 113 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var ReactCompositeComponent = __webpack_require__(115);
	var ReactEmptyComponent = __webpack_require__(121);
	var ReactHostComponent = __webpack_require__(122);
	var ReactInstrumentation = __webpack_require__(59);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getDisplayName(instance) {
	  var element = instance._currentElement;
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else if (instance.getName) {
	    return instance.getName() || 'Unknown';
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    if (shouldHaveDebugID) {
	      var debugID = nextDebugID++;
	      instance._debugID = debugID;
	      var displayName = getDisplayName(instance);
	      ReactInstrumentation.debugTool.onSetDisplayName(debugID, displayName);
	      var owner = node && node._owner;
	      if (owner) {
	        ReactInstrumentation.debugTool.onSetOwner(debugID, owner._debugID);
	      }
	    } else {
	      instance._debugID = 0;
	    }
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var ReactComponentEnvironment = __webpack_require__(110);
	var ReactCurrentOwner = __webpack_require__(9);
	var ReactElement = __webpack_require__(8);
	var ReactErrorUtils = __webpack_require__(43);
	var ReactInstanceMap = __webpack_require__(111);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactNodeTypes = __webpack_require__(116);
	var ReactPropTypeLocations = __webpack_require__(21);
	var ReactReconciler = __webpack_require__(56);
	
	var checkReactTypeSpec = __webpack_require__(117);
	var emptyObject = __webpack_require__(18);
	var invariant = __webpack_require__(7);
	var shallowEqual = __webpack_require__(119);
	var shouldUpdateReactComponent = __webpack_require__(120);
	var warning = __webpack_require__(10);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function invokeComponentDidMountWithTimer() {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	  publicInstance.componentDidMount();
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	}
	
	function invokeComponentDidUpdateWithTimer(prevProps, prevState, prevContext) {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	  publicInstance.componentDidUpdate(prevProps, prevState, prevContext);
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function (component) {
	          return ReactInstrumentation.debugTool.onComponentHasMounted(_this._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	    var instanceOrElement;
	    if (doConstruct) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	      instanceOrElement = new Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	    } else {
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	      instanceOrElement = Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	    }
	    return instanceOrElement;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onError();
	        }
	      }
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      inst.componentWillMount();
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	    if (false) {
	      if (child._debugID !== 0 && this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	      }
	    }
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context));
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	      inst.componentWillReceiveProps(nextProps, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	        shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        if (false) {
	          if (this._debugID !== 0) {
	            ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	          }
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidUpdateWithTimer.bind(this, prevProps, prevState, prevContext), this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	
	    if (false) {
	      if (this._debugID) {
	        var callback = function () {
	          return ReactInstrumentation.debugTool.onComponentHasUpdated(_this2._debugID);
	        };
	        transaction.getReactMountReady().enqueue(callback, this);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	      if (false) {
	        if (child._debugID !== 0 && this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	        }
	      }
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context));
	
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	    var renderedComponent = inst.render();
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactElement = __webpack_require__(8);
	
	var invariant = __webpack_require__(7);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactPropTypeLocationNames = __webpack_require__(23);
	var ReactPropTypesSecret = __webpack_require__(28);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(118);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeDevtool) {
	            ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(113)))

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeDevtool
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(9);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	var tree = {};
	var unmountedIDs = {};
	var rootIDs = {};
	
	function updateTree(id, update) {
	  if (!tree[id]) {
	    tree[id] = {
	      element: null,
	      parentID: null,
	      ownerID: null,
	      text: null,
	      childIDs: [],
	      displayName: 'Unknown',
	      isMounted: false,
	      updateCount: 0
	    };
	  }
	  update(tree[id]);
	}
	
	function purgeDeep(id) {
	  var item = tree[id];
	  if (item) {
	    var childIDs = item.childIDs;
	
	    delete tree[id];
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeDevtool.getDisplayName(id);
	  var element = ReactComponentTreeDevtool.getElement(id);
	  var ownerID = ReactComponentTreeDevtool.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeDevtool.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeDevtool: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeDevtool = {
	  onSetDisplayName: function (id, displayName) {
	    updateTree(id, function (item) {
	      return item.displayName = displayName;
	    });
	  },
	  onSetChildren: function (id, nextChildIDs) {
	    updateTree(id, function (item) {
	      item.childIDs = nextChildIDs;
	
	      nextChildIDs.forEach(function (nextChildID) {
	        var nextChild = tree[nextChildID];
	        !nextChild ?  false ? invariant(false, 'Expected devtool events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('68') : void 0;
	        !(nextChild.displayName != null) ?  false ? invariant(false, 'Expected onSetDisplayName() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('69') : void 0;
	        !(nextChild.childIDs != null || nextChild.text != null) ?  false ? invariant(false, 'Expected onSetChildren() or onSetText() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('70') : void 0;
	        !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	        if (nextChild.parentID == null) {
	          nextChild.parentID = id;
	          // TODO: This shouldn't be necessary but mounting a new root during in
	          // componentWillMount currently causes not-yet-mounted components to
	          // be purged from our tree data so their parent ID is missing.
	        }
	        !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onSetParent() and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('72', nextChildID, nextChild.parentID, id) : void 0;
	      });
	    });
	  },
	  onSetOwner: function (id, ownerID) {
	    updateTree(id, function (item) {
	      return item.ownerID = ownerID;
	    });
	  },
	  onSetParent: function (id, parentID) {
	    updateTree(id, function (item) {
	      return item.parentID = parentID;
	    });
	  },
	  onSetText: function (id, text) {
	    updateTree(id, function (item) {
	      return item.text = text;
	    });
	  },
	  onBeforeMountComponent: function (id, element) {
	    updateTree(id, function (item) {
	      return item.element = element;
	    });
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    updateTree(id, function (item) {
	      return item.element = element;
	    });
	  },
	  onMountComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.isMounted = true;
	    });
	  },
	  onMountRootComponent: function (id) {
	    rootIDs[id] = true;
	  },
	  onUpdateComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.updateCount++;
	    });
	  },
	  onUnmountComponent: function (id) {
	    updateTree(id, function (item) {
	      return item.isMounted = false;
	    });
	    unmountedIDs[id] = true;
	    delete rootIDs[id];
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeDevtool._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var id in unmountedIDs) {
	      purgeDeep(id);
	    }
	    unmountedIDs = {};
	  },
	  isMounted: function (id) {
	    var item = tree[id];
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeDevtool.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeDevtool.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = tree[id];
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var item = tree[id];
	    return item ? item.displayName : 'Unknown';
	  },
	  getElement: function (id) {
	    var item = tree[id];
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var item = tree[id];
	    return item ? item.ownerID : null;
	  },
	  getParentID: function (id) {
	    var item = tree[id];
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = tree[id];
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var item = tree[id];
	    return item ? item.text : null;
	  },
	  getUpdateCount: function (id) {
	    var item = tree[id];
	    return item ? item.updateCount : 0;
	  },
	  getRootIDs: function () {
	    return Object.keys(rootIDs);
	  },
	  getRegisteredIDs: function () {
	    return Object.keys(tree);
	  }
	};
	
	module.exports = ReactComponentTreeDevtool;

/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var invariant = __webpack_require__(7);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(15);
	var traverseAllChildren = __webpack_require__(13);
	var warning = __webpack_require__(10);
	
	var ReactComponentTreeDevtool;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeDevtool = __webpack_require__(118);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeDevtool) {
	        ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	      }
	      process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(113)))

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var PooledClass = __webpack_require__(5);
	var Transaction = __webpack_require__(60);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactServerUpdateQueue = __webpack_require__(125);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(126);
	var Transaction = __webpack_require__(60);
	var warning = __webpack_require__(10);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(9);
	var ReactInstanceMap = __webpack_require__(111);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactUpdates = __webpack_require__(53);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var emptyFunction = __webpack_require__(11);
	var warning = __webpack_require__(10);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(33);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(3);
	
	var DOMChildrenOperations = __webpack_require__(72);
	var DOMLazyTree = __webpack_require__(73);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstrumentation = __webpack_require__(59);
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(7);
	var validateDOMNesting = __webpack_require__(127);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetText(this._debugID, this._stringText);
	
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	
	        if (false) {
	          ReactInstrumentation.debugTool.onSetText(this._debugID, nextStringText);
	        }
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var ReactUpdates = __webpack_require__(53);
	var Transaction = __webpack_require__(60);
	
	var emptyFunction = __webpack_require__(11);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var EventListener = __webpack_require__(133);
	var ExecutionEnvironment = __webpack_require__(46);
	var PooledClass = __webpack_require__(5);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactUpdates = __webpack_require__(53);
	
	var getEventTarget = __webpack_require__(61);
	var getUnboundedScrollPosition = __webpack_require__(134);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(11);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(34);
	var EventPluginHub = __webpack_require__(40);
	var EventPluginUtils = __webpack_require__(42);
	var ReactComponentEnvironment = __webpack_require__(110);
	var ReactClass = __webpack_require__(20);
	var ReactEmptyComponent = __webpack_require__(121);
	var ReactBrowserEventEmitter = __webpack_require__(99);
	var ReactHostComponent = __webpack_require__(122);
	var ReactUpdates = __webpack_require__(53);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var CallbackQueue = __webpack_require__(54);
	var PooledClass = __webpack_require__(5);
	var ReactBrowserEventEmitter = __webpack_require__(99);
	var ReactInputSelection = __webpack_require__(137);
	var ReactInstrumentation = __webpack_require__(59);
	var Transaction = __webpack_require__(60);
	var ReactUpdateQueue = __webpack_require__(126);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(138);
	
	var containsNode = __webpack_require__(140);
	var focusNode = __webpack_require__(87);
	var getActiveElement = __webpack_require__(143);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(46);
	
	var getNodeForCharacterOffset = __webpack_require__(139);
	var getTextContentAccessor = __webpack_require__(48);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(141);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(142);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 144 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(38);
	var EventPropagators = __webpack_require__(39);
	var ExecutionEnvironment = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInputSelection = __webpack_require__(137);
	var SyntheticEvent = __webpack_require__(50);
	
	var getActiveElement = __webpack_require__(143);
	var isTextInputElement = __webpack_require__(63);
	var keyOf = __webpack_require__(24);
	var shallowEqual = __webpack_require__(119);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventConstants = __webpack_require__(38);
	var EventListener = __webpack_require__(133);
	var EventPropagators = __webpack_require__(39);
	var ReactDOMComponentTree = __webpack_require__(33);
	var SyntheticAnimationEvent = __webpack_require__(147);
	var SyntheticClipboardEvent = __webpack_require__(148);
	var SyntheticEvent = __webpack_require__(50);
	var SyntheticFocusEvent = __webpack_require__(149);
	var SyntheticKeyboardEvent = __webpack_require__(150);
	var SyntheticMouseEvent = __webpack_require__(66);
	var SyntheticDragEvent = __webpack_require__(153);
	var SyntheticTouchEvent = __webpack_require__(154);
	var SyntheticTransitionEvent = __webpack_require__(155);
	var SyntheticUIEvent = __webpack_require__(67);
	var SyntheticWheelEvent = __webpack_require__(156);
	
	var emptyFunction = __webpack_require__(11);
	var getEventCharCode = __webpack_require__(151);
	var invariant = __webpack_require__(7);
	var keyOf = __webpack_require__(24);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(50);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(50);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(67);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(67);
	
	var getEventCharCode = __webpack_require__(151);
	var getEventKey = __webpack_require__(152);
	var getEventModifierState = __webpack_require__(69);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(151);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(66);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(67);
	
	var getEventModifierState = __webpack_require__(69);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(50);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(66);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(73);
	var DOMProperty = __webpack_require__(34);
	var ReactBrowserEventEmitter = __webpack_require__(99);
	var ReactCurrentOwner = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactDOMContainerInfo = __webpack_require__(158);
	var ReactDOMFeatureFlags = __webpack_require__(159);
	var ReactElement = __webpack_require__(8);
	var ReactFeatureFlags = __webpack_require__(55);
	var ReactInstanceMap = __webpack_require__(111);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactMarkupChecksum = __webpack_require__(160);
	var ReactReconciler = __webpack_require__(56);
	var ReactUpdateQueue = __webpack_require__(126);
	var ReactUpdates = __webpack_require__(53);
	
	var emptyObject = __webpack_require__(18);
	var instantiateReactComponent = __webpack_require__(114);
	var invariant = __webpack_require__(7);
	var setInnerHTML = __webpack_require__(75);
	var shouldUpdateReactComponent = __webpack_require__(120);
	var warning = __webpack_require__(10);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      // The instance here is TopLevelWrapper so we report mount for its child.
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance._renderedComponent._debugID);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(127);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(161);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 161 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(33);
	var ReactInstanceMap = __webpack_require__(111);
	
	var getHostComponentFromComposite = __webpack_require__(163);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(10);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(116);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(157);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactInputAutosize = __webpack_require__(166);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsStripDiacritics = __webpack_require__(168);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var _Async = __webpack_require__(169);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Option = __webpack_require__(170);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(171);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function stringifyValue(value) {
		if (typeof value === 'object') {
			return JSON.stringify(value);
		} else {
			return value;
		}
	}
	
	var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
	var Select = _react2['default'].createClass({
	
		displayName: 'Select',
	
		propTypes: {
			addLabelText: _react2['default'].PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			allowCreate: _react2['default'].PropTypes.bool, // whether to allow creation of new entries
			autoBlur: _react2['default'].PropTypes.bool,
			autofocus: _react2['default'].PropTypes.bool, // autofocus the component on mount
			autosize: _react2['default'].PropTypes.bool, // whether to enable autosizing or not
			backspaceRemoves: _react2['default'].PropTypes.bool, // whether backspace removes an item if there is no text input
			className: _react2['default'].PropTypes.string, // className for the outer element
			clearAllText: stringOrNode, // title for the "clear" control when multi: true
			clearValueText: stringOrNode, // title for the "clear" control
			clearable: _react2['default'].PropTypes.bool, // should it be possible to reset value
			delimiter: _react2['default'].PropTypes.string, // delimiter to use to join multiple values for the hidden field value
			disabled: _react2['default'].PropTypes.bool, // whether the Select is disabled or not
			escapeClearsValue: _react2['default'].PropTypes.bool, // whether escape clears the value when the menu is closed
			filterOption: _react2['default'].PropTypes.func, // method to filter a single option (option, filterString)
			filterOptions: _react2['default'].PropTypes.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: _react2['default'].PropTypes.object, // custom attributes for the Input
			isLoading: _react2['default'].PropTypes.bool, // whether the Select is loading externally or not (such as options being loaded)
			joinValues: _react2['default'].PropTypes.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
			labelKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			matchPos: _react2['default'].PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: _react2['default'].PropTypes.string, // (any|label|value) which option property to filter on
			menuBuffer: _react2['default'].PropTypes.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
			menuContainerStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu container
			menuRenderer: _react2['default'].PropTypes.func, // renders a custom menu with options
			menuStyle: _react2['default'].PropTypes.object, // optional style to apply to the menu
			multi: _react2['default'].PropTypes.bool, // multi-value input
			name: _react2['default'].PropTypes.string, // generates a hidden <input /> tag with this field name for html forms
			newOptionCreator: _react2['default'].PropTypes.func, // factory to create new options when allowCreate set
			noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
			onBlur: _react2['default'].PropTypes.func, // onBlur handler: function (event) {}
			onBlurResetsInput: _react2['default'].PropTypes.bool, // whether input is cleared on blur
			onChange: _react2['default'].PropTypes.func, // onChange handler: function (newValue) {}
			onClose: _react2['default'].PropTypes.func, // fires when the menu is closed
			onFocus: _react2['default'].PropTypes.func, // onFocus handler: function (event) {}
			onInputChange: _react2['default'].PropTypes.func, // onInputChange handler: function (inputValue) {}
			onMenuScrollToBottom: _react2['default'].PropTypes.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
			onOpen: _react2['default'].PropTypes.func, // fires when the menu is opened
			onValueClick: _react2['default'].PropTypes.func, // onClick handler for value labels: function (value, event) {}
			openAfterFocus: _react2['default'].PropTypes.bool, // boolean to enable opening dropdown when focused
			optionClassName: _react2['default'].PropTypes.string, // additional class(es) to apply to the <Option /> elements
			optionComponent: _react2['default'].PropTypes.func, // option component to render in dropdown
			optionRenderer: _react2['default'].PropTypes.func, // optionRenderer: function (option) {}
			options: _react2['default'].PropTypes.array, // array of options
			placeholder: stringOrNode, // field placeholder, displayed when there's no value
			required: _react2['default'].PropTypes.bool, // applies HTML5 required attribute when needed
			scrollMenuIntoView: _react2['default'].PropTypes.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
			searchable: _react2['default'].PropTypes.bool, // whether to enable searching feature or not
			simpleValue: _react2['default'].PropTypes.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
			style: _react2['default'].PropTypes.object, // optional style to apply to the control
			tabIndex: _react2['default'].PropTypes.string, // optional tab index of the control
			value: _react2['default'].PropTypes.any, // initial field value
			valueComponent: _react2['default'].PropTypes.func, // value component to render
			valueKey: _react2['default'].PropTypes.string, // path of the label value in option objects
			valueRenderer: _react2['default'].PropTypes.func, // valueRenderer: function (option) {}
			wrapperStyle: _react2['default'].PropTypes.object },
	
		// optional style to apply to the component wrapper
		statics: { Async: _Async2['default'] },
	
		getDefaultProps: function getDefaultProps() {
			return {
				addLabelText: 'Add "{label}"?',
				autosize: true,
				allowCreate: false,
				backspaceRemoves: true,
				clearable: true,
				clearAllText: 'Clear all',
				clearValueText: 'Clear value',
				delimiter: ',',
				disabled: false,
				escapeClearsValue: true,
				filterOptions: true,
				ignoreAccents: true,
				ignoreCase: true,
				inputProps: {},
				isLoading: false,
				joinValues: false,
				labelKey: 'label',
				matchPos: 'any',
				matchProp: 'any',
				menuBuffer: 0,
				multi: false,
				noResultsText: 'No results found',
				onBlurResetsInput: true,
				openAfterFocus: false,
				optionComponent: _Option2['default'],
				placeholder: 'Select...',
				required: false,
				scrollMenuIntoView: true,
				searchable: true,
				simpleValue: false,
				valueComponent: _Value2['default'],
				valueKey: 'value'
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				inputValue: '',
				isFocused: false,
				isLoading: false,
				isOpen: false,
				isPseudoFocused: false,
				required: this.props.required && this.handleRequired(this.props.value, this.props.multi)
			};
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			if (this.props.value !== nextProps.value && nextProps.required) {
				this.setState({
					required: this.handleRequired(nextProps.value, nextProps.multi)
				});
			}
		},
	
		componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		},
	
		componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.refs.menu && this.refs.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2['default'].findDOMNode(this.refs.focused);
				var menuNode = _reactDom2['default'].findDOMNode(this.refs.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}
	
			if (prevState.inputValue !== this.state.inputValue && this.props.onInputChange) {
				this.props.onInputChange(this.state.inputValue);
			}
			if (this._scrollToFocusedOptionOnUpdate && this.refs.focused && this.refs.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2['default'].findDOMNode(this.refs.focused);
				var menuDOM = _reactDom2['default'].findDOMNode(this.refs.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				}
			}
			if (this.props.scrollMenuIntoView && this.refs.menuContainer) {
				var menuContainerRect = this.refs.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollTo(0, window.scrollY + menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			}
		},
	
		focus: function focus() {
			if (!this.refs.input) return;
			this.refs.input.focus();
	
			if (this.props.openAfterFocus) {
				this.setState({
					isOpen: true
				});
			}
		},
	
		blurInput: function blurInput() {
			if (!this.refs.input) return;
			this.refs.input.blur();
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.handleMouseDown(event);
		},
	
		handleTouchEndClearValue: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Clear the value
			this.clearValue(event);
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
	
			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}
	
			if (this.state.isFocused) {
				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = true;
				this.focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		},
	
		handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
	
			this._openAfterFocus = true;
			this.focus();
		},
	
		closeMenu: function closeMenu() {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: ''
			});
			this.hasScrolledToOption = false;
		},
	
		handleInputFocus: function handleInputFocus(event) {
			var isOpen = this.state.isOpen || this._openAfterFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		},
	
		handleInputBlur: function handleInputBlur(event) {
			if (this.refs.menu && document.activeElement.isEqualNode(this.refs.menu)) {
				return;
			}
	
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = '';
			}
			this.setState(onBlurredState);
		},
	
		handleInputChange: function handleInputChange(event) {
			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: event.target.value
			});
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.props.disabled) return;
			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				// case 188: // ,
				// 	if (this.props.allowCreate && this.props.multi) {
				// 		event.preventDefault();
				// 		event.stopPropagation();
				// 		this.selectFocusedOption();
				// 	} else {
				// 		return;
				// 	}
				// break;
				default:
					return;
			}
			event.preventDefault();
		},
	
		handleValueClick: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		},
	
		handleMenuScroll: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;
	
			if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
				this.props.onMenuScrollToBottom();
			}
		},
	
		handleRequired: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		},
	
		getOptionLabel: function getOptionLabel(op) {
			return op[this.props.labelKey];
		},
	
		getValueArray: function getValueArray() {
			var value = this.props.value;
			if (this.props.multi) {
				if (typeof value === 'string') value = value.split(this.props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(this.expandValue).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value);
			return expandedValue ? [expandedValue] : [];
		},
	
		expandValue: function expandValue(value) {
			if (typeof value !== 'string' && typeof value !== 'number') return value;
			var _props = this.props;
			var options = _props.options;
			var valueKey = _props.valueKey;
	
			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		},
	
		setValue: function setValue(value) {
			var _this = this;
	
			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (!this.props.onChange) return;
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			this.props.onChange(value);
		},
	
		selectValue: function selectValue(value) {
			this.hasScrolledToOption = false;
			if (this.props.multi) {
				this.addValue(value);
				this.setState({
					inputValue: ''
				});
			} else {
				this.setValue(value);
				this.setState({
					isOpen: false,
					inputValue: '',
					isPseudoFocused: this.state.isFocused
				});
			}
		},
	
		addValue: function addValue(value) {
			var valueArray = this.getValueArray();
			this.setValue(valueArray.concat(value));
		},
	
		popValue: function popValue() {
			var valueArray = this.getValueArray();
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(valueArray.slice(0, valueArray.length - 1));
		},
	
		removeValue: function removeValue(value) {
			var valueArray = this.getValueArray();
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(null);
			this.setState({
				isOpen: false,
				inputValue: ''
			}, this.focus);
		},
	
		focusOption: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.filter(function (i) {
				return !i.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || options[dir === 'next' ? 0 : options.length - 1]
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i]) {
					focusedIndex = i;
					break;
				}
			}
			var focusedOption = options[0];
			if (dir === 'next' && focusedIndex > -1 && focusedIndex < options.length - 1) {
				focusedOption = options[focusedIndex + 1];
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedOption = options[focusedIndex - 1];
				} else {
					focusedOption = options[options.length - 1];
				}
			}
			this.setState({
				focusedOption: focusedOption
			});
		},
	
		selectFocusedOption: function selectFocusedOption() {
			// if (this.props.allowCreate && !this.state.focusedOption) {
			// 	return this.selectValue(this.state.inputValue);
			// }
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		},
	
		renderLoading: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2['default'].createElement('span', { className: 'Select-loading' })
			);
		},
	
		renderValue: function renderValue(valueArray, isOpen) {
			var _this2 = this;
	
			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2['default'].createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2['default'].createElement(
						ValueComponent,
						{
							disabled: _this2.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this2.props.valueKey],
							onClick: onClick,
							onRemove: _this2.removeValue,
							value: value
						},
						renderLabel(value)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2['default'].createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		},
	
		renderInput: function renderInput(valueArray) {
			var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
			if (this.props.disabled || !this.props.searchable) {
				return _react2['default'].createElement('div', _extends({}, this.props.inputProps, {
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: 'input',
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}
			if (this.props.autosize) {
				return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, this.props.inputProps, {
					className: className,
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					minWidth: '5',
					ref: 'input',
					required: this.state.required,
					value: this.state.inputValue
				}));
			}
			return _react2['default'].createElement(
				'div',
				{ className: className },
				_react2['default'].createElement('input', _extends({}, this.props.inputProps, {
					tabIndex: this.props.tabIndex,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: 'input',
					required: this.state.required,
					value: this.state.inputValue
				}))
			);
		},
	
		renderClear: function renderClear() {
			if (!this.props.clearable || !this.props.value || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue },
				_react2['default'].createElement('span', { className: 'Select-clear', dangerouslySetInnerHTML: { __html: '&times;' } })
			);
		},
	
		renderArrow: function renderArrow() {
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-arrow-zone', onMouseDown: this.handleMouseDownOnArrow },
				_react2['default'].createElement('span', { className: 'Select-arrow', onMouseDown: this.handleMouseDownOnArrow })
			);
		},
	
		filterOptions: function filterOptions(excludeOptions) {
			var _this3 = this;
	
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (typeof this.props.filterOptions === 'function') {
				return this.props.filterOptions.call(this, options, filterValue, excludeOptions);
			} else if (this.props.filterOptions) {
				if (this.props.ignoreAccents) {
					filterValue = (0, _utilsStripDiacritics2['default'])(filterValue);
				}
				if (this.props.ignoreCase) {
					filterValue = filterValue.toLowerCase();
				}
				if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
					return i[_this3.props.valueKey];
				});
				return options.filter(function (option) {
					if (excludeOptions && excludeOptions.indexOf(option[_this3.props.valueKey]) > -1) return false;
					if (_this3.props.filterOption) return _this3.props.filterOption.call(_this3, option, filterValue);
					if (!filterValue) return true;
					var valueTest = String(option[_this3.props.valueKey]);
					var labelTest = String(option[_this3.props.labelKey]);
					if (_this3.props.ignoreAccents) {
						if (_this3.props.matchProp !== 'label') valueTest = (0, _utilsStripDiacritics2['default'])(valueTest);
						if (_this3.props.matchProp !== 'value') labelTest = (0, _utilsStripDiacritics2['default'])(labelTest);
					}
					if (_this3.props.ignoreCase) {
						if (_this3.props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
						if (_this3.props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
					}
					return _this3.props.matchPos === 'start' ? _this3.props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || _this3.props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : _this3.props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || _this3.props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
				});
			} else {
				return options;
			}
		},
	
		renderMenu: function renderMenu(options, valueArray, focusedOption) {
			var _this4 = this;
	
			if (options && options.length) {
				if (this.props.menuRenderer) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						labelKey: this.props.labelKey,
						options: options,
						selectValue: this.selectValue,
						valueArray: valueArray
					});
				} else {
					var _ret = (function () {
						var Option = _this4.props.optionComponent;
						var renderLabel = _this4.props.optionRenderer || _this4.getOptionLabel;
	
						return {
							v: options.map(function (option, i) {
								var isSelected = valueArray && valueArray.indexOf(option) > -1;
								var isFocused = option === focusedOption;
								var optionRef = isFocused ? 'focused' : null;
								var optionClass = (0, _classnames2['default'])(_this4.props.optionClassName, {
									'Select-option': true,
									'is-selected': isSelected,
									'is-focused': isFocused,
									'is-disabled': option.disabled
								});
	
								return _react2['default'].createElement(
									Option,
									{
										className: optionClass,
										isDisabled: option.disabled,
										isFocused: isFocused,
										key: 'option-' + i + '-' + option[_this4.props.valueKey],
										onSelect: _this4.selectValue,
										onFocus: _this4.focusOption,
										option: option,
										isSelected: isSelected,
										ref: optionRef
									},
									renderLabel(option)
								);
							})
						};
					})();
	
					if (typeof _ret === 'object') return _ret.v;
				}
			} else if (this.props.noResultsText) {
				return _react2['default'].createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		},
	
		renderHiddenField: function renderHiddenField(valueArray) {
			var _this5 = this;
	
			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this5.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2['default'].createElement('input', {
					type: 'hidden',
					ref: 'value',
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2['default'].createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this5.props.name,
					value: stringifyValue(item[_this5.props.valueKey]),
					disabled: _this5.props.disabled });
			});
		},
	
		getFocusableOption: function getFocusableOption(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && options.indexOf(focusedOption) > -1) return focusedOption;
			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return options[i];
			}
		},
	
		render: function render() {
			var valueArray = this.getValueArray();
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOption = this._focusedOption = this.getFocusableOption(valueArray[0]);
			var className = (0, _classnames2['default'])('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});
			return _react2['default'].createElement(
				'div',
				{ ref: 'wrapper', className: className, style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2['default'].createElement(
					'div',
					{ ref: 'control',
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray),
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? _react2['default'].createElement(
					'div',
					{ ref: 'menuContainer', className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2['default'].createElement(
						'div',
						{ ref: 'menu', className: 'Select-menu',
							style: this.props.menuStyle,
							onScroll: this.handleMenuScroll,
							onMouseDown: this.handleMouseDownOnMenu },
						this.renderMenu(options, !this.props.multi ? valueArray : null, focusedOption)
					)
				) : null
			);
		}
	
	});
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	
	var sizerStyle = { position: 'absolute', visibility: 'hidden', height: 0, width: 0, overflow: 'scroll', whiteSpace: 'pre' };
	
	var nextFrame = typeof window !== 'undefined' ? (function () {
		return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
			window.setTimeout(callback, 1000 / 60);
		};
	})().bind(window) : undefined; // If window is undefined, then we can't define a nextFrame function
	
	var AutosizeInput = React.createClass({
		displayName: 'AutosizeInput',
	
		propTypes: {
			value: React.PropTypes.any, // field value
			defaultValue: React.PropTypes.any, // default field value
			onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
			style: React.PropTypes.object, // css styles for the outer element
			className: React.PropTypes.string, // className for the outer element
			minWidth: React.PropTypes.oneOfType([// minimum width for input element
			React.PropTypes.number, React.PropTypes.string]),
			inputStyle: React.PropTypes.object, // css styles for the input element
			inputClassName: React.PropTypes.string // className for the input element
		},
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth
			};
		},
		componentDidMount: function componentDidMount() {
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate() {
			this.updateInputWidth();
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.isMounted() || !window.getComputedStyle) {
				return;
			}
			var inputStyle = window.getComputedStyle(this.refs.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.refs.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			if (this.props.placeholder) {
				var placeholderNode = this.refs.placeholderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.isMounted() || typeof this.refs.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = undefined;
			if (this.props.placeholder) {
				newInputWidth = Math.max(this.refs.sizer.scrollWidth, this.refs.placeholderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.refs.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.refs.input;
		},
		focus: function focus() {
			this.refs.input.focus();
		},
		blur: function blur() {
			this.refs.input.blur();
		},
		select: function select() {
			this.refs.input.select();
		},
		render: function render() {
			var sizerValue = this.props.defaultValue || this.props.value || '';
			var wrapperStyle = this.props.style || {};
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';
			var placeholder = this.props.placeholder ? React.createElement(
				'div',
				{ ref: 'placeholderSizer', style: sizerStyle },
				this.props.placeholder
			) : null;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('input', _extends({}, this.props, { ref: 'input', className: this.props.inputClassName, style: inputStyle })),
				React.createElement(
					'div',
					{ ref: 'sizer', style: sizerStyle },
					sizerValue
				),
				placeholder
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	module.exports = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(165);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _utilsStripDiacritics = __webpack_require__(168);
	
	var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);
	
	var requestId = 0;
	
	function initCache(cache) {
		if (cache && typeof cache !== 'object') {
			cache = {};
		}
		return cache ? cache : null;
	}
	
	function updateCache(cache, input, data) {
		if (!cache) return;
		cache[input] = data;
	}
	
	function getFromCache(cache, input) {
		if (!cache) return;
		for (var i = input.length; i >= 0; --i) {
			var cacheKey = input.slice(0, i);
			if (cache[cacheKey] && (input === cacheKey || cache[cacheKey].complete)) {
				return cache[cacheKey];
			}
		}
	}
	
	function thenPromise(promise, callback) {
		if (!promise || typeof promise.then !== 'function') return;
		return promise.then(function (data) {
			callback(null, data);
		}, function (err) {
			callback(err);
		});
	}
	
	var stringOrNode = _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.node]);
	
	var Async = _react2['default'].createClass({
		displayName: 'Async',
	
		propTypes: {
			cache: _react2['default'].PropTypes.any, // object to use to cache results, can be null to disable cache
			ignoreAccents: _react2['default'].PropTypes.bool, // whether to strip diacritics when filtering (shared with Select)
			ignoreCase: _react2['default'].PropTypes.bool, // whether to perform case-insensitive filtering (shared with Select)
			isLoading: _react2['default'].PropTypes.bool, // overrides the isLoading state when set to true
			loadOptions: _react2['default'].PropTypes.func.isRequired, // function to call to load options asynchronously
			loadingPlaceholder: _react2['default'].PropTypes.string, // replaces the placeholder while options are loading
			minimumInput: _react2['default'].PropTypes.number, // the minimum number of characters that trigger loadOptions
			noResultsText: _react2['default'].PropTypes.string, // placeholder displayed when there are no matching search results (shared with Select)
			placeholder: stringOrNode, // field placeholder, displayed when there's no value (shared with Select)
			searchPromptText: _react2['default'].PropTypes.string, // label to prompt for search input
			searchingText: _react2['default'].PropTypes.string },
		// message to display while options are loading
		getDefaultProps: function getDefaultProps() {
			return {
				cache: true,
				ignoreAccents: true,
				ignoreCase: true,
				loadingPlaceholder: 'Loading...',
				minimumInput: 0,
				searchingText: 'Searching...',
				searchPromptText: 'Type to search'
			};
		},
		getInitialState: function getInitialState() {
			return {
				cache: initCache(this.props.cache),
				isLoading: false,
				options: []
			};
		},
		componentWillMount: function componentWillMount() {
			this._lastInput = '';
		},
		componentDidMount: function componentDidMount() {
			this.loadOptions('');
		},
		componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
			if (nextProps.cache !== this.props.cache) {
				this.setState({
					cache: initCache(nextProps.cache)
				});
			}
		},
		focus: function focus() {
			this.refs.select.focus();
		},
		resetState: function resetState() {
			this._currentRequestId = -1;
			this.setState({
				isLoading: false,
				options: []
			});
		},
		getResponseHandler: function getResponseHandler(input) {
			var _this = this;
	
			var _requestId = this._currentRequestId = requestId++;
			return function (err, data) {
				if (err) throw err;
				if (!_this.isMounted()) return;
				updateCache(_this.state.cache, input, data);
				if (_requestId !== _this._currentRequestId) return;
				_this.setState({
					isLoading: false,
					options: data && data.options || []
				});
			};
		},
		loadOptions: function loadOptions(input) {
			if (this.props.ignoreAccents) input = (0, _utilsStripDiacritics2['default'])(input);
			if (this.props.ignoreCase) input = input.toLowerCase();
			this._lastInput = input;
			if (input.length < this.props.minimumInput) {
				return this.resetState();
			}
			var cacheResult = getFromCache(this.state.cache, input);
			if (cacheResult) {
				return this.setState({
					options: cacheResult.options
				});
			}
			this.setState({
				isLoading: true
			});
			var responseHandler = this.getResponseHandler(input);
			return thenPromise(this.props.loadOptions(input, responseHandler), responseHandler);
		},
		render: function render() {
			var noResultsText = this.props.noResultsText;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;
	
			if (this.props.isLoading) isLoading = true;
			var placeholder = isLoading ? this.props.loadingPlaceholder : this.props.placeholder;
			if (!options.length) {
				if (this._lastInput.length < this.props.minimumInput) noResultsText = this.props.searchPromptText;
				if (isLoading) noResultsText = this.props.searchingText;
			}
			return _react2['default'].createElement(_Select2['default'], _extends({}, this.props, {
				ref: 'select',
				isLoading: isLoading,
				noResultsText: noResultsText,
				onInputChange: this.loadOptions,
				options: options,
				placeholder: placeholder
			}));
		}
	});
	
	module.exports = Async;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Option = _react2['default'].createClass({
		displayName: 'Option',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			className: _react2['default'].PropTypes.string, // className (based on mouse position)
			isDisabled: _react2['default'].PropTypes.bool, // the option is disabled
			isFocused: _react2['default'].PropTypes.bool, // the option is focused
			isSelected: _react2['default'].PropTypes.bool, // the option is selected
			onFocus: _react2['default'].PropTypes.func, // method to handle mouseEnter on option element
			onSelect: _react2['default'].PropTypes.func, // method to handle click on option element
			onUnfocus: _react2['default'].PropTypes.func, // method to handle mouseLeave on option element
			option: _react2['default'].PropTypes.object.isRequired },
		// object that is base for that option
		blockEvent: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		},
	
		handleMouseDown: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		},
	
		handleMouseEnter: function handleMouseEnter(event) {
			this.onFocus(event);
		},
	
		handleMouseMove: function handleMouseMove(event) {
			this.onFocus(event);
		},
	
		handleTouchEnd: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			this.handleMouseDown(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		onFocus: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		},
		render: function render() {
			var option = this.props.option;
	
			var className = (0, _classnames2['default'])(this.props.className, option.className);
	
			return option.disabled ? _react2['default'].createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2['default'].createElement(
				'div',
				{ className: className,
					style: option.style,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					title: option.title },
				this.props.children
			);
		}
	});
	
	module.exports = Option;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Value = _react2['default'].createClass({
	
		displayName: 'Value',
	
		propTypes: {
			children: _react2['default'].PropTypes.node,
			disabled: _react2['default'].PropTypes.bool, // disabled prop passed to ReactSelect
			onClick: _react2['default'].PropTypes.func, // method to handle click on value label
			onRemove: _react2['default'].PropTypes.func, // method to handle removal of the value
			value: _react2['default'].PropTypes.object.isRequired },
	
		// the option object for this value
		handleMouseDown: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		},
	
		onRemove: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		},
	
		handleTouchEndRemove: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;
	
			// Fire the mouse events
			this.onRemove(event);
		},
	
		handleTouchMove: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		},
	
		handleTouchStart: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		},
	
		renderRemoveIcon: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2['default'].createElement(
				'span',
				{ className: 'Select-value-icon',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'×'
			);
		},
	
		renderLabel: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2['default'].createElement(
				'span',
				{ className: className },
				this.props.children
			);
		},
	
		render: function render() {
			return _react2['default'].createElement(
				'div',
				{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	
	});
	
	module.exports = Value;

/***/ },
/* 172 */,
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var Reflux = __webpack_require__(174);
	
	Reflux.connect = __webpack_require__(187);
	
	Reflux.connectFilter = __webpack_require__(189);
	
	Reflux.ListenerMixin = __webpack_require__(188);
	
	Reflux.listenTo = __webpack_require__(190);
	
	Reflux.listenToMany = __webpack_require__(191);
	
	module.exports = Reflux;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Reflux = {
	    version: {
	        "reflux-core": "0.3.0"
	    }
	};
	
	Reflux.ActionMethods = __webpack_require__(175);
	
	Reflux.ListenerMethods = __webpack_require__(176);
	
	Reflux.PublisherMethods = __webpack_require__(185);
	
	Reflux.StoreMethods = __webpack_require__(184);
	
	Reflux.createAction = __webpack_require__(186);
	
	Reflux.createStore = __webpack_require__(180);
	
	var maker = __webpack_require__(179).staticJoinCreator;
	
	Reflux.joinTrailing = Reflux.all = maker("last"); // Reflux.all alias for backward compatibility
	
	Reflux.joinLeading = maker("first");
	
	Reflux.joinStrict = maker("strict");
	
	Reflux.joinConcat = maker("all");
	
	var _ = Reflux.utils = __webpack_require__(177);
	
	Reflux.EventEmitter = _.EventEmitter;
	
	Reflux.Promise = _.Promise;
	
	/**
	 * Convenience function for creating a set of actions
	 *
	 * @param definitions the definitions for the actions to be created
	 * @returns an object with actions of corresponding action names
	 */
	Reflux.createActions = (function () {
	    var reducer = function reducer(definitions, actions) {
	        Object.keys(definitions).forEach(function (actionName) {
	            var val = definitions[actionName];
	            actions[actionName] = Reflux.createAction(val);
	        });
	    };
	
	    return function (definitions) {
	        var actions = {};
	        if (definitions instanceof Array) {
	            definitions.forEach(function (val) {
	                if (_.isObject(val)) {
	                    reducer(val, actions);
	                } else {
	                    actions[val] = Reflux.createAction(val);
	                }
	            });
	        } else {
	            reducer(definitions, actions);
	        }
	        return actions;
	    };
	})();
	
	/**
	 * Sets the eventmitter that Reflux uses
	 */
	Reflux.setEventEmitter = function (ctx) {
	    Reflux.EventEmitter = _.EventEmitter = ctx;
	};
	
	/**
	 * Sets the method used for deferring actions and stores
	 */
	Reflux.nextTick = function (nextTick) {
	    _.nextTick = nextTick;
	};
	
	Reflux.use = function (pluginCb) {
	    pluginCb(Reflux);
	};
	
	/**
	 * Provides the set of created actions and stores for introspection
	 */
	/*eslint-disable no-underscore-dangle*/
	Reflux.__keep = __webpack_require__(181);
	/*eslint-enable no-underscore-dangle*/
	
	/**
	 * Warn if Function.prototype.bind not available
	 */
	if (!Function.prototype.bind) {
	    console.error("Function.prototype.bind not available. " + "ES5 shim required. " + "https://github.com/spoike/refluxjs#es5");
	}
	
	exports["default"] = Reflux;
	module.exports = exports["default"];

/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * A module of methods that you want to include in all actions.
	 * This module is consumed by `createAction`.
	 */
	"use strict";
	
	module.exports = {};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(177),
	    maker = __webpack_require__(179).instanceJoinCreator;
	
	/**
	 * Extract child listenables from a parent from their
	 * children property and return them in a keyed Object
	 *
	 * @param {Object} listenable The parent listenable
	 */
	var mapChildListenables = function mapChildListenables(listenable) {
	    var i = 0,
	        children = {},
	        childName;
	    for (; i < (listenable.children || []).length; ++i) {
	        childName = listenable.children[i];
	        if (listenable[childName]) {
	            children[childName] = listenable[childName];
	        }
	    }
	    return children;
	};
	
	/**
	 * Make a flat dictionary of all listenables including their
	 * possible children (recursively), concatenating names in camelCase.
	 *
	 * @param {Object} listenables The top-level listenables
	 */
	var flattenListenables = function flattenListenables(listenables) {
	    var flattened = {};
	    for (var key in listenables) {
	        var listenable = listenables[key];
	        var childMap = mapChildListenables(listenable);
	
	        // recursively flatten children
	        var children = flattenListenables(childMap);
	
	        // add the primary listenable and chilren
	        flattened[key] = listenable;
	        for (var childKey in children) {
	            var childListenable = children[childKey];
	            flattened[key + _.capitalize(childKey)] = childListenable;
	        }
	    }
	
	    return flattened;
	};
	
	/**
	 * A module of methods related to listening.
	 */
	module.exports = {
	
	    /**
	     * An internal utility function used by `validateListening`
	     *
	     * @param {Action|Store} listenable The listenable we want to search for
	     * @returns {Boolean} The result of a recursive search among `this.subscriptions`
	     */
	    hasListener: function hasListener(listenable) {
	        var i = 0,
	            j,
	            listener,
	            listenables;
	        for (; i < (this.subscriptions || []).length; ++i) {
	            listenables = [].concat(this.subscriptions[i].listenable);
	            for (j = 0; j < listenables.length; j++) {
	                listener = listenables[j];
	                if (listener === listenable || listener.hasListener && listener.hasListener(listenable)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    },
	
	    /**
	     * A convenience method that listens to all listenables in the given object.
	     *
	     * @param {Object} listenables An object of listenables. Keys will be used as callback method names.
	     */
	    listenToMany: function listenToMany(listenables) {
	        var allListenables = flattenListenables(listenables);
	        for (var key in allListenables) {
	            var cbname = _.callbackName(key),
	                localname = this[cbname] ? cbname : this[key] ? key : undefined;
	            if (localname) {
	                this.listenTo(allListenables[key], localname, this[cbname + "Default"] || this[localname + "Default"] || localname);
	            }
	        }
	    },
	
	    /**
	     * Checks if the current context can listen to the supplied listenable
	     *
	     * @param {Action|Store} listenable An Action or Store that should be
	     *  listened to.
	     * @returns {String|Undefined} An error message, or undefined if there was no problem.
	     */
	    validateListening: function validateListening(listenable) {
	        if (listenable === this) {
	            return "Listener is not able to listen to itself";
	        }
	        if (!_.isFunction(listenable.listen)) {
	            return listenable + " is missing a listen method";
	        }
	        if (listenable.hasListener && listenable.hasListener(this)) {
	            return "Listener cannot listen to this listenable because of circular loop";
	        }
	    },
	
	    /**
	     * Sets up a subscription to the given listenable for the context object
	     *
	     * @param {Action|Store} listenable An Action or Store that should be
	     *  listened to.
	     * @param {Function|String} callback The callback to register as event handler
	     * @param {Function|String} defaultCallback The callback to register as default handler
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is the object being listened to
	     */
	    listenTo: function listenTo(listenable, callback, defaultCallback) {
	        var desub,
	            unsubscriber,
	            subscriptionobj,
	            subs = this.subscriptions = this.subscriptions || [];
	        _.throwIf(this.validateListening(listenable));
	        this.fetchInitialState(listenable, defaultCallback);
	        desub = listenable.listen(this[callback] || callback, this);
	        unsubscriber = function () {
	            var index = subs.indexOf(subscriptionobj);
	            _.throwIf(index === -1, "Tried to remove listen already gone from subscriptions list!");
	            subs.splice(index, 1);
	            desub();
	        };
	        subscriptionobj = {
	            stop: unsubscriber,
	            listenable: listenable
	        };
	        subs.push(subscriptionobj);
	        return subscriptionobj;
	    },
	
	    /**
	     * Stops listening to a single listenable
	     *
	     * @param {Action|Store} listenable The action or store we no longer want to listen to
	     * @returns {Boolean} True if a subscription was found and removed, otherwise false.
	     */
	    stopListeningTo: function stopListeningTo(listenable) {
	        var sub,
	            i = 0,
	            subs = this.subscriptions || [];
	        for (; i < subs.length; i++) {
	            sub = subs[i];
	            if (sub.listenable === listenable) {
	                sub.stop();
	                _.throwIf(subs.indexOf(sub) !== -1, "Failed to remove listen from subscriptions list!");
	                return true;
	            }
	        }
	        return false;
	    },
	
	    /**
	     * Stops all subscriptions and empties subscriptions array
	     */
	    stopListeningToAll: function stopListeningToAll() {
	        var remaining,
	            subs = this.subscriptions || [];
	        while (remaining = subs.length) {
	            subs[0].stop();
	            _.throwIf(subs.length !== remaining - 1, "Failed to remove listen from subscriptions list!");
	        }
	    },
	
	    /**
	     * Used in `listenTo`. Fetches initial data from a publisher if it has a `getInitialState` method.
	     * @param {Action|Store} listenable The publisher we want to get initial state from
	     * @param {Function|String} defaultCallback The method to receive the data
	     */
	    fetchInitialState: function fetchInitialState(listenable, defaultCallback) {
	        defaultCallback = defaultCallback && this[defaultCallback] || defaultCallback;
	        var me = this;
	        if (_.isFunction(defaultCallback) && _.isFunction(listenable.getInitialState)) {
	            var data = listenable.getInitialState();
	            if (data && _.isFunction(data.then)) {
	                data.then(function () {
	                    defaultCallback.apply(me, arguments);
	                });
	            } else {
	                defaultCallback.call(this, data);
	            }
	        }
	    },
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with the last emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinTrailing: maker("last"),
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with the first emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinLeading: maker("first"),
	
	    /**
	     * The callback will be called once all listenables have triggered at least once.
	     * It will be invoked with all emission from each listenable.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinConcat: maker("all"),
	
	    /**
	     * The callback will be called once all listenables have triggered.
	     * If a callback triggers twice before that happens, an error is thrown.
	     * @param {...Publishers} publishers Publishers that should be tracked.
	     * @param {Function|String} callback The method to call when all publishers have emitted
	     * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
	     */
	    joinStrict: maker("strict")
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.capitalize = capitalize;
	exports.callbackName = callbackName;
	exports.isObject = isObject;
	exports.extend = extend;
	exports.isFunction = isFunction;
	exports.object = object;
	exports.isArguments = isArguments;
	exports.throwIf = throwIf;
	
	function capitalize(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	function callbackName(string, prefix) {
	    prefix = prefix || "on";
	    return prefix + exports.capitalize(string);
	}
	
	/*
	 * isObject, extend, isFunction, isArguments are taken from undescore/lodash in
	 * order to remove the dependency
	 */
	
	function isObject(obj) {
	    var type = typeof obj;
	    return type === "function" || type === "object" && !!obj;
	}
	
	function extend(obj) {
	    if (!isObject(obj)) {
	        return obj;
	    }
	    var source, prop;
	    for (var i = 1, length = arguments.length; i < length; i++) {
	        source = arguments[i];
	        for (prop in source) {
	            if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
	                var propertyDescriptor = Object.getOwnPropertyDescriptor(source, prop);
	                Object.defineProperty(obj, prop, propertyDescriptor);
	            } else {
	                obj[prop] = source[prop];
	            }
	        }
	    }
	    return obj;
	}
	
	function isFunction(value) {
	    return typeof value === "function";
	}
	
	exports.EventEmitter = __webpack_require__(178);
	
	exports.nextTick = function (callback) {
	    setTimeout(callback, 0);
	};
	
	function object(keys, vals) {
	    var o = {},
	        i = 0;
	    for (; i < keys.length; i++) {
	        o[keys[i]] = vals[i];
	    }
	    return o;
	}
	
	function isArguments(value) {
	    return typeof value === "object" && "callee" in value && typeof value.length === "number";
	}
	
	function throwIf(val, msg) {
	    if (val) {
	        throw Error(msg || val);
	    }
	}

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	//
	// We store our EE objects in a plain object whose properties are event names.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// `~` to make sure that the built-in object properties are not overridden or
	// used as an attack vector.
	// We also assume that `Object.create(null)` is available when the event name
	// is an ES6 Symbol.
	//
	var prefix = typeof Object.create !== 'function' ? '~' : false;
	
	/**
	 * Representation of a single EventEmitter function.
	 *
	 * @param {Function} fn Event handler to be called.
	 * @param {Mixed} context Context for function execution.
	 * @param {Boolean} [once=false] Only emit once
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal EventEmitter interface that is molded against the Node.js
	 * EventEmitter interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() { /* Nothing to set */ }
	
	/**
	 * Hold the assigned EventEmitters by name.
	 *
	 * @type {Object}
	 * @private
	 */
	EventEmitter.prototype._events = undefined;
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var events = this._events
	    , names = []
	    , name;
	
	  if (!events) return names;
	
	  for (name in events) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return a list of assigned event listeners.
	 *
	 * @param {String} event The events that should be listed.
	 * @param {Boolean} exists We only need to know if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events && this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Emit an event to all registered event listeners.
	 *
	 * @param {String} event The name of the event.
	 * @returns {Boolean} Indication if we've emitted an event.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if ('function' === typeof listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Register a new EventListener for the given event.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Add an EventListener that's only called once.
	 *
	 * @param {String} event Name of the event.
	 * @param {Function} fn Callback function.
	 * @param {Mixed} [context=this] The context of the function.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events) this._events = prefix ? {} : Object.create(null);
	  if (!this._events[evt]) this._events[evt] = listener;
	  else {
	    if (!this._events[evt].fn) this._events[evt].push(listener);
	    else this._events[evt] = [
	      this._events[evt], listener
	    ];
	  }
	
	  return this;
	};
	
	/**
	 * Remove event listeners.
	 *
	 * @param {String} event The event we want to remove.
	 * @param {Function} fn The listener that we need to find.
	 * @param {Mixed} context Only remove listeners matching this context.
	 * @param {Boolean} once Only remove once listeners.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events || !this._events[evt]) return this;
	
	  var listeners = this._events[evt]
	    , events = [];
	
	  if (fn) {
	    if (listeners.fn) {
	      if (
	           listeners.fn !== fn
	        || (once && !listeners.once)
	        || (context && listeners.context !== context)
	      ) {
	        events.push(listeners);
	      }
	    } else {
	      for (var i = 0, length = listeners.length; i < length; i++) {
	        if (
	             listeners[i].fn !== fn
	          || (once && !listeners[i].once)
	          || (context && listeners[i].context !== context)
	        ) {
	          events.push(listeners[i]);
	        }
	      }
	    }
	  }
	
	  //
	  // Reset the array, or remove it completely if we have no more listeners.
	  //
	  if (events.length) {
	    this._events[evt] = events.length === 1 ? events[0] : events;
	  } else {
	    delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners or only the listeners for the specified event.
	 *
	 * @param {String} event The event want to remove all listeners for.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  if (!this._events) return this;
	
	  if (event) delete this._events[prefix ? prefix + event : event];
	  else this._events = prefix ? {} : Object.create(null);
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Internal module used to create static and instance join methods
	 */
	
	"use strict";
	
	var createStore = __webpack_require__(180),
	    _ = __webpack_require__(177);
	
	var slice = Array.prototype.slice,
	    strategyMethodNames = {
	    strict: "joinStrict",
	    first: "joinLeading",
	    last: "joinTrailing",
	    all: "joinConcat"
	};
	
	/**
	 * Used in `index.js` to create the static join methods
	 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
	 * @returns {Function} A static function which returns a store with a join listen on the given listenables using the given strategy
	 */
	exports.staticJoinCreator = function (strategy) {
	    return function () /* listenables... */{
	        var listenables = slice.call(arguments);
	        return createStore({
	            init: function init() {
	                this[strategyMethodNames[strategy]].apply(this, listenables.concat("triggerAsync"));
	            }
	        });
	    };
	};
	
	/**
	 * Used in `ListenerMethods.js` to create the instance join methods
	 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
	 * @returns {Function} An instance method which sets up a join listen on the given listenables using the given strategy
	 */
	exports.instanceJoinCreator = function (strategy) {
	    return function () /* listenables..., callback*/{
	        _.throwIf(arguments.length < 2, "Cannot create a join with less than 2 listenables!");
	        var listenables = slice.call(arguments),
	            callback = listenables.pop(),
	            numberOfListenables = listenables.length,
	            join = {
	            numberOfListenables: numberOfListenables,
	            callback: this[callback] || callback,
	            listener: this,
	            strategy: strategy
	        },
	            i,
	            cancels = [],
	            subobj;
	        for (i = 0; i < numberOfListenables; i++) {
	            _.throwIf(this.validateListening(listenables[i]));
	        }
	        for (i = 0; i < numberOfListenables; i++) {
	            cancels.push(listenables[i].listen(newListener(i, join), this));
	        }
	        reset(join);
	        subobj = { listenable: listenables };
	        subobj.stop = makeStopper(subobj, cancels, this);
	        this.subscriptions = (this.subscriptions || []).concat(subobj);
	        return subobj;
	    };
	};
	
	// ---- internal join functions ----
	
	function makeStopper(subobj, cancels, context) {
	    return function () {
	        var i,
	            subs = context.subscriptions,
	            index = subs ? subs.indexOf(subobj) : -1;
	        _.throwIf(index === -1, "Tried to remove join already gone from subscriptions list!");
	        for (i = 0; i < cancels.length; i++) {
	            cancels[i]();
	        }
	        subs.splice(index, 1);
	    };
	}
	
	function reset(join) {
	    join.listenablesEmitted = new Array(join.numberOfListenables);
	    join.args = new Array(join.numberOfListenables);
	}
	
	function newListener(i, join) {
	    return function () {
	        var callargs = slice.call(arguments);
	        if (join.listenablesEmitted[i]) {
	            switch (join.strategy) {
	                case "strict":
	                    throw new Error("Strict join failed because listener triggered twice.");
	                case "last":
	                    join.args[i] = callargs;break;
	                case "all":
	                    join.args[i].push(callargs);
	            }
	        } else {
	            join.listenablesEmitted[i] = true;
	            join.args[i] = join.strategy === "all" ? [callargs] : callargs;
	        }
	        emitIfAllListenablesEmitted(join);
	    };
	}
	
	function emitIfAllListenablesEmitted(join) {
	    for (var i = 0; i < join.numberOfListenables; i++) {
	        if (!join.listenablesEmitted[i]) {
	            return;
	        }
	    }
	    join.callback.apply(join.listener, join.args);
	    reset(join);
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(177),
	    Keep = __webpack_require__(181),
	    mixer = __webpack_require__(182),
	    bindMethods = __webpack_require__(183);
	
	var allowed = { preEmit: 1, shouldEmit: 1 };
	
	/**
	 * Creates an event emitting Data Store. It is mixed in with functions
	 * from the `ListenerMethods` and `PublisherMethods` mixins. `preEmit`
	 * and `shouldEmit` may be overridden in the definition object.
	 *
	 * @param {Object} definition The data store object definition
	 * @returns {Store} A data store instance
	 */
	module.exports = function (definition) {
	
	    var StoreMethods = __webpack_require__(184),
	        PublisherMethods = __webpack_require__(185),
	        ListenerMethods = __webpack_require__(176);
	
	    definition = definition || {};
	
	    for (var a in StoreMethods) {
	        if (!allowed[a] && (PublisherMethods[a] || ListenerMethods[a])) {
	            throw new Error("Cannot override API method " + a + " in Reflux.StoreMethods. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead.");
	        }
	    }
	
	    for (var d in definition) {
	        if (!allowed[d] && (PublisherMethods[d] || ListenerMethods[d])) {
	            throw new Error("Cannot override API method " + d + " in store creation. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead.");
	        }
	    }
	
	    definition = mixer(definition);
	
	    function Store() {
	        var i = 0,
	            arr;
	        this.subscriptions = [];
	        this.emitter = new _.EventEmitter();
	        this.eventLabel = "change";
	        bindMethods(this, definition);
	        if (this.init && _.isFunction(this.init)) {
	            this.init();
	        }
	        if (this.listenables) {
	            arr = [].concat(this.listenables);
	            for (; i < arr.length; i++) {
	                this.listenToMany(arr[i]);
	            }
	        }
	    }
	
	    _.extend(Store.prototype, ListenerMethods, PublisherMethods, StoreMethods, definition);
	
	    var store = new Store();
	    Keep.createdStores.push(store);
	
	    return store;
	};

/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	
	exports.createdStores = [];
	
	exports.createdActions = [];
	
	exports.reset = function () {
	    while (exports.createdStores.length) {
	        exports.createdStores.pop();
	    }
	    while (exports.createdActions.length) {
	        exports.createdActions.pop();
	    }
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(177);
	
	module.exports = function mix(def) {
	    var composed = {
	        init: [],
	        preEmit: [],
	        shouldEmit: []
	    };
	
	    var updated = (function mixDef(mixin) {
	        var mixed = {};
	        if (mixin.mixins) {
	            mixin.mixins.forEach(function (subMixin) {
	                _.extend(mixed, mixDef(subMixin));
	            });
	        }
	        _.extend(mixed, mixin);
	        Object.keys(composed).forEach(function (composable) {
	            if (mixin.hasOwnProperty(composable)) {
	                composed[composable].push(mixin[composable]);
	            }
	        });
	        return mixed;
	    })(def);
	
	    if (composed.init.length > 1) {
	        updated.init = function () {
	            var args = arguments;
	            composed.init.forEach(function (init) {
	                init.apply(this, args);
	            }, this);
	        };
	    }
	    if (composed.preEmit.length > 1) {
	        updated.preEmit = function () {
	            return composed.preEmit.reduce((function (args, preEmit) {
	                var newValue = preEmit.apply(this, args);
	                return newValue === undefined ? args : [newValue];
	            }).bind(this), arguments);
	        };
	    }
	    if (composed.shouldEmit.length > 1) {
	        updated.shouldEmit = function () {
	            var args = arguments;
	            return !composed.shouldEmit.some(function (shouldEmit) {
	                return !shouldEmit.apply(this, args);
	            }, this);
	        };
	    }
	    Object.keys(composed).forEach(function (composable) {
	        if (composed[composable].length === 1) {
	            updated[composable] = composed[composable][0];
	        }
	    });
	
	    return updated;
	};

/***/ },
/* 183 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (store, definition) {
	    for (var name in definition) {
	        if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
	            var propertyDescriptor = Object.getOwnPropertyDescriptor(definition, name);
	
	            if (!propertyDescriptor.value || typeof propertyDescriptor.value !== "function" || !definition.hasOwnProperty(name)) {
	                continue;
	            }
	
	            store[name] = definition[name].bind(store);
	        } else {
	            var property = definition[name];
	
	            if (typeof property !== "function" || !definition.hasOwnProperty(name)) {
	                continue;
	            }
	
	            store[name] = property.bind(store);
	        }
	    }
	
	    return store;
	};

/***/ },
/* 184 */
/***/ function(module, exports) {

	/**
	 * A module of methods that you want to include in all stores.
	 * This module is consumed by `createStore`.
	 */
	"use strict";
	
	module.exports = {};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(177);
	
	/**
	 * A module of methods for object that you want to be able to listen to.
	 * This module is consumed by `createStore` and `createAction`
	 */
	module.exports = {
	
	    /**
	     * Hook used by the publisher that is invoked before emitting
	     * and before `shouldEmit`. The arguments are the ones that the action
	     * is invoked with. If this function returns something other than
	     * undefined, that will be passed on as arguments for shouldEmit and
	     * emission.
	     */
	    preEmit: function preEmit() {},
	
	    /**
	     * Hook used by the publisher after `preEmit` to determine if the
	     * event should be emitted with given arguments. This may be overridden
	     * in your application, default implementation always returns true.
	     *
	     * @returns {Boolean} true if event should be emitted
	     */
	    shouldEmit: function shouldEmit() {
	        return true;
	    },
	
	    /**
	     * Subscribes the given callback for action triggered
	     *
	     * @param {Function} callback The callback to register as event handler
	     * @param {Mixed} [optional] bindContext The context to bind the callback with
	     * @returns {Function} Callback that unsubscribes the registered event handler
	     */
	    listen: function listen(callback, bindContext) {
	        bindContext = bindContext || this;
	        var eventHandler = function eventHandler(args) {
	            if (aborted) {
	                return;
	            }
	            callback.apply(bindContext, args);
	        },
	            me = this,
	            aborted = false;
	        this.emitter.addListener(this.eventLabel, eventHandler);
	        return function () {
	            aborted = true;
	            me.emitter.removeListener(me.eventLabel, eventHandler);
	        };
	    },
	
	    /**
	     * Publishes an event using `this.emitter` (if `shouldEmit` agrees)
	     */
	    trigger: function trigger() {
	        var args = arguments,
	            pre = this.preEmit.apply(this, args);
	        args = pre === undefined ? args : _.isArguments(pre) ? pre : [].concat(pre);
	        if (this.shouldEmit.apply(this, args)) {
	            this.emitter.emit(this.eventLabel, args);
	        }
	    },
	
	    /**
	     * Tries to publish the event on the next tick
	     */
	    triggerAsync: function triggerAsync() {
	        var args = arguments,
	            me = this;
	        _.nextTick(function () {
	            me.trigger.apply(me, args);
	        });
	    },
	
	    /**
	     * Wraps the trigger mechanism with a deferral function.
	     *
	     * @param {Function} callback the deferral function,
	     *        first argument is the resolving function and the
	     *        rest are the arguments provided from the previous
	     *        trigger invocation
	     */
	    deferWith: function deferWith(callback) {
	        var oldTrigger = this.trigger,
	            ctx = this,
	            resolver = function resolver() {
	            oldTrigger.apply(ctx, arguments);
	        };
	        this.trigger = function () {
	            callback.apply(ctx, [resolver].concat([].splice.call(arguments, 0)));
	        };
	    }
	
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(177),
	    ActionMethods = __webpack_require__(175),
	    PublisherMethods = __webpack_require__(185),
	    Keep = __webpack_require__(181);
	
	var allowed = { preEmit: 1, shouldEmit: 1 };
	
	/**
	 * Creates an action functor object. It is mixed in with functions
	 * from the `PublisherMethods` mixin. `preEmit` and `shouldEmit` may
	 * be overridden in the definition object.
	 *
	 * @param {Object} definition The action object definition
	 */
	var createAction = function createAction(definition) {
	
	    definition = definition || {};
	    if (!_.isObject(definition)) {
	        definition = { actionName: definition };
	    }
	
	    for (var a in ActionMethods) {
	        if (!allowed[a] && PublisherMethods[a]) {
	            throw new Error("Cannot override API method " + a + " in Reflux.ActionMethods. Use another method name or override it on Reflux.PublisherMethods instead.");
	        }
	    }
	
	    for (var d in definition) {
	        if (!allowed[d] && PublisherMethods[d]) {
	            throw new Error("Cannot override API method " + d + " in action creation. Use another method name or override it on Reflux.PublisherMethods instead.");
	        }
	    }
	
	    definition.children = definition.children || [];
	    if (definition.asyncResult) {
	        definition.children = definition.children.concat(["completed", "failed"]);
	    }
	
	    var i = 0,
	        childActions = {};
	    for (; i < definition.children.length; i++) {
	        var name = definition.children[i];
	        childActions[name] = createAction(name);
	    }
	
	    var context = _.extend({
	        eventLabel: "action",
	        emitter: new _.EventEmitter(),
	        _isAction: true
	    }, PublisherMethods, ActionMethods, definition);
	
	    var functor = function functor() {
	        var triggerType = functor.sync ? "trigger" : "triggerAsync";
	        return functor[triggerType].apply(functor, arguments);
	    };
	
	    _.extend(functor, childActions, context);
	
	    Keep.createdActions.push(functor);
	
	    return functor;
	};
	
	module.exports = createAction;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var ListenerMethods = __webpack_require__(176),
	    ListenerMixin = __webpack_require__(188),
	    _ = __webpack_require__(177);
	
	module.exports = function(listenable,key){
	    return {
	        getInitialState: function(){
	            if (!_.isFunction(listenable.getInitialState)) {
	                return {};
	            } else if (key === undefined) {
	                return listenable.getInitialState();
	            } else {
	                return _.object([key],[listenable.getInitialState()]);
	            }
	        },
	        componentDidMount: function(){
	            _.extend(this,ListenerMethods);
	            var me = this, cb = (key === undefined ? this.setState : function(v){
	                if (typeof me.isMounted === "undefined" || me.isMounted() === true) {
	                    me.setState(_.object([key],[v]));
	                }
	            });
	            this.listenTo(listenable,cb);
	        },
	        componentWillUnmount: ListenerMixin.componentWillUnmount
	    };
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(177),
	    ListenerMethods = __webpack_require__(176);
	
	/**
	 * A module meant to be consumed as a mixin by a React component. Supplies the methods from
	 * `ListenerMethods` mixin and takes care of teardown of subscriptions.
	 * Note that if you're using the `connect` mixin you don't need this mixin, as connect will
	 * import everything this mixin contains!
	 */
	module.exports = _.extend({
	
	    /**
	     * Cleans up all listener previously registered.
	     */
	    componentWillUnmount: ListenerMethods.stopListeningToAll
	
	}, ListenerMethods);


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var ListenerMethods = __webpack_require__(176),
	    ListenerMixin = __webpack_require__(188),
	    _ = __webpack_require__(177);
	
	module.exports = function(listenable, key, filterFunc) {
	    filterFunc = _.isFunction(key) ? key : filterFunc;
	    return {
	        getInitialState: function() {
	            if (!_.isFunction(listenable.getInitialState)) {
	                return {};
	            } else if (_.isFunction(key)) {
	                return filterFunc.call(this, listenable.getInitialState());
	            } else {
	                // Filter initial payload from store.
	                var result = filterFunc.call(this, listenable.getInitialState());
	                if (typeof(result) !== "undefined") {
	                    return _.object([key], [result]);
	                } else {
	                    return {};
	                }
	            }
	        },
	        componentDidMount: function() {
	            _.extend(this, ListenerMethods);
	            var me = this;
	            var cb = function(value) {
	                if (_.isFunction(key)) {
	                    me.setState(filterFunc.call(me, value));
	                } else {
	                    var result = filterFunc.call(me, value);
	                    me.setState(_.object([key], [result]));
	                }
	            };
	
	            this.listenTo(listenable, cb);
	        },
	        componentWillUnmount: ListenerMixin.componentWillUnmount
	    };
	};
	


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var ListenerMethods = __webpack_require__(176);
	
	/**
	 * A mixin factory for a React component. Meant as a more convenient way of using the `ListenerMixin`,
	 * without having to manually set listeners in the `componentDidMount` method.
	 *
	 * @param {Action|Store} listenable An Action or Store that should be
	 *  listened to.
	 * @param {Function|String} callback The callback to register as event handler
	 * @param {Function|String} defaultCallback The callback to register as default handler
	 * @returns {Object} An object to be used as a mixin, which sets up the listener for the given listenable.
	 */
	module.exports = function(listenable,callback,initial){
	    return {
	        /**
	         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
	         * and then make the call to `listenTo` with the arguments provided to the factory function
	         */
	        componentDidMount: function() {
	            for(var m in ListenerMethods){
	                if (this[m] !== ListenerMethods[m]){
	                    if (this[m]){
	                        throw "Can't have other property '"+m+"' when using Reflux.listenTo!";
	                    }
	                    this[m] = ListenerMethods[m];
	                }
	            }
	            this.listenTo(listenable,callback,initial);
	        },
	        /**
	         * Cleans up all listener previously registered.
	         */
	        componentWillUnmount: ListenerMethods.stopListeningToAll
	    };
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var ListenerMethods = __webpack_require__(176);
	
	/**
	 * A mixin factory for a React component. Meant as a more convenient way of using the `listenerMixin`,
	 * without having to manually set listeners in the `componentDidMount` method. This version is used
	 * to automatically set up a `listenToMany` call.
	 *
	 * @param {Object} listenables An object of listenables
	 * @returns {Object} An object to be used as a mixin, which sets up the listeners for the given listenables.
	 */
	module.exports = function(listenables){
	    return {
	        /**
	         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
	         * and then make the call to `listenTo` with the arguments provided to the factory function
	         */
	        componentDidMount: function() {
	            for(var m in ListenerMethods){
	                if (this[m] !== ListenerMethods[m]){
	                    if (this[m]){
	                        throw "Can't have other property '"+m+"' when using Reflux.listenToMany!";
	                    }
	                    this[m] = ListenerMethods[m];
	                }
	            }
	            this.listenToMany(listenables);
	        },
	        /**
	         * Cleans up all listener previously registered.
	         */
	        componentWillUnmount: ListenerMethods.stopListeningToAll
	    };
	};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
	 * @license MIT */
	
	;(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.NProgress = factory();
	  }
	
	})(this, function() {
	  var NProgress = {};
	
	  NProgress.version = '0.2.0';
	
	  var Settings = NProgress.settings = {
	    minimum: 0.08,
	    easing: 'ease',
	    positionUsing: '',
	    speed: 200,
	    trickle: true,
	    trickleRate: 0.02,
	    trickleSpeed: 800,
	    showSpinner: true,
	    barSelector: '[role="bar"]',
	    spinnerSelector: '[role="spinner"]',
	    parent: 'body',
	    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
	  };
	
	  /**
	   * Updates configuration.
	   *
	   *     NProgress.configure({
	   *       minimum: 0.1
	   *     });
	   */
	  NProgress.configure = function(options) {
	    var key, value;
	    for (key in options) {
	      value = options[key];
	      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
	    }
	
	    return this;
	  };
	
	  /**
	   * Last number.
	   */
	
	  NProgress.status = null;
	
	  /**
	   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
	   *
	   *     NProgress.set(0.4);
	   *     NProgress.set(1.0);
	   */
	
	  NProgress.set = function(n) {
	    var started = NProgress.isStarted();
	
	    n = clamp(n, Settings.minimum, 1);
	    NProgress.status = (n === 1 ? null : n);
	
	    var progress = NProgress.render(!started),
	        bar      = progress.querySelector(Settings.barSelector),
	        speed    = Settings.speed,
	        ease     = Settings.easing;
	
	    progress.offsetWidth; /* Repaint */
	
	    queue(function(next) {
	      // Set positionUsing if it hasn't already been set
	      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
	
	      // Add transition
	      css(bar, barPositionCSS(n, speed, ease));
	
	      if (n === 1) {
	        // Fade out
	        css(progress, { 
	          transition: 'none', 
	          opacity: 1 
	        });
	        progress.offsetWidth; /* Repaint */
	
	        setTimeout(function() {
	          css(progress, { 
	            transition: 'all ' + speed + 'ms linear', 
	            opacity: 0 
	          });
	          setTimeout(function() {
	            NProgress.remove();
	            next();
	          }, speed);
	        }, speed);
	      } else {
	        setTimeout(next, speed);
	      }
	    });
	
	    return this;
	  };
	
	  NProgress.isStarted = function() {
	    return typeof NProgress.status === 'number';
	  };
	
	  /**
	   * Shows the progress bar.
	   * This is the same as setting the status to 0%, except that it doesn't go backwards.
	   *
	   *     NProgress.start();
	   *
	   */
	  NProgress.start = function() {
	    if (!NProgress.status) NProgress.set(0);
	
	    var work = function() {
	      setTimeout(function() {
	        if (!NProgress.status) return;
	        NProgress.trickle();
	        work();
	      }, Settings.trickleSpeed);
	    };
	
	    if (Settings.trickle) work();
	
	    return this;
	  };
	
	  /**
	   * Hides the progress bar.
	   * This is the *sort of* the same as setting the status to 100%, with the
	   * difference being `done()` makes some placebo effect of some realistic motion.
	   *
	   *     NProgress.done();
	   *
	   * If `true` is passed, it will show the progress bar even if its hidden.
	   *
	   *     NProgress.done(true);
	   */
	
	  NProgress.done = function(force) {
	    if (!force && !NProgress.status) return this;
	
	    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
	  };
	
	  /**
	   * Increments by a random amount.
	   */
	
	  NProgress.inc = function(amount) {
	    var n = NProgress.status;
	
	    if (!n) {
	      return NProgress.start();
	    } else {
	      if (typeof amount !== 'number') {
	        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
	      }
	
	      n = clamp(n + amount, 0, 0.994);
	      return NProgress.set(n);
	    }
	  };
	
	  NProgress.trickle = function() {
	    return NProgress.inc(Math.random() * Settings.trickleRate);
	  };
	
	  /**
	   * Waits for all supplied jQuery promises and
	   * increases the progress as the promises resolve.
	   *
	   * @param $promise jQUery Promise
	   */
	  (function() {
	    var initial = 0, current = 0;
	
	    NProgress.promise = function($promise) {
	      if (!$promise || $promise.state() === "resolved") {
	        return this;
	      }
	
	      if (current === 0) {
	        NProgress.start();
	      }
	
	      initial++;
	      current++;
	
	      $promise.always(function() {
	        current--;
	        if (current === 0) {
	            initial = 0;
	            NProgress.done();
	        } else {
	            NProgress.set((initial - current) / initial);
	        }
	      });
	
	      return this;
	    };
	
	  })();
	
	  /**
	   * (Internal) renders the progress bar markup based on the `template`
	   * setting.
	   */
	
	  NProgress.render = function(fromStart) {
	    if (NProgress.isRendered()) return document.getElementById('nprogress');
	
	    addClass(document.documentElement, 'nprogress-busy');
	    
	    var progress = document.createElement('div');
	    progress.id = 'nprogress';
	    progress.innerHTML = Settings.template;
	
	    var bar      = progress.querySelector(Settings.barSelector),
	        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
	        parent   = document.querySelector(Settings.parent),
	        spinner;
	    
	    css(bar, {
	      transition: 'all 0 linear',
	      transform: 'translate3d(' + perc + '%,0,0)'
	    });
	
	    if (!Settings.showSpinner) {
	      spinner = progress.querySelector(Settings.spinnerSelector);
	      spinner && removeElement(spinner);
	    }
	
	    if (parent != document.body) {
	      addClass(parent, 'nprogress-custom-parent');
	    }
	
	    parent.appendChild(progress);
	    return progress;
	  };
	
	  /**
	   * Removes the element. Opposite of render().
	   */
	
	  NProgress.remove = function() {
	    removeClass(document.documentElement, 'nprogress-busy');
	    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
	    var progress = document.getElementById('nprogress');
	    progress && removeElement(progress);
	  };
	
	  /**
	   * Checks if the progress bar is rendered.
	   */
	
	  NProgress.isRendered = function() {
	    return !!document.getElementById('nprogress');
	  };
	
	  /**
	   * Determine which positioning CSS rule to use.
	   */
	
	  NProgress.getPositioningCSS = function() {
	    // Sniff on document.body.style
	    var bodyStyle = document.body.style;
	
	    // Sniff prefixes
	    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
	                       ('MozTransform' in bodyStyle) ? 'Moz' :
	                       ('msTransform' in bodyStyle) ? 'ms' :
	                       ('OTransform' in bodyStyle) ? 'O' : '';
	
	    if (vendorPrefix + 'Perspective' in bodyStyle) {
	      // Modern browsers with 3D support, e.g. Webkit, IE10
	      return 'translate3d';
	    } else if (vendorPrefix + 'Transform' in bodyStyle) {
	      // Browsers without 3D support, e.g. IE9
	      return 'translate';
	    } else {
	      // Browsers without translate() support, e.g. IE7-8
	      return 'margin';
	    }
	  };
	
	  /**
	   * Helpers
	   */
	
	  function clamp(n, min, max) {
	    if (n < min) return min;
	    if (n > max) return max;
	    return n;
	  }
	
	  /**
	   * (Internal) converts a percentage (`0..1`) to a bar translateX
	   * percentage (`-100%..0%`).
	   */
	
	  function toBarPerc(n) {
	    return (-1 + n) * 100;
	  }
	
	
	  /**
	   * (Internal) returns the correct CSS for changing the bar's
	   * position given an n percentage, and speed and ease from Settings
	   */
	
	  function barPositionCSS(n, speed, ease) {
	    var barCSS;
	
	    if (Settings.positionUsing === 'translate3d') {
	      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
	    } else if (Settings.positionUsing === 'translate') {
	      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
	    } else {
	      barCSS = { 'margin-left': toBarPerc(n)+'%' };
	    }
	
	    barCSS.transition = 'all '+speed+'ms '+ease;
	
	    return barCSS;
	  }
	
	  /**
	   * (Internal) Queues a function to be executed.
	   */
	
	  var queue = (function() {
	    var pending = [];
	    
	    function next() {
	      var fn = pending.shift();
	      if (fn) {
	        fn(next);
	      }
	    }
	
	    return function(fn) {
	      pending.push(fn);
	      if (pending.length == 1) next();
	    };
	  })();
	
	  /**
	   * (Internal) Applies css properties to an element, similar to the jQuery 
	   * css method.
	   *
	   * While this helper does assist with vendor prefixed property names, it 
	   * does not perform any manipulation of values prior to setting styles.
	   */
	
	  var css = (function() {
	    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
	        cssProps    = {};
	
	    function camelCase(string) {
	      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
	        return letter.toUpperCase();
	      });
	    }
	
	    function getVendorProp(name) {
	      var style = document.body.style;
	      if (name in style) return name;
	
	      var i = cssPrefixes.length,
	          capName = name.charAt(0).toUpperCase() + name.slice(1),
	          vendorName;
	      while (i--) {
	        vendorName = cssPrefixes[i] + capName;
	        if (vendorName in style) return vendorName;
	      }
	
	      return name;
	    }
	
	    function getStyleProp(name) {
	      name = camelCase(name);
	      return cssProps[name] || (cssProps[name] = getVendorProp(name));
	    }
	
	    function applyCss(element, prop, value) {
	      prop = getStyleProp(prop);
	      element.style[prop] = value;
	    }
	
	    return function(element, properties) {
	      var args = arguments,
	          prop, 
	          value;
	
	      if (args.length == 2) {
	        for (prop in properties) {
	          value = properties[prop];
	          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
	        }
	      } else {
	        applyCss(element, args[1], args[2]);
	      }
	    }
	  })();
	
	  /**
	   * (Internal) Determines if an element or space separated list of class names contains a class name.
	   */
	
	  function hasClass(element, name) {
	    var list = typeof element == 'string' ? element : classList(element);
	    return list.indexOf(' ' + name + ' ') >= 0;
	  }
	
	  /**
	   * (Internal) Adds a class to an element.
	   */
	
	  function addClass(element, name) {
	    var oldList = classList(element),
	        newList = oldList + name;
	
	    if (hasClass(oldList, name)) return; 
	
	    // Trim the opening space.
	    element.className = newList.substring(1);
	  }
	
	  /**
	   * (Internal) Removes a class from an element.
	   */
	
	  function removeClass(element, name) {
	    var oldList = classList(element),
	        newList;
	
	    if (!hasClass(element, name)) return;
	
	    // Replace the class name.
	    newList = oldList.replace(' ' + name + ' ', ' ');
	
	    // Trim the opening and closing spaces.
	    element.className = newList.substring(1, newList.length - 1);
	  }
	
	  /**
	   * (Internal) Gets a space separated list of the class names on the element. 
	   * The list is wrapped with a single space on each end to facilitate finding 
	   * matches within the list.
	   */
	
	  function classList(element) {
	    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
	  }
	
	  /**
	   * (Internal) Removes an element from the DOM.
	   */
	
	  function removeElement(element) {
	    element && element.parentNode && element.parentNode.removeChild(element);
	  }
	
	  return NProgress;
	});
	


/***/ },
/* 193 */,
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(195);
	var reduce = __webpack_require__(196);
	var requestBase = __webpack_require__(197);
	var isObject = __webpack_require__(198);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Expose `request`.
	 */
	
	var request = module.exports = __webpack_require__(199).bind(null, Request);
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter` and `requestBase`.
	 */
	
	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr && this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }
	
	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * @deprecated
	 */
	Response.prototype.parse = function serialize(fn){
	  if (root.console) {
	    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
	  }
	  this.serialize(fn);
	  return this;
	};
	
	Response.prototype.serialize = function serialize(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 196 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(198);
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */
	
	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	exports.then = function then(fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Allow for extension
	 */
	
	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}
	
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	exports.getHeader = exports.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};


/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null != obj && 'object' == typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 199 */
/***/ function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }
	
	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }
	
	  return new RequestConstructor(method, url);
	}
	
	module.exports = request;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201).Buffer))

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(202)
	var ieee754 = __webpack_require__(203)
	var isArray = __webpack_require__(204)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(201).Buffer, (function() { return this; }())))

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 203 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 204 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addblock = __webpack_require__(473);
	
	var _addblock2 = _interopRequireDefault(_addblock);
	
	var _builderStore = __webpack_require__(556);
	
	var _builderStore2 = _interopRequireDefault(_builderStore);
	
	var _showBuilderPreview = __webpack_require__(557);
	
	var _showBuilderPreview2 = _interopRequireDefault(_showBuilderPreview);
	
	var _gridStore = __webpack_require__(498);
	
	var _gridStore2 = _interopRequireDefault(_gridStore);
	
	var _settingStore = __webpack_require__(848);
	
	var _settingStore2 = _interopRequireDefault(_settingStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function () {
	  var ReactiveBuilder = function (_React$Component) {
	    _inherits(ReactiveBuilder, _React$Component);
	
	    function ReactiveBuilder(props) {
	      _classCallCheck(this, ReactiveBuilder);
	
	      var _this = _possibleConstructorReturn(this, (ReactiveBuilder.__proto__ || Object.getPrototypeOf(ReactiveBuilder)).call(this, props));
	
	      _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	      window.mkey = _this.metakey;
	      var dummy = void 0;
	      if (REBUILDER.hasOwnProperty(_this.metakey)) {
	        dummy = {
	          Reactive: REBUILDER[_this.metakey].hasOwnProperty('layoutData') ? REBUILDER[_this.metakey].layoutData : [],
	          Preview: REBUILDER[_this.metakey].hasOwnProperty('previewData') ? REBUILDER[_this.metakey].previewData : [],
	          Helper: REBUILDER[_this.metakey].hasOwnProperty('helperData') ? REBUILDER[_this.metakey].helperData : [],
	          Settings: REBUILDER[_this.metakey].hasOwnProperty('settingsData') ? REBUILDER[_this.metakey].settingsData : {}
	        };
	      }
	      _this.state = _extends({}, dummy, {
	        isEditable: API.isEditable ? true : false
	      });
	      _this.storeAddLayout = _this.storeAddLayout.bind(_this);
	      _this.storeSettings = _this.storeSettings.bind(_this);
	      _this.switchAdmin = _this.switchAdmin.bind(_this);
	      _this.isEditable = API.isEditable ? true : false;
	      return _this;
	    }
	
	    _createClass(ReactiveBuilder, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        _builderStore2.default.listen(this.storeAddLayout);
	        _gridStore2.default.listen(this.storeAddLayout);
	        _settingStore2.default.listen(this.storeSettings);
	      }
	    }, {
	      key: 'switchAdmin',
	      value: function switchAdmin(e) {
	        e.preventDefault();
	        // console.log('called');
	        var flag = this.state.isEditable;
	        this.setState({ isEditable: !flag });
	      }
	    }, {
	      key: 'storeSettings',
	      value: function storeSettings(settings) {
	        if (settings.hasOwnProperty(this.props.shortcodeKey)) {
	          if ('settingsData' in settings[this.props.shortcodeKey]) {
	            this.setState({
	              Helper: settings[this.props.shortcodeKey].helperData,
	              Settings: settings[this.props.shortcodeKey].settingsData,
	              Preview: settings[this.props.shortcodeKey].previewData
	            });
	          }
	        }
	      }
	    }, {
	      key: 'storeAddLayout',
	      value: function storeAddLayout(layout) {
	        if (layout.hasOwnProperty(this.props.shortcodeKey)) {
	          if ('layoutData' in layout[this.props.shortcodeKey]) {
	            this.setState({
	              Reactive: layout[this.props.shortcodeKey].layoutData,
	              Preview: layout[this.props.shortcodeKey].previewData,
	              Helper: layout[this.props.shortcodeKey].helperData
	            });
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        ReactiveFanoutData.helperData = this.state.Helper;
	        return _react2.default.createElement(
	          'div',
	          null,
	          this.isEditable ? _react2.default.createElement(
	            'a',
	            { className: 'rq-switch-link', href: '#', onClick: this.switchAdmin },
	            _react2.default.createElement(
	              'span',
	              null,
	              API.LANG.REACTIVE_PREVIEW_BUTTON
	            )
	          ) : null,
	          _react2.default.createElement(_addblock2.default, _extends({}, this.props, { isEditable: this.state.isEditable, allLayout: this.state.Reactive, helperData: this.state.Helper, settingsData: this.state.Settings })),
	          this.state.Reactive.length ? _react2.default.createElement(_showBuilderPreview2.default, _extends({}, this.props, {
	            allLayout: this.state.Reactive,
	            helperData: this.state.Helper,
	            previewData: this.state.Preview,
	            settingsData: this.state.Settings,
	            isEditable: this.state.isEditable
	          })) : null
	        );
	      }
	    }]);
	
	    return ReactiveBuilder;
	  }(_react2.default.Component);
	
	  ReactiveBuilder.propTypes = {
	    'shortcodeKey': _react2.default.PropTypes.number,
	    'prevLayout': _react2.default.PropTypes.array
	  };
	
	  var allBuilder = jQuery('.reactive-gsb');
	  if (allBuilder) {
	    window.openWindow = {};
	    jQuery(allBuilder).each(function (index, builder) {
	      var key = jQuery(builder).data('key');
	      var panel = 'panel_' + key;
	      window.openWindow[panel] = false;
	      if (key) {
	        _reactDom2.default.render(_react2.default.createElement(ReactiveBuilder, { shortcodeKey: key }), builder);
	      }
	    });
	  }
	};

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _editPanel = __webpack_require__(474);
	
	var _editPanel2 = _interopRequireDefault(_editPanel);
	
	var _addPanel = __webpack_require__(477);
	
	var _addPanel2 = _interopRequireDefault(_addPanel);
	
	var _searchPanel = __webpack_require__(502);
	
	var _searchPanel2 = _interopRequireDefault(_searchPanel);
	
	var _advancedsearchpanel = __webpack_require__(522);
	
	var _advancedsearchpanel2 = _interopRequireDefault(_advancedsearchpanel);
	
	var _togglePanelStore = __webpack_require__(530);
	
	var _togglePanelStore2 = _interopRequireDefault(_togglePanelStore);
	
	var _reactModal = __webpack_require__(531);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _appearPanel = __webpack_require__(551);
	
	var _appearPanel2 = _interopRequireDefault(_appearPanel);
	
	var _viewPagerPanel = __webpack_require__(554);
	
	var _viewPagerPanel2 = _interopRequireDefault(_viewPagerPanel);
	
	var _welcomeBlock = __webpack_require__(555);
	
	var _welcomeBlock2 = _interopRequireDefault(_welcomeBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var AddBlock = function (_React$Component) {
	  _inherits(AddBlock, _React$Component);
	
	  function AddBlock(props) {
	    _classCallCheck(this, AddBlock);
	
	    var _this = _possibleConstructorReturn(this, (AddBlock.__proto__ || Object.getPrototypeOf(AddBlock)).call(this, props));
	
	    _this.isEditable = API.isEditable ? true : false;
	    _this.state = {
	      isOpen: false,
	      panelType: 'addblock',
	      editUid: null,
	      childUid: null,
	      successShow: false,
	      welcomeShow: true
	    };
	    _this.reactiveSiteTour = 'false';
	    _this.handleAddComponent = _this.handleAddComponent.bind(_this);
	    _this.handleToggleEditPanel = _this.handleToggleEditPanel.bind(_this);
	    _this.handleApperance = _this.handleApperance.bind(_this);
	    _this.handleViewPager = _this.handleViewPager.bind(_this);
	    _this.loadProps = _this.loadProps.bind(_this);
	    _this.handleReactiveSiteTour = _this.handleReactiveSiteTour.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    _togglePanelStore2.default.listen(_this.handleToggleEditPanel);
	    return _this;
	  }
	
	  _createClass(AddBlock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (localStorage.getItem('reactiveSiteTour')) {
	        this.reactiveSiteTour = localStorage.getItem('reactiveSiteTour');
	      } else {
	        localStorage.setItem('reactiveSiteTour', 'false');
	      }
	      if (this.reactiveSiteTour === 'false' && this.state.isEditable) {
	        this.handleReactiveSiteTour();
	      }
	      this.loadProps(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.loadProps(nextProps);
	    }
	  }, {
	    key: 'loadProps',
	    value: function loadProps(props) {
	      var welcomeShow = null;
	      if (props.allLayout.length) {
	        welcomeShow = false;
	      } else {
	        welcomeShow = true;
	      }
	      this.setState({ welcomeShow: welcomeShow, isEditable: props.isEditable });
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.setState({ modalIsOpen: true, isOpen: false });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      var _this2 = this;
	
	      this.setState({ modalIsOpen: false });
	      setTimeout(function () {
	        _this2.setState({ successShow: false });
	      }, 300);
	    }
	  }, {
	    key: 'handleAddComponent',
	    value: function handleAddComponent() {
	      this.setState({ modalIsOpen: true, 'panelType': 'addblock' });
	    }
	  }, {
	    key: 'handleApperance',
	    value: function handleApperance() {
	      this.setState({ modalIsOpen: true, 'panelType': 'appear' });
	    }
	  }, {
	    key: 'handleViewPager',
	    value: function handleViewPager(event) {
	      event.preventDefault();
	      this.setState({ modalIsOpen: true, 'panelType': 'viewPager' });
	    }
	  }, {
	    key: 'handleReactiveSiteTour',
	    value: function handleReactiveSiteTour() {
	      this.setState({ modalIsOpen: true, 'panelType': 'viewPager' });
	    }
	  }, {
	    key: 'successMessage',
	    value: function successMessage() {
	      this.setState({ successShow: true });
	    }
	    // toggling it for hide purpose of course :)
	
	  }, {
	    key: 'handleToggleEditPanel',
	    value: function handleToggleEditPanel(command, panelType, shortcodeKey, uid, childUid) {
	      if (panelType === 'search') {
	        this.setState({ modalIsOpen: !this.state.modalIsOpen });
	      }
	      // it has some place for improvements
	      if (this.props.shortcodeKey === shortcodeKey) {
	        if (panelType === '') {
	          this.setState({ isOpen: false, modalIsOpen: false });
	        } else {
	          if (panelType !== this.state.panelType) {
	            this.setState({ isOpen: true, panelType: panelType, editUid: uid, childUid: childUid });
	          } else {
	            this.setState({ isOpen: command, panelType: panelType, editUid: uid, childUid: childUid });
	          }
	        }
	      } else {
	        this.setState({ isOpen: false });
	      }
	      if (panelType === 'advancedsearch') {
	        this.setState({ modalIsOpen: !this.state.modalIsOpen });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var addClass = this.state.isOpen ? 'active' : '';
	      var successMessage = (0, _classnames2.default)({
	        'modal-overlay-content': true,
	        'active': this.state.successShow
	      });
	      var showModal = void 0;
	
	      switch (this.state.panelType) {
	        case 'addblock':
	          showModal = _react2.default.createElement(_addPanel2.default, _extends({}, this.props, { onClickedPanel: this.successMessage.bind(this) }));break;
	        case 'search':
	          showModal = _react2.default.createElement(_searchPanel2.default, _extends({}, this.props, { onClickedPanel: this.successMessage.bind(this), panelType: this.state.panelType, uid: this.state.editUid, childUid: this.state.childUid }));break;
	        case 'advancedsearch':
	          showModal = _react2.default.createElement(_advancedsearchpanel2.default, _extends({}, this.props, { onClickedPanel: this.successMessage.bind(this), panelType: this.state.panelType, uid: this.state.editUid, childUid: this.state.childUid }));break;
	        case 'appear':
	          showModal = _react2.default.createElement(_appearPanel2.default, _extends({}, this.props, { onClickedPanel: this.successMessage.bind(this) }));break;
	        case 'viewPager':
	          showModal = _react2.default.createElement(_viewPagerPanel2.default, _extends({}, this.props, { onCloseModal: this.closeModal }));break;
	        default:
	          break;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            className: 'Modal__Bootstrap modal-dialog',
	            portalClassName: 'rq-modal-wrapper',
	            closeTimeoutMS: 150,
	            isOpen: this.state.modalIsOpen,
	            onRequestClose: this.closeModal,
	            shouldCloseOnOverlayClick: false
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-close-content' },
	            _react2.default.createElement(
	              'button',
	              { className: 'modal-close', onClick: this.closeModal },
	              _react2.default.createElement('i', { className: 'ion-android-close' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'modal-component' },
	            _react2.default.createElement(
	              'div',
	              { className: successMessage },
	              _react2.default.createElement(
	                'div',
	                { className: 'reactive-alert showSweetAlert visible' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sa-icon sa-success animate' },
	                  _react2.default.createElement('span', { className: 'sa-line sa-tip animateSuccessTip' }),
	                  _react2.default.createElement('span', { className: 'sa-line sa-long animateSuccessLong' }),
	                  _react2.default.createElement('div', { className: 'sa-placeholder' }),
	                  _react2.default.createElement('div', { className: 'sa-fix' })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Successfully Added!'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'sa-confirm-button-container' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'hide-button', onClick: this.closeModal },
	                    'Close'
	                  )
	                )
	              )
	            ),
	            showModal
	          )
	        ),
	        this.state.isEditable && _react2.default.createElement(
	          'a',
	          { className: 'rq-help-link', href: '#', onClick: this.handleViewPager },
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.REACTIVE_HELP_BUTTON
	          )
	        ),
	        this.state.isEditable && _react2.default.createElement(
	          'div',
	          { className: 'flex-row addblock-button-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'addblock-button flex-md-6 flex-sm-6 flex-xs-6', 'data-toggle': 'tooltip', 'data-placement': 'top', title: API.LANG.TOOL_TIP_ADD_BLOCK, onClick: this.handleAddComponent },
	                _react2.default.createElement('i', { className: 'fa fa-paw', 'aria-hidden': 'true' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'addblock-button flex-md-6 flex-sm-6 flex-xs-6', 'data-toggle': 'tooltip', 'data-placement': 'top', title: API.LANG.TOOL_TIP_SETTINGS, style: { background: '#E6E6E6' }, onClick: this.handleApperance },
	                _react2.default.createElement('i', { className: 'fa fa-bolt', 'aria-hidden': 'true' })
	              )
	            ),
	            this.state.isEditable && this.state.welcomeShow ? _react2.default.createElement(_welcomeBlock2.default, this.props) : ''
	          )
	        ),
	        this.state.panelType !== 'search' && this.state.panelType !== 'addblock' && this.state.panelType !== 'viewPager' && this.state.panelType !== 'advancedsearch' && this.state.panelType !== 'appear' ? _react2.default.createElement(_editPanel2.default, _extends({}, this.props, { addClass: addClass, panelType: this.state.panelType, uid: this.state.editUid, childUid: this.state.childUid })) : null
	      );
	    }
	  }]);
	
	  return AddBlock;
	}(_react2.default.Component);
	
	AddBlock.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = AddBlock;

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _addPanel = __webpack_require__(477);
	
	var _addPanel2 = _interopRequireDefault(_addPanel);
	
	var _gridPanel = __webpack_require__(479);
	
	var _gridPanel2 = _interopRequireDefault(_gridPanel);
	
	var _userPanel = __webpack_require__(493);
	
	var _userPanel2 = _interopRequireDefault(_userPanel);
	
	var _categoryPanel = __webpack_require__(494);
	
	var _categoryPanel2 = _interopRequireDefault(_categoryPanel);
	
	var _dateRangePickerPanel = __webpack_require__(499);
	
	var _dateRangePickerPanel2 = _interopRequireDefault(_dateRangePickerPanel);
	
	var _searchPanel = __webpack_require__(502);
	
	var _searchPanel2 = _interopRequireDefault(_searchPanel);
	
	var _sidebarPanel = __webpack_require__(503);
	
	var _sidebarPanel2 = _interopRequireDefault(_sidebarPanel);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _checkboxPanel = __webpack_require__(505);
	
	var _checkboxPanel2 = _interopRequireDefault(_checkboxPanel);
	
	var _linearcheckboxPanel = __webpack_require__(506);
	
	var _linearcheckboxPanel2 = _interopRequireDefault(_linearcheckboxPanel);
	
	var _radioboxPanel = __webpack_require__(507);
	
	var _radioboxPanel2 = _interopRequireDefault(_radioboxPanel);
	
	var _selectboxPanel = __webpack_require__(508);
	
	var _selectboxPanel2 = _interopRequireDefault(_selectboxPanel);
	
	var _textboxPanel = __webpack_require__(509);
	
	var _textboxPanel2 = _interopRequireDefault(_textboxPanel);
	
	var _tagPanel = __webpack_require__(510);
	
	var _tagPanel2 = _interopRequireDefault(_tagPanel);
	
	var _imageselectPanel = __webpack_require__(511);
	
	var _imageselectPanel2 = _interopRequireDefault(_imageselectPanel);
	
	var _rangeinputPanel = __webpack_require__(512);
	
	var _rangeinputPanel2 = _interopRequireDefault(_rangeinputPanel);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _sizeboxPanel = __webpack_require__(513);
	
	var _sizeboxPanel2 = _interopRequireDefault(_sizeboxPanel);
	
	var _scrolltabPannel = __webpack_require__(514);
	
	var _scrolltabPannel2 = _interopRequireDefault(_scrolltabPannel);
	
	var _mapsearchboxPanel = __webpack_require__(515);
	
	var _mapsearchboxPanel2 = _interopRequireDefault(_mapsearchboxPanel);
	
	var _colorboxPanel = __webpack_require__(516);
	
	var _colorboxPanel2 = _interopRequireDefault(_colorboxPanel);
	
	var _comboboxPanel = __webpack_require__(517);
	
	var _comboboxPanel2 = _interopRequireDefault(_comboboxPanel);
	
	var _resetbuttonPanel = __webpack_require__(518);
	
	var _resetbuttonPanel2 = _interopRequireDefault(_resetbuttonPanel);
	
	var _mapPanel = __webpack_require__(519);
	
	var _mapPanel2 = _interopRequireDefault(_mapPanel);
	
	var _isotopePanel = __webpack_require__(520);
	
	var _isotopePanel2 = _interopRequireDefault(_isotopePanel);
	
	var _mapRadiusPanel = __webpack_require__(521);
	
	var _mapRadiusPanel2 = _interopRequireDefault(_mapRadiusPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import CalendarPanel from './calendarPanel';
	
	
	var EditPanel = function (_Component) {
	  _inherits(EditPanel, _Component);
	
	  function EditPanel(props) {
	    _classCallCheck(this, EditPanel);
	
	    var _this = _possibleConstructorReturn(this, (EditPanel.__proto__ || Object.getPrototypeOf(EditPanel)).call(this, props));
	
	    _this.state = { modalIsOpen: false };
	    _this.hidePanel = _this.hidePanel.bind(_this);
	    _this.openModal = _this.openModal.bind(_this);
	    _this.closeModal = _this.closeModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditPanel, [{
	    key: 'hidePanel',
	    value: function hidePanel(e) {
	      e.preventDefault();
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'openModal',
	    value: function openModal() {
	      this.setState({ modalIsOpen: true });
	    }
	  }, {
	    key: 'closeModal',
	    value: function closeModal() {
	      this.setState({ modalIsOpen: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showPanel = void 0;
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      var settings = {};
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          settings = _extends({}, _.omit(allLayout[find].searchAttr[findSearchIndex], 'uid', 'viewType'));
	        } else {
	          settings = _extends({}, _.omit(allLayout[find], 'uid', 'viewType'));
	        }
	      }
	
	      switch (this.props.panelType) {
	        case 'search-linearcheckbox':
	          showPanel = _react2.default.createElement(_linearcheckboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-checkbox':
	          showPanel = _react2.default.createElement(_checkboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-radio':
	          showPanel = _react2.default.createElement(_radioboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-select':
	          showPanel = _react2.default.createElement(_selectboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-sizebox':
	          showPanel = _react2.default.createElement(_sizeboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-colorbox':
	          showPanel = _react2.default.createElement(_colorboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-scrollbox':
	          showPanel = _react2.default.createElement(_scrolltabPannel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-text':
	          showPanel = _react2.default.createElement(_textboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-combobox':
	          showPanel = _react2.default.createElement(_comboboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-tag':
	          showPanel = _react2.default.createElement(_tagPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-imageselect':
	          showPanel = _react2.default.createElement(_imageselectPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-rangeinput':
	          showPanel = _react2.default.createElement(_rangeinputPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-rnb-daterange':
	          showPanel = _react2.default.createElement(_dateRangePickerPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-sidebar':
	          showPanel = _react2.default.createElement(_sidebarPanel2.default, this.props);
	          break;
	        case 'grid':
	          showPanel = _react2.default.createElement(_gridPanel2.default, this.props);
	          break;
	        case 'isotope':
	          showPanel = _react2.default.createElement(_isotopePanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'map':
	          showPanel = _react2.default.createElement(_mapPanel2.default, this.props);
	          break;
	        case 'search-mapsearch':
	          showPanel = _react2.default.createElement(_mapsearchboxPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'user':
	          showPanel = _react2.default.createElement(_userPanel2.default, this.props);
	          break;
	        case 'category':
	          showPanel = _react2.default.createElement(_categoryPanel2.default, this.props);
	          break;
	        // case 'calendar':
	        //   showPanel = <CalendarPanel {...this.props} />;
	        //   break;
	        case 'search-daterange':
	          showPanel = _react2.default.createElement(_dateRangePickerPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        case 'search-reset':
	          showPanel = _react2.default.createElement(_resetbuttonPanel2.default, this.props);
	          break;
	        case 'search-mapradius':
	          showPanel = _react2.default.createElement(_mapRadiusPanel2.default, _extends({}, this.props, { settings: settings }));
	          break;
	        default:
	          break;
	      }
	      var addClasses = (0, _classnames2.default)('editpanel', this.props.addClass);
	      return _react2.default.createElement(
	        'div',
	        { className: addClasses },
	        _react2.default.createElement(
	          'div',
	          { className: 'rightControl' },
	          _react2.default.createElement(
	            'a',
	            { className: 'hide-button', href: '#', onClick: this.hidePanel },
	            ' ',
	            _react2.default.createElement('i', { className: 'fa fa-chevron-down' }),
	            ' '
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'scrollable-area' },
	          showPanel
	        )
	      );
	    }
	  }]);
	
	  return EditPanel;
	}(_react.Component);
	
	EditPanel.propTypes = {
	  'panelType': _react2.default.PropTypes.string,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'addClass': _react2.default.PropTypes.string
	};
	
	exports.default = EditPanel;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _ajax = __webpack_require__(476);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PanelActions = _reflux2.default.createActions(['togglePanel', 'addSearchAttribute', 'publishNewSearchItem']);
	
	PanelActions.addSearchAttribute.preEmit = function (item) {
	  _ajax2.default.post('add_search_element', item).end(function (error, res) {
	    if (res.text) {
	      PanelActions.publishNewSearchItem(JSON.parse(res.text));
	    }
	  });
	};
	
	exports.default = PanelActions;

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _superagent = __webpack_require__(194);
	
	var _superagent2 = _interopRequireDefault(_superagent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var http = {
	  post: function post(url, data) {
	    var postUrl = API.ajaxurl + '?action=re_' + url;
	    if (API.post_id) {
	      data.post_id = API.post_id;
	    }
	    if (API.builder_nonce) {
	      data.builder_nonce = API.builder_nonce;
	    }
	    var param = '';
	    if (data) {
	      param = jQuery.param(data);
	    }
	    return _superagent2.default.post(postUrl).send(param).set('Accept', 'application/x-www-form-urlencoded');
	  }
	};
	
	exports.default = http;

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddPanel = function (_React$Component) {
	  _inherits(AddPanel, _React$Component);
	
	  function AddPanel(props) {
	    _classCallCheck(this, AddPanel);
	
	    var _this = _possibleConstructorReturn(this, (AddPanel.__proto__ || Object.getPrototypeOf(AddPanel)).call(this, props));
	
	    _this.allLayout = [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
	    _this.addNewLayout = _this.addNewLayout.bind(_this);
	    _this.displayName = 'AddPanel';
	    _this.state = { rangeValue: 12 };
	    _this.valueIncrement = _this.valueIncrement.bind(_this);
	    _this.valueDecrement = _this.valueDecrement.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddPanel, [{
	    key: 'valueIncrement',
	    value: function valueIncrement() {
	      var value = this.state.rangeValue;
	      if (value + 1 > 12) {
	        return;
	      }
	      value += 1;
	      this.setState({ rangeValue: value });
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'valueDecrement',
	    value: function valueDecrement() {
	      var value = this.state.rangeValue;
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.setState({ rangeValue: value });
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'handleLayoutChange',
	    value: function handleLayoutChange(type, layout, val) {
	      switch (type) {
	        case 'type':
	          this.layoutType = val.value;
	          if (this.state.rangeValue !== 0) {
	            this.setState({ errorMsg: null });
	          }
	          break;
	        case 'layout':
	          this.layout = layout;
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'addNewLayout',
	    value: function addNewLayout(e) {
	      e.preventDefault();
	      var Index = _.indexOf(this.allLayout, this.state.rangeValue);
	      if (this.layoutType !== undefined && Index !== -1) {
	        var allLayout = this.props.allLayout !== '' ? this.props.allLayout : [];
	        var newLayout = {
	          type: this.layoutType,
	          layout: this.state.rangeValue,
	          uid: new Date().getTime(),
	          position: allLayout.length + 1
	        };
	
	        allLayout.push(newLayout);
	        var pushLayout = {
	          allLayout: allLayout,
	          'shortcodeKey': this.props.shortcodeKey
	        };
	        _builderActions2.default.saveAllBlocks(pushLayout);
	        this.props.onClickedPanel();
	      } else {
	        this.setState({ errorMsg: 'Grid layout Or Grid Type not selected.' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // for showing different layout
	      var index = (0, _underscore.findIndex)(this.props.allLayout, { type: 'grid' });
	      var isMap = (0, _underscore.findIndex)(this.props.allLayout, { type: 'map' });
	      var isIsotop = (0, _underscore.findIndex)(this.props.allLayout, { type: 'isotope' });
	      var options = [];
	
	      if (index === -1) {
	        var simpleItem = { value: 'grid', label: API.LANG.GRID, icon: 'ion-grid' };
	        options.push(simpleItem);
	      }
	      if (isMap === -1) {
	        var _simpleItem = { value: 'map', label: API.LANG.MAP, icon: 'ion-map' };
	        options.push(_simpleItem);
	      }
	      if (isIsotop === -1) {
	        var _simpleItem2 = { value: 'isotope', label: API.LANG.GRID_ISOTOPE, icon: 'ion-ios-keypad' };
	        options.push(_simpleItem2);
	      }
	      options = options.concat([{ value: 'search', label: API.LANG.SEARCH, icon: 'ion-android-locate' }, { value: 'category', label: API.LANG.CATEGORY, icon: 'ion-steam' }]);
	
	      // if (API.isActiveUserplace === 'true') {
	      //   options.push({ value: 'user', label: API.LANG.USER });
	      // }
	      var showOption = function showOption(item, itemIndex) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'search-content', key: itemIndex },
	          _react2.default.createElement('input', { type: 'radio', name: 'search-element', id: itemIndex, value: item.value, onChange: _this2.handleLayoutChange.bind(_this2, 'type', item.value, item) }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select-search-content', htmlFor: itemIndex },
	            _react2.default.createElement('i', { className: item.icon }),
	            item.label
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-choose-option' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-sm-12 flex-xs-12' },
	              _react2.default.createElement(
	                'span',
	                { className: 'caption' },
	                API.LANG.CHOOSE_GRID_LAYOUT
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.valueIncrement },
	                  _react2.default.createElement('i', { className: 'fa fa-plus' })
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { onClick: this.valueDecrement },
	                  _react2.default.createElement('i', { className: 'fa fa-minus' })
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'gird-value-count' },
	                this.state.rangeValue !== null ? this.state.rangeValue : null
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          _react2.default.createElement('div', { className: '' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'select-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-xs-12' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'caption' },
	                  API.LANG.SELECT_TYPE
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-xs-12' },
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'reactive-list-item' },
	                  options.map(showOption)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'add-button-content' },
	          this.state.errorMsg !== undefined ? _react2.default.createElement(
	            'p',
	            { className: 'error-body' },
	            this.state.errorMsg
	          ) : null,
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'add-button', onClick: this.addNewLayout },
	            ' ',
	            API.LANG.ADD,
	            ' '
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddPanel;
	}(_react2.default.Component);
	
	AddPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'allLayout': _react2.default.PropTypes.array,
	  'onClickedPanel': _react2.default.PropTypes.func
	};
	
	exports.default = AddPanel;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _nprogress = __webpack_require__(192);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _ajax = __webpack_require__(476);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BuildActions = _reflux2.default.createActions(['addNewLayout', 'saveSettingsData', 'publishSettingsData', 'publishNewLayout', 'deleteLayout', 'saveAllBlocks']);
	
	BuildActions.saveAllBlocks.preEmit = function (allLayout) {
	  _nprogress2.default.start();
	  jQuery('#ajax-loader').fadeIn(300);
	  _ajax2.default.post('save_builder', allLayout).end(function (error, res) {
	    if (res) {
	      if (allLayout.reload) {
	        location.reload();
	      }
	      _nprogress2.default.done();
	      jQuery('#ajax-loader').fadeOut(300);
	      BuildActions.publishNewLayout(JSON.parse(res.text));
	    }
	  });
	};
	
	BuildActions.deleteLayout.preEmit = function (uid) {
	  _nprogress2.default.start();
	  jQuery('#ajax-loader').fadeIn(300);
	  var data = { uid: uid };
	  _ajax2.default.post('delete_layout', data).end(function (error, res) {
	    if (res) {
	      _nprogress2.default.done();
	      jQuery('#ajax-loader').fadeOut(300);
	      BuildActions.publishNewLayout(JSON.parse(res.text));
	    }
	  });
	};
	
	BuildActions.saveSettingsData.preEmit = function (data) {
	  _nprogress2.default.start();
	  _ajax2.default.post('save_settings', data).end(function (error, res) {
	    if (res) {
	      _nprogress2.default.done();
	      location.reload();
	      // BuildActions.publishSettingsData(JSON.parse(res.text));
	    }
	  });
	};
	
	exports.default = BuildActions;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gridActions = __webpack_require__(480);
	
	var _gridActions2 = _interopRequireDefault(_gridActions);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gridselect = __webpack_require__(481);
	
	var _gridselect2 = _interopRequireDefault(_gridselect);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _topbarPanel = __webpack_require__(482);
	
	var _topbarPanel2 = _interopRequireDefault(_topbarPanel);
	
	var _columnPanel = __webpack_require__(489);
	
	var _columnPanel2 = _interopRequireDefault(_columnPanel);
	
	var _bottombarPanel = __webpack_require__(490);
	
	var _bottombarPanel2 = _interopRequireDefault(_bottombarPanel);
	
	var _sortingPanel = __webpack_require__(491);
	
	var _sortingPanel2 = _interopRequireDefault(_sortingPanel);
	
	var _barpanel = __webpack_require__(492);
	
	var _barpanel2 = _interopRequireDefault(_barpanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridPanel = function (_React$Component) {
	  _inherits(GridPanel, _React$Component);
	
	  function GridPanel(props) {
	    _classCallCheck(this, GridPanel);
	
	    var _this = _possibleConstructorReturn(this, (GridPanel.__proto__ || Object.getPrototypeOf(GridPanel)).call(this, props));
	
	    _this.valueIncrement = _this.valueIncrement.bind(_this);
	    _this.valueDecrement = _this.valueDecrement.bind(_this);
	    _this.valueIncrementLayout = _this.valueIncrementLayout.bind(_this);
	    _this.valueDecrementLayout = _this.valueDecrementLayout.bind(_this);
	    _this.handleViewType = _this.handleViewType.bind(_this);
	    _this.handleListWrapperClass = _this.handleListWrapperClass.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    // API is for few help , just for getting whole post type list
	    _this.postTypesHelper = API.helper.all_post_types ? API.helper.all_post_types : ['post'];
	    _this.postTypeOptions = [];
	    _this.postTypesHelper.forEach(function (type) {
	      _this.postTypeOptions.push({
	        value: type,
	        label: type
	      });
	    });
	    _this.state = {
	      'helperData': (0, _clone2.default)(_this.props.helperData),
	      'numberOfPosts': 10,
	      'allLayout': (0, _clone2.default)(_this.props.allLayout),
	      'activeTap': 'settings',
	      'gridWrapperClass': '',
	      'listWrapperClass': ''
	    };
	
	    _this.contents = {
	      shortcodeKey: _this.props.shortcodeKey,
	      uid: _this.props.uid,
	      save: {}
	    };
	    _this.previewLayouts = {};
	    var index = (0, _underscore.findIndex)(_this.props.allLayout, { uid: _this.props.uid });
	    if (index !== -1) {
	      _this.tempLayouts = (0, _clone2.default)(_this.props.allLayout[index].previewLayouts);
	    } else _this.tempLayouts = {};
	    _this.onChangeSelectedImage = _this.onChangeSelectedImage.bind(_this);
	    return _this;
	  }
	
	  _createClass(GridPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.block = _.where(this.props.allLayout, { uid: this.props.uid });
	      if (this.block) {
	        this.block = this.block[0];
	        this.setState(_extends({}, this.block));
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        'allLayout': (0, _clone2.default)(nextProps.allLayout)
	      });
	    }
	    // on save click
	
	  }, {
	    key: 'onChangeSelectedImage',
	    value: function onChangeSelectedImage(ImageId, type) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find].previewLayouts = ImageId;
	      }
	      var pushLayout = {
	        'allLayout': (0, _clone2.default)(allLayout),
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	    }
	  }, {
	    key: 'handleSubmitLayout',
	    value: function handleSubmitLayout() {
	      if (_.isEmpty(this.state.allLayout)) {
	        return;
	      }
	      var pushLayout = {
	        'allLayout': (0, _clone2.default)(this.state.allLayout),
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	
	    // Note:  per update won't chnage the whole preview , only save button will change the preview .
	
	  }, {
	    key: 'updateGridState',
	    value: function updateGridState(fieldKey, e) {
	      var content = {};
	      content[fieldKey] = e.target.value;
	      this.contents.save = _extends({}, this.state, content);
	      this.contents.save = _.omit(this.contents.save, 'helperData', 'uid', 'layout', 'type');
	      _gridActions2.default.getBuilderData(this.contents);
	      this.setState(_extends({}, content));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(val) {
	      this.selectedPostTypes = val;
	    }
	  }, {
	    key: 'handleTopBarData',
	    value: function handleTopBarData(data) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find]['topbar'] = data;
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'handleColumnData',
	    value: function handleColumnData(data) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find]['column'] = data;
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'handleBottomBarData',
	    value: function handleBottomBarData(data) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find]['bottombar'] = data;
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'handleSortingData',
	    value: function handleSortingData(data) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find]['sorting'] = data;
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'handleTabChange',
	    value: function handleTabChange(view) {
	      this.setState({ activeTap: view });
	    }
	  }, {
	    key: 'handleBarData',
	    value: function handleBarData(data) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find]['bardata'] = data;
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'valueIncrement',
	    value: function valueIncrement() {
	      var value = null;
	      if (this.state.numberOfPosts !== undefined) {
	        value = parseInt(this.state.numberOfPosts, 10);
	      } else {
	        value = 0;
	      }
	      value += 1;
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        allLayout[index].numberOfPosts = value;
	        this.setState({ numberOfPosts: value, allLayout: allLayout });
	      }
	    }
	  }, {
	    key: 'valueDecrement',
	    value: function valueDecrement() {
	      var value = null;
	      if (this.state.numberOfPosts !== undefined) {
	        value = parseInt(this.state.numberOfPosts, 10);
	      } else {
	        return;
	      }
	      if (value === 0) {
	        return;
	      }
	      value -= 1;
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        allLayout[index].numberOfPosts = value;
	        this.setState({ numberOfPosts: value, allLayout: allLayout });
	      }
	    }
	  }, {
	    key: 'valueIncrementLayout',
	    value: function valueIncrementLayout() {
	      var value = parseInt(this.state.layout, 10);
	      if (value + 1 > 12) {
	        return;
	      }
	      value += 1;
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        allLayout[index].layout = value;
	        this.setState({ layout: value, allLayout: allLayout });
	      }
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'valueDecrementLayout',
	    value: function valueDecrementLayout() {
	      var value = parseInt(this.state.layout, 10);
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        allLayout[index].layout = value;
	        this.setState({ layout: value, allLayout: allLayout });
	      }
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'handleViewType',
	    value: function handleViewType(type) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find]['viewType'] = type;
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'handleWrapperClass',
	    value: function handleWrapperClass(value) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find].gridWrapperClass = value;
	        this.setState({ gridWrapperClass: value, allLayout: allLayout });
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'handleListWrapperClass',
	    value: function handleListWrapperClass(value) {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find].listWrapperClass = value;
	        this.setState({ listWrapperClass: value, allLayout: allLayout });
	      }
	      this.setState({ allLayout: allLayout });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var ImageId = [];
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      var viewType = null;
	      if (find !== -1) {
	        viewType = allLayout[find].hasOwnProperty('viewType') ? allLayout[find].viewType : null;
	        if (allLayout[find].hasOwnProperty('previewLayouts')) {
	          ImageId.push(allLayout[find].previewLayouts.toString());
	        } else {
	          ImageId.push('latestGridLayoutThree');
	        }
	      }
	      var topbarData = null;
	      var columnData = null;
	      var bottombarData = null;
	      var sortingData = null;
	      var barData = null;
	      if (find !== -1 && allLayout[find]) {
	        if ('topbar' in allLayout[find]) {
	          topbarData = allLayout[find].topbar;
	        }
	        if ('bardata' in allLayout[find]) {
	          barData = allLayout[find].bardata;
	        }
	        if ('column' in allLayout[find]) {
	          columnData = allLayout[find].column;
	        }
	
	        if ('bottombar' in allLayout[find]) {
	          bottombarData = allLayout[find].bottombar;
	        }
	
	        if ('sorting' in allLayout[find]) {
	          sortingData = allLayout[find].sorting;
	        }
	      }
	
	      var gridPanelClass = (0, _classnames2.default)({
	        'panel-type-body': true,
	        'has-postType': !this.props.settingsData.post_type
	      });
	
	      var FilteredImageSelect = function FilteredImageSelect(item, index) {
	        item.data.splice(9, 1);
	        if (item.data.length !== 0) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(_gridselect2.default, { option: item.data, defaultvalue: ImageId, onImageSelcted: _this2.onChangeSelectedImage, multiselect: 'false' })
	          );
	        }
	      };
	      this.filteredFormatData = [];
	      if (this.state.helperData.formats !== undefined || this.state.helperData.formats !== null) {
	        this.state.helperData.formats.map(function (item) {
	          if (item.toString() !== 'standard') {
	            return;
	          }
	          var filteredFormat = {};
	          filteredFormat.data = _.where(filteredFormat.data, { type: _this2.state.postTypes });
	          var selfPostType = _this2.state.postTypes ? _this2.state.postTypes : 'post';
	          filteredFormat.data = _.filter(ReactiveLayouts, function (sigleitem) {
	            return sigleitem.type === selfPostType || sigleitem.type === 'all';
	          });
	          if (filteredFormat.data.length === 0) {
	            filteredFormat.data = _.where(ReactiveLayouts, { type: 'all' });
	          }
	          _this2.filteredFormatData.push(filteredFormat);
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', disabled: this.state.activeTap === 'layout' ? true : false, onClick: this.handleSubmitLayout.bind(this) },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active', onClick: this.handleTabChange.bind(this, 'settings') },
	              _react2.default.createElement(
	                'a',
	                { href: '#general', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.SETTINGS
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', onClick: this.handleTabChange.bind(this, 'layout') },
	              _react2.default.createElement(
	                'a',
	                { href: '#layout', 'aria-controls': 'layout', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.LAYOUT
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', onClick: this.handleTabChange.bind(this, 'column') },
	              _react2.default.createElement(
	                'a',
	                { href: '#column', 'aria-controls': 'column', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.COLUMN
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', onClick: this.handleTabChange.bind(this, 'sorting') },
	              _react2.default.createElement(
	                'a',
	                { href: '#sorting', 'aria-controls': 'layout', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.SORTING
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', onClick: this.handleTabChange.bind(this, 'topbar') },
	              _react2.default.createElement(
	                'a',
	                { href: '#topbar', 'aria-controls': 'topbar', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.TOP_BAR
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', onClick: this.handleTabChange.bind(this, 'bottombar') },
	              _react2.default.createElement(
	                'a',
	                { href: '#botombar', 'aria-controls': 'botombar', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.BOTTOM_BAR
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', onClick: this.handleTabChange.bind(this, 'barapps') },
	              _react2.default.createElement(
	                'a',
	                { href: '#barapp', 'aria-controls': 'barapp', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.BAR_APPS
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'general' },
	              _react2.default.createElement(
	                'div',
	                { className: gridPanelClass },
	                _react2.default.createElement('div', { className: 'overlay' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row post-type-choose-grid-option' },
	                  !this.props.settingsData.post_type && _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'rq-post-type-seletion-first' },
	                        _react2.default.createElement('i', { className: 'fa fa-smile-o' }),
	                        _react2.default.createElement(
	                          'h4',
	                          null,
	                          API.LANG.SELECT_POST_TYPE_FIRST,
	                          '.'
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-5 flex-xs-6' },
	                  _react2.default.createElement('input', { type: 'text', value: this.state.gridWrapperClass, className: 'reactive-input', onChange: function onChange(node) {
	                      _this2.handleWrapperClass(node.target.value);
	                    }, placeholder: API.LANG.WRAPPER_CLASS_GRID })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-5 flex-xs-6' },
	                  _react2.default.createElement('input', { type: 'text', value: this.state.listWrapperClass, className: 'reactive-input', onChange: function onChange(node) {
	                      _this2.handleListWrapperClass(node.target.value);
	                    }, placeholder: API.LANG.WRAPPER_CLASS_LIST })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.CHANGE_GRID_LAYOUT
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.valueIncrementLayout },
	                          _react2.default.createElement('i', { className: 'fa fa-plus' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.valueDecrementLayout },
	                          _react2.default.createElement('i', { className: 'fa fa-minus' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'gird-value-count' },
	                        this.state.layout !== undefined ? this.state.layout : null
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option no-padding' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.NUMBER_OF_POST
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: this.valueIncrement },
	                        _react2.default.createElement('i', { className: 'fa fa-plus' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'button',
	                        { onClick: this.valueDecrement },
	                        _react2.default.createElement('i', { className: 'fa fa-minus' })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'gird-value-count' },
	                      this.state.numberOfPosts !== null ? this.state.numberOfPosts : null
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option no-padding' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.View_Type
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'defaultGridListView' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: viewType === 'grid' ? 'active' : null, onClick: this.handleViewType.bind(this, 'grid') },
	                        API.LANG.Grid_View
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'defaultGridListView' },
	                      _react2.default.createElement(
	                        'button',
	                        { className: viewType === 'list' ? 'active' : null, onClick: this.handleViewType.bind(this, 'list') },
	                        API.LANG.List_View
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'layout' },
	              this.filteredFormatData.map(FilteredImageSelect)
	            ),
	            _react2.default.createElement(_topbarPanel2.default, { topbarData: topbarData, onTopBarSubmit: this.handleTopBarData.bind(this) }),
	            _react2.default.createElement(_bottombarPanel2.default, { bottombarData: bottombarData, onBottomBarSubmit: this.handleBottomBarData.bind(this) }),
	            _react2.default.createElement(_columnPanel2.default, _extends({}, this.props, { columnData: columnData, onColumnSubmit: this.handleColumnData.bind(this) })),
	            _react2.default.createElement(_sortingPanel2.default, _extends({}, this.props, { sortingData: sortingData, onSortingSubmit: this.handleSortingData.bind(this) })),
	            _react2.default.createElement(_barpanel2.default, _extends({}, this.props, { barData: barData, appearData: this.handleBarData.bind(this) }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return GridPanel;
	}(_react2.default.Component);
	
	GridPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array
	};
	exports.default = GridPanel;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _ajax = __webpack_require__(476);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GridActions = _reflux2.default.createActions(['getBuilderData', 'publishHelper']);
	
	// builder-ajax
	GridActions.getBuilderData.preEmit = function (reqData) {
	  _ajax2.default.post('load_request_data', reqData).end(function (error, res) {
	    if (res) {
	      GridActions.publishHelper(JSON.parse(res.text));
	    }
	  });
	};
	
	exports.default = GridActions;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridSelect = function (_React$Component) {
	  _inherits(GridSelect, _React$Component);
	
	  function GridSelect(props) {
	    _classCallCheck(this, GridSelect);
	
	    var _this = _possibleConstructorReturn(this, (GridSelect.__proto__ || Object.getPrototypeOf(GridSelect)).call(this, props));
	
	    var option = _this.props.option;
	    var defaultValue = _this.props.defaultvalue;
	    option.map(function (item) {
	      item.isChecked = false;
	      if (_this.props.multiselect === 'false' && item.key === _this.props.defaultvalue[0]) {
	        item.isChecked = true;
	      }
	    });
	    if (_this.props.multiselect === 'true') {
	      defaultValue.map(function (defaultitem) {
	        option.map(function (item, index) {
	          if (item.key === defaultitem) {
	            option[index].isChecked = true;
	          }
	        });
	      });
	    }
	    _this.state = {
	      option: option
	    };
	    return _this;
	  }
	
	  _createClass(GridSelect, [{
	    key: 'handleImageSelect',
	    value: function handleImageSelect(e) {
	      var _this2 = this;
	
	      var option = this.state.option;
	      if (this.props.multiselect === 'false') {
	        option.map(function (item) {
	          if (item.key === e.target.id) {
	            item.isChecked = !item.isChecked;
	            if (item.isChecked === true) {
	              _this2.props.onImageSelcted(e.target.id, 'false');
	            }
	          } else {
	            item.isChecked = false;
	          }
	        });
	      } else {
	        option.map(function (item) {
	          if (item.key === e.target.id) {
	            item.isChecked = !item.isChecked;
	            _this2.props.onImageSelcted(e.target.id, 'true');
	          }
	        });
	      }
	      this.setState({ option: option });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var singleImage = function singleImage(item) {
	
	        return _react2.default.createElement(
	          'span',
	          { className: 'search-content', key: item.key },
	          _react2.default.createElement('input', { type: 'checkbox', checked: item.isChecked, id: item.key, value: item.key, onChange: _this3.handleImageSelect.bind(_this3) }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select-search-content', htmlFor: item.key },
	            item.gridName
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'span',
	        { className: 'checkbox-input-content' },
	        this.state.option.map(singleImage)
	      );
	    }
	  }]);
	
	  return GridSelect;
	}(_react2.default.Component);
	
	GridSelect.propTypes = {
	  'multiselect': _react2.default.PropTypes.string,
	  'option': _react2.default.PropTypes.array,
	  'defaultvalue': _react2.default.PropTypes.array
	};
	
	exports.default = GridSelect;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopBarPanel = function (_React$Component) {
	  _inherits(TopBarPanel, _React$Component);
	
	  function TopBarPanel(props) {
	    _classCallCheck(this, TopBarPanel);
	
	    var _this = _possibleConstructorReturn(this, (TopBarPanel.__proto__ || Object.getPrototypeOf(TopBarPanel)).call(this, props));
	
	    var topbarData = {
	      topbar: false,
	      filter: false,
	      sorting: false,
	      viewchanger: false,
	      topbarpagination: false
	    };
	
	    if ('topbarData' in _this.props) {
	      topbarData = _this.props.topbarData ? _this.props.topbarData : topbarData;
	    }
	
	    _this.state = {
	      topbarData: topbarData
	    };
	    return _this;
	  }
	
	  _createClass(TopBarPanel, [{
	    key: 'handleAttributeOnOff',
	    value: function handleAttributeOnOff(element) {
	      var elmData = this.state.topbarData;
	      if (elmData[element] === 'false' || elmData[element] === false) {
	        elmData[element] = true;
	      } else {
	        elmData[element] = false;
	      }
	      this.props.onTopBarSubmit(elmData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var topbarData = this.state.topbarData;
	
	
	      return _react2.default.createElement(
	        'div',
	        { role: 'tabpanel', className: 'tab-pane', id: 'topbar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_TOPBAR
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: topbarData.topbar === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'topbar')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_SEARCH_FILTER_ATTRIBUTES
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: topbarData.filter === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'filter')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_SORTING_OPTION
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: topbarData.sorting === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'sorting')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_VIEW_CHANGER
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: topbarData.viewchanger === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'viewchanger')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_TOPBAR_PAGINATION
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: topbarData.topbarpagination === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'topbarpagination')
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TopBarPanel;
	}(_react2.default.Component);
	
	exports.default = TopBarPanel;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = _interopRequire(__webpack_require__(1));
	
	var classNames = _interopRequire(__webpack_require__(167));
	
	var Check = _interopRequire(__webpack_require__(484));
	
	var X = _interopRequire(__webpack_require__(485));
	
	var PureRenderMixin = _interopRequire(__webpack_require__(486));
	
	module.exports = React.createClass({
	  mixins: [PureRenderMixin],
	
	  displayName: "Toggle",
	
	  propTypes: {
	    checked: React.PropTypes.bool,
	    defaultChecked: React.PropTypes.bool,
	    onChange: React.PropTypes.func,
	    name: React.PropTypes.string,
	    value: React.PropTypes.string,
	    id: React.PropTypes.string,
	    "aria-labelledby": React.PropTypes.string,
	    "aria-label": React.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    var checked = false;
	    if ("checked" in this.props) {
	      checked = this.props.checked;
	    } else if ("defaultChecked" in this.props) {
	      checked = this.props.defaultChecked;
	    }
	    return {
	      checked: !!checked,
	      hasFocus: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ("checked" in nextProps) {
	      this.setState({ checked: !!nextProps.checked });
	    }
	  },
	
	  handleClick: function handleClick(event) {
	    var checkbox = this.refs.input;
	    if (event.target !== checkbox) {
	      event.preventDefault();
	      checkbox.focus();
	      checkbox.click();
	      return;
	    }
	
	    if (!("checked" in this.props)) {
	      this.setState({ checked: checkbox.checked });
	    }
	  },
	
	  handleFocus: function handleFocus() {
	    this.setState({ hasFocus: true });
	  },
	
	  handleBlur: function handleBlur() {
	    this.setState({ hasFocus: false });
	  },
	
	  render: function render() {
	    var classes = classNames("react-toggle", {
	      "react-toggle--checked": this.state.checked,
	      "react-toggle--focus": this.state.hasFocus,
	      "react-toggle--disabled": this.props.disabled
	    });
	
	    return React.createElement(
	      "div",
	      { className: classes, onClick: this.handleClick },
	      React.createElement(
	        "div",
	        { className: "react-toggle-track" },
	        React.createElement(
	          "div",
	          { className: "react-toggle-track-check" },
	          React.createElement(Check, null)
	        ),
	        React.createElement(
	          "div",
	          { className: "react-toggle-track-x" },
	          React.createElement(X, null)
	        )
	      ),
	      React.createElement("div", { className: "react-toggle-thumb" }),
	      React.createElement("input", _extends({
	        ref: "input",
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        className: "react-toggle-screenreader-only",
	        type: "checkbox"
	      }, this.props))
	    );
	  }
	});


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var React = _interopRequire(__webpack_require__(1));
	
	module.exports = React.createClass({
	  displayName: "check.es6",
	
	  render: function render() {
	    return React.createElement(
	      "svg",
	      { width: "14", height: "11", viewBox: "0 0 14 11" },
	      React.createElement(
	        "title",
	        null,
	        "switch-check"
	      ),
	      React.createElement("path", { d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0", fill: "#fff", fillRule: "evenodd" })
	    );
	  }
	});


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };
	
	var React = _interopRequire(__webpack_require__(1));
	
	module.exports = React.createClass({
	  displayName: "x.es6",
	
	  render: function render() {
	    return React.createElement(
	      "svg",
	      { width: "10", height: "10", viewBox: "0 0 10 10" },
	      React.createElement(
	        "title",
	        null,
	        "switch-x"
	      ),
	      React.createElement("path", { d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12", fill: "#fff", fillRule: "evenodd" })
	    );
	  }
	});


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(487);

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentWithPureRenderMixin
	 */
	
	'use strict';
	
	var shallowCompare = __webpack_require__(488);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 *
	 * See https://facebook.github.io/react/docs/pure-render-mixin.html
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function (nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule shallowCompare
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(119);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColumnPanel = function (_React$Component) {
	  _inherits(ColumnPanel, _React$Component);
	
	  function ColumnPanel(props) {
	    _classCallCheck(this, ColumnPanel);
	
	    var _this = _possibleConstructorReturn(this, (ColumnPanel.__proto__ || Object.getPrototypeOf(ColumnPanel)).call(this, props));
	
	    var columnData = {
	      grid_desktop_hd: 2,
	      list_desktop_hd: 2,
	      grid_desktop: 2,
	      list_desktop: 2,
	      grid_tablet: 1,
	      list_tablet: 1,
	      grid_mobile: 1,
	      list_mobile: 1
	    };
	    if ('columnData' in _this.props) {
	      columnData = _this.props.columnData ? _this.props.columnData : columnData;
	    }
	    _this.state = {
	      columnData: columnData
	    };
	    return _this;
	  }
	
	  _createClass(ColumnPanel, [{
	    key: 'handleValueIncrement',
	    value: function handleValueIncrement(element) {
	      var columnData = this.state.columnData;
	      var value = parseInt(columnData[element], 10);
	      if (element === 'grid_tablet') {
	        if (value + 1 > 3) {
	          return;
	        }
	      } else if (element === 'grid_desktop_hd') {
	        if (value + 1 > 4) {
	          return;
	        }
	      } else if (element === 'grid_desktop') {
	        if (value + 1 > 4) {
	          return;
	        }
	      } else if (element === 'grid_mobile') {
	        if (value + 1 > 2) {
	          return;
	        }
	      } else if (element === 'list_desktop_hd') {
	        if (value + 1 > 2) {
	          return;
	        }
	      } else if (element === 'list_desktop') {
	        if (value + 1 > 2) {
	          return;
	        }
	      } else {
	        if (value + 1 > 12) {
	          return;
	        }
	      }
	      value += 1;
	      columnData[element] = value;
	      this.setState({ columnData: columnData });
	      this.props.onColumnSubmit(columnData);
	    }
	  }, {
	    key: 'handleValueDecrement',
	    value: function handleValueDecrement(element) {
	      var columnData = this.state.columnData;
	      var value = parseInt(columnData[element], 10);
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      columnData[element] = value;
	      this.setState({ columnData: columnData });
	      this.props.onColumnSubmit(columnData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { role: 'tabpanel', className: 'tab-pane', id: 'column' },
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-choose-option' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-sm-6' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'list-grid-title' },
	                ' ',
	                API.LANG.GRID,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.GRID_DESKTOP_HD
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-9 flex-xs-12' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueIncrement.bind(this, 'grid_desktop_hd') },
	                      _react2.default.createElement('i', { className: 'fa fa-plus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueDecrement.bind(this, 'grid_desktop_hd') },
	                      _react2.default.createElement('i', { className: 'fa fa-minus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'gird-value-count' },
	                    this.state.columnData.grid_desktop_hd !== null ? this.state.columnData.grid_desktop_hd : null
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.GRID_DESKTOP
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-9 flex-xs-12' },
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.handleValueIncrement.bind(this, 'grid_desktop') },
	                    _react2.default.createElement('i', { className: 'fa fa-plus' })
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.handleValueDecrement.bind(this, 'grid_desktop') },
	                    _react2.default.createElement('i', { className: 'fa fa-minus' })
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'gird-value-count' },
	                    this.state.columnData.grid_desktop !== null ? this.state.columnData.grid_desktop : null
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.GRID_TABLET
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-9 flex-xs-12' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueIncrement.bind(this, 'grid_tablet') },
	                      _react2.default.createElement('i', { className: 'fa fa-plus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueDecrement.bind(this, 'grid_tablet') },
	                      _react2.default.createElement('i', { className: 'fa fa-minus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'gird-value-count' },
	                    this.state.columnData.grid_tablet !== null ? this.state.columnData.grid_tablet : null
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.GRID_MOBILE
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-9 flex-xs-12' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueIncrement.bind(this, 'grid_mobile') },
	                      _react2.default.createElement('i', { className: 'fa fa-plus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueDecrement.bind(this, 'grid_mobile') },
	                      _react2.default.createElement('i', { className: 'fa fa-minus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'gird-value-count' },
	                    this.state.columnData.grid_mobile !== null ? this.state.columnData.grid_mobile : null
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'flex-sm-6' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'list-grid-title' },
	                ' ',
	                API.LANG.LIST,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.LIST_DESKTOP_HD
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-9 flex-xs-12' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueIncrement.bind(this, 'list_desktop_hd') },
	                      _react2.default.createElement('i', { className: 'fa fa-plus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueDecrement.bind(this, 'list_desktop_hd') },
	                      _react2.default.createElement('i', { className: 'fa fa-minus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'gird-value-count' },
	                    this.state.columnData.list_desktop_hd !== null ? this.state.columnData.list_desktop_hd : null
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.LIST_DESKTOP
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-9 flex-xs-12' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueIncrement.bind(this, 'list_desktop') },
	                      _react2.default.createElement('i', { className: 'fa fa-plus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.handleValueDecrement.bind(this, 'list_desktop') },
	                      _react2.default.createElement('i', { className: 'fa fa-minus' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'gird-value-count' },
	                    this.state.columnData.list_desktop !== null ? this.state.columnData.list_desktop : null
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ColumnPanel;
	}(_react2.default.Component);
	
	ColumnPanel.propTypes = {
	  'columnData': _react2.default.PropTypes.object,
	  'onColumnSubmit': _react2.default.PropTypes.func
	};
	exports.default = ColumnPanel;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BottomBarPanel = function (_React$Component) {
	  _inherits(BottomBarPanel, _React$Component);
	
	  function BottomBarPanel(props) {
	    _classCallCheck(this, BottomBarPanel);
	
	    var _this = _possibleConstructorReturn(this, (BottomBarPanel.__proto__ || Object.getPrototypeOf(BottomBarPanel)).call(this, props));
	
	    var bottombarData = {
	      bottombar: false,
	      bottompagination: false
	    };
	    if ('bottombarData' in _this.props) {
	      bottombarData = _this.props.bottombarData ? _this.props.bottombarData : bottombarData;
	    }
	    _this.state = {
	      bottombarData: bottombarData
	    };
	    return _this;
	  }
	
	  _createClass(BottomBarPanel, [{
	    key: 'handleAttributeOnOff',
	    value: function handleAttributeOnOff(element) {
	      var elmData = this.state.bottombarData;
	      if (elmData[element] === 'false' || elmData[element] === false || elmData[element] === undefined) {
	        elmData[element] = true;
	      } else {
	        elmData[element] = false;
	      }
	      this.props.onBottomBarSubmit(elmData);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bottombarData = this.state.bottombarData;
	
	      return _react2.default.createElement(
	        'div',
	        { role: 'tabpanel', className: 'tab-pane', id: 'botombar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_BOTTOMBAR
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: bottombarData.bottombar === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'bottombar')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_BOTTOMBAR_PAGINATION
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: bottombarData.bottompagination === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'bottompagination')
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-4 flex-xs-9' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.SHOW_OR_HIDE_THE_BOTTOMBAR_LOADMORE
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-1 flex-xs-3 end-xs' },
	            _react2.default.createElement(_reactToggle2.default, {
	              defaultChecked: bottombarData.bottomloadMore === 'true',
	              onChange: this.handleAttributeOnOff.bind(this, 'bottomloadMore')
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return BottomBarPanel;
	}(_react2.default.Component);
	
	exports.default = BottomBarPanel;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var SortingPanel = function (_React$Component) {
	  _inherits(SortingPanel, _React$Component);
	
	  function SortingPanel(props) {
	    _classCallCheck(this, SortingPanel);
	
	    var _this = _possibleConstructorReturn(this, (SortingPanel.__proto__ || Object.getPrototypeOf(SortingPanel)).call(this, props));
	
	    _this.state = {
	      allmetakeys: _this.props.sortingData ? _this.props.sortingData : []
	    };
	    return _this;
	  }
	
	  _createClass(SortingPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      jQuery('#sortmeta').sortable({
	        handle: '.sort-shortable',
	        stop: this.handleSort.bind(this)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.sortingData !== null) {
	        this.setState({
	          allmetakeys: nextProps.sortingData
	        });
	      } else {
	        this.setState({ allmetakeys: [] });
	      }
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(event) {
	      var oldmeta = (0, _clone2.default)(this.props.sortingData);
	      var allmetakeys = [];
	
	      $(event.target).children('.sortingmeta').each(function (index, item) {
	        var value = $(item).data('value');
	        var findKey = (0, _underscore.findIndex)(oldmeta, { value: value });
	        if (findKey !== -1) {
	          allmetakeys.push(oldmeta[findKey]);
	        }
	      });
	      this.props.onSortingSubmit(allmetakeys);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(data) {
	      var allmetakeys = (0, _clone2.default)(this.state.allmetakeys);
	      var self = this;
	      var tempmetakeys = [];
	      if (data !== null) {
	        data.forEach(function (meta) {
	          var index = (0, _underscore.findIndex)(allmetakeys, { value: meta.value });
	          if (index !== -1) {
	            tempmetakeys.push({
	              value: meta.value,
	              label: meta.value,
	              title: allmetakeys[index].title
	            });
	          } else {
	            tempmetakeys.push({
	              value: meta.value,
	              label: meta.value,
	              title: meta.value
	            });
	          }
	        });
	        self.props.onSortingSubmit(tempmetakeys);
	        self.setState({ allmetakeys: tempmetakeys });
	      } else {
	        self.setState({ allmetakeys: [] });
	        self.props.onSortingSubmit([]);
	      }
	    }
	  }, {
	    key: 'handleRemoveMeta',
	    value: function handleRemoveMeta(meta, event) {
	      event.preventDefault();
	      var allmetakeys = this.state.allmetakeys;
	      var findKey = (0, _underscore.findIndex)(allmetakeys, { value: meta.value });
	      allmetakeys.splice(findKey, 1);
	      this.props.onSortingSubmit(allmetakeys);
	      this.setState({ allmetakeys: allmetakeys });
	    }
	  }, {
	    key: 'handleChangeMeta',
	    value: function handleChangeMeta(meta, event) {
	      meta.title = event.target.value;
	      var allmetakeys = this.state.allmetakeys;
	      var Index = (0, _underscore.findIndex)(allmetakeys, { value: meta.value });
	      allmetakeys[Index] = meta;
	      this.props.onSortingSubmit(allmetakeys);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var sortingData = this.state.allmetakeys;
	      this.metakeys = [{
	        value: 'post_date',
	        label: 'post_date'
	      }, {
	        value: 'comment_count',
	        label: 'comment_count'
	      }, {
	        value: 'post_title',
	        label: 'post_title'
	      }];
	      if (this.props.helperData !== undefined) {
	        this.props.helperData.metakeys.forEach(function (metakey) {
	          _this2.metakeys.push({
	            'value': metakey,
	            'label': metakey
	          });
	        });
	      }
	
	      var sortingValues = [];
	      sortingData.forEach(function (meta) {
	        sortingValues.push(meta.value);
	      });
	      var sortingValue = sortingValues.join(',');
	
	      var showAllMetakey = function showAllMetakey(meta, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'sortingmeta', key: 'sorting-' + index, 'data-value': meta.value },
	          _react2.default.createElement('i', { className: 'fa fa-ellipsis-h sort-shortable', 'aria-hidden': 'true' }),
	          _react2.default.createElement('input', { type: 'text', className: 'reactive-input', defaultValue: meta.title, onChange: _this2.handleChangeMeta.bind(_this2, meta), placeholder: API.LANG.PLACE_TITLE }),
	          _react2.default.createElement(
	            'a',
	            { className: 'metaremove', href: '#', onClick: _this2.handleRemoveMeta.bind(_this2, meta) },
	            _react2.default.createElement('i', { className: 'ion-android-close' })
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { role: 'tabpanel', className: 'tab-pane', id: 'sorting' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-6 flex-xs-12' },
	            _react2.default.createElement(
	              'p',
	              { className: 'caption' },
	              API.LANG.PLEASE_SELECT_SORTING_ATTRIBUTES
	            ),
	            _react2.default.createElement(_reactSelect2.default, { onChange: this.handleChange.bind(this), options: this.metakeys, multi: true, value: sortingValue }),
	            _react2.default.createElement(
	              'div',
	              { id: 'sortmeta' },
	              sortingData.length ? sortingData.map(showAllMetakey) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SortingPanel;
	}(_react2.default.Component);
	
	exports.default = SortingPanel;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BarAppearance = function (_React$Component) {
	  _inherits(BarAppearance, _React$Component);
	
	  function BarAppearance(props) {
	    _classCallCheck(this, BarAppearance);
	
	    var _this = _possibleConstructorReturn(this, (BarAppearance.__proto__ || Object.getPrototypeOf(BarAppearance)).call(this, props));
	
	    _this.displayName = 'BarAppearance';
	    _this.state = {
	      data: _this.props.barData
	    };
	    return _this;
	  }
	
	  _createClass(BarAppearance, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.barData) {
	        this.setState({
	          data: nextProps.barData
	        });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(key, event) {
	      var data = this.state.data ? this.state.data : {};
	      data[key] = event.target.value;
	      this.props.appearData(data);
	      this.setState({ data: data });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dummy = {
	        filter_count: '',
	        sorting_option: '',
	        view_changer: '',
	        topbar_pagination: '',
	        bottombar_loadmore: '',
	        bottombar_pagination: ''
	      };
	
	      var data = this.state.data ? this.state.data : dummy;
	      return _react2.default.createElement(
	        'div',
	        { role: 'tabpanel', className: 'tab-pane', id: 'barapp' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-sm-6 flex-xs-12' },
	            _react2.default.createElement('input', { type: 'text', value: data.filter_count, className: 'reactive-input', onChange: this.handleChange.bind(this, 'filter_count'), placeholder: API.LANG.PLACE_CLASS_NAME_4_FILTER_COUNT })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-sm-6 flex-xs-12' },
	            _react2.default.createElement('input', { type: 'text', value: data.sorting_option, className: 'reactive-input', onChange: this.handleChange.bind(this, 'sorting_option'), placeholder: API.LANG.PLACE_CLASS_NAME_4_SORT })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-sm-6 flex-xs-12' },
	            _react2.default.createElement('input', { type: 'text', value: data.view_changer, className: 'reactive-input', onChange: this.handleChange.bind(this, 'view_changer'), placeholder: API.LANG.PLACE_CLASS_NAME_4_VIEW })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-sm-6 flex-xs-12' },
	            _react2.default.createElement('input', { type: 'text', value: data.topbar_pagination, className: 'reactive-input', onChange: this.handleChange.bind(this, 'topbar_pagination'), placeholder: API.LANG.PLACE_CLASS_NAME_4_TOP_PAGINATION })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-sm-6 flex-xs-12' },
	            _react2.default.createElement('input', { type: 'text', value: data.bottombar_pagination, className: 'reactive-input', onChange: this.handleChange.bind(this, 'bottombar_pagination'), placeholder: API.LANG.PLACE_CLASS_NAME_4_BOTTOM_PAGINATION })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-sm-6 flex-xs-12' },
	            _react2.default.createElement('input', { type: 'text', value: data.bottombar_loadmore, className: 'reactive-input', onChange: this.handleChange.bind(this, 'bottombar_loadmore'), placeholder: API.LANG.PLACE_CLASS_NAME_4_BOTTOM_LOAD_MORE })
	          )
	        )
	      );
	    }
	  }]);
	
	  return BarAppearance;
	}(_react2.default.Component);
	
	exports.default = BarAppearance;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import Select from 'react-select';
	// import GridActions from './action/gridActions';
	// import BuildActions from '../builder/action/builderActions';
	// import { findIndex } from 'underscore';
	// import clone from 'clone';
	// import GridStore from './store/gridStore';
	// import classNames from 'classnames';
	// import ImageSelect from '../element/imageselect';
	
	
	var UserPanel = function (_React$Component) {
	  _inherits(UserPanel, _React$Component);
	
	  function UserPanel() {
	    _classCallCheck(this, UserPanel);
	
	    return _possibleConstructorReturn(this, (UserPanel.__proto__ || Object.getPrototypeOf(UserPanel)).apply(this, arguments));
	  }
	
	  _createClass(UserPanel, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "this is user panel "
	        )
	      );
	    }
	  }]);
	
	  return UserPanel;
	}(_react2.default.Component);
	
	exports.default = UserPanel;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _categoryActions = __webpack_require__(495);
	
	var _categoryActions2 = _interopRequireDefault(_categoryActions);
	
	var _categoryStore = __webpack_require__(496);
	
	var _categoryStore2 = _interopRequireDefault(_categoryStore);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _underscore = __webpack_require__(205);
	
	var _gridselect = __webpack_require__(481);
	
	var _gridselect2 = _interopRequireDefault(_gridselect);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryPanel = function (_React$Component) {
	  _inherits(CategoryPanel, _React$Component);
	
	  function CategoryPanel(props) {
	    _classCallCheck(this, CategoryPanel);
	
	    var _this = _possibleConstructorReturn(this, (CategoryPanel.__proto__ || Object.getPrototypeOf(CategoryPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleSubmiCategory = _this.handleSubmiCategory.bind(_this);
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.loadSettings = _this.loadSettings.bind(_this);
	    _this.valueIncrement = _this.valueIncrement.bind(_this);
	    _this.valueDecrement = _this.valueDecrement.bind(_this);
	    _this.valueIncrementLayout = _this.valueIncrementLayout.bind(_this);
	    _this.valueDecrementLayout = _this.valueDecrementLayout.bind(_this);
	    _this.handleLoadMoreButton = _this.handleLoadMoreButton.bind(_this);
	    _this.handleCheckedCategoryTemplate = _this.handleCheckedCategoryTemplate.bind(_this);
	    _this.state = {
	      settings: {
	        numberOfCategories: 6,
	        loadMoreOption: false,
	        desktop_hd: 2,
	        desktop: 2,
	        tablet: 1,
	        mobile: 1
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CategoryPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadSettings(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.loadSettings(nextProps);
	    }
	  }, {
	    key: 'loadSettings',
	    value: function loadSettings(props) {
	      var allLayout = props.allLayout;
	      var categoryTemplate = [];
	      this.FlagCategoryTemplate = false;
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var settings = {};
	        if (allLayout[find].categorySettings) {
	          settings = allLayout[find].categorySettings;
	        }
	        if (!settings.hasOwnProperty('termName')) {
	          settings.termName = null;
	        }
	        // Categorey Template  value assigning starts
	        if (!settings.hasOwnProperty('categoryTemplate')) {
	          for (var key in ReactiveCategoryTemplate) {
	            if (ReactiveCategoryTemplate.hasOwnProperty(key)) {
	              var temp = {};
	              temp.key = key;
	              temp.value = ReactiveCategoryTemplate[key];
	              if (settings.categoryTemplate !== key.toString()) {
	                temp.isChecked = false;
	              } else {
	                this.FlagCategoryTemplate = true;
	                temp.isChecked = true;
	              }
	              categoryTemplate.push(temp);
	            }
	          }
	        } else {
	          this.FlagCategoryTemplate = true;
	          categoryTemplate = settings.categoryTemplate;
	        }
	        if (this.FlagCategoryTemplate === false) {
	          var index = (0, _underscore.findIndex)(categoryTemplate, { key: 'default' });
	          if (index !== -1) {
	            categoryTemplate[index].isChecked = true;
	          }
	        }
	        settings['categoryTemplate'] = categoryTemplate;
	        // Categorey Template  value assigning ends
	        this.setState({
	          settings: _extends({}, this.state.settings, settings),
	          'allLayout': (0, _clone2.default)(this.props.allLayout)
	        });
	      }
	    }
	  }, {
	    key: 'saveSettingsData',
	    value: function saveSettingsData(key, value) {
	      var settings = this.state.settings;
	
	      if (key === 'layout') {
	        var allLayout = (0, _clone2.default)(this.props.allLayout);
	        var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	        if (index !== -1) {
	          allLayout[index].layout = value;
	          settings[key] = value;
	          this.setState({ settings: settings, allLayout: allLayout });
	        }
	      } else {
	        settings[key] = value;
	        this.setState({ settings: settings });
	      }
	    }
	  }, {
	    key: 'handleSubmiCategory',
	    value: function handleSubmiCategory() {
	      var allLayout = (0, _clone2.default)(this.state.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find]['categorySettings'] = (0, _clone2.default)(this.state.settings);
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(termName) {
	      var settings = this.state.settings;
	
	      settings['termName'] = termName;
	      this.setState({ settings: settings });
	    }
	  }, {
	    key: 'valueIncrement',
	    value: function valueIncrement() {
	      var value = null;
	      if (this.state.settings.numberOfCategories !== undefined) {
	        value = parseInt(this.state.settings.numberOfCategories, 10);
	      } else {
	        value = 5;
	      }
	      value += 1;
	      this.saveSettingsData('numberOfCategories', value);
	    }
	  }, {
	    key: 'valueDecrement',
	    value: function valueDecrement() {
	      var value = null;
	      if (this.state.settings.numberOfCategories !== undefined) {
	        value = parseInt(this.state.settings.numberOfCategories, 10);
	      } else {
	        value = 5;
	      }
	      if (value === 0) {
	        return;
	      }
	      value -= 1;
	      this.saveSettingsData('numberOfCategories', value);
	    }
	  }, {
	    key: 'valueIncrementLayout',
	    value: function valueIncrementLayout() {
	      var value = null;
	      if (this.state.settings.layout !== undefined) {
	        value = parseInt(this.state.settings.layout, 10);
	      } else {
	        value = 12;
	      }
	      if (value + 1 > 12) {
	        return;
	      }
	      value += 1;
	      this.saveSettingsData('layout', value);
	    }
	  }, {
	    key: 'valueDecrementLayout',
	    value: function valueDecrementLayout() {
	      var value = null;
	      if (this.state.settings.layout !== undefined) {
	        value = parseInt(this.state.settings.layout, 10);
	      } else {
	        value = 12;
	      }
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.saveSettingsData('layout', value);
	    }
	  }, {
	    key: 'handleCategoreyValueIncrement',
	    value: function handleCategoreyValueIncrement(element) {
	      var value = null;
	      if (this.state.settings[element] !== undefined) {
	        value = parseInt(this.state.settings[element], 10);
	      } else {
	        value = 2;
	      }
	      if (element === 'desktop_hd') {
	        if (value + 1 > 4) {
	          return;
	        }
	      } else if (element === 'desktop') {
	        if (value + 1 > 4) {
	          return;
	        }
	      } else if (element === 'tablet') {
	        if (value + 1 > 3) {
	          return;
	        }
	      } else if (element === 'mobile') {
	        if (value + 1 > 2) {
	          return;
	        }
	      }
	      value += 1;
	      this.saveSettingsData(element, value);
	    }
	  }, {
	    key: 'handleCategoreyValueDecrement',
	    value: function handleCategoreyValueDecrement(element) {
	      var value = null;
	      if (this.state.settings[element] !== undefined) {
	        value = parseInt(this.state.settings[element], 10);
	      } else {
	        value = 2;
	      }
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.saveSettingsData(element, value);
	    }
	  }, {
	    key: 'handleCheckedCategoryTemplate',
	    value: function handleCheckedCategoryTemplate(e) {
	      var categoryTemplate = this.state.settings.categoryTemplate;
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        categoryTemplate.map(function (item) {
	          if (item.value === e.target.value.toString()) {
	            if (item.isChecked === 'false' || item.isChecked === false) {
	              item.isChecked = true;
	            } else {
	              item.isChecked = false;
	            }
	          } else {
	            item.isChecked = false;
	          }
	        });
	      }
	      this.saveSettingsData('categoryTemplate', categoryTemplate);
	    }
	  }, {
	    key: 'handleLoadMoreButton',
	    value: function handleLoadMoreButton() {
	      if (this.state.settings.loadMoreOption === 'false' || this.state.settings.loadMoreOption === false) {
	        this.saveSettingsData('loadMoreOption', true);
	      } else {
	        this.saveSettingsData('loadMoreOption', false);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var self = this;
	      var showCategoryTemplate = function showCategoryTemplate(item, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'search-content', key: 'categorypanel-' + index },
	          _react2.default.createElement('input', { type: 'radio', name: 'search-categoreyElement', checked: item.isChecked === true || item.isChecked === 'true', id: 'categoryStyle-' + index, value: item.value,
	            onChange: _this2.handleCheckedCategoryTemplate
	          }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select-search-content', htmlFor: 'categoryStyle-' + index },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.key
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.handleSubmiCategory },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#general', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.SETTINGS
	              )
	            ),
	            this.state.settings.termName && _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'layout', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            this.state.settings.termName && _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#styles', 'aria-controls': 'styles', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.LAYOUT
	              )
	            ),
	            this.state.settings.termName && _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#options', 'aria-controls': 'options', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.OPTIONS
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'general' },
	              _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.termName }, this.props))
	            ),
	            this.state.settings.termName && _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'appearance' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.NUMBER_OF_CATEGOREY
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.valueIncrement },
	                            _react2.default.createElement('i', { className: 'fa fa-plus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.valueDecrement },
	                            _react2.default.createElement('i', { className: 'fa fa-minus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'gird-value-count' },
	                          this.state.settings.numberOfCategories !== undefined ? this.state.settings.numberOfCategories : 5
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.CHANGE_CATEGOREY_LAYOUT
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'choose-grid-button' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.valueIncrementLayout },
	                              _react2.default.createElement('i', { className: 'fa fa-plus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.valueDecrementLayout },
	                              _react2.default.createElement('i', { className: 'fa fa-minus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'gird-value-count' },
	                            this.state.settings.layout !== undefined ? this.state.settings.layout : 12
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option no-padding' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.LOAD_MORE_TOGGLE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(_reactToggle2.default, {
	                          defaultChecked: this.state.settings.loadMoreOption === 'true' || this.state.settings.loadMoreOption === true,
	                          onChange: this.handleLoadMoreButton
	                        })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.CATEGOREY_DESKTOP_HD
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueIncrement.bind(this, 'desktop_hd') },
	                            _react2.default.createElement('i', { className: 'fa fa-plus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueDecrement.bind(this, 'desktop_hd') },
	                            _react2.default.createElement('i', { className: 'fa fa-minus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'gird-value-count' },
	                          this.state.settings.desktop_hd !== undefined ? this.state.settings.desktop_hd : 2
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.CATEGOREY_DESKTOP
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueIncrement.bind(this, 'desktop') },
	                            _react2.default.createElement('i', { className: 'fa fa-plus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueDecrement.bind(this, 'desktop') },
	                            _react2.default.createElement('i', { className: 'fa fa-minus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'gird-value-count' },
	                          this.state.settings.desktop !== undefined ? this.state.settings.desktop : 2
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.CATEGOREY_TABLET
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueIncrement.bind(this, 'tablet') },
	                            _react2.default.createElement('i', { className: 'fa fa-plus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueDecrement.bind(this, 'tablet') },
	                            _react2.default.createElement('i', { className: 'fa fa-minus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'gird-value-count' },
	                          this.state.settings.tablet !== undefined ? this.state.settings.tablet : 1
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.CATEGOREY_MOBILE
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueIncrement.bind(this, 'mobile') },
	                            _react2.default.createElement('i', { className: 'fa fa-plus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleCategoreyValueDecrement.bind(this, 'mobile') },
	                            _react2.default.createElement('i', { className: 'fa fa-minus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'gird-value-count' },
	                          this.state.settings.mobile !== undefined ? this.state.settings.mobile : 1
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            this.state.settings.termName && _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'styles' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'caption' },
	                  API.LANG.SELECT_CATEGORY_TEMPLATE
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'list-inline' },
	                    ' ',
	                    this.state.settings.categoryTemplate !== undefined ? this.state.settings.categoryTemplate.map(showCategoryTemplate) : null
	                  )
	                )
	              )
	            ),
	            this.state.settings.termName && _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'options' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option no-padding' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.LOAD_MORE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.viewMoreLink, onChange: function onChange(node) {
	                        self.saveSettingsData('viewMoreLink', node.target.value);
	                      } })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option no-padding' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.WRAPPER_CLASS_CATEGORY
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.categoryWrapperClass, onChange: function onChange(node) {
	                        self.saveSettingsData('categoryWrapperClass', node.target.value);
	                      } })
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CategoryPanel;
	}(_react2.default.Component);
	
	CategoryPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array
	};
	
	exports.default = CategoryPanel;
	// roman sucks

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _ajax = __webpack_require__(476);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryActions = _reflux2.default.createActions(['getBuilderData', 'publishHelper', 'publishTaxonomyData']);
	
	// builder-ajax
	CategoryActions.getBuilderData.preEmit = function (reqData) {
	
	  _ajax2.default.post('load_request_data', reqData).end(function (error, res) {
	    if (res) {
	      CategoryActions.publishHelper(JSON.parse(res.text));
	    }
	  });
	};
	
	exports.default = CategoryActions;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _categoryActions = __webpack_require__(495);
	
	var _categoryActions2 = _interopRequireDefault(_categoryActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CategoryStore = _reflux2.default.createStore({
	  listenables: _categoryActions2.default,
	  onPublishHelper: function onPublishHelper(data) {
	    this.trigger(data);
	  },
	  onPublishTaxonomyData: function onPublishTaxonomyData(data) {
	    this.trigger(data);
	  }
	});
	
	exports.default = CategoryStore;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _gridStore = __webpack_require__(498);
	
	var _gridStore2 = _interopRequireDefault(_gridStore);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaxonomySelection = function (_React$Component) {
	  _inherits(TaxonomySelection, _React$Component);
	
	  function TaxonomySelection(props) {
	    _classCallCheck(this, TaxonomySelection);
	
	    var _this = _possibleConstructorReturn(this, (TaxonomySelection.__proto__ || Object.getPrototypeOf(TaxonomySelection)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.taxonomies = [];
	    return _this;
	  }
	
	  _createClass(TaxonomySelection, [{
	    key: 'handleChange',
	    value: function handleChange(val) {
	      this.props.onTaxonomySelection(val);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.props.helperData) {
	        this.helperData = this.props.helperData ? (0, _clone2.default)(this.props.helperData) : {};
	      }
	      var isSearchLayout = (0, _underscore.findIndex)(this.props.allLayout, { type: 'search' });
	      if (isSearchLayout !== -1 && this.props.allLayout[isSearchLayout].hasOwnProperty('searchAttr')) {
	
	        this.props.allLayout[isSearchLayout].searchAttr.map(function (item) {
	          var duplicatedTaxonomyIndex = _.indexOf(_this2.helperData.taxonomies, item.selectedTaxonomy);
	          if (duplicatedTaxonomyIndex !== -1 && _this2.props.value !== item.selectedTaxonomy) {
	            _this2.helperData.taxonomies = _.without(_this2.helperData.taxonomies, _this2.helperData.taxonomies[duplicatedTaxonomyIndex]);
	          }
	        });
	      }
	      this.taxonomies = [];
	      var panelTypeSearch = this.props.panelType.indexOf('search');
	      if ('taxonomies' in this.helperData && panelTypeSearch !== -1) {
	        this.helperData.taxonomies.forEach(function (taxonomy) {
	          _this2.taxonomies.push({
	            'value': taxonomy,
	            'label': taxonomy
	          });
	        });
	      } else {
	        this.props.helperData.taxonomies.forEach(function (taxonomy) {
	          _this2.taxonomies.push({
	            'value': taxonomy,
	            'label': taxonomy
	          });
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex-row' },
	        this.taxonomies.length ? _react2.default.createElement(
	          'div',
	          { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	          _react2.default.createElement(_reactSelect2.default, {
	            name: 'form-field-name',
	            placeholder: 'Please select a taxonomy',
	            value: this.props.value,
	            options: this.taxonomies,
	            onChange: this.handleChange
	          })
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          ' sorry, Please select a post type form content section '
	        )
	      );
	    }
	  }]);
	
	  return TaxonomySelection;
	}(_react2.default.Component);
	
	TaxonomySelection.propTypes = {
	  'panelType': _react2.default.PropTypes.string,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'onTaxonomySelection': _react2.default.PropTypes.func
	};
	
	exports.default = TaxonomySelection;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _gridActions = __webpack_require__(480);
	
	var _gridActions2 = _interopRequireDefault(_gridActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GridStore = _reflux2.default.createStore({
	  listenables: _gridActions2.default,
	  onPublishHelper: function onPublishHelper(data) {
	    this.trigger(data);
	  }
	});
	
	exports.default = GridStore;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRangePicker = function (_React$Component) {
	  _inherits(DateRangePicker, _React$Component);
	
	  function DateRangePicker(props) {
	    _classCallCheck(this, DateRangePicker);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.handeDateFormat = _this.handeDateFormat.bind(_this);
	    _this.handleChangeCalenderViewType = _this.handleChangeCalenderViewType.bind(_this);
	    _this.handleMonthView = _this.handleMonthView.bind(_this);
	    _this.handleClassName = _this.handleClassName.bind(_this);
	    _this.datatypes = [{
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.DateFormat = [{
	      'label': 'DD-MM-YYYY',
	      'value': 'DD-MM-YYYY'
	    }, {
	      'label': 'DD/MM/YYYY',
	      'value': 'DD/MM/YYYY'
	    }, {
	      'label': 'MM-DD-YYYY',
	      'value': 'MM-DD-YYYY'
	    }, {
	      'label': 'MM/DD/YYYY',
	      'value': 'MM/DD/YYYY'
	    }, {
	      'label': 'YYYY/MM/DD',
	      'value': 'YYYY/MM/DD'
	    }, {
	      'label': 'YYYY-MM-DD',
	      'value': 'YYYY-MM-DD'
	    }, {
	      'label': 'DD/MMM/YYYY',
	      'value': 'DD/MMM/YYYY'
	    }, {
	      'label': 'DD-MMM-YYYY',
	      'value': 'DD-MMM-YYYY'
	    }, {
	      'label': 'DD.MM.YYYY',
	      'value': 'DD.MM.YYYY'
	    }, {
	      'label': 'MM.DD.YYYY',
	      'value': 'MM.DD.YYYY'
	    }, {
	      'label': 'YYYY.MM.DD',
	      'value': 'YYYY.MM.DD'
	    }, {
	      'label': 'Mo MMM YYYY',
	      'value': 'Mo MMM YYYY'
	    }, {
	      'label': 'Mo MMM, YYYY',
	      'value': 'Mo MMM, YYYY'
	    }];
	    _this.calenderView = [{
	      'label': 'Date Range',
	      'value': 'range'
	    }, {
	      'label': 'Single Date',
	      'value': 'single'
	    }];
	    _this.monthView = [{
	      'label': 'Double Month',
	      'value': 'double'
	    }, {
	      'label': 'Single Month',
	      'value': 'single'
	    }];
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handeDateFormat',
	    value: function handeDateFormat(e) {
	      var value = e === null ? 'DD-MM-YYYY' : e.value;
	      this.settings.dateFormat = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelMaxValue',
	    value: function handelMaxValue(e) {
	      this.settings.maxvalue = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelMinValue',
	    value: function handelMinValue(e) {
	      this.settings.minvalue = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeCalenderViewType',
	    value: function handleChangeCalenderViewType(val) {
	      this.settings.selectedCalenderViewType = val.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMonthView',
	    value: function handleMonthView(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMonthViewType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Appearance'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                'Data'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME }),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLACE_TOOGLE,
	                    value: this.state.settings.selectedToogleViewType,
	                    options: this.toogleviewtype,
	                    onChange: this.handleChangeToogleViewTypes
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_THE_DATE_FORMAT,
	                    value: this.state.settings.dateFormat,
	                    options: this.DateFormat,
	                    onChange: this.handeDateFormat
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLACE_CAL_VIEW,
	                    value: this.state.settings.selectedCalenderViewType,
	                    options: this.calenderView,
	                    onChange: this.handleChangeCalenderViewType
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLACE_MONTH_VIEW,
	                    value: this.state.settings.selectedMonthViewType,
	                    options: this.monthView,
	                    onChange: this.handleMonthView
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, date: true, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DateRangePicker;
	}(_react2.default.Component);
	
	DateRangePicker.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = DateRangePicker;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetaDataSelection = function (_React$Component) {
	  _inherits(MetaDataSelection, _React$Component);
	
	  function MetaDataSelection(props) {
	    _classCallCheck(this, MetaDataSelection);
	
	    var _this = _possibleConstructorReturn(this, (MetaDataSelection.__proto__ || Object.getPrototypeOf(MetaDataSelection)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    // Note : it may change the metakeys if the post type change
	    if (REBUILDER.hasOwnProperty(_this.metakey)) {
	      _this.helperData = REBUILDER[_this.metakey].helperData ? REBUILDER[_this.metakey].helperData : {};
	    } else {
	      alert('sorry select a post type into content section');
	    }
	    _this.metakeys = [];
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(MetaDataSelection, [{
	    key: 'handleChange',
	    value: function handleChange(val) {
	      this.props.onMetakeySelection(val);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.metakeys = [];
	      if (this.props.date) {
	        this.metakeys.push({
	          'value': 'post_date',
	          'label': 'post_date'
	        });
	      }
	      if ('metakeys' in this.helperData) {
	        this.helperData.metakeys.forEach(function (metakey) {
	          _this2.metakeys.push({
	            'value': metakey,
	            'label': metakey
	          });
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex-row' },
	        this.metakeys.length ? _react2.default.createElement(
	          'div',
	          { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	          _react2.default.createElement(_reactSelect2.default, {
	            name: 'form-field-name',
	            placeholder: 'Please select a metakey',
	            value: this.props.value,
	            options: this.metakeys,
	            onChange: this.handleChange
	          })
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          ' sorry, Please select a post type form content section '
	        )
	      );
	    }
	  }]);
	
	  return MetaDataSelection;
	}(_react2.default.Component);
	
	MetaDataSelection.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'value': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'onMetakeySelection': _react2.default.PropTypes.func
	};
	
	exports.default = MetaDataSelection;

/***/ },
/* 501 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stringify = stringify;
	function stringify(inputString) {
	  if (inputString === undefined) {
	    return '';
	  }
	  var title = '';
	  for (var i = 0; i < inputString.length; i++) {
	    if (inputString[i] !== '\\') {
	      title = title + inputString[i];
	    }
	  }
	  return title;
	}

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchPanel = function (_React$Component) {
	  _inherits(SearchPanel, _React$Component);
	
	  function SearchPanel(props) {
	    _classCallCheck(this, SearchPanel);
	
	    var _this = _possibleConstructorReturn(this, (SearchPanel.__proto__ || Object.getPrototypeOf(SearchPanel)).call(this, props));
	
	    _this.searchComponents = [{
	      icon: 'ion-android-checkbox-outline',
	      type: 'checkbox',
	      name: API.LANG.CHECK_BOX
	    }, {
	      icon: 'ion-android-radio-button-on',
	      type: 'radio',
	      name: API.LANG.RADIO
	    }, {
	      icon: 'ion-compose',
	      type: 'select',
	      name: API.LANG.SELECT
	    }, {
	      icon: 'ion-android-list',
	      type: 'combobox',
	      name: API.LANG.COMBO_BOX
	    }, {
	      icon: 'ion-arrow-resize',
	      type: 'sizebox',
	      name: API.LANG.SIZE_BOX
	    }, {
	      icon: 'ion-ios-color-wand-outline',
	      type: 'colorbox',
	      name: API.LANG.COLOR_BOX
	    }, {
	      icon: 'ion-arrow-swap',
	      type: 'scrollbox',
	      name: API.LANG.SCROLL_BOX
	    }, {
	      icon: 'ion-image',
	      type: 'imageselect',
	      name: API.LANG.IMAGE_SELECT
	    }, {
	      icon: 'ion-social-tumblr',
	      type: 'text',
	      name: API.LANG.TEXT
	    }, {
	      icon: 'ion-pricetag',
	      type: 'tag',
	      name: API.LANG.TAGS
	    }, {
	      icon: 'ion-android-options',
	      type: 'rangeinput',
	      name: API.LANG.RANGE_INPUT
	    }, {
	      icon: 'ion-location',
	      type: 'mapsearch',
	      name: API.LANG.MAP_SEARCH
	    }, {
	      icon: 'ion-loop',
	      type: 'reset',
	      name: API.LANG.RESET
	    }, {
	      icon: 'ion-hammer',
	      type: 'sidebar',
	      name: API.LANG.SIDEBAR
	    }, {
	      icon: 'ion-ios-list',
	      type: 'linearcheckbox',
	      name: API.LANG.LINEARCHECKBOX
	    }, {
	      icon: 'ion-calendar',
	      type: 'daterange',
	      name: API.LANG.DATEPICKER
	    }];
	    var isRnB = _this.props.settingsData.hasOwnProperty('rnb_active') ? true : false;
	    if (isRnB === true) {
	      var temp = {
	        icon: 'ion-model-s',
	        type: 'rnb-daterange',
	        name: API.LANG.RNBDATEPICKER
	      };
	      _this.searchComponents.push(temp);
	    }
	    _this.handleSelected = _this.handleSelected.bind(_this);
	    _this.allLayout = [12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
	    _this.addSelected = _this.addSelected.bind(_this);
	    var indexType = (0, _underscore.findIndex)(_this.props.allLayout, { uid: _this.props.uid });
	    if (indexType !== -1) {
	      _this.state = { styleType: _this.props.allLayout[indexType].styleType, showAdvacedOption: false };
	    } else {
	      _this.state = { styleType: null, showAdvacedOption: false };
	    }
	    return _this;
	  }
	
	  _createClass(SearchPanel, [{
	    key: 'handleSelected',
	    value: function handleSelected(e) {
	      if (e.target.checked) {
	        this.selectedElement = e.target.value;
	      }
	    }
	  }, {
	    key: 'addSelected',
	    value: function addSelected(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      if (this.selectedElement) {
	        var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	        if (find !== -1) {
	          if (typeof allLayout[find].searchAttr === 'undefined') {
	            allLayout[find].searchAttr = [];
	          }
	          allLayout[find].searchAttr.push({
	            'uid': new Date().getTime(),
	            'viewType': this.selectedElement,
	            'title': this.selectedElement
	          });
	        }
	        var pushLayout = {
	          allLayout: allLayout,
	          'shortcodeKey': this.props.shortcodeKey
	        };
	        _builderActions2.default.saveAllBlocks(pushLayout);
	        this.props.onClickedPanel();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var showSearchElements = function showSearchElements(element, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'search-content', key: 'searchElement-' + index },
	          _react2.default.createElement('input', { type: 'radio', name: 'search-element', id: 'search-block-' + index, value: element.type, onChange: _this2.handleSelected }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select-search-content', htmlFor: 'search-block-' + index },
	            _react2.default.createElement('i', { className: element.icon }),
	            _react2.default.createElement(
	              'span',
	              { className: 'search-title' },
	              element.name
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'for-search-panel' },
	          _react2.default.createElement(
	            'div',
	            { className: '' },
	            _react2.default.createElement(
	              'span',
	              { className: 'caption' },
	              API.LANG.SELECT_TYPE
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: '' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'list-inline' },
	                ' ',
	                this.searchComponents.map(showSearchElements)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'add-button-content' },
	          this.state.errorMsg !== undefined ? _react2.default.createElement(
	            'p',
	            { className: 'error-body' },
	            this.state.errorMsg
	          ) : null,
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'add-button', onClick: this.addSelected },
	            ' ',
	            API.LANG.ADD,
	            ' '
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchPanel;
	}(_react2.default.Component);
	
	SearchPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'onClickedPanel': _react2.default.PropTypes.func,
	  'settingsData': _react2.default.PropTypes.object
	};
	
	exports.default = SearchPanel;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _underscore = __webpack_require__(205);
	
	var _sidebarAction = __webpack_require__(504);
	
	var _sidebarAction2 = _interopRequireDefault(_sidebarAction);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideBarPanel = function (_React$Component) {
	  _inherits(SideBarPanel, _React$Component);
	
	  function SideBarPanel(props) {
	    _classCallCheck(this, SideBarPanel);
	
	    var _this = _possibleConstructorReturn(this, (SideBarPanel.__proto__ || Object.getPrototypeOf(SideBarPanel)).call(this, props));
	
	    _this.sidebarOptions = API.sidebar;
	    _this.handleSubmiCategory = _this.handleSubmiCategory.bind(_this);
	    _this.handleSidebarOptionChange = _this.handleSidebarOptionChange.bind(_this);
	    _this.state = {
	      selectedSidebar: null
	    };
	    return _this;
	  }
	
	  _createClass(SideBarPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var uid = (0, _clone2.default)(this.props.uid);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: uid.toString() });
	      var self = this;
	      if (index !== -1) {
	        var indexOfSidebar = (0, _underscore.findIndex)(allLayout[index].searchAttr, { viewType: 'sidebar' });
	        if (indexOfSidebar !== -1) {
	          var name = allLayout[index].searchAttr[indexOfSidebar].sidebarName;
	          self.setState({ selectedSidebar: name });
	        }
	      }
	    }
	  }, {
	    key: 'handleSidebarOptionChange',
	    value: function handleSidebarOptionChange(selectedValue) {
	      var value = selectedValue === null ? null : selectedValue.value;
	      this.setState({
	        selectedSidebar: value
	      });
	    }
	  }, {
	    key: 'handleSubmiCategory',
	    value: function handleSubmiCategory() {
	      _sidebarAction2.default.getSidebarWidget({
	        name: this.state.selectedSidebar
	      });
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var uid = (0, _clone2.default)(this.props.uid);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: uid.toString() });
	      if (index !== -1) {
	        var indexOfSidebar = (0, _underscore.findIndex)(allLayout[index].searchAttr, { viewType: 'sidebar' });
	        if (indexOfSidebar !== -1) {
	          allLayout[index].searchAttr[indexOfSidebar].sidebarName = this.state.selectedSidebar;
	        }
	        var pushLayout = {
	          allLayout: allLayout,
	          'shortcodeKey': this.props.shortcodeKey
	        };
	        _builderActions2.default.saveAllBlocks(pushLayout);
	        _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var sidebarArray = [];
	      if (this.sidebarOptions !== undefined && this.sidebarOptions.length > 0) {
	        this.sidebarOptions.forEach(function (sidebarOption) {
	          sidebarArray.push({
	            'value': sidebarOption.name,
	            'label': sidebarOption.name
	          });
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.handleSubmiCategory },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#general', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Settings'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'general' },
	              _react2.default.createElement(
	                'p',
	                { className: 'caption' },
	                'Please select a sidbar'
	              ),
	              _react2.default.createElement(_reactSelect2.default, { onChange: this.handleSidebarOptionChange, options: sidebarArray, value: this.state.selectedSidebar })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SideBarPanel;
	}(_react2.default.Component);
	
	exports.default = SideBarPanel;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _nprogress = __webpack_require__(192);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _ajax = __webpack_require__(476);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarAction = _reflux2.default.createActions(['getSidebarWidget', 'publishAllWidget']);
	
	_nprogress2.default.configure({ easing: 'ease', speed: 1000 });
	
	SidebarAction.getSidebarWidget.preEmit = function (data) {
	  _nprogress2.default.start();
	  _ajax2.default.post('load_sidebar', data).end(function (error, res) {
	    if (res) {
	      _nprogress2.default.done();
	      SidebarAction.publishAllWidget(res.text);
	    }
	  });
	};
	
	exports.default = SidebarAction;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckBoxPanel = function (_React$Component) {
	  _inherits(CheckBoxPanel, _React$Component);
	
	  function CheckBoxPanel(props) {
	    _classCallCheck(this, CheckBoxPanel);
	
	    var _this = _possibleConstructorReturn(this, (CheckBoxPanel.__proto__ || Object.getPrototypeOf(CheckBoxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.handleValueIncrement = _this.handleValueIncrement.bind(_this);
	    _this.handleValueDecrement = _this.handleValueDecrement.bind(_this);
	    _this.handleShowItem = _this.handleShowItem.bind(_this);
	    _this.handleChangeLoadMore = _this.handleChangeLoadMore.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }, {
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'title': null,
	      'subtitle': null,
	      settings: {
	        showNumberOfItems: false,
	        setColumn: 2,
	        showItem: 5
	      }
	    };
	    return _this;
	  }
	
	  _createClass(CheckBoxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.state.settings, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleChangeLoadMore',
	    value: function handleChangeLoadMore(val) {
	      this.settings.LoadMoreOption = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleShowItem',
	    value: function handleShowItem(e) {
	      this.settings.showItem = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleShowNumberOfItems',
	    value: function handleShowNumberOfItems() {
	      if (this.state.settings.showNumberOfItems === 'false' || this.state.settings.showNumberOfItems === false) {
	        this.settings.showNumberOfItems = true;
	      } else {
	        this.settings.showNumberOfItems = false;
	      }
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueIncrement',
	    value: function handleValueIncrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value + 1 > 4) {
	        return;
	      }
	      value += 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueDecrement',
	    value: function handleValueDecrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-sm-8' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'caption' },
	                        API.LANG.LOADMORELESS_DEFAULT_ITEM_NO
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-sm-4' },
	                      _react2.default.createElement('input', { type: 'text', className: 'reactive-input',
	                        value: this.state.settings.showItem,
	                        onChange: this.handleShowItem.bind(this),
	                        placeholder: 'Enter the Item on Show More'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option from-search-panel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.SET_COLUMN
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'choose-grid-button' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueIncrement },
	                              _react2.default.createElement('i', { className: 'fa fa-plus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueDecrement },
	                              _react2.default.createElement('i', { className: 'fa fa-minus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'gird-value-count' },
	                            this.state.settings.setColumn !== undefined ? this.state.settings.setColumn : 2
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.LOADMORE_LESS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.LoadMoreOption === 'true' || this.state.settings.LoadMoreOption === true,
	                        onChange: this.handleChangeLoadMore.bind(this)
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.SHOW_NUMBER_OF_ITEMS
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactToggle2.default, {
	                    defaultChecked: this.state.settings.showNumberOfItems === 'true' || this.state.settings.showNumberOfItems === true,
	                    onChange: this.handleShowNumberOfItems.bind(this)
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CheckBoxPanel;
	}(_react2.default.Component);
	
	CheckBoxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = CheckBoxPanel;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinearCheckBoxPanel = function (_React$Component) {
	  _inherits(LinearCheckBoxPanel, _React$Component);
	
	  function LinearCheckBoxPanel(props) {
	    _classCallCheck(this, LinearCheckBoxPanel);
	
	    var _this = _possibleConstructorReturn(this, (LinearCheckBoxPanel.__proto__ || Object.getPrototypeOf(LinearCheckBoxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.handleValueIncrement = _this.handleValueIncrement.bind(_this);
	    _this.handleValueDecrement = _this.handleValueDecrement.bind(_this);
	    _this.handleShowItem = _this.handleShowItem.bind(_this);
	    _this.handleChangeLoadMore = _this.handleChangeLoadMore.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }, {
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'title': null,
	      'subtitle': null,
	      settings: {
	        showNumberOfItems: false,
	        setColumn: 2,
	        showItem: 5
	      }
	    };
	    return _this;
	  }
	
	  _createClass(LinearCheckBoxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.state.settings, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleChangeLoadMore',
	    value: function handleChangeLoadMore(val) {
	      this.settings.LoadMoreOption = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleShowItem',
	    value: function handleShowItem(e) {
	      this.settings.showItem = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleShowNumberOfItems',
	    value: function handleShowNumberOfItems() {
	      if (this.state.settings.showNumberOfItems === 'false' || this.state.settings.showNumberOfItems === false) {
	        this.settings.showNumberOfItems = true;
	      } else {
	        this.settings.showNumberOfItems = false;
	      }
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueIncrement',
	    value: function handleValueIncrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value + 1 > 4) {
	        return;
	      }
	      value += 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueDecrement',
	    value: function handleValueDecrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option from-search-panel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.SET_COLUMN
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'choose-grid-button' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueIncrement },
	                              _react2.default.createElement('i', { className: 'fa fa-plus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueDecrement },
	                              _react2.default.createElement('i', { className: 'fa fa-minus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'gird-value-count' },
	                            this.state.settings.setColumn !== undefined ? this.state.settings.setColumn : 2
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.SHOW_NUMBER_OF_ITEMS
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactToggle2.default, {
	                    defaultChecked: this.state.settings.showNumberOfItems === 'true' || this.state.settings.showNumberOfItems === true,
	                    onChange: this.handleShowNumberOfItems.bind(this)
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinearCheckBoxPanel;
	}(_react2.default.Component);
	
	LinearCheckBoxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = LinearCheckBoxPanel;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioBoxPanel = function (_React$Component) {
	  _inherits(RadioBoxPanel, _React$Component);
	
	  function RadioBoxPanel(props) {
	    _classCallCheck(this, RadioBoxPanel);
	
	    var _this = _possibleConstructorReturn(this, (RadioBoxPanel.__proto__ || Object.getPrototypeOf(RadioBoxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.handleChangeLoadMore = _this.handleChangeLoadMore.bind(_this);
	    _this.handleValueIncrement = _this.handleValueIncrement.bind(_this);
	    _this.handleValueDecrement = _this.handleValueDecrement.bind(_this);
	    _this.handleShowItem = _this.handleShowItem.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }, {
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'title': null,
	      'subtitle': null,
	      settings: {
	        showNumberOfItems: false,
	        setColumn: 2,
	        showItem: 5
	      }
	    };
	    return _this;
	  }
	
	  _createClass(RadioBoxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.state.settings, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleChangeLoadMore',
	    value: function handleChangeLoadMore(val) {
	      this.settings.LoadMoreOption = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleShowItem',
	    value: function handleShowItem(e) {
	      this.settings.showItem = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleShowNumberOfItems',
	    value: function handleShowNumberOfItems() {
	      if (this.state.settings.showNumberOfItems === 'false' || this.state.settings.showNumberOfItems === false) {
	        this.settings.showNumberOfItems = true;
	      } else {
	        this.settings.showNumberOfItems = false;
	      }
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueIncrement',
	    value: function handleValueIncrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value + 1 > 4) {
	        return;
	      }
	      value += 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueDecrement',
	    value: function handleValueDecrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-row' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-sm-8' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'caption' },
	                        API.LANG.LOADMORELESS_DEFAULT_ITEM_NO
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-sm-4' },
	                      _react2.default.createElement('input', { type: 'text', className: 'reactive-input',
	                        value: this.state.settings.showItem,
	                        onChange: this.handleShowItem.bind(this),
	                        placeholder: 'Enter the Item on Show More'
	                      })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.SET_COLUMN
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'choose-grid-button' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueIncrement },
	                              _react2.default.createElement('i', { className: 'fa fa-plus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueDecrement },
	                              _react2.default.createElement('i', { className: 'fa fa-minus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'gird-value-count' },
	                            this.state.settings.setColumn !== undefined ? this.state.settings.setColumn : 2
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.LOADMORE_LESS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.LoadMoreOption === 'true' || this.state.settings.LoadMoreOption === true,
	                        onChange: this.handleChangeLoadMore.bind(this)
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-3 flex-xs-12' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'caption' },
	                    API.LANG.SHOW_NUMBER_OF_ITEMS
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactToggle2.default, {
	                    defaultChecked: this.state.settings.showNumberOfItems === 'true' || this.state.settings.showNumberOfItems === true,
	                    onChange: this.handleShowNumberOfItems.bind(this)
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RadioBoxPanel;
	}(_react2.default.Component);
	
	RadioBoxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = RadioBoxPanel;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectBoxPanel = function (_React$Component) {
	  _inherits(SelectBoxPanel, _React$Component);
	
	  function SelectBoxPanel(props) {
	    _classCallCheck(this, SelectBoxPanel);
	
	    var _this = _possibleConstructorReturn(this, (SelectBoxPanel.__proto__ || Object.getPrototypeOf(SelectBoxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }, {
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'title': null,
	      'subtitle': null
	    };
	    return _this;
	  }
	
	  _createClass(SelectBoxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.state.settings, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row ' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.TOGGLE_OPTION
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'choose-grid-button' },
	                          _react2.default.createElement(_reactToggle2.default, {
	                            defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                            onChange: this.handleChangeToogleViewTypes.bind(this)
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SelectBoxPanel;
	}(_react2.default.Component);
	
	SelectBoxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = SelectBoxPanel;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBoxPanel = function (_React$Component) {
	  _inherits(TextBoxPanel, _React$Component);
	
	  function TextBoxPanel(props) {
	    _classCallCheck(this, TextBoxPanel);
	
	    var _this = _possibleConstructorReturn(this, (TextBoxPanel.__proto__ || Object.getPrototypeOf(TextBoxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.saveData = _this.saveData.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(TextBoxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassTextBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassTextBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { role: 'tabpanel', className: 'tab-pane', id: 'populate' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return TextBoxPanel;
	}(_react2.default.Component);
	
	TextBoxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = TextBoxPanel;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagPanel = function (_React$Component) {
	  _inherits(TagPanel, _React$Component);
	
	  function TagPanel(props) {
	    _classCallCheck(this, TagPanel);
	
	    var _this = _possibleConstructorReturn(this, (TagPanel.__proto__ || Object.getPrototypeOf(TagPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeSelectTypes = _this.handleChangeSelectTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.state = {
	      settings: {
	        selectedType: {
	          value: 'singleselect'
	        }
	      }
	    };
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }];
	    _this.selecttypes = [{
	      'label': 'Multi-Select',
	      'value': 'multiselect'
	    }, {
	      'label': 'Single-Select',
	      'value': 'singleselect'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(TagPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	        this.settings = _extends({}, this.state.settings);
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeSelectTypes',
	    value: function handleChangeSelectTypes(val) {
	      this.settings.selectedType = val;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'form-field-name',
	                placeholder: API.LANG.PLEASE_CHOOSE_A_SELECT_TYPE,
	                value: this.state.settings.selectedType !== undefined ? this.state.settings.selectedType.value : '',
	                options: this.selecttypes,
	                onChange: this.handleChangeSelectTypes
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TagPanel;
	}(_react2.default.Component);
	
	TagPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = TagPanel;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageSelectPanel = function (_React$Component) {
	  _inherits(ImageSelectPanel, _React$Component);
	
	  function ImageSelectPanel(props) {
	    _classCallCheck(this, ImageSelectPanel);
	
	    var _this = _possibleConstructorReturn(this, (ImageSelectPanel.__proto__ || Object.getPrototypeOf(ImageSelectPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeSelectTypes = _this.handleChangeSelectTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.state = {
	      settings: {
	        selectedType: 'singleselect'
	      }
	    };
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }];
	    _this.selecttypes = [{
	      'label': 'Multi-Select',
	      'value': 'multiselect'
	    }, {
	      'label': 'Single-Select',
	      'value': 'singleselect'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(ImageSelectPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.state.settings, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeSelectTypes',
	    value: function handleChangeSelectTypes(val) {
	      this.settings.selectedType = val.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'form-field-name',
	                placeholder: API.LANG.PLEASE_CHOOSE_A_SELECT_TYPE,
	                value: this.state.settings.selectedType,
	                options: this.selecttypes,
	                onChange: this.handleChangeSelectTypes
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ImageSelectPanel;
	}(_react2.default.Component);
	
	ImageSelectPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = ImageSelectPanel;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RangeInputPanel = function (_React$Component) {
	  _inherits(RangeInputPanel, _React$Component);
	
	  function RangeInputPanel(props) {
	    _classCallCheck(this, RangeInputPanel);
	
	    var _this = _possibleConstructorReturn(this, (RangeInputPanel.__proto__ || Object.getPrototypeOf(RangeInputPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.handleChangeUnitFix = _this.handleChangeUnitFix.bind(_this);
	    _this.handleChangeRangeInputType = _this.handleChangeRangeInputType.bind(_this);
	    _this.handleClassName = _this.handleClassName.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.state = {
	      settings: {
	        histogramToggle: false
	      }
	    };
	    _this.datatypes = [{
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.unitFix = [{
	      label: 'PostFix Unit',
	      value: 'postfix'
	    }, {
	      label: 'PreFix Unit',
	      value: 'prefix'
	    }];
	    _this.RangeInputType = [{
	      label: 'Single',
	      value: 'single'
	    }, {
	      label: 'Double',
	      value: 'double'
	    }];
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(RangeInputPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeUnitFix',
	    value: function handleChangeUnitFix(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedUnitFix = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelMaxValue',
	    value: function handelMaxValue(e) {
	      this.settings.maxvalue = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelMinValue',
	    value: function handelMinValue(e) {
	      this.settings.minvalue = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeRangeInputType',
	    value: function handleChangeRangeInputType(val) {
	      this.settings.selectedRangeType = val === null ? null : val.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleRangeUnit',
	    value: function handleRangeUnit(e) {
	      this.settings.unit = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleHistogramToggle',
	    value: function handleHistogramToggle() {
	      if (this.state.settings.histogramToggle === 'false' || this.state.settings.histogramToggle === false) {
	        this.settings.histogramToggle = true;
	      } else {
	        this.settings.histogramToggle = false;
	      }
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Appearance'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                'Data'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.unit, onChange: this.handleRangeUnit.bind(this), placeholder: API.LANG.ENTER_UNIT }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME }),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.minvalue, onChange: this.handelMinValue.bind(this), placeholder: API.LANG.PLACE_MIN_VAL })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.maxvalue, onChange: this.handelMaxValue.bind(this), placeholder: API.LANG.PLACE_MAX_VAL })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.UNIT_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactSelect2.default, {
	                        name: 'form-field-name',
	                        placeholder: 'PostFix/Prefix Unit',
	                        value: this.state.settings.selectedUnitFix,
	                        options: this.unitFix,
	                        onChange: this.handleChangeUnitFix
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.RANGE_TYPE
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactSelect2.default, {
	                        name: 'form-field-name',
	                        placeholder: 'Double/Single',
	                        value: this.state.settings.selectedRangeType,
	                        options: this.RangeInputType,
	                        onChange: this.handleChangeRangeInputType
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RangeInputPanel;
	}(_react2.default.Component);
	
	RangeInputPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = RangeInputPanel;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SizeboxPanel = function (_React$Component) {
	  _inherits(SizeboxPanel, _React$Component);
	
	  function SizeboxPanel(props) {
	    _classCallCheck(this, SizeboxPanel);
	
	    var _this = _possibleConstructorReturn(this, (SizeboxPanel.__proto__ || Object.getPrototypeOf(SizeboxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeViewTypes = _this.handleChangeViewTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }];
	    _this.viewtypes = [{
	      'label': 'Radio-view',
	      'value': 'big'
	    }, {
	      'label': 'Box-View',
	      'value': 'list'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(SizeboxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeViewTypes',
	    value: function handleChangeViewTypes(val) {
	      this.settings.selectedViewType = val.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassSizeBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Appearance'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                'Data'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement(_reactSelect2.default, {
	                name: 'form-field-name',
	                placeholder: API.LANG.PLACE_SELECT_VIEW,
	                value: this.state.settings.selectedViewType,
	                options: this.viewtypes,
	                onChange: this.handleChangeViewTypes
	              }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassSizeBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLACE_CUSTOM_CSS }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null,
	              _react2.default.createElement(
	                'pre',
	                { className: 'alert alert-danger' },
	                'Don\'t Select anything except Size(S/M/XL/XXL/XXXL) related data type'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SizeboxPanel;
	}(_react2.default.Component);
	
	SizeboxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = SizeboxPanel;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollBoxPannel = function (_React$Component) {
	  _inherits(ScrollBoxPannel, _React$Component);
	
	  function ScrollBoxPannel(props) {
	    _classCallCheck(this, ScrollBoxPannel);
	
	    var _this = _possibleConstructorReturn(this, (ScrollBoxPannel.__proto__ || Object.getPrototypeOf(ScrollBoxPannel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }, {
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(ScrollBoxPannel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassScrollBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Appearance'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                'Data'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassScrollBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLACE_CUSTOM_CSS }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ScrollBoxPannel;
	}(_react2.default.Component);
	
	ScrollBoxPannel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = ScrollBoxPannel;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapSearchBoxPanel = function (_React$Component) {
	  _inherits(MapSearchBoxPanel, _React$Component);
	
	  function MapSearchBoxPanel(props) {
	    _classCallCheck(this, MapSearchBoxPanel);
	
	    var _this = _possibleConstructorReturn(this, (MapSearchBoxPanel.__proto__ || Object.getPrototypeOf(MapSearchBoxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.handleMapRadious = _this.handleMapRadious.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }, {
	      'label': 'Metadata',
	      'value': 'metakeys'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'title': null,
	      'subtitle': null,
	      'value': null
	    };
	    return _this;
	  }
	
	  _createClass(MapSearchBoxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      var self = this;
	      this.setState({
	        'settings': _extends({}, this.props.settings)
	      });
	      if (this.props.settings.latitude !== undefined) {
	        var latlng = { lat: parseFloat(this.props.settings.latitude), lng: parseFloat(this.props.settings.longitude) };
	        var geocoder = new google.maps.Geocoder();
	        geocoder.geocode({ latLng: latlng }, function (responses) {
	          self.setState({ value: responses[0].formatted_address });
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMapRadious',
	    value: function handleMapRadious(e) {
	      this.settings.mapradious = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      this.setState({ value: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Appearance'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.MAP_RADIOUS
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.mapradious, onChange: this.handleMapRadious })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MapSearchBoxPanel;
	}(_react2.default.Component);
	
	MapSearchBoxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = MapSearchBoxPanel;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorBoxPannel = function (_React$Component) {
	  _inherits(ColorBoxPannel, _React$Component);
	
	  function ColorBoxPannel(props) {
	    _classCallCheck(this, ColorBoxPannel);
	
	    var _this = _possibleConstructorReturn(this, (ColorBoxPannel.__proto__ || Object.getPrototypeOf(ColorBoxPannel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.handleValueIncrement = _this.handleValueIncrement.bind(_this);
	    _this.handleValueDecrement = _this.handleValueDecrement.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'title': null,
	      'subtitle': null,
	      settings: {
	        showItemColorName: true,
	        setColumn: 2
	      }
	    };
	    return _this;
	  }
	
	  _createClass(ColorBoxPannel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewItemNames',
	    value: function handleChangeToogleViewItemNames() {
	      if (this.state.settings.showItemColorName === 'false' || this.state.settings.showItemColorName === false) {
	        this.settings.showItemColorName = true;
	      } else {
	        this.settings.showItemColorName = false;
	      }
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueIncrement',
	    value: function handleValueIncrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value + 1 > 4) {
	        return;
	      }
	      value += 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleValueDecrement',
	    value: function handleValueDecrement() {
	      var value = null;
	      if (this.state.settings.setColumn !== undefined) {
	        value = parseInt(this.state.settings.setColumn, 10);
	      } else {
	        value = 2;
	      }
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.settings.setColumn = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  this.state.settings.showItemColorName === 'true' || this.state.settings.showItemColorName === true ? _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.SET_COLUMN
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-6 flex-xs-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'choose-grid-button' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueIncrement },
	                              _react2.default.createElement('i', { className: 'fa fa-plus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.handleValueDecrement },
	                              _react2.default.createElement('i', { className: 'fa fa-minus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'gird-value-count' },
	                            this.state.settings.setColumn !== undefined ? this.state.settings.setColumn : 2
	                          )
	                        )
	                      )
	                    )
	                  ) : ''
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.SHOW_ITEM_COLOR_NAME
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.showItemColorName === 'true' || this.state.settings.showItemColorName === true,
	                        onChange: this.handleChangeToogleViewItemNames.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ColorBoxPannel;
	}(_react2.default.Component);
	
	ColorBoxPannel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = ColorBoxPannel;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _metadataSelection = __webpack_require__(500);
	
	var _metadataSelection2 = _interopRequireDefault(_metadataSelection);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComboBoxPanel = function (_React$Component) {
	  _inherits(ComboBoxPanel, _React$Component);
	
	  function ComboBoxPanel(props) {
	    _classCallCheck(this, ComboBoxPanel);
	
	    var _this = _possibleConstructorReturn(this, (ComboBoxPanel.__proto__ || Object.getPrototypeOf(ComboBoxPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleMetakey = _this.handleMetakey.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }];
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'title': null,
	      'subtitle': null
	    };
	    return _this;
	  }
	
	  _createClass(ComboBoxPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleMetakey',
	    value: function handleMetakey(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedMetakey = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassCheckBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#populate', 'aria-controls': 'populate', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.DATA
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassCheckBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME }),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'populate' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6 flex-xs-12' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null,
	              this.state.settings.selectedDataType === 'metakeys' ? _react2.default.createElement(_metadataSelection2.default, _extends({ onMetakeySelection: this.handleMetakey, value: this.state.settings.selectedMetakey }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ComboBoxPanel;
	}(_react2.default.Component);
	
	ComboBoxPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = ComboBoxPanel;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import TaxonomySelection from '../../helper/taxonomySelection';
	// import MetadataSelection from '../../helper/metadataSelection';
	
	
	var ResetButtonPanel = function (_React$Component) {
	  _inherits(ResetButtonPanel, _React$Component);
	
	  function ResetButtonPanel(props) {
	    _classCallCheck(this, ResetButtonPanel);
	
	    var _this = _possibleConstructorReturn(this, (ResetButtonPanel.__proto__ || Object.getPrototypeOf(ResetButtonPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.saveData = _this.saveData.bind(_this);
	    _this.settings = {};
	    return _this;
	  }
	
	  _createClass(ResetButtonPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        var indexOfReset = (0, _underscore.findIndex)(allLayout[index].searchAttr, { viewType: 'reset' });
	        if (indexOfReset !== -1) {
	          this.settings.buttonstyle = allLayout[index].searchAttr[indexOfReset].buttonstyle;
	          this.settings.buttontitle = allLayout[index].searchAttr[indexOfReset].buttontitle;
	          this.settings.dynamicNameClassScrollBox = allLayout[index].searchAttr[indexOfReset].dynamicNameClassScrollBox;
	        }
	      }
	      this.setState({
	        'settings': _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, nextProps.settings)
	        });
	        this.settings = {};
	      }
	    }
	  }, {
	    key: 'handelButtonTitle',
	    value: function handelButtonTitle(e) {
	      this.settings.buttontitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelButtonStyle',
	    value: function handelButtonStyle(e) {
	      this.settings.buttonstyle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleClassName',
	    value: function handleClassName(e) {
	      this.settings.dynamicNameClassScrollBox = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Appearance'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.buttontitle), onChange: this.handelButtonTitle.bind(this), placeholder: API.LANG.PLACE_BUTTON_TEXT }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.buttonstyle, onChange: this.handelButtonStyle.bind(this), placeholder: API.LANG.PLACE_BUTTON_STYLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.dynamicNameClassScrollBox, onChange: this.handleClassName.bind(this), placeholder: API.LANG.PLACE_CUSTOM_CSS })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetButtonPanel;
	}(_react2.default.Component);
	
	ResetButtonPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = ResetButtonPanel;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapPanel = function (_React$Component) {
	  _inherits(MapPanel, _React$Component);
	
	  function MapPanel(props) {
	    _classCallCheck(this, MapPanel);
	
	    var _this = _possibleConstructorReturn(this, (MapPanel.__proto__ || Object.getPrototypeOf(MapPanel)).call(this, props));
	
	    _this.valueIncrementLayout = _this.valueIncrementLayout.bind(_this);
	    _this.valueDecrementLayout = _this.valueDecrementLayout.bind(_this);
	    _this.handleCheckedMarkerTemplate = _this.handleCheckedMarkerTemplate.bind(_this);
	    _this.handleCheckedMarkerIcon = _this.handleCheckedMarkerIcon.bind(_this);
	    _this.handleHight = _this.handleHight.bind(_this);
	    _this.handleZoom = _this.handleZoom.bind(_this);
	    _this.displayName = 'MapPanel';
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.block = _.where(_this.props.allLayout, { uid: _this.props.uid });
	    _this.state = {
	      'helperData': (0, _clone2.default)(_this.props.helperData)
	    };
	    _this.allLayout = {};
	    return _this;
	  }
	
	  _createClass(MapPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.block = _.where(this.props.allLayout, { uid: this.props.uid });
	
	      if (this.block) {
	        var value = this.block[0].hight ? parseInt(this.block[0].hight, 10) : 500;
	        var zoomIn = this.block[0].zoom ? parseInt(this.block[0].zoom, 10) : 3;
	        this.block = this.block[0];
	        var markerTemplate = [];
	        this.FlagMarkerTemplate = false;
	        this.FlagMarkerIcon = false;
	        this.allLayout = (0, _clone2.default)(this.props.allLayout);
	        for (var key in ReactiveMarkerTemplate) {
	          if (ReactiveMarkerTemplate.hasOwnProperty(key)) {
	            var temp = {};
	            temp.key = key;
	            temp.value = key;
	            if (this.block.markerTemplate !== key.toString()) {
	              temp.isChecked = false;
	            } else {
	              this.FlagmarkerTemplate = true;
	              temp.isChecked = true;
	            }
	            markerTemplate.push(temp);
	          }
	        }
	        if (this.FlagMarkerTemplate === false) {
	          var index = (0, _underscore.findIndex)(markerTemplate, { key: 'default' });
	          if (index !== -1) {
	            markerTemplate[index].isChecked = true;
	          }
	        }
	        var markerIcon = [];
	        for (var _key in ReactiveMarkerIcon) {
	          if (ReactiveMarkerIcon.hasOwnProperty(_key)) {
	            var _temp = {};
	            _temp.key = _key;
	            _temp.value = _key;
	            if (this.block.markerIcon !== _key.toString()) {
	              _temp.isChecked = false;
	            } else {
	              this.FlagMarkerIcon = true;
	              _temp.isChecked = true;
	            }
	            markerIcon.push(_temp);
	          }
	        }
	        if (this.FlagMarkerIcon === false) {
	          var _index = (0, _underscore.findIndex)(markerTemplate, { key: 'default' });
	          if (_index !== -1) {
	            markerIcon[_index].isChecked = true;
	          }
	        }
	        this.setState(_extends({}, this.block, { value: value, markerTemplate: markerTemplate, markerIcon: markerIcon, zoomIn: zoomIn }));
	      }
	    }
	    // Note:  per update won't chnage the whole preview , only save button will change the preview .
	
	  }, {
	    key: 'handleSubmitLayout',
	    value: function handleSubmitLayout() {
	      if (_.isEmpty(this.allLayout)) {
	        return;
	      }
	      var pushLayout = {
	        'allLayout': this.allLayout,
	        'shortcodeKey': this.props.shortcodeKey,
	        reload: true
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'valueIncrementLayout',
	    value: function valueIncrementLayout() {
	      var value = parseInt(this.state.layout, 10);
	      if (value + 1 > 12) {
	        return;
	      }
	      value += 1;
	      // this.allLayout = clone(this.props.allLayout);
	      var index = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        this.allLayout[index].layout = value;
	        this.setState({ layout: value });
	      }
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'valueDecrementLayout',
	    value: function valueDecrementLayout() {
	      var value = parseInt(this.state.layout, 10);
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      // this.allLayout = clone(this.props.allLayout);
	      var index = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        this.allLayout[index].layout = value;
	        this.allLayout[index].hight = this.state.value;
	        this.setState({ layout: value, value: this.state.value });
	      }
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'handleHight',
	    value: function handleHight(e) {
	      e.preventDefault();
	      this.allLayout = (0, _clone2.default)(this.props.allLayout);
	      var index = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        this.allLayout[index].hight = e.target.value;
	        this.setState({ value: e.target.value });
	      }
	    }
	  }, {
	    key: 'handleZoom',
	    value: function handleZoom(e) {
	      this.allLayout = (0, _clone2.default)(this.props.allLayout);
	      var index = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (index !== -1 && e.target.value >= 1) {
	        this.allLayout[index].zoom = e.target.value;
	        this.setState({ zoomIn: e.target.value });
	      }
	    }
	  }, {
	    key: 'handleCheckedMarkerTemplate',
	    value: function handleCheckedMarkerTemplate(e) {
	      // this.allLayout = clone(this.props.allLayout);
	      var markerTemplate = this.state.markerTemplate;
	      var index = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        markerTemplate.map(function (item) {
	          if (item.value === e.target.value.toString()) {
	            item.isChecked = true;
	          } else {
	            item.isChecked = false;
	          }
	        });
	        this.allLayout[index].markerTemplate = e.target.value;
	        this.setState({ markerTemplate: markerTemplate });
	      }
	    }
	  }, {
	    key: 'handleCheckedMarkerIcon',
	    value: function handleCheckedMarkerIcon(e) {
	      // this.allLayout = clone(this.props.allLayout);
	      var markerIcon = this.state.markerIcon;
	      var index = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        markerIcon.map(function (item) {
	          if (item.value === e.target.value.toString()) {
	            item.isChecked = true;
	          } else {
	            item.isChecked = false;
	          }
	        });
	        this.allLayout[index].markerIcon = e.target.value;
	        this.setState({ markerIcon: markerIcon });
	      }
	    }
	  }, {
	    key: 'handleWrapperClass',
	    value: function handleWrapperClass(value) {
	      var find = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        this.allLayout[find].mapWrapperClass = value;
	        this.setState({ mapWrapperClass: value });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var showMarkerTemplate = function showMarkerTemplate(item, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'search-content', key: 'mappanel-' + index },
	          _react2.default.createElement('input', { type: 'radio', name: 'search-markerElement', checked: item.isChecked, id: 'markerStyle-' + index, value: item.key,
	            onChange: _this2.handleCheckedMarkerTemplate
	          }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select-search-content', htmlFor: 'markerStyle-' + index },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.value
	            )
	          )
	        );
	      };
	      var showMarkerIcon = function showMarkerIcon(item, index) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'search-content', key: 'markericon-' + index },
	          _react2.default.createElement('input', { type: 'radio', name: 'search-iconElement', checked: item.isChecked, id: 'iconStyle-' + index, value: item.key,
	            onChange: _this2.handleCheckedMarkerIcon
	          }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select-search-content', htmlFor: 'iconStyle-' + index },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.value
	            )
	          )
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.handleSubmitLayout.bind(this) },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#general', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.SETTINGS
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearence', 'aria-controls': 'appearence', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.APPEARANCE
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'general' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.CHANGE_MAP_LAYOUT
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'choose-grid-button' },
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.valueIncrementLayout },
	                              _react2.default.createElement('i', { className: 'fa fa-plus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            _react2.default.createElement(
	                              'button',
	                              { onClick: this.valueDecrementLayout },
	                              _react2.default.createElement('i', { className: 'fa fa-minus' })
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'gird-value-count' },
	                            this.state.layout !== undefined ? this.state.layout : null
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-5 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'text', value: this.state.mapWrapperClass, className: 'reactive-input', onChange: function onChange(node) {
	                        _this2.handleWrapperClass(node.target.value);
	                      }, placeholder: API.LANG.WRAPPER_CLASS_MAP })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12 flex-md-2' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.CHANGE_HEIGHT
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-5 flex-md-5 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'number', className: 'form-control', value: this.state.value, onChange: this.handleHight })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12 flex-md-2' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.ZOOM
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-5 flex-md-5 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'number', className: 'form-control', value: this.state.zoomIn, onChange: this.handleZoom })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'appearence' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-xs-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.MARKER_TEMPLATE
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        ' ',
	                        this.state.markerTemplate.map(showMarkerTemplate)
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-xs-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.ICON_TEMPLATE
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'list-inline' },
	                        ' ',
	                        this.state.markerIcon.map(showMarkerIcon)
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MapPanel;
	}(_react2.default.Component);
	
	MapPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array
	};
	exports.default = MapPanel;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _underscore = __webpack_require__(205);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _taxonomySelection = __webpack_require__(497);
	
	var _taxonomySelection2 = _interopRequireDefault(_taxonomySelection);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _gridselect = __webpack_require__(481);
	
	var _gridselect2 = _interopRequireDefault(_gridselect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsotopePanel = function (_React$Component) {
	  _inherits(IsotopePanel, _React$Component);
	
	  function IsotopePanel(props) {
	    _classCallCheck(this, IsotopePanel);
	
	    var _this = _possibleConstructorReturn(this, (IsotopePanel.__proto__ || Object.getPrototypeOf(IsotopePanel)).call(this, props));
	
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleChangeDataTypes = _this.handleChangeDataTypes.bind(_this);
	    _this.valueIncrementLayout = _this.valueIncrementLayout.bind(_this);
	    _this.valueDecrementLayout = _this.valueDecrementLayout.bind(_this);
	    _this.onChangeSelectedImage = _this.onChangeSelectedImage.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.datatypes = [{
	      'label': 'Taxonomy',
	      'value': 'taxonomies'
	    }];
	    _this.settings = {};
	    _this.state = {
	      'allLayout': (0, _clone2.default)(_this.props.allLayout),
	      settings: {
	        // 'numberOfPosts': 10,
	        loadMoreOption: false,
	        isotope_column: 2
	      }
	    };
	    return _this;
	  }
	
	  _createClass(IsotopePanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.block = _.where(this.props.allLayout, { uid: this.props.uid });
	      if (this.block) {
	        this.block = this.block[0];
	        this.setState(_extends({}, this.block, {
	          'settings': _extends({}, this.state.settings, this.block)
	        }));
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        'allLayout': (0, _clone2.default)(nextProps.allLayout),
	        'settings': _extends({}, this.state.settings, nextProps.settings)
	      });
	      this.settings = {};
	    }
	  }, {
	    key: 'valueIncrementLayout',
	    value: function valueIncrementLayout() {
	      var value = null;
	      if (this.state.settings.layout !== undefined) {
	        value = parseInt(this.state.settings.layout, 10);
	      } else {
	        value = 12;
	      }
	      if (value + 1 > 12) {
	        return;
	      }
	      value += 1;
	      this.state.settings.layout = value;
	      this.setState({
	        settings: _extends({}, this.state.settings)
	      });
	    }
	  }, {
	    key: 'valueDecrementLayout',
	    value: function valueDecrementLayout() {
	      var value = null;
	      if (this.state.settings.layout !== undefined) {
	        value = parseInt(this.state.settings.layout, 10);
	      } else {
	        value = 12;
	      }
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.state.settings.layout = value;
	      this.setState({
	        settings: _extends({}, this.state.settings)
	      });
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(val) {
	      var value = val === null ? null : val.value;
	      this.state.settings.selectedTaxonomy = value;
	      this.setState({
	        settings: _extends({}, this.state.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeDataTypes',
	    value: function handleChangeDataTypes(val) {
	      var value = val === null ? null : val.value;
	      this.state.settings.selectedDataType = value;
	      this.setState({
	        settings: _extends({}, this.state.settings)
	      });
	    }
	  }, {
	    key: 'handleColumnValueIncrement',
	    value: function handleColumnValueIncrement(element) {
	      var value = null;
	      if (this.state.settings[element] !== undefined) {
	        value = parseInt(this.state.settings[element], 10);
	      } else {
	        value = 2;
	      }
	      if (element === 'isotope_column') {
	        if (value + 1 > 4) {
	          return;
	        }
	      }
	      value += 1;
	      this.state.settings[element] = value;
	      this.setState({
	        settings: _extends({}, this.state.settings)
	      });
	    }
	  }, {
	    key: 'handleColumnValueDecrement',
	    value: function handleColumnValueDecrement(element) {
	      var value = null;
	      if (this.state.settings[element] !== undefined) {
	        value = parseInt(this.state.settings[element], 10);
	      } else {
	        value = 2;
	      }
	      if (value - 1 < 2) {
	        return;
	      }
	      value -= 1;
	      this.state.settings[element] = value;
	      this.setState({
	        settings: _extends({}, this.state.settings)
	      });
	    }
	  }, {
	    key: 'handleIsotopeBarClass',
	    value: function handleIsotopeBarClass(value) {
	      var allLayout = this.props.allLayout;
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find].isotopeBarClass = value;
	        this.setState({ isotopeBarClass: value, allLayout: allLayout });
	      }
	      // this.setState({ allLayout });
	    }
	  }, {
	    key: 'handleWrapperClass',
	    value: function handleWrapperClass(value) {
	      var allLayout = this.props.allLayout;
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find].isotopeWrapperClass = value;
	        this.setState({ isotopeWrapperClass: value, allLayout: allLayout });
	      }
	      // this.setState({ allLayout });
	    }
	  }, {
	    key: 'onChangeSelectedImage',
	    value: function onChangeSelectedImage(ImageId, type) {
	      var allLayout = this.props.allLayout;
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find].previewLayouts = ImageId;
	      }
	      var pushLayout = {
	        'allLayout': (0, _clone2.default)(allLayout),
	        'shortcodeKey': this.props.shortcodeKey,
	        reload: true
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        allLayout[find] = Object.assign(allLayout[find], this.state.settings, this.state.allLayout[find]);
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey,
	        reload: true
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	      // location.reload();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var self = this;
	      var ImageId = [];
	      var allLayout = this.props.allLayout;
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      var viewType = null;
	      if (find !== -1) {
	        viewType = allLayout[find].hasOwnProperty('viewType') ? allLayout[find].viewType : null;
	        if (allLayout[find].hasOwnProperty('previewLayouts')) {
	          ImageId.push(allLayout[find].previewLayouts.toString());
	        } else {
	          ImageId.push('latestGridLayoutThree');
	        }
	      }
	      var FilteredImageSelect = function FilteredImageSelect(item, index) {
	        if (item.data.length !== 0) {
	          return _react2.default.createElement(
	            'div',
	            { key: index },
	            _react2.default.createElement(_gridselect2.default, { option: item.data, defaultvalue: ImageId, onImageSelcted: _this2.onChangeSelectedImage, multiselect: 'false' })
	          );
	        }
	      };
	      this.filteredFormatData = [];
	      if (this.props.helperData.formats !== undefined) {
	        this.props.helperData.formats.map(function (item) {
	          if (item.toString() !== 'standard') {
	            return;
	          }
	          var filteredFormat = {};
	          filteredFormat.data = _.where(filteredFormat.data, { type: _this2.state.postTypes });
	          var selfPostType = _this2.state.postTypes ? _this2.state.postTypes : 'post';
	          filteredFormat.data = _.filter(ReactiveLayouts, function (sigleitem) {
	            return sigleitem.type === selfPostType || sigleitem.type === 'all';
	          });
	          if (filteredFormat.data.length === 0) {
	            filteredFormat.data = _.where(ReactiveLayouts, { type: 'all' });
	          }
	          _this2.filteredFormatData.push(filteredFormat);
	        });
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            API.LANG.SAVE
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#general', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.SETTINGS
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#layout', 'aria-controls': 'layout', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.LAYOUT
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#column', 'aria-controls': 'column', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.COLUMN
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#option', 'aria-controls': 'option', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.OPTION
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation' },
	              _react2.default.createElement(
	                'a',
	                { href: '#isotope-bar', 'aria-controls': 'isotope-bar', role: 'tab', 'data-toggle': 'tab' },
	                API.LANG.BAR
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'general' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.CHANGE_GRID_LAYOUT
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.valueIncrementLayout },
	                          _react2.default.createElement('i', { className: 'fa fa-plus' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.valueDecrementLayout },
	                          _react2.default.createElement('i', { className: 'fa fa-minus' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'gird-value-count' },
	                        this.state.settings.layout !== undefined ? this.state.settings.layout : null
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'layout' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'caption' },
	                  API.LANG.SELECT_ISOTOPE_TEMPLATE
	                )
	              ),
	              this.filteredFormatData.map(FilteredImageSelect)
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'column' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-3 flex-xs-12' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.ISOTOPE_COLUMN
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'flex-sm-9 flex-xs-12' },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleColumnValueIncrement.bind(this, 'isotope_column') },
	                            _react2.default.createElement('i', { className: 'fa fa-plus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'button',
	                            { onClick: this.handleColumnValueDecrement.bind(this, 'isotope_column') },
	                            _react2.default.createElement('i', { className: 'fa fa-minus' })
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'gird-value-count' },
	                          this.state.settings.isotope_column !== undefined ? this.state.settings.isotope_column : 2
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'option' },
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option no-padding' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'text', value: this.state.settings.isotopeBarClass, className: 'reactive-input', onChange: function onChange(node) {
	                        _this2.handleIsotopeBarClass(node.target.value);
	                      }, placeholder: API.LANG.WRAPPER_CLASS_ISOTOPE_BAR })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option no-padding' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement('input', { type: 'text', value: this.state.settings.isotopeWrapperClass, className: 'reactive-input', onChange: function onChange(node) {
	                        _this2.handleWrapperClass(node.target.value);
	                      }, placeholder: API.LANG.WRAPPER_CLASS_ISOTOPE_GRID })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane', id: 'isotope-bar' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-sm-6 flex-md-6' },
	                  _react2.default.createElement(_reactSelect2.default, {
	                    name: 'form-field-name',
	                    placeholder: API.LANG.PLEASE_ENTER_A_DATA_TYPE,
	                    value: this.state.settings.selectedDataType,
	                    options: this.datatypes,
	                    onChange: this.handleChangeDataTypes
	                  })
	                )
	              ),
	              this.state.settings.selectedDataType === 'taxonomies' ? _react2.default.createElement(_taxonomySelection2.default, _extends({ onTaxonomySelection: this.handleTaxonomy, value: this.state.settings.selectedTaxonomy }, this.props)) : null
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IsotopePanel;
	}(_react2.default.Component);
	
	IsotopePanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	exports.default = IsotopePanel;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapRadiusPanel = function (_React$Component) {
	  _inherits(MapRadiusPanel, _React$Component);
	
	  function MapRadiusPanel(props) {
	    _classCallCheck(this, MapRadiusPanel);
	
	    var _this = _possibleConstructorReturn(this, (MapRadiusPanel.__proto__ || Object.getPrototypeOf(MapRadiusPanel)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleChangeToogleViewTypes = _this.handleChangeToogleViewTypes.bind(_this);
	    _this.saveData = _this.saveData.bind(_this);
	    _this.state = {
	      settings: {
	        histogramToggle: false
	      }
	    };
	    _this.toogleviewtype = [{
	      'label': 'Toogle Show On',
	      'value': 'true'
	    }, {
	      'label': 'Toogle Show Off',
	      'value': 'false'
	    }];
	    return _this;
	  }
	
	  _createClass(MapRadiusPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.settings = _extends({}, this.props.settings, this.props.settings);
	      this.setState({
	        'settings': _extends({}, this.state.settings, this.props.settings)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.childUid !== this.props.childUid) {
	        this.setState({
	          'settings': _extends({}, this.state.settings, nextProps.settings)
	        });
	      }
	    }
	  }, {
	    key: 'handelTitle',
	    value: function handelTitle(e) {
	      this.settings.title = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handelMaxValue',
	    value: function handelMaxValue(e) {
	      this.settings.maxvalue = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handelMinValue',
	    value: function handelMinValue(e) {
	      this.settings.minvalue = e.target.value;
	      this.setState({
	        settings: _extends({}, this.state.settings, this.settings)
	      });
	    }
	  }, {
	    key: 'handleChangeToogleViewTypes',
	    value: function handleChangeToogleViewTypes(val) {
	      this.settings.selectedToogleViewType = val.target.checked;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handelSubTitle',
	    value: function handelSubTitle(e) {
	      this.settings.subtitle = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'handleRangeUnit',
	    value: function handleRangeUnit(e) {
	      this.settings.unit = e.target.value;
	      this.setState({
	        settings: _extends({}, this.settings)
	      });
	    }
	  }, {
	    key: 'saveData',
	    value: function saveData(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchIndex = (0, _underscore.findIndex)(allLayout[find].searchAttr, { uid: this.props.childUid });
	        if (findSearchIndex !== -1) {
	          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
	        }
	      }
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { className: 'layout-save-button', onClick: this.saveData },
	          _react2.default.createElement('i', { className: 'fa fa-floppy-o' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reactive-tab-setting' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'nav nav-tabs', role: 'tablist' },
	            _react2.default.createElement(
	              'li',
	              { role: 'presentation', className: 'active' },
	              _react2.default.createElement(
	                'a',
	                { href: '#appearance', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                'Appearance'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tab-content' },
	            _react2.default.createElement(
	              'div',
	              { role: 'tabpanel', className: 'tab-pane active', id: 'appearance' },
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.title), onChange: this.handelTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_TITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: (0, _helperFunction.stringify)(this.state.settings.subtitle), onChange: this.handelSubTitle.bind(this), placeholder: API.LANG.PLEASE_ENTER_THE_SUBTITLE }),
	              _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.unit, onChange: this.handleRangeUnit.bind(this), placeholder: API.LANG.ENTER_UNIT }),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.minvalue, onChange: this.handelMinValue.bind(this), placeholder: API.LANG.PLACE_MIN_VAL })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-6 flex-xs-12' },
	                  _react2.default.createElement('input', { type: 'text', className: 'reactive-input', value: this.state.settings.maxvalue, onChange: this.handelMaxValue.bind(this), placeholder: API.LANG.PLACE_MAX_VAL })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'grid-choose-option' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row ' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-3 flex-xs-12' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TOGGLE_OPTION
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-sm-9 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(_reactToggle2.default, {
	                        defaultChecked: this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true,
	                        onChange: this.handleChangeToogleViewTypes.bind(this)
	                      })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MapRadiusPanel;
	}(_react2.default.Component);
	
	MapRadiusPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'childUid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'settings': _react2.default.PropTypes.object
	};
	
	exports.default = MapRadiusPanel;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(523);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdvancedSearchPanel = function (_React$Component) {
	  _inherits(AdvancedSearchPanel, _React$Component);
	
	  function AdvancedSearchPanel(props) {
	    _classCallCheck(this, AdvancedSearchPanel);
	
	    var _this = _possibleConstructorReturn(this, (AdvancedSearchPanel.__proto__ || Object.getPrototypeOf(AdvancedSearchPanel)).call(this, props));
	
	    _this.valueIncrement = _this.valueIncrement.bind(_this);
	    _this.valueDecrement = _this.valueDecrement.bind(_this);
	    _this.showAdvacedOption = _this.showAdvacedOption.bind(_this);
	    _this.verticalSearch = _this.verticalSearch.bind(_this);
	    _this.horizontalSearch = _this.horizontalSearch.bind(_this);
	    _this.addSelected = _this.addSelected.bind(_this);
	    _this.dropdownTemplate = _this.dropdownTemplate.bind(_this);
	    _this.defaultTemplate = _this.defaultTemplate.bind(_this);
	    _this.handelCustomCss = _this.handelCustomCss.bind(_this);
	    var indexType = (0, _underscore.findIndex)(_this.props.allLayout, { uid: _this.props.uid });
	    if (indexType !== -1) {
	      _this.state = { styleType: _this.props.allLayout[indexType].styleType };
	    } else {
	      _this.state = { styleType: '' };
	    }
	    return _this;
	  }
	
	  _createClass(AdvancedSearchPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var layout = parseInt(allLayout[find].layout, 10);
	        var styleType = allLayout[find].styleType !== undefined ? allLayout[find].styleType : null;
	        var styleTemplate = allLayout[find].styleTemplate !== undefined ? allLayout[find].styleTemplate : null;
	        var customCssClass = allLayout[find].customCssClass !== undefined ? allLayout[find].customCssClass : null;
	        this.setState({ rangeValue: layout, styleType: styleType, styleTemplate: styleTemplate, customCssClass: customCssClass });
	      }
	    }
	  }, {
	    key: 'valueDecrement',
	    value: function valueDecrement() {
	      var value = this.state.rangeValue;
	      if (value - 1 < 1) {
	        return;
	      }
	      value -= 1;
	      this.setState({ rangeValue: value });
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'addSelected',
	    value: function addSelected(e) {
	      e.preventDefault();
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (allLayout[indexOfSearch].styleType !== this.state.styleType || parseInt(allLayout[indexOfSearch].layout, 10) !== this.state.rangeValue || allLayout[indexOfSearch].styleTemplate !== this.state.styleTemplate || allLayout[indexOfSearch].customCssClass !== this.state.customCssClass) {
	        var find = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	        if (find !== -1) {
	          allLayout[find].styleType = this.state.styleType;
	          allLayout[find].layout = this.state.rangeValue;
	          allLayout[find].styleTemplate = this.state.styleTemplate;
	          allLayout[find].customCssClass = this.state.customCssClass;
	        }
	        var pushLayout = {
	          allLayout: allLayout,
	          'shortcodeKey': this.props.shortcodeKey
	        };
	        _builderActions2.default.saveAllBlocks(pushLayout);
	        this.props.onClickedPanel();
	      }
	    }
	  }, {
	    key: 'valueIncrement',
	    value: function valueIncrement() {
	      var value = this.state.rangeValue;
	      if (value + 1 > 12) {
	        return;
	      }
	      value += 1;
	      this.setState({ rangeValue: value });
	      if (this.layoutType !== undefined) {
	        this.setState({ errorMsg: null });
	      }
	    }
	  }, {
	    key: 'showAdvacedOption',
	    value: function showAdvacedOption(e) {
	      e.preventDefault();
	      this.setState({ showAdvacedOption: !this.state.showAdvacedOption });
	    }
	  }, {
	    key: 'verticalSearch',
	    value: function verticalSearch(e) {
	      e.preventDefault();
	      this.setState({ styleType: 'vertical' });
	    }
	  }, {
	    key: 'horizontalSearch',
	    value: function horizontalSearch(e) {
	      e.preventDefault();
	      this.setState({ styleType: 'horizontal' });
	    }
	  }, {
	    key: 'defaultTemplate',
	    value: function defaultTemplate(e) {
	      e.preventDefault();
	      this.setState({ styleTemplate: 'default' });
	    }
	  }, {
	    key: 'dropdownTemplate',
	    value: function dropdownTemplate(e) {
	      e.preventDefault();
	      this.setState({ styleTemplate: 'dropdown' });
	    }
	  }, {
	    key: 'handelCustomCss',
	    value: function handelCustomCss(e) {
	      e.preventDefault();
	      this.setState({ customCssClass: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var customStyleClass = this.state.styleType === 'horizontal' ? 'horizontalactive' : 'verticalactive';
	      var customTemplateClass = this.state.styleTemplate === 'dropdown' ? 'horizontalactive' : 'verticalactive';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'advancedsearchmodal' },
	          _react2.default.createElement(
	            'div',
	            { className: 'for-search-panel grid-choose-option' },
	            _react2.default.createElement(
	              'div',
	              { className: '' },
	              _react2.default.createElement(
	                'div',
	                { className: 'flex-row bottom-panel-search' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-7 flex-sm-6 flex-xs-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: ' grid-choose-option from-search-panel' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.ADVANCE_SETTINGS,
	                      ':'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'search-view-type-change' },
	                      _react2.default.createElement(
	                        _reactAddonsCssTransitionGroup2.default,
	                        { transitionName: 'simplefade', transitionEnterTimeout: 200, transitionLeaveTimeout: 200 },
	                        _react2.default.createElement(
	                          'p',
	                          { className: customStyleClass },
	                          _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'vertical', onClick: this.verticalSearch },
	                            API.LANG.VERTICAL
	                          ),
	                          _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'horizontal', onClick: this.horizontalSearch },
	                            API.LANG.HORIZONTAL
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-7 flex-sm-6 flex-xs-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: ' grid-choose-option from-search-panel' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.TEMPLATE_SETTINGS,
	                      ':'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'search-view-type-change' },
	                      _react2.default.createElement(
	                        _reactAddonsCssTransitionGroup2.default,
	                        { transitionName: 'simplefade', transitionEnterTimeout: 200, transitionLeaveTimeout: 200 },
	                        _react2.default.createElement(
	                          'p',
	                          { className: customTemplateClass },
	                          _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'vertical', onClick: this.defaultTemplate },
	                            API.LANG.DEFAULT
	                          ),
	                          _react2.default.createElement(
	                            'a',
	                            { href: '#', className: 'horizontal', onClick: this.dropdownTemplate },
	                            API.LANG.DROPDOWN
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option from-search-panel' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.CUSTOM_CLASS,
	                      ':'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'search-view-type-change custom-class-content' },
	                      _react2.default.createElement('input', { type: 'text', className: 'reactive-input', placeholder: API.LANG.PLACE_ENTER_ANY_CLASS_NAME, value: this.state.customCssClass, onChange: this.handelCustomCss })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option from-search-panel' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'caption' },
	                      API.LANG.CHANGE_GRID_LAYOUT
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'choose-grid-button' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.valueIncrement },
	                          _react2.default.createElement('i', { className: 'fa fa-plus' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                          'button',
	                          { onClick: this.valueDecrement },
	                          _react2.default.createElement('i', { className: 'fa fa-minus' })
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { className: 'gird-value-count' },
	                        this.state.rangeValue !== undefined ? this.state.rangeValue : null
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'add-button-content' },
	            this.state.errorMsg !== undefined ? _react2.default.createElement(
	              'p',
	              { className: 'error-body' },
	              this.state.errorMsg
	            ) : null,
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'add-button', onClick: this.addSelected },
	              ' ',
	              API.LANG.SAVE,
	              ' '
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdvancedSearchPanel;
	}(_react2.default.Component);
	
	AdvancedSearchPanel.propTypes = {
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'allLayout': _react2.default.PropTypes.array,
	  'onClickedPanel': _react2.default.PropTypes.func
	};
	
	exports.default = AdvancedSearchPanel;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(524);

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var React = __webpack_require__(2);
	
	var ReactTransitionGroup = __webpack_require__(525);
	var ReactCSSTransitionGroupChild = __webpack_require__(527);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	        }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool,
	    transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	    transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	    transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	  },
	
	  getDefaultProps: function () {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function (child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return React.createElement(ReactCSSTransitionGroupChild, {
	      name: this.props.transitionName,
	      appear: this.props.transitionAppear,
	      enter: this.props.transitionEnter,
	      leave: this.props.transitionLeave,
	      appearTimeout: this.props.transitionAppearTimeout,
	      enterTimeout: this.props.transitionEnterTimeout,
	      leaveTimeout: this.props.transitionLeaveTimeout
	    }, child);
	  },
	
	  render: function () {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(3);
	
	var React = __webpack_require__(2);
	var ReactInstanceMap = __webpack_require__(111);
	var ReactTransitionChildMapping = __webpack_require__(526);
	
	var emptyFunction = __webpack_require__(11);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function () {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function () {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function () {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function (key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      this.setState(function (state) {
	        var newChildren = _assign({}, state.children);
	        delete newChildren[key];
	        return { children: newChildren };
	      });
	    }
	  },
	
	  render: function () {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  }
	});
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(123);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(32);
	
	var CSSCore = __webpack_require__(528);
	var ReactTransitionEvents = __webpack_require__(529);
	
	var onlyChild = __webpack_require__(30);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactDOM.findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(7);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(46);
	
	var getVendorPrefixedEventName = __webpack_require__(101);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  listenables: _panelActions2.default,
	  onTogglePanel: function onTogglePanel() {
	    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var shortcodeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var parentUid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var childUid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    var key = 'panel_' + shortcodeKey;
	    window.openWindow[key] = !window.openWindow[key];
	    this.trigger(window.openWindow[key], type, shortcodeKey, parentUid, childUid);
	  }
	});

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(532);
	


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(31);
	var ExecutionEnvironment = __webpack_require__(533);
	var ModalPortal = React.createFactory(__webpack_require__(534));
	var ariaAppHider = __webpack_require__(549);
	var elementClass = __webpack_require__(550);
	var renderSubtreeIntoContainer = __webpack_require__(31).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(538);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = React.createClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: React.PropTypes.bool.isRequired,
	    style: React.PropTypes.shape({
	      content: React.PropTypes.object,
	      overlay: React.PropTypes.object
	    }),
	    portalClassName: React.PropTypes.string,
	    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: React.PropTypes.func,
	    onRequestClose: React.PropTypes.func,
	    closeTimeoutMS: React.PropTypes.number,
	    ariaHideApp: React.PropTypes.bool,
	    shouldCloseOnOverlayClick: React.PropTypes.bool,
	    parentSelector: React.PropTypes.func,
	    role: React.PropTypes.string,
	    contentLabel: React.PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      portalClassName: 'ReactModalPortal',
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true,
	      parentSelector: function () { return document.body; }
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = this.props.portalClassName;
	
	    var parent = getParentElement(this.props.parentSelector);
	    parent.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    var currentParent = getParentElement(this.props.parentSelector);
	    var newParent = getParentElement(newProps.parentSelector);
	
	    if(newParent !== currentParent) {
	      currentParent.removeChild(this.node);
	      newParent.appendChild(this.node);
	    }
	
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    if (this.props.ariaHideApp) {
	      ariaAppHider.show(this.props.appElement);
	    }
	
	    ReactDOM.unmountComponentAtNode(this.node);
	    var parent = getParentElement(this.props.parentSelector);
	    parent.removeChild(this.node);
	    elementClass(document.body).remove('ReactModal__Body--open');
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen) {
	      elementClass(document.body).add('ReactModal__Body--open');
	    } else {
	      elementClass(document.body).remove('ReactModal__Body--open');
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return React.DOM.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var div = React.DOM.div;
	var focusManager = __webpack_require__(535);
	var scopeTab = __webpack_require__(537);
	var Assign = __webpack_require__(538);
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: {
	    base: 'ReactModal__Overlay',
	    afterOpen: 'ReactModal__Overlay--after-open',
	    beforeClose: 'ReactModal__Overlay--before-close'
	  },
	  content: {
	    base: 'ReactModal__Content',
	    afterOpen: 'ReactModal__Content--after-open',
	    beforeClose: 'ReactModal__Content--before-close'
	  }
	};
	
	var ModalPortal = module.exports = React.createClass({
	
	  displayName: 'ModalPortal',
	  shouldClose: null,
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  open: function() {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (!this.ownerHandlesClose())
	      return;
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    // Don't steal focus from inner elements
	    if (!this.contentHasFocus()) {
	      this.refs.content.focus();
	    }
	  },
	
	  closeWithTimeout: function() {
	    this.setState({beforeClose: true}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	    }, this.afterClose);
	  },
	
	  afterClose: function() {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayMouseDown: function(event) {
	    if (this.shouldClose === null) {
	      this.shouldClose = true;
	    }
	  },
	
	  handleOverlayMouseUp: function(event) {
	    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	    this.shouldClose = null;
	  },
	
	  handleContentMouseDown: function(event) {
	    this.shouldClose = false;
	  },
	
	  handleContentMouseUp: function(event) {
	    this.shouldClose = false;
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.props.isOpen && !this.state.beforeClose;
	  },
	
	  contentHasFocus: function() {
	    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
	  },
	
	  buildClassName: function(which, additional) {
	    var className = CLASS_NAMES[which].base;
	    if (this.state.afterOpen)
	      className += ' '+CLASS_NAMES[which].afterOpen;
	    if (this.state.beforeClose)
	      className += ' '+CLASS_NAMES[which].beforeClose;
	    return additional ? className + ' ' + additional : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onMouseDown: this.handleOverlayMouseDown,
	        onMouseUp: this.handleOverlayMouseUp
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown,
	          onMouseDown: this.handleContentMouseDown,
	          onMouseUp: this.handleContentMouseUp,
	          role: this.props.role,
	          "aria-label": this.props.contentLabel
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(536);
	var modalElement = null;
	var focusLaterElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation 
	    // is that the document.body gets focus, and then we focus our element right 
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElement = document.activeElement;
	};
	
	exports.returnFocus = function() {
	  try {
	    focusLaterElement.focus();
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
	  }
	  focusLaterElement = null;
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};
	
	


/***/ },
/* 536 */
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(536);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseAssign = __webpack_require__(539),
	    createAssigner = __webpack_require__(545),
	    keys = __webpack_require__(541);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(540),
	    keys = __webpack_require__(541);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 540 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(542),
	    isArguments = __webpack_require__(543),
	    isArray = __webpack_require__(544);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 542 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 543 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 544 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(546),
	    isIterateeCall = __webpack_require__(547),
	    restParam = __webpack_require__(548);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 546 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ },
/* 547 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 548 */
/***/ function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 549 */
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },
/* 550 */
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _reactToggle = __webpack_require__(483);
	
	var _reactToggle2 = _interopRequireDefault(_reactToggle);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _prequery = __webpack_require__(552);
	
	var _prequery2 = _interopRequireDefault(_prequery);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppearPanel = function (_React$Component) {
	  _inherits(AppearPanel, _React$Component);
	
	  function AppearPanel(props) {
	    _classCallCheck(this, AppearPanel);
	
	    var _this = _possibleConstructorReturn(this, (AppearPanel.__proto__ || Object.getPrototypeOf(AppearPanel)).call(this, props));
	
	    _this.displayName = 'AppearPanel';
	    _this.saveSettings = _this.saveSettings.bind(_this);
	    _this.handleChangeTheme = _this.handleChangeTheme.bind(_this);
	    _this.handleTaxonomySelection = _this.handleTaxonomySelection.bind(_this);
	    _this.selectPrequery = _this.selectPrequery.bind(_this);
	    _this.postTypesHelper = API.helper.all_post_types ? API.helper.all_post_types : ['post'];
	    _this.postTypeOptions = [];
	    _this.postTypesHelper.forEach(function (type) {
	      _this.postTypeOptions.push({
	        value: type,
	        label: type
	      });
	    });
	    var dummy = {
	      theme: 'reactive',
	      post_type: 'post',
	      ajax: 'false'
	
	    };
	    _this.state = {
	      data: _this.props.settingsData.hasOwnProperty('post_type') ? _this.props.settingsData : dummy,
	      defaultTaxonomy: [],
	      defaultMeta: []
	    };
	    return _this;
	  }
	
	  _createClass(AppearPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var settingsData = (0, _clone2.default)(this.props.settingsData);
	      var defaultTaxonomy = [];
	      var defaultPrequery = '';
	      if (settingsData.hasOwnProperty('prequery')) {
	        if (settingsData.prequery.hasOwnProperty('taxonomy')) {
	          defaultTaxonomy = (0, _clone2.default)(settingsData.prequery.taxonomy);
	        }
	        if (settingsData.prequery.hasOwnProperty('defaultPrequery')) {
	          defaultPrequery = settingsData.prequery.defaultPrequery;
	        }
	      }
	      this.setState({ defaultTaxonomy: defaultTaxonomy, defaultPrequery: defaultPrequery });
	    }
	  }, {
	    key: 'handleChangeTheme',
	    value: function handleChangeTheme(option) {
	      var data = this.state.data;
	
	      data['theme'] = option;
	      this.setState({ data: data });
	    }
	  }, {
	    key: 'handleTaxonomySelection',
	    value: function handleTaxonomySelection(value) {
	      this.setState({ defaultTaxonomy: value });
	    }
	  }, {
	    key: 'selectPrequery',
	    value: function selectPrequery(value) {
	      this.setState({ defaultPrequery: value });
	    }
	  }, {
	    key: 'saveSettings',
	    value: function saveSettings() {
	      var data = (0, _clone2.default)(this.state.data);
	      data['prequery'] = {};
	      if (this.state.defaultTaxonomy !== undefined) {
	        data['prequery'].taxonomy = this.state.defaultTaxonomy;
	      }
	      if (this.state.defaultPrequery !== undefined && this.state.defaultPrequery.length !== 0) {
	        data['prequery'].defaultPrequery = this.state.defaultPrequery;
	      }
	      var pushLayout = {
	        'settingsData': data,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveSettingsData(pushLayout);
	      this.props.onClickedPanel();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // processing themes into array
	      var themes = [];
	      if (window.ReactiveTheme) {
	        for (var theme in window.ReactiveTheme) {
	          themes.push(theme);
	        }
	      }
	
	      var data = this.state.data;
	
	      var settings = (0, _clone2.default)(this.props.settingsData);
	      var showPreQuery = false;
	      if (settings.hasOwnProperty('post_type')) {
	        showPreQuery = true;
	      }
	      var showThemes = function showThemes(theme, index) {
	        var checked = false;
	        if (data.theme === theme) {
	          checked = true;
	        }
	        return _react2.default.createElement(
	          'li',
	          { className: 'search-content', key: 'appearpanel-' + index },
	          _react2.default.createElement('input', { type: 'radio', name: 'search-markerElement', checked: checked, id: 'theme-' + index, value: theme,
	            onChange: _this2.handleChangeTheme.bind(_this2, theme)
	          }),
	          _react2.default.createElement(
	            'label',
	            { className: 'select-search-content', htmlFor: 'theme-' + index },
	            _react2.default.createElement(
	              'span',
	              null,
	              theme
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'reactive-tab-setting' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'nav nav-tabs', role: 'tablist' },
	                _react2.default.createElement(
	                  'li',
	                  { role: 'presentation', className: 'active' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#settingsGeneral', 'aria-controls': 'general', role: 'tab', 'data-toggle': 'tab' },
	                    API.LANG.SETTINGS
	                  )
	                ),
	                showPreQuery ? _react2.default.createElement(
	                  'li',
	                  { role: 'presentation' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#settingsLayout', 'aria-controls': 'layout', role: 'tab', 'data-toggle': 'tab' },
	                    API.LANG.PREQUERY
	                  )
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'tab-content' },
	                _react2.default.createElement(
	                  'div',
	                  { role: 'tabpanel', className: 'tab-pane active', id: 'settingsGeneral' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'grid-choose-option smallmargin ' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'caption' },
	                          API.LANG.SELECT_THEME
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'ul',
	                            { className: 'list-inline' },
	                            themes.map(showThemes)
	                          )
	                        )
	                      )
	                    )
	                  )
	                ),
	                showPreQuery === true ? _react2.default.createElement(
	                  'div',
	                  { role: 'tabpanel', className: 'tab-pane', id: 'settingsLayout' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'grid-choose-option' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'flex-row' },
	                      _react2.default.createElement(
	                        'pre',
	                        null,
	                        API.LANG.PREQUERY_AJAX_WARNING
	                      ),
	                      _react2.default.createElement(_prequery2.default, _extends({}, this.props, { defaultTaxonomy: this.state.defaultTaxonomy, selectPrequery: this.selectPrequery,
	                        defaultPrequery: this.state.defaultPrequery,
	                        handleTaxonomySelection: this.handleTaxonomySelection
	                      }))
	                    )
	                  )
	                ) : null
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'add-button-content-settings' },
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'add-button', onClick: this.saveSettings },
	            ' ',
	            API.LANG.SAVE,
	            ' '
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppearPanel;
	}(_react2.default.Component);
	
	AppearPanel.propTypes = {
	  'onClickedPanel': _react2.default.PropTypes.func,
	  settingsData: _react2.default.PropTypes.object
	};
	
	exports.default = AppearPanel;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMultiSelect = __webpack_require__(553);
	
	var _reactMultiSelect2 = _interopRequireDefault(_reactMultiSelect);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreQueryPanel = function (_React$Component) {
	  _inherits(PreQueryPanel, _React$Component);
	
	  function PreQueryPanel(props) {
	    _classCallCheck(this, PreQueryPanel);
	
	    var _this = _possibleConstructorReturn(this, (PreQueryPanel.__proto__ || Object.getPrototypeOf(PreQueryPanel)).call(this, props));
	
	    _this.handleTaxonomy = _this.handleTaxonomy.bind(_this);
	    _this.handleSelectValue = _this.handleSelectValue.bind(_this);
	    _this.state = {
	      optionsForOthers: [{
	        value: 'popular-asc',
	        label: 'popular-asc'
	      }, {
	        value: 'popular-dsc',
	        label: 'popular-dsc'
	      }, {
	        value: 'date-asc',
	        label: 'date-asc'
	      }, {
	        value: 'date-dsc',
	        label: 'date-dsc'
	      }, {
	        value: 'title-asc',
	        label: 'title-asc'
	      }, {
	        value: 'title-dsc',
	        label: 'title-dsc'
	      }]
	    };
	    return _this;
	  }
	
	  _createClass(PreQueryPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var taxonomies = [];
	      if (this.props.helperData === undefined) {
	        return;
	      }
	      if (this.props.helperData.hasOwnProperty('terms')) {
	        var terms = (0, _clone2.default)(this.props.helperData.terms);
	        for (var key in terms) {
	          if (terms.hasOwnProperty(key)) {
	            for (var index = 0; index < terms[key].linear.length; index++) {
	              var temp = {};
	              temp.value = terms[key]['linear'][index].slug;
	              temp.label = terms[key]['linear'][index].slug;
	              taxonomies.push(temp);
	            }
	          }
	        }
	      }
	      this.setState({ taxonomies: taxonomies });
	    }
	  }, {
	    key: 'handleTaxonomy',
	    value: function handleTaxonomy(value) {
	      this.props.handleTaxonomySelection(value);
	    }
	  }, {
	    key: 'handleSelectValue',
	    value: function handleSelectValue(val) {
	      if (val === null) {
	        this.props.selectPrequery('');
	      } else {
	        this.props.selectPrequery(val.value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'grid-choose-option' },
	        _react2.default.createElement(_reactMultiSelect2.default, { options: this.state.taxonomies, handleOperation: this.handleTaxonomy,
	          values: this.props.defaultTaxonomy
	        }),
	        _react2.default.createElement(_reactSelect2.default, { options: this.state.optionsForOthers, value: this.props.defaultPrequery,
	          onChange: this.handleSelectValue
	        })
	      );
	    }
	  }]);
	
	  return PreQueryPanel;
	}(_react2.default.Component);
	
	PreQueryPanel.propTypes = {
	  'handleTaxonomySelection': _react2.default.PropTypes.func,
	  'handleMetaSelection': _react2.default.PropTypes.func,
	  'defaultTaxonomy': _react2.default.PropTypes.array,
	  'defaultMeta': _react2.default.PropTypes.array,
	  'helperData': _react2.default.PropTypes.object,
	  'defaultPrequery': _react2.default.PropTypes.string
	};
	
	exports.default = PreQueryPanel;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactMultiSelect = function (_React$Component) {
	  _inherits(ReactMultiSelect, _React$Component);
	
	  function ReactMultiSelect(props) {
	    _classCallCheck(this, ReactMultiSelect);
	
	    var _this = _possibleConstructorReturn(this, (ReactMultiSelect.__proto__ || Object.getPrototypeOf(ReactMultiSelect)).call(this, props));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReactMultiSelect, [{
	    key: 'handleSelect',
	    value: function handleSelect(val) {
	      var values = [];
	      for (var index = 0; index < val.length; index++) {
	        values.push(val[index].value);
	      }
	      this.props.handleOperation(values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactSelect2.default, { options: this.props.options, onChange: this.handleSelect,
	          multi: true, value: this.props.values
	        })
	      );
	    }
	  }]);
	
	  return ReactMultiSelect;
	}(_react2.default.Component);
	
	ReactMultiSelect.propTypes = {
	  'handleOperation': _react2.default.PropTypes.func,
	  'options': _react2.default.PropTypes.array,
	  'values': _react2.default.PropTypes.array
	};
	
	exports.default = ReactMultiSelect;

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Welcome = function Welcome() {
	  return _react2.default.createElement(
	    "div",
	    { className: "grid-choose-option view-pager-panel" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      API.LANG.WELCOME
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "img-container" },
	      _react2.default.createElement("img", { src: API.IMG + 'Package.png', alt: "" })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      " ",
	      API.LANG.ON_BOARD,
	      " "
	    )
	  );
	};
	var SearchPage = function SearchPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "grid-choose-option view-pager-panel" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      API.LANG.STEP_1
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "img-container" },
	      _react2.default.createElement("img", { className: "box-shadow", src: API.IMG + 'first-step.png', alt: "" })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      " ",
	      API.LANG.CREATE_SEARCH,
	      " "
	    )
	  );
	};
	var GridOption = function GridOption() {
	  return _react2.default.createElement(
	    "div",
	    { className: "grid-choose-option view-pager-panel" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      API.LANG.STEP_2
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "img-container" },
	      _react2.default.createElement("img", { src: API.IMG + 'second-step.png', alt: "" })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      API.LANG.WISH_LETTER,
	      " "
	    )
	  );
	};
	var SearchOption = function SearchOption() {
	  return _react2.default.createElement(
	    "div",
	    { className: "grid-choose-option view-pager-panel" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      API.LANG.STEP_3
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "img-container" },
	      _react2.default.createElement("img", { src: API.IMG + 'third-step.png', alt: "" })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      API.LANG.BEAST_RELEASE
	    )
	  );
	};
	var PostSelect = function PostSelect() {
	  return _react2.default.createElement(
	    "div",
	    { className: "grid-choose-option view-pager-panel" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      API.LANG.STEP_4
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "img-container" },
	      _react2.default.createElement("img", { src: API.IMG + 'forth-step.png', alt: "" })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      API.LANG.DATA_CONTROL
	    )
	  );
	};
	var Congrates = function Congrates() {
	  return _react2.default.createElement(
	    "div",
	    { className: "grid-choose-option view-pager-panel" },
	    _react2.default.createElement(
	      "h2",
	      null,
	      API.LANG.READY
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "img-container" },
	      _react2.default.createElement("img", { src: API.IMG + 'Processing.png', alt: "" })
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      API.LANG.FOLLOW,
	      _react2.default.createElement(
	        "a",
	        { href: "https://redq.gitbooks.io/reactive/content/" },
	        API.LANG.REACTIVE_DOC_LINK
	      ),
	      API.LANG.FURTHER_QUERIES,
	      _react2.default.createElement(
	        "a",
	        { href: "mailto:support@redqteam.com" },
	        API.LANG.REDQ_EMAIL
	      ),
	      API.LANG.LET_US_KNOW
	    )
	  );
	};
	
	var ViewPagerPanel = function (_React$Component) {
	  _inherits(ViewPagerPanel, _React$Component);
	
	  function ViewPagerPanel(props) {
	    _classCallCheck(this, ViewPagerPanel);
	
	    var _this = _possibleConstructorReturn(this, (ViewPagerPanel.__proto__ || Object.getPrototypeOf(ViewPagerPanel)).call(this, props));
	
	    _this.viewPagerElementArray = [{
	      item: _react2.default.createElement(Welcome, null),
	      'image_url': API.IMG + 'package.png'
	    }, {
	      item: _react2.default.createElement(SearchPage, null),
	      'image_url': API.IMG + 'first-step.png'
	    }, {
	      item: _react2.default.createElement(GridOption, null),
	      'image_url': API.IMG + 'second-step.png'
	    }, {
	      item: _react2.default.createElement(SearchOption, null),
	      'image_url': API.IMG + 'third-step.png'
	    }, {
	      item: _react2.default.createElement(PostSelect, null),
	      'image_url': API.IMG + 'forth-step.png'
	    }, {
	      item: _react2.default.createElement(Congrates, null),
	      'image_url': API.IMG + 'Processing.png'
	    }];
	    _this.state = { windowValue: 0 };
	    _this.previousWindow = _this.previousWindow.bind(_this);
	    _this.nextWindow = _this.nextWindow.bind(_this);
	    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
	    return _this;
	  }
	
	  _createClass(ViewPagerPanel, [{
	    key: "previousWindow",
	    value: function previousWindow() {
	      if (this.state.windowValue > 0) {
	        var windowValue = this.state.windowValue - 1;
	        this.setState({ windowValue: windowValue });
	      }
	    }
	  }, {
	    key: "nextWindow",
	    value: function nextWindow() {
	      if (this.state.windowValue < this.viewPagerElementArray.length - 1) {
	        var windowValue = this.state.windowValue + 1;
	        this.setState({ windowValue: windowValue });
	      }
	    }
	  }, {
	    key: "handleCloseModal",
	    value: function handleCloseModal() {
	      localStorage.setItem('reactiveSiteTour', 'true');
	      this.props.onCloseModal();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevButton = true;
	      var nextButton = true;
	      var finishButton = false;
	      if (this.state.windowValue === 0) {
	        prevButton = false;
	      }
	      if (this.state.windowValue === this.viewPagerElementArray.length - 1) {
	        nextButton = false;
	      }
	      if (this.state.windowValue === this.viewPagerElementArray.length - 1) {
	        finishButton = true;
	      }
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement("div", { className: "grid-choose-option view-pager-img" }),
	        this.viewPagerElementArray[this.state.windowValue].item,
	        _react2.default.createElement(
	          "div",
	          { className: "add-button-content view-agerpanerl-button" },
	          _react2.default.createElement(
	            "div",
	            { className: "right-btn" },
	            _react2.default.createElement(
	              "button",
	              { className: "view-pager-button", onClick: this.handleCloseModal },
	              API.LANG.SKIP
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "left-btn" },
	            nextButton ? _react2.default.createElement(
	              "button",
	              { className: "view-pager-button", onClick: this.nextWindow },
	              API.LANG.NEXT
	            ) : null,
	            finishButton ? _react2.default.createElement(
	              "button",
	              { className: "view-pager-button", onClick: this.handleCloseModal },
	              API.LANG.FINISH
	            ) : null,
	            prevButton ? _react2.default.createElement(
	              "button",
	              { className: "view-pager-button previous", onClick: this.previousWindow },
	              API.LANG.PREVIOUS
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return ViewPagerPanel;
	}(_react2.default.Component);
	
	exports.default = ViewPagerPanel;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WelcomeBlock = function (_React$Component) {
	  _inherits(WelcomeBlock, _React$Component);
	
	  function WelcomeBlock(props) {
	    _classCallCheck(this, WelcomeBlock);
	
	    return _possibleConstructorReturn(this, (WelcomeBlock.__proto__ || Object.getPrototypeOf(WelcomeBlock)).call(this, props));
	  }
	
	  _createClass(WelcomeBlock, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "rq-welcomeblock" },
	          _react2.default.createElement("i", { className: "fa fa-paw" }),
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Please add ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "a Block"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return WelcomeBlock;
	}(_react2.default.Component);
	
	exports.default = WelcomeBlock;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  listenables: _builderActions2.default,
	  onPublishNewLayout: function onPublishNewLayout(layout) {
	    this.trigger(layout);
	  }
	});

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _gridStore = __webpack_require__(498);
	
	var _gridStore2 = _interopRequireDefault(_gridStore);
	
	var _gridBlock = __webpack_require__(558);
	
	var _gridBlock2 = _interopRequireDefault(_gridBlock);
	
	var _categoryBlock = __webpack_require__(684);
	
	var _categoryBlock2 = _interopRequireDefault(_categoryBlock);
	
	var _userBlock = __webpack_require__(688);
	
	var _userBlock2 = _interopRequireDefault(_userBlock);
	
	var _searchBlock = __webpack_require__(689);
	
	var _searchBlock2 = _interopRequireDefault(_searchBlock);
	
	var _mapBlock = __webpack_require__(690);
	
	var _mapBlock2 = _interopRequireDefault(_mapBlock);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _underscore = __webpack_require__(205);
	
	var _history = __webpack_require__(692);
	
	var _urlHandlerStore = __webpack_require__(718);
	
	var _urlHandlerStore2 = _interopRequireDefault(_urlHandlerStore);
	
	var _filterOperation = __webpack_require__(719);
	
	var _filterOperation2 = _interopRequireDefault(_filterOperation);
	
	var _filterAction = __webpack_require__(721);
	
	var _filterAction2 = _interopRequireDefault(_filterAction);
	
	var _filterStore = __webpack_require__(722);
	
	var _filterStore2 = _interopRequireDefault(_filterStore);
	
	var _toogleHandlerStore = __webpack_require__(723);
	
	var _toogleHandlerStore2 = _interopRequireDefault(_toogleHandlerStore);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(725);
	
	var _isotopeBlock = __webpack_require__(843);
	
	var _isotopeBlock2 = _interopRequireDefault(_isotopeBlock);
	
	var _quicksort = __webpack_require__(846);
	
	var _quicksort2 = _interopRequireDefault(_quicksort);
	
	var _sortAllInOne = __webpack_require__(847);
	
	var _sortAllInOne2 = _interopRequireDefault(_sortAllInOne);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var history = (0, _history.useQueries)(_history.createHistory)();
	var $ = jQuery;
	window.doAjax = true;
	window.loadPageNumber = false;
	
	var ShowBuilderPreview = function (_React$Component) {
	  _inherits(ShowBuilderPreview, _React$Component);
	
	  function ShowBuilderPreview(props) {
	    _classCallCheck(this, ShowBuilderPreview);
	
	    var _this = _possibleConstructorReturn(this, (ShowBuilderPreview.__proto__ || Object.getPrototypeOf(ShowBuilderPreview)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    // this.mergeSort = this.mergeSort.bind(this);
	    _this.state = {
	      'previewData': _this.props.previewData,
	      'previewTaxonomyData': _this.props.allLayout,
	      'urlData': {},
	      gridToggle: true,
	      searchToggle: true,
	      categoryToggle: true,
	      mapToggle: true,
	      isotopeToggle: true,
	      originData: (0, _clone2.default)(_this.props.previewData),
	      isEditable: API.isEditable ? true : false
	    };
	    API['filterable'] = _this.props.settingsData.ajax === 'true' && _this.props.settingsData.ajax ? 'true' : 'false';
	    _this.filterable = API.filterable === 'false' ? true : false;
	    _this.previewOptions = (0, _clone2.default)(_this.state.previewData);
	    _this.makeFilterCall = _this.makeFilterCall.bind(_this);
	    _this.handleBlockToggle = _this.handleBlockToggle.bind(_this);
	    _this.handleFilter = _this.handleFilter.bind(_this);
	    _this.doProcessUrl = _this.doProcessUrl.bind(_this);
	    _this.filterDataOnPrequery = _this.filterDataOnPrequery.bind(_this);
	    _this.switchAdmin = _this.switchAdmin.bind(_this);
	    return _this;
	  }
	
	  _createClass(ShowBuilderPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var dropdownAttributeToogle = {};
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      for (var key in allLayout) {
	        if (allLayout.hasOwnProperty(key)) {
	          if (allLayout[key]['type'] === 'search' && allLayout[key].hasOwnProperty('searchAttr')) {
	            for (var index = 0; index < allLayout[key]['searchAttr'].length; index++) {
	              dropdownAttributeToogle[allLayout[key]['searchAttr'][index].uid] = false;
	            }
	          }
	        }
	      }
	      this.setState({ dropdownAttributeToogle: dropdownAttributeToogle });
	      this.doProcessUrl();
	      this.handleFilter({}, this.props.previewData);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // for url handling
	      history.listen(function (location) {
	        if (API.filterable === 'true') {
	          if ('pagenumber' in location.query) {
	            _this2.makeFilterCall(location.query, location.query.pagenumber);
	          } else {
	            _this2.makeFilterCall(location.query);
	          }
	        }
	        if (_.isEmpty(location.query) === false) {
	          _this2.handleFilter(location.query, _this2.props.previewData);
	        }
	      });
	
	      _gridStore2.default.listen(this.updateData.bind(this));
	      _urlHandlerStore2.default.listen(this.updateUrlData.bind(this));
	      _filterStore2.default.listen(this.updateFilterData.bind(this));
	      _toogleHandlerStore2.default.listen(this.toggleDropdown.bind(this));
	
	      if (this.state.isEditable) {
	        $('.rebuilder').sortable({
	          handle: '.builder-shortable',
	          start: function start(e, ui) {
	            ui.placeholder.height(ui.item.height());
	            ui.placeholder.width(ui.item.width());
	            $(ui.item).addClass('forceBg');
	          },
	          delay: 150,
	          stop: this.handleSort.bind(this),
	          placeholder: 'ui-state-highlight'
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      API['filterable'] = nextProps.settingsData.ajax === 'true' && nextProps.settingsData.ajax ? 'true' : 'false';
	      var dropdownAttributeToogle = {};
	      var allLayout = (0, _clone2.default)(nextProps.allLayout);
	      for (var key in allLayout) {
	        if (allLayout.hasOwnProperty(key)) {
	          if (allLayout[key]['type'] === 'search' && allLayout[key].hasOwnProperty('searchAttr')) {
	            for (var index = 0; index < allLayout[key]['searchAttr'].length; index++) {
	              dropdownAttributeToogle[allLayout[key]['searchAttr'][index].uid] = false;
	            }
	          }
	        }
	      }
	      this.setState({ dropdownAttributeToogle: dropdownAttributeToogle, isEditable: nextProps.isEditable });
	      this.handleFilter({}, nextProps.previewData);
	    }
	  }, {
	    key: 'doProcessUrl',
	    value: function doProcessUrl() {
	      var _this3 = this;
	
	      var hash = '';
	      var hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
	      for (var i = 0; i < hashes.length; i++) {
	        hash = hashes[i].split('=');
	        var temp = {};
	        if (hash[0].length !== 0) {
	          temp.key = hash[0];
	          temp.value = hash[1];
	          window.searchArray.push(temp);
	        }
	      }
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var isSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (isSearch !== -1) {
	        (function () {
	          var searchAttr = (0, _clone2.default)(allLayout[isSearch].searchAttr);
	          window.searchArray.map(function (searchItem) {
	            var isTaxonomy = (0, _underscore.findIndex)(searchAttr, { selectedTaxonomy: searchItem.key });
	            var isMetakey = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: searchItem.key });
	            if (isTaxonomy !== -1) {
	              searchItem.selectedDataType = searchAttr[isTaxonomy].selectedDataType;
	              searchItem.viewType = searchAttr[isTaxonomy].viewType;
	              searchItem.title = searchAttr[isTaxonomy].title;
	              if (searchItem.viewType === 'combobox') {
	                searchItem.linearData = _this3.props.helperData.terms[searchItem.key].linear;
	              }
	            } else if (isMetakey !== -1 && searchItem.key.search('[min]') === -1 && searchItem.key.search('[start]')) {
	              searchItem.selectedDataType = searchAttr[isMetakey].selectedDataType;
	              searchItem.viewType = searchAttr[isMetakey].viewType;
	              searchItem.title = searchAttr[isMetakey].title;
	              searchItem.metakey = searchAttr[isMetakey].selectedMetakey;
	            } else {
	              // will work for range and daterange
	              var key = 'key';
	              var isDateRangeStart = searchItem[key].indexOf('[start]');
	              var isDateRangeEnd = searchItem[key].indexOf('[end]');
	              var isRangeMin = searchItem[key].indexOf('[min]');
	              var isRangeMax = searchItem[key].indexOf('[max]');
	              if (isDateRangeStart !== -1) {
	                var dateStartMetakey = searchItem[key].split('[start]').length ? searchItem[key].split('[start]')[0] : null;
	                var index = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: dateStartMetakey });
	                searchItem.selectedDataType = searchAttr[index].selectedDataType;
	                searchItem.viewType = searchAttr[index].viewType;
	                searchItem.title = searchAttr[index].title;
	                searchItem.metakey = dateStartMetakey;
	                searchItem.key = searchItem[key];
	              } else if (isDateRangeEnd !== -1) {
	                var dateEndmetakey = searchItem[key].split('[end]').length ? searchItem[key].split('[end]')[0] : null;
	                var _index = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: dateEndmetakey });
	                searchItem.selectedDataType = searchAttr[_index].selectedDataType;
	                searchItem.viewType = searchAttr[_index].viewType;
	                searchItem.title = searchAttr[_index].title;
	                searchItem.metakey = dateEndmetakey;
	                searchItem.key = searchItem[key];
	              } else if (isRangeMin !== -1) {
	                var rangeMinMetakey = searchItem[key].split('[min]').length ? searchItem[key].split('[min]')[0] : null;
	                var indexforRangeMin = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: rangeMinMetakey });
	                searchItem.selectedDataType = searchAttr[indexforRangeMin].selectedDataType;
	                searchItem.viewType = searchAttr[indexforRangeMin].viewType;
	                searchItem.title = searchAttr[indexforRangeMin].title;
	                searchItem.metakey = rangeMinMetakey;
	                searchItem.key = searchItem[key];
	              } else if (isRangeMax !== -1) {
	                var rangeMaxMetakey = searchItem[key].split('[max]').length ? searchItem[key].split('[max]')[0] : null;
	                var indexRangeMin = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: rangeMaxMetakey });
	                searchItem.selectedDataType = searchAttr[indexRangeMin].selectedDataType;
	                searchItem.viewType = searchAttr[indexRangeMin].viewType;
	                searchItem.title = searchAttr[indexRangeMin].title;
	                searchItem.metakey = rangeMaxMetakey;
	                searchItem.key = searchItem[key];
	              }
	            }
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'updateUrlData',
	    value: function updateUrlData(urlData) {
	      if (API.filterable === 'true') {
	        if ('pagenumber' in urlData.query) {
	          this.makeFilterCall(urlData.query, urlData.query.pagenumber);
	        } else {
	          this.makeFilterCall(urlData.query);
	        }
	      }
	      if (_.isEmpty(urlData) === false) {
	        this.handleFilter(urlData.query, this.state.previewData);
	      }
	    }
	  }, {
	    key: 'handleFilter',
	    value: function handleFilter(urlData, previewData) {
	      var self = this;
	      var previewOptions = {};
	      this.availableData = (0, _clone2.default)(previewData.data);
	      this.filterTermData = [];
	      if (_.isEmpty(urlData) || API.filterable === 'false' || API.filterable === false) {
	        previewOptions = (0, _clone2.default)(previewData);
	        // console.log(previewOptions);
	      }
	      var totalNumberOfPosts = previewOptions.total_post ? previewOptions.total_post : 0;
	
	      if (this.filterable) {
	        var defaultProps = {};
	        defaultProps.metakey = this.metakey;
	        defaultProps.urlData = urlData;
	        defaultProps.filterTermData = this.filterTermData;
	        defaultProps.availableData = this.availableData;
	        defaultProps.props = this.props;
	        var doFilterOnData = new _filterOperation2.default(defaultProps);
	        previewOptions.data = doFilterOnData.filterOperation();
	        if (previewOptions.data !== undefined) {
	          totalNumberOfPosts = previewOptions.data.length;
	        }
	      }
	
	      if (urlData.location) {
	        this.filterDataForMapSearch(urlData.location, previewOptions.data).then(function (res) {
	          previewOptions.data = res;
	          self.setState({
	            urlData: urlData,
	            previewOptions: previewOptions,
	            totalNumberOfPosts: res.length,
	            'previewData': (0, _clone2.default)(previewData)
	          });
	        });
	      } else {
	        this.setState({
	          urlData: urlData,
	          previewOptions: previewOptions,
	          totalNumberOfPosts: totalNumberOfPosts,
	          'previewData': (0, _clone2.default)(previewData)
	        });
	      }
	    }
	
	    // very handy stuff
	
	  }, {
	    key: 'getLocation',
	    value: function getLocation(components, type) {
	      var result = '';
	      components.forEach(function (address) {
	        if (address.types.indexOf(type) !== -1) {
	          result = address;
	        }
	      });
	      return result;
	    }
	  }, {
	    key: 'compareLocation',
	    value: function compareLocation(geocode, location, item, distance) {
	      if (geocode[0].types.indexOf('country') !== -1 && geocode[0].types.indexOf('political') !== -1) {
	        // location is country name
	        var country = this.getLocation(geocode[0].address_components, 'country');
	        if (item.meta.country === country.long_name) {
	          return item;
	        }
	      } else {
	        var searchRadious = 100;
	        var allLayout = (0, _clone2.default)(this.props.allLayout);
	        var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	        if (indexOfSearch !== -1) {
	          var indexOfLocation = (0, _underscore.findIndex)(allLayout[indexOfSearch].searchAttr, { viewType: 'mapsearch' });
	          if (allLayout[indexOfSearch].searchAttr[indexOfLocation].hasOwnProperty('mapradious')) {
	            searchRadious = parseInt(allLayout[indexOfSearch].searchAttr[indexOfLocation]['mapradious'], 10);
	          }
	        }
	        if (distance < searchRadious * 1000) {
	          // searchRadious is converted to meter form kilo meter
	          return item;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'filterDataForMapSearch',
	    value: function filterDataForMapSearch(value, availableData) {
	      var _this4 = this;
	
	      var filteredData = [];
	      var geocoder = new google.maps.Geocoder();
	      var latitude = null;
	      var longitude = null;
	
	      return new Promise(function (resolve) {
	        geocoder.geocode({ 'address': value }, function (results, status) {
	          if (status === google.maps.GeocoderStatus.OK) {
	            (function () {
	              latitude = results[0].geometry.location.lat();
	              longitude = results[0].geometry.location.lng();
	              var origin = new google.maps.LatLng(latitude, longitude);
	              // console.log(availableData);
	              availableData.map(function (item) {
	                if (item.meta.hasOwnProperty('latitude') && item.meta.hasOwnProperty('longitude')) {
	                  // console.log(item.meta.latitude);
	                  var destination = new google.maps.LatLng(parseFloat(item.meta.latitude), parseFloat(item.meta.longitude));
	                  var distance = google.maps.geometry.spherical.computeDistanceBetween(origin, destination);
	                  var data = _this4.compareLocation(results, value, item, distance); // country, city
	                  if (data !== false) {
	                    data.distance = distance;
	                    filteredData.push(data);
	                  }
	                }
	              });
	              var newArray = [];
	              if (filteredData.length !== 0) {
	                var opts = {
	                  algo: 'bubble', // bubble,selection,insertion,quick,merge
	                  array: filteredData,
	                  key: 'distance',
	                  orderBy: 'asc', // asc,desc
	                  date: false },
	                    mySorting = new _sortAllInOne2.default();
	                newArray = mySorting.sort(opts);
	              }
	              resolve(newArray);
	            })();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'handleBlockToggle',
	    value: function handleBlockToggle(type) {
	      var self = this;
	      switch (type) {
	        case 'grid':
	          self.setState({ gridToggle: !self.state.gridToggle });
	          break;
	        case 'search':
	          self.setState({ searchToggle: !self.state.searchToggle });
	          break;
	        case 'category':
	          self.setState({ categoryToggle: !self.state.categoryToggle });
	          break;
	        case 'map':
	          self.setState({ mapToggle: !self.state.mapToggle });
	          break;
	        case 'isotope':
	          self.setState({ isotopeToggle: !self.state.isotopeToggle });
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'makeFilterCall',
	    value: function makeFilterCall(query) {
	      var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
	      var sortData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var search_stack = (0, _clone2.default)(window.searchArray);
	      var post_type = this.props.settingsData.post_type ? this.props.settingsData.post_type : 'post';
	      var numberOfPosts = '10';
	      this.props.allLayout.forEach(function (layout) {
	        if ('numberOfPosts' in layout) {
	          numberOfPosts = layout.numberOfPosts;
	        }
	      });
	      var rangekeys = [];
	      // need to check in searchArray
	      search_stack.forEach(function (stack, index) {
	        if (index + 1 < search_stack.length && stack.key.search('[min]') !== -1 && stack.key.search('[start]') !== -1 && stack.key !== 'pagenumber' && stack.key !== 'search_item' && stack.key !== 'view') {
	          if (stack.key.indexOf('[start]') !== -1) {
	            if (search_stack[index].metakey === search_stack[index + 1].metakey) {
	              rangekeys.push(_extends({}, stack, {
	                metakey: search_stack[index].metakey,
	                values: [(0, _moment2.default)(search_stack[index].value).unix(), (0, _moment2.default)(search_stack[index + 1]).unix()]
	              }));
	            }
	          } else {
	            if (search_stack[index].metakey === search_stack[index + 1].metakey) {
	              rangekeys.push(_extends({}, stack, {
	                metakey: search_stack[index].metakey,
	                values: [search_stack[index].value, search_stack[index + 1].value]
	              }));
	            }
	          }
	        }
	      });
	      if (window.doAjax === true) {
	        _filterAction2.default.pushForFilter({
	          post_type: post_type,
	          numberOfPosts: numberOfPosts,
	          pageNumber: pageNumber,
	          url_data: (0, _underscore.omit)(query, 'pagenumber', 'view', 'oldviewvalue'),
	          search_stack: search_stack,
	          rangekeys: rangekeys,
	          sortData: sortData
	        });
	      }
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(event, ui) {
	      $(ui.item).removeClass('forceBg');
	      var oldLayout = (0, _clone2.default)(this.props.allLayout);
	      var allLayout = [];
	      $(event.target).children().each(function (index, item) {
	        var uid = String($(item).data('uid'));
	        var findKey = (0, _underscore.findIndex)(oldLayout, { uid: uid });
	        if (findKey !== -1) {
	          allLayout.push(_extends({}, oldLayout[findKey], { position: index + 1 }));
	        }
	      });
	      var pushLayout = {
	        allLayout: allLayout,
	        'shortcodeKey': this.props.shortcodeKey,
	        'return': 'dont'
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	    }
	  }, {
	    key: 'handleAsyncSorting',
	    value: function handleAsyncSorting(sortData) {
	      this.makeFilterCall(this.state.urlData, '', sortData);
	    }
	  }, {
	    key: 'handleChangePagination',
	    value: function handleChangePagination(pageNumber) {
	      this.makeFilterCall(this.state.urlData, pageNumber);
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData(builderData) {
	      var key = this.props.shortcodeKey;
	      if (builderData.hasOwnProperty(key)) {
	        this.setState({
	          'previewData': builderData[key].previewData
	        });
	      }
	    }
	  }, {
	    key: 'updateFilterData',
	    value: function updateFilterData(result) {
	      $('#LoadTime').fadeOut(100);
	      this.setState({
	        previewOptions: result.posts,
	        totalNumberOfPosts: result.posts.total_post
	      });
	    }
	  }, {
	    key: 'toggleDropdown',
	    value: function toggleDropdown(field) {
	      var dropdownAttributeToogle = (0, _clone2.default)(this.state.dropdownAttributeToogle);
	      for (var key in dropdownAttributeToogle) {
	        if (dropdownAttributeToogle.hasOwnProperty(key)) {
	          if (field === key) {
	            dropdownAttributeToogle[key] = !dropdownAttributeToogle[key];
	          } else {
	            dropdownAttributeToogle[key] = false;
	          }
	        }
	      }
	      this.setState({ dropdownAttributeToogle: dropdownAttributeToogle });
	    }
	  }, {
	    key: 'showPanel',
	    value: function showPanel(panelType, uid, e) {
	      e.preventDefault();
	      _panelActions2.default.togglePanel(panelType, this.props.shortcodeKey, uid);
	    }
	  }, {
	    key: 'deleteBlock',
	    value: function deleteBlock(uid, e) {
	      e.preventDefault();
	      var layouts = this.props.allLayout;
	      var key = (0, _underscore.findIndex)(layouts, { uid: uid }); // object shorthand
	      if (key !== -1) {
	        layouts.splice(key, 1);
	      }
	      var pushBlock = {
	        'allLayout': layouts,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _panelActions2.default.togglePanel('', this.props.shortcodeKey);
	      _builderActions2.default.saveAllBlocks(pushBlock);
	    }
	  }, {
	    key: 'capitalize',
	    value: function capitalize(text) {
	      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
	    }
	  }, {
	    key: 'filterDataOnPrequery',
	    value: function filterDataOnPrequery(allData) {
	      var selectedTaxonomy = [];
	      var filteredData = [];
	      var prequeryOption = null;
	      if (this.props.settingsData.hasOwnProperty('prequery')) {
	        if (this.props.settingsData.prequery.hasOwnProperty('taxonomy')) {
	          selectedTaxonomy = (0, _clone2.default)(this.props.settingsData['prequery']['taxonomy']);
	        }
	        if (this.props.settingsData.prequery.hasOwnProperty('defaultPrequery')) {
	          prequeryOption = this.props.settingsData['prequery']['defaultPrequery'];
	        }
	      }
	      allData.data.map(function (item) {
	        var terms = (0, _clone2.default)(item.terms);
	        var takenastaxonomy = false;
	        for (var key in terms) {
	          if (terms.hasOwnProperty(key)) {
	            var result = _.intersection(terms[key], selectedTaxonomy);
	            if (result.length) {
	              takenastaxonomy = true;
	            }
	          }
	        }
	        if (takenastaxonomy === true) {
	          filteredData.push(item);
	        }
	      });
	      if (selectedTaxonomy.length === 0) {
	        filteredData = allData.data;
	      }
	      if (prequeryOption !== null) {
	        var partialPrequryOptions = prequeryOption.split('-');
	        var base = partialPrequryOptions[0];
	        var type = partialPrequryOptions[1];
	        switch (base) {
	          case 'popular':
	            // this.mergeSort(filteredData, 0, filteredData.length);
	            var quickSortPopular = new _quicksort2.default({ key: 'comment_count', type: type });
	            filteredData = quickSortPopular.startSorting(filteredData);
	            break;
	          case 'date':
	            var quickSortDate = new _quicksort2.default({ key: 'post_date', type: type });
	            filteredData = quickSortDate.startSorting(filteredData);
	            break;
	          case 'title':
	            var quickSortTitle = new _quicksort2.default({ key: 'post_title', type: type });
	            filteredData = quickSortTitle.startSorting(filteredData);
	            break;
	          default:
	            break;
	        }
	      }
	      return filteredData;
	    }
	  }, {
	    key: 'switchAdmin',
	    value: function switchAdmin(e) {
	      var flag = this.state.isEditable;
	      this.setState({ isEditable: !flag });
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var self = this;
	      var _state = this.state;
	      var previewOptions = _state.previewOptions;
	      var totalNumberOfPosts = _state.totalNumberOfPosts;
	
	      var windowUrlData = (0, _clone2.default)(window.searchArray);
	      var allLayout = this.props.allLayout;
	
	      if (allLayout.length) {
	        allLayout = (0, _underscore.sortBy)(allLayout, 'position', 'asc');
	      }
	      var searchUrl = 0;
	      for (var index = 0; index < windowUrlData.length; index++) {
	        if (windowUrlData[index].key !== 'pagenumber') {
	          searchUrl++;
	        }
	      }
	      var data = [];
	      if (searchUrl === 0) {
	        data = this.filterDataOnPrequery(previewOptions);
	        // previewOptions.data = clone(data);
	        // totalNumberOfPosts = data.length;
	      }
	      var gridViewIndex = (0, _underscore.findIndex)(windowUrlData, { key: 'view' });
	      var view = 'grid';
	      if (gridViewIndex !== -1) {
	        view = windowUrlData[gridViewIndex].value;
	      }
	      var showAllBlock = function showAllBlock(block, index) {
	        var blockClass = void 0;
	        switch (block.layout) {
	          default:
	            blockClass = 'flex-md-' + block.layout + ' ' + 'flex-xs-12';
	            break;
	        }
	        var customClassName = null;
	        switch (block.type) {
	          case 'grid':
	            customClassName = !_this5.state.gridToggle ? 'active' : '';
	            break;
	          case 'category':
	            customClassName = !_this5.state.categoryToggle ? 'active' : '';
	            break;
	          case 'search':
	            customClassName = !_this5.state.searchToggle ? 'active' : '';
	            break;
	          case 'map':
	            customClassName = !_this5.state.mapToggle ? 'active' : '';
	            break;
	          case 'isotope':
	            customClassName = !_this5.state.isotopeToggle ? 'active' : '';
	            break;
	          default:
	            break;
	        }
	        var isEditableClass = _this5.state.isEditable ? 'single-block' : 'preview-block';
	        return _react2.default.createElement(
	          'div',
	          { key: 'showBuilder-' + index, className: 'reblock ' + blockClass, 'data-uid': block.uid },
	          _react2.default.createElement(
	            'div',
	            { className: isEditableClass },
	            _react2.default.createElement(
	              'div',
	              { className: 'child-block-handle rq-main-sorting-block' },
	              _this5.state.isEditable ? _react2.default.createElement(
	                'div',
	                { className: 'block-edit-button', style: { paddingRight: 30 + 'px' } },
	                block.type === 'search' ? _react2.default.createElement(
	                  'a',
	                  { className: 'edit-button', href: '#', onClick: self.showPanel.bind(self, 'advancedsearch', block.uid), 'data-toggle': 'tooltip', 'data-placement': 'top', title: API.LANG.TOOL_TIP_SEARCH_SETTINGS },
	                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                ) : _react2.default.createElement(
	                  'a',
	                  { className: 'edit-button', href: '#', onClick: self.showPanel.bind(self, block.type, block.uid), 'data-toggle': 'tooltip', 'data-placement': 'top', title: API.LANG.TOOL_TIP_BLOCK_PANEL },
	                  _react2.default.createElement('i', { className: 'fa fa-pencil' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'hidden-button-block' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: '#', onClick: self.deleteBlock.bind(self, block.uid) },
	                      _react2.default.createElement('i', { className: 'fa fa-times' })
	                    )
	                  )
	                )
	              ) : null,
	              _this5.state.isEditable ? _react2.default.createElement(
	                'a',
	                { href: '#', className: 'builder-shortable' },
	                _react2.default.createElement('i', { className: 'fa fa-bars' })
	              ) : null,
	              _this5.state.isEditable && _react2.default.createElement(
	                'label',
	                { style: { marginLeft: '30px' } },
	                _this5.capitalize(block.type)
	              ),
	              _this5.state.isEditable && _react2.default.createElement(
	                'button',
	                { className: 'panel-toggle-button' + ' ' + customClassName, onClick: _this5.handleBlockToggle.bind(_this5, block.type), 'data-toggle': 'tooltip', 'data-placement': 'top', title: API.LANG.TOOL_TIP_TOGGLE },
	                _react2.default.createElement('i', { className: 'fa fa-chevron-down' })
	              ),
	              _this5.state.isEditable && _react2.default.createElement(
	                'div',
	                null,
	                block.type === 'search' ? _react2.default.createElement(
	                  'div',
	                  { className: 'search-panel-edit-button' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: self.showPanel.bind(self, block.type, block.uid), 'data-toggle': 'tooltip', 'data-placement': 'top', title: API.LANG.TOOL_TIP_SEARCH_ADD },
	                    _react2.default.createElement('i', { className: 'fa fa-plus' })
	                  )
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              block.type === 'grid' && 'data' in _this5.state.previewData && previewOptions ? _react2.default.createElement(
	                'div',
	                { className: view === 'grid' ? block.gridWrapperClass : block.listWrapperClass },
	                _react2.default.createElement(_gridBlock2.default, _extends({ urlData: _this5.state.urlData }, _this5.props, {
	                  block: block, uid: block.uid,
	                  previewOption: searchUrl !== 0 ? previewOptions : { data: data },
	                  total: totalNumberOfPosts,
	                  isToggle: _this5.state.gridToggle,
	                  onChangePagination: _this5.handleChangePagination.bind(_this5),
	                  onSortChange: _this5.handleAsyncSorting.bind(_this5)
	                }))
	              ) : null,
	              block.type === 'isotope' && 'data' in _this5.state.previewData && _this5.previewOptions ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_isotopeBlock2.default, _extends({}, _this5.props, {
	                  previewData: _this5.props.previewData,
	                  previewOptions: previewOptions,
	                  isToggle: _this5.state.isotopeToggle,
	                  block: block }))
	              ) : null,
	              block.type === 'search' && block.searchAttr ? _react2.default.createElement(
	                'div',
	                { className: block.customCssClass },
	                _react2.default.createElement(_searchBlock2.default, _extends({}, _this5.props, {
	                  previewData: previewOptions,
	                  isToggle: _this5.state.searchToggle,
	                  urlData: _this5.state.urlData,
	                  uid: block.uid,
	                  searchAttr: block.searchAttr,
	                  dropdonwtoggle: _this5.state.dropdownAttributeToogle,
	                  isEditable: _this5.state.isEditable
	                }))
	              ) : null,
	              block.type === 'category' ? _react2.default.createElement(
	                'div',
	                { className: block.categorySettings !== undefined ? block.categorySettings.categoryWrapperClass : '' },
	                _react2.default.createElement(_categoryBlock2.default, _extends({}, _this5.props, {
	                  isToggle: _this5.state.categoryToggle,
	                  block: block
	                }))
	              ) : null,
	              block.type === 'map' ? _react2.default.createElement(
	                'div',
	                { className: block.mapWrapperClass },
	                _react2.default.createElement(_mapBlock2.default, _extends({}, _this5.props, {
	                  block: block,
	                  isToggle: _this5.state.mapToggle,
	                  previewOption: previewOptions
	                }))
	              ) : null
	            )
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: ' rq-reactive-builder flex-row rebuilder' },
	        allLayout.length ? allLayout.map(showAllBlock) : null
	      );
	    }
	  }]);
	
	  return ShowBuilderPreview;
	}(_react2.default.Component);
	
	ShowBuilderPreview.propTypes = {
	  'allLayout': _react2.default.PropTypes.array,
	  'previewData': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'settingsData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ShowBuilderPreview;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _topbarBlock = __webpack_require__(559);
	
	var _topbarBlock2 = _interopRequireDefault(_topbarBlock);
	
	__webpack_require__(561);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(523);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _hoverAction = __webpack_require__(683);
	
	var _hoverAction2 = _interopRequireDefault(_hoverAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var GridBlock = function (_React$Component) {
	  _inherits(GridBlock, _React$Component);
	
	  function GridBlock(props) {
	    _classCallCheck(this, GridBlock);
	
	    var _this = _possibleConstructorReturn(this, (GridBlock.__proto__ || Object.getPrototypeOf(GridBlock)).call(this, props));
	
	    _this.displayName = 'GridBlock';
	    _this.showAllPosts = _this.showAllPosts.bind(_this);
	    _this.handleLoadMore = _this.handleLoadMore.bind(_this);
	    _this.changePage = _this.changePage.bind(_this);
	    _this.isUrlChange = _this.isUrlChange.bind(_this);
	    _this.state = {
	      'posts': _this.props.previewOption ? _this.props.previewOption.data : [],
	      'showAnimatedMsg': _this.props.previewOption.data === 0 ? 0 : 1,
	      'pageNumber': 1,
	      'loadedItem': 5,
	      'filterable': _this.props.settingsData.ajax === 'false' ? true : false,
	      previousPosts: [],
	      gridUrlData: (0, _clone2.default)(window.searchArray)
	    };
	    return _this;
	  }
	
	  _createClass(GridBlock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var self = this;
	      var index = (0, _underscore.findIndex)(window.searchArray, { key: 'pagenumber' });
	      if (index !== -1) {
	        self.setState({ pageNumber: parseInt(window.searchArray[index].value, 10) });
	      }
	      var gridIndex = (0, _underscore.findIndex)(self.props.allLayout, { type: 'grid' });
	      if (gridIndex !== -1) {
	        self.setState({
	          loadedItem: self.props.allLayout[gridIndex].hasOwnProperty('numberOfPosts') ? parseInt(self.props.allLayout[gridIndex].numberOfPosts, 10) : 5 });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      // const posts = clone(nextProps.previewOption.data);
	      var posts = null;
	      if (_.isArray(nextProps.previewOption.data)) {
	        posts = (0, _clone2.default)(nextProps.previewOption.data);
	      } else {
	        posts = [];
	      }
	      var urlChangeFlag = (0, _clone2.default)(this.isUrlChange());
	      var bottombar = nextProps.block.bottombar ? nextProps.block.bottombar : {};
	      var bottomloadMore = false;
	      if ('bottomloadMore' in bottombar) {
	        bottomloadMore = bottombar.bottomloadMore;
	      }
	      var pageNumber = urlChangeFlag ? 1 : this.state.pageNumber;
	      if (bottomloadMore === 'false') {
	        bottomloadMore = false;
	      }
	      if (bottomloadMore === 'true') {
	        bottomloadMore = true;
	      }
	
	      if (urlChangeFlag === true && nextProps.settingsData.ajax === 'false') {
	        (function () {
	          // non ajax
	          var self = _this2;
	          setTimeout(function () {
	            self.setState({ pageNumber: 1, posts: [] });
	            if (posts.length === 0) {
	              self.setState({ showAnimatedMsg: 0 });
	            } else {
	              self.setState({ showAnimatedMsg: 1, posts: posts });
	            }
	          }, 5);
	          $('#LoadTime').fadeOut(300);
	        })();
	      } else {
	        if (nextProps.settingsData.ajax === 'false') {
	          $('#LoadTime').fadeOut(300);
	        }
	      }
	
	      if (bottomloadMore) {
	        var newPosts = [];
	        if (pageNumber !== 1 && this.state.posts[0].ID !== posts[0].ID) {
	          newPosts = this.state.posts.concat(posts);
	        } else {
	          newPosts = posts;
	        }
	        this.setState({
	          filterable: nextProps.settingsData.ajax === 'false' ? true : false,
	          posts: newPosts,
	          showAnimatedMsg: newPosts.length === 0 ? 0 : 1,
	          pageNumber: pageNumber
	        });
	      } else {
	        this.setState({
	          'filterable': nextProps.settingsData.ajax === 'false' ? true : false,
	          posts: posts,
	          showAnimatedMsg: posts.length === 0 ? 0 : 1,
	          pageNumber: pageNumber
	        });
	      }
	    }
	  }, {
	    key: 'isUrlChange',
	    value: function isUrlChange() {
	      var propsUrlData = (0, _clone2.default)(this.state.gridUrlData);
	      var nextPropsUrlData = (0, _clone2.default)(window.searchArray);
	      var indexOfPropsUrl = (0, _underscore.findIndex)(propsUrlData, { key: 'pagenumber' });
	      if (indexOfPropsUrl !== -1) {
	        propsUrlData.splice(indexOfPropsUrl, 1);
	      }
	      var indexOfNextPropsUrl = (0, _underscore.findIndex)(nextPropsUrlData, { key: 'pagenumber' });
	      if (indexOfNextPropsUrl !== -1) {
	        nextPropsUrlData.splice(indexOfNextPropsUrl, 1);
	      }
	      var flag = false;
	      if (nextPropsUrlData.length < propsUrlData.length) {
	        flag = true;
	      }
	      if (nextPropsUrlData.length === 0) {
	        flag = true;
	      }
	      nextPropsUrlData.map(function (item) {
	        var index = (0, _underscore.findIndex)(propsUrlData, { key: item.key });
	        if (index === -1) {
	          flag = true;
	        } else {
	          var tempKeyValue = [];
	          for (var indexOfPropsUrlData = 0; indexOfPropsUrlData < propsUrlData.length; indexOfPropsUrlData++) {
	            if (item.key === propsUrlData[indexOfPropsUrlData].key) {
	              tempKeyValue.push(propsUrlData[indexOfPropsUrlData].value);
	            }
	          }
	          if (_.indexOf(tempKeyValue, item.value) === -1) {
	            flag = true;
	          }
	        }
	      });
	      this.setState({ gridUrlData: (0, _clone2.default)(window.searchArray) });
	      if (propsUrlData.length === 0 && nextPropsUrlData.length === 0) {
	        flag = false;
	      }
	      return flag;
	    }
	  }, {
	    key: 'showAllPosts',
	    value: function showAllPosts(post, index) {
	      var columnSize = void 0;
	      var columnSizeList = void 0;
	      var gridindex = (0, _underscore.findIndex)(this.props.allLayout, {
	        type: 'grid'
	      });
	      var isViewType = (0, _underscore.findIndex)(window.searchArray, { key: 'view' });
	      var viewTypeGrid = 'grid';
	      if (isViewType !== -1) {
	        viewTypeGrid = window.searchArray[isViewType].value;
	      }
	      if (gridindex !== -1) {
	        if (viewTypeGrid === 'grid') {
	          if (this.props.allLayout[gridindex].hasOwnProperty('column')) {
	            columnSize = (0, _classnames2.default)({
	              'flex-lg-12': this.props.allLayout[gridindex].column.grid_desktop_hd === '1',
	              'flex-lg-6': this.props.allLayout[gridindex].column.grid_desktop_hd === '2',
	              'flex-lg-4': this.props.allLayout[gridindex].column.grid_desktop_hd === '3',
	              'flex-lg-3': this.props.allLayout[gridindex].column.grid_desktop_hd === '4',
	              'flex-md-12': this.props.allLayout[gridindex].column.gird_desktop === '1',
	              'flex-md-6': this.props.allLayout[gridindex].column.grid_desktop === '2',
	              'flex-md-4': this.props.allLayout[gridindex].column.grid_desktop === '3',
	              'flex-md-3': this.props.allLayout[gridindex].column.grid_desktop === '4',
	              'flex-sm-6': this.props.allLayout[gridindex].column.grid_tablet === '2',
	              'flex-sm-12': this.props.allLayout[gridindex].column.grid_tablet === '1',
	              'flex-sm-4': this.props.allLayout[gridindex].column.grid_tablet === '3',
	              'flex-xs-6': this.props.allLayout[gridindex].column.grid_mobile === '2',
	              'flex-xs-12': this.props.allLayout[gridindex].column.grid_mobile === '1'
	            });
	          } else {
	            gridindex = 0;
	            columnSize = (0, _classnames2.default)({
	              'flex-md-6': true,
	              'flex-sm-6': true,
	              'flex-xs-12': true
	            });
	          }
	        } else {
	          if (this.props.allLayout[gridindex].hasOwnProperty('column')) {
	            columnSizeList = (0, _classnames2.default)({
	              'flex-lg-12': this.props.allLayout[gridindex].column.list_desktop_hd === '1',
	              'flex-lg-6': this.props.allLayout[gridindex].column.list_desktop_hd === '2',
	              'flex-md-12': this.props.allLayout[gridindex].column.list_desktop === '1',
	              'flex-md-6': this.props.allLayout[gridindex].column.list_desktop === '2',
	              'flex-sm-12': this.props.allLayout[gridindex].column.list_tablet === '1',
	              'flex-xs-12': this.props.allLayout[gridindex].column.list_mobile === '1'
	            });
	          } else {
	            columnSizeList = (0, _classnames2.default)({
	              'flex-lg-6': true,
	              'flex-md-6': true,
	              'flex-sm-12': true,
	              'flex-xs-12': true
	            });
	          }
	        }
	      }
	      var urlData = (0, _clone2.default)(this.props.urlData);
	      var indexOfGrid = (0, _underscore.findIndex)(this.props.allLayout, { type: 'grid' });
	      var view = null;
	      if (indexOfGrid !== -1) {
	        view = this.props.allLayout[indexOfGrid].hasOwnProperty('viewType') ? this.props.allLayout[indexOfGrid].viewType : 'grid';
	      }
	      if (urlData.hasOwnProperty('view')) {
	        view = urlData.view;
	      }
	      if (this.props.allLayout[indexOfGrid].previewLayouts !== undefined) {
	        this.ComponentName = ReactiveTemplates[this.props.allLayout[indexOfGrid].previewLayouts];
	      } else {
	        // const componentFormat = 'doPost' + post.post_format.replace(/(^[a-z])/, (p) => { return p.toUpperCase(); });
	        this.ComponentName = ReactiveTemplates.latestGridLayoutThree;
	      }
	      var transitionOption = {
	        transitionName: 'fly',
	        transitionEnterTimeout: 500,
	        transitionAppearTimeout: 500,
	        transitionLeaveTimeout: 300,
	        transitionAppear: true
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: viewTypeGrid === 'grid' ? columnSize : columnSizeList, key: post.ID },
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          transitionOption,
	          _react2.default.createElement(
	            'div',
	            { className: 'check-post-effect', onMouseLeave: this.handleLeave.bind(this), onMouseEnter: this.handleHover.bind(this, post) },
	            _react2.default.createElement(this.ComponentName, _extends({ post: post, view: view }, this.props))
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleLeave',
	    value: function handleLeave() {
	      _hoverAction2.default.pushHoverData({
	        hide: true
	      });
	    }
	  }, {
	    key: 'handleHover',
	    value: function handleHover(post) {
	      _hoverAction2.default.pushHoverData(post);
	    }
	  }, {
	    key: 'changePage',
	    value: function changePage(selectedPageNumber) {
	      var pageNumber = parseInt(selectedPageNumber, 10);
	      var posts = (0, _clone2.default)(this.state.posts);
	      _urlHandlerActions2.default.push({
	        'searchItem': 'pagenumber',
	        'searchType': 'globalSearch',
	        'searchField': 'pagination',
	        pageNumber: pageNumber
	      });
	      var self = this;
	      setTimeout(function () {
	        self.setState({ posts: [] });
	        self.setState({ pageNumber: pageNumber, posts: posts });
	      }, 5);
	    }
	  }, {
	    key: 'handleListenTopBar',
	    value: function handleListenTopBar(data) {
	      var _this3 = this;
	
	      var posts = (0, _clone2.default)(this.state.posts);
	      var newPosts = [];
	      if ('sortAttr' in data) {
	        if (data.sortAttr === 'post_title' || data.sortAttr === 'comment_count') {
	          if (data.sortBy === 'desc') {
	            newPosts = (0, _underscore.sortBy)(posts, data.sortAttr).reverse();
	          } else {
	            newPosts = (0, _underscore.sortBy)(posts, data.sortAttr);
	          }
	        } else if (data.sortAttr === 'post_date') {
	          if (data.sortBy === 'desc') {
	            newPosts = posts.sort(function (a, b) {
	              return new Date(b.post_date) - new Date(a.post_date);
	            });
	          } else {
	            newPosts = posts.sort(function (a, b) {
	              return new Date(a.post_date) - new Date(b.post_date);
	            });
	          }
	        } else {
	          newPosts = posts.sort(function (a, b) {
	            if (data.sortBy === 'desc') {
	              return b.meta[data.sortAttr] - a.meta[data.sortAttr];
	            }
	            return a.meta[data.sortAttr] - b.meta[data.sortAttr];
	          });
	        }
	      }
	      if (this.state.filterable === 'false') {
	        this.props.onSortChange(data);
	      } else {
	        (function () {
	          var self = _this3;
	          setTimeout(function () {
	            self.setState({ posts: [] });
	            self.setState({ posts: newPosts });
	          }, 5);
	        })();
	      }
	    }
	  }, {
	    key: 'handleLoadMore',
	    value: function handleLoadMore() {
	      var pageNumber = this.state.pageNumber;
	
	      if (this.state.filterable === false) {
	        this.setState({ pageNumber: pageNumber + 1 });
	        this.props.onChangePagination(pageNumber + 1);
	      } else {
	        var loadedItem = parseInt(this.state.loadedItem, 10);
	        var gridIndex = (0, _underscore.findIndex)(this.props.allLayout, { type: 'grid' });
	        if (gridIndex !== -1 && this.props.allLayout[gridIndex].hasOwnProperty('numberOfPosts')) {
	          var numberOfPosts = 'numberOfPosts';
	          this.setState({ loadedItem: parseInt(this.props.allLayout[gridIndex].numberOfPosts, 10) });
	          loadedItem += parseInt(this.props.allLayout[gridIndex].numberOfPosts, 10);
	        } else {
	          loadedItem += 5;
	        }
	        this.setState({ loadedItem: loadedItem });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var displayItemNo = parseInt(this.props.block.numberOfPosts, 10);
	      var pageNumber = this.state.pageNumber;
	      var settingsData = this.props.settingsData;
	
	
	      var topbar = this.props.block.topbar ? this.props.block.topbar : {};
	      var bottombar = this.props.block.bottombar ? this.props.block.bottombar : {};
	      var barData = this.props.block.bardata ? this.props.block.bardata : {};
	      var topbarpagination = false;
	      var bottompagination = false;
	      var showBottomBar = false;
	      var bottomloadMore = false;
	
	      if ('topbarpagination' in topbar) {
	        topbarpagination = topbar.topbarpagination;
	      }
	      if ('bottompagination' in bottombar) {
	        bottompagination = bottombar.bottompagination;
	        showBottomBar = bottombar.bottombar;
	      }
	      if ('bottomloadMore' in bottombar) {
	        bottomloadMore = bottombar.bottomloadMore;
	        showBottomBar = bottombar.bottombar;
	      }
	
	      if (!displayItemNo) {
	        displayItemNo = 10;
	      }
	      var posts = this.state.posts ? this.state.posts : [];
	      var paginatedItem = [];
	      var start = null;
	      var pageLimit = null;
	      var isDisabled = null;
	      if (posts.length !== 0) {
	        if (this.props.settingsData.ajax === 'false') {
	          if (topbarpagination === 'true' || bottompagination === 'true') {
	            start = (pageNumber - 1) * displayItemNo;
	            for (var index = start; index < start + displayItemNo && posts.length > index; index++) {
	              paginatedItem.push(posts[index]);
	            }
	            pageLimit = parseInt(posts.length / displayItemNo, 10) + (posts.length % displayItemNo !== 0 ? 1 : 0);
	            if (displayItemNo > posts.length) {
	              paginatedItem = (0, _clone2.default)(posts);
	            }
	          } else if (bottomloadMore === 'true') {
	            pageLimit = parseInt(posts.length / displayItemNo, 10) + (posts.length % displayItemNo !== 0 ? 1 : 0);
	            for (var _index = 0; _index < parseInt(this.state.loadedItem, 10) && posts.length > _index; _index++) {
	              paginatedItem.push(posts[_index]);
	            }
	            isDisabled = paginatedItem.length === posts.length ? true : false;
	          } else {
	            pageLimit = parseInt(posts.length / displayItemNo, 10) + (posts.length % displayItemNo !== 0 ? 1 : 0);
	            for (var _index2 = 0; _index2 < displayItemNo && posts.length > _index2; _index2++) {
	              paginatedItem.push(posts[_index2]);
	            }
	          }
	        } else {
	          paginatedItem = posts;
	          pageLimit = Math.ceil(parseInt(this.props.total, 10) / displayItemNo);
	        }
	      }
	
	      var paginationOption = {
	        totalPage: pageLimit,
	        selectPage: this.changePage,
	        startPage: this.state.pageNumber
	      };
	
	      var showLoadMoreButton = true;
	
	      if (paginatedItem.length === parseInt(this.props.total, 10)) {
	        showLoadMoreButton = false;
	      }
	
	      var loadMoreOption = {
	        className: barData.bottombar_loadmore,
	        disabled: isDisabled,
	        onClick: this.handleLoadMore,
	        show: showLoadMoreButton
	      };
	      var ThemeComponent = window.ReactiveTheme[settingsData.theme] ? window.ReactiveTheme[settingsData.theme].bar : '';
	      if (bottomloadMore) {
	        paginatedItem = this.state.previousPosts.concat(paginatedItem);
	      }
	      var ifOpen = this.props.isToggle ? 'active ' + 'rq-grid-container' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: ifOpen },
	        this.props.isToggle ? _react2.default.createElement(
	          'div',
	          null,
	          ' ',
	          _react2.default.createElement(_topbarBlock2.default, _extends({}, this.props, { barData: barData, results: parseInt(this.props.total, 10), onListenTopBlock: this.handleListenTopBar.bind(this) })),
	          pageNumber <= pageLimit ? _react2.default.createElement(
	            'div',
	            { className: 'rq-reactive-builder flex-row' },
	            paginatedItem.length && topbarpagination === 'true' ? _react2.default.createElement(
	              'div',
	              { className: 'flex-xs-12 top-bar-pagination' },
	              _react2.default.createElement(ThemeComponent.topbarPagniation, _extends({ className: barData.topbar_pagination }, paginationOption))
	            ) : null,
	            paginatedItem.length ? paginatedItem.map(this.showAllPosts) : null,
	            paginatedItem.length && showBottomBar === 'true' && bottompagination === 'true' ? _react2.default.createElement(
	              'div',
	              { className: 'flex-xs-12 ' },
	              _react2.default.createElement(ThemeComponent.bottombarPagination, _extends({ className: barData.bottombar_pagination }, paginationOption))
	            ) : null
	          ) : null,
	          bottomloadMore === 'true' ? _react2.default.createElement(ThemeComponent.bottomLoadMore, loadMoreOption) : null,
	          ' '
	        ) : null,
	        this.state.showAnimatedMsg === 0 ? _react2.default.createElement(
	          'div',
	          { className: 'rq-no-post-found' },
	          _react2.default.createElement('i', { className: 'fa fa-frown-o' }),
	          _react2.default.createElement(
	            'h3',
	            null,
	            API.LANG.FOF
	          )
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          { id: 'LoadTime', style: { display: 'none' } },
	          _react2.default.createElement('img', { src: API.IMG + 'loader.png', alt: '' })
	        )
	      );
	    }
	  }]);
	
	  return GridBlock;
	}(_react2.default.Component);
	
	GridBlock.propTypes = {
	  'previewOption': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'settingsData': _react2.default.PropTypes.object,
	  'onChangePagination': _react2.default.PropTypes.func,
	  'onSortChange': _react2.default.PropTypes.func,
	  'allLayout': _react2.default.PropTypes.array,
	  'block': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'helperData.posts': _react2.default.PropTypes.object,
	  'helperData.posts.data': _react2.default.PropTypes.array,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'total': _react2.default.PropTypes.node,
	  'isToggle': _react2.default.PropTypes.bool
	};
	
	GridBlock.defaultProps = {
	  'previewOption': {
	    'posts': {
	      'data': []
	    }
	  }
	};
	
	exports.default = GridBlock;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopBarBlock = function (_React$Component) {
	  _inherits(TopBarBlock, _React$Component);
	
	  function TopBarBlock(props) {
	    _classCallCheck(this, TopBarBlock);
	
	    var _this = _possibleConstructorReturn(this, (TopBarBlock.__proto__ || Object.getPrototypeOf(TopBarBlock)).call(this, props));
	
	    _this.handleSortBy = _this.handleSortBy.bind(_this);
	    _this.handleSortingData = _this.handleSortingData.bind(_this);
	    _this.deleteSearch = _this.deleteSearch.bind(_this);
	
	    _this.state = {
	      option: {
	        sortBy: 'asc'
	      }
	    };
	    return _this;
	  }
	
	  _createClass(TopBarBlock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.processData();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.processData();
	    }
	  }, {
	    key: 'processData',
	    value: function processData() {
	      var _this2 = this;
	
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var isSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (isSearch !== -1) {
	        (function () {
	          var searchAttr = (0, _clone2.default)(allLayout[isSearch].searchAttr);
	          window.searchArray.map(function (searchItem) {
	            var isTaxonomy = (0, _underscore.findIndex)(searchAttr, { selectedTaxonomy: searchItem.key });
	            var isMetakey = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: searchItem.key });
	            if (isTaxonomy !== -1) {
	              searchItem.selectedDataType = searchAttr[isTaxonomy].selectedDataType;
	              searchItem.viewType = searchAttr[isTaxonomy].viewType;
	              searchItem.title = searchAttr[isTaxonomy].title;
	              if (searchItem.viewType === 'combobox') {
	                searchItem.linearData = _this2.props.helperData.terms[searchItem.key].linear;
	              }
	            } else if (isMetakey !== -1 && searchItem.key.search('[min]') === -1 && searchItem.key.search('[start]')) {
	              searchItem.selectedDataType = searchAttr[isMetakey].selectedDataType;
	              searchItem.viewType = searchAttr[isMetakey].viewType;
	              searchItem.title = searchAttr[isMetakey].title;
	              searchItem.metakey = searchAttr[isMetakey].selectedMetakey;
	            } else {
	              // will work for range and daterange
	              var key = 'key';
	              var isDateRangeStart = searchItem[key].indexOf('[start]');
	              var isDateRangeEnd = searchItem[key].indexOf('[end]');
	              var isRangeMin = searchItem[key].indexOf('[min]');
	              var isRangeMax = searchItem[key].indexOf('[max]');
	              if (isDateRangeStart !== -1) {
	                var dateStartMetakey = searchItem[key].split('[start]').length ? searchItem[key].split('[start]')[0] : null;
	                var index = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: dateStartMetakey });
	                searchItem.selectedDataType = searchAttr[index].selectedDataType;
	                searchItem.viewType = searchAttr[index].viewType;
	                searchItem.title = searchAttr[index].title;
	                searchItem.metakey = dateStartMetakey;
	                searchItem.key = searchItem[key];
	                _this2.startDateRange = searchItem.value;
	              } else if (isDateRangeEnd !== -1) {
	                var dateEndmetakey = searchItem[key].split('[end]').length ? searchItem[key].split('[end]')[0] : null;
	                var _index = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: dateEndmetakey });
	                searchItem.selectedDataType = searchAttr[_index].selectedDataType;
	                searchItem.viewType = searchAttr[_index].viewType;
	                searchItem.title = searchAttr[_index].title;
	                searchItem.metakey = dateEndmetakey;
	                searchItem.key = searchItem[key];
	                _this2.endDateRange = searchItem.value;
	              } else if (isRangeMin !== -1) {
	                var rangeMinMetakey = searchItem[key].split('[min]').length === 2 && searchItem[key].split('[min]')[0].length !== 0 ? searchItem[key].split('[min]')[0] : null;
	                var indexforRangeMin = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: rangeMinMetakey });
	                searchItem.selectedDataType = searchAttr[indexforRangeMin].selectedDataType;
	                searchItem.viewType = searchAttr[indexforRangeMin].viewType;
	                searchItem.title = searchAttr[indexforRangeMin].title;
	                searchItem.metakey = rangeMinMetakey;
	                searchItem.key = searchItem[key];
	                _this2.minRangeValue = searchItem.value;
	              } else if (isRangeMax !== -1) {
	                var rangeMaxMetakey = searchItem[key].split('[max]').length ? searchItem[key].split('[max]')[0] : null;
	                var indexRangeMin = (0, _underscore.findIndex)(searchAttr, { selectedMetakey: rangeMaxMetakey });
	                searchItem.selectedDataType = searchAttr[indexRangeMin].selectedDataType;
	                searchItem.viewType = searchAttr[indexRangeMin].viewType;
	                searchItem.title = searchAttr[indexRangeMin].title;
	                searchItem.metakey = rangeMaxMetakey;
	                searchItem.key = searchItem[key];
	                _this2.maxRangeValue = searchItem.value;
	              }
	            }
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'deleteSearch',
	    value: function deleteSearch(index, item) {
	      _urlHandlerActions2.default.push({
	        'searchType': 'globalSearch',
	        'searchField': 'searchAttrTopBar',
	        'value': item.value,
	        'key': item.key,
	        'rangeKey': item.metakey,
	        'viewType': item.viewType,
	        'linearData': item.linearData,
	        index: index
	      });
	    }
	  }, {
	    key: 'handleSortingData',
	    value: function handleSortingData(data) {
	      var option = this.state.option;
	
	      option.sortAttr = data;
	      this.setState({ option: option });
	      this.props.onListenTopBlock(option);
	    }
	  }, {
	    key: 'handleSortBy',
	    value: function handleSortBy(type) {
	      var option = this.state.option;
	
	      option.sortBy = type;
	      this.setState({ option: option });
	      if ('sortAttr' in option) {
	        this.props.onListenTopBlock(option);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var settingsData = this.props.settingsData;
	
	      var topbar = void 0;
	      if ('topbar' in this.props.block) {
	        topbar = this.props.block.topbar;
	      } else {
	        topbar = {
	          topbar: false,
	          filter: false,
	          sorting: false,
	          viewchanger: false,
	          topbarpagination: false
	        };
	      }
	
	      var sortingData = [];
	      if ('sorting' in this.props.block) {
	        sortingData = this.props.block.sorting;
	      }
	
	      var index = (0, _underscore.findIndex)(window.searchArray, { key: 'pagenumber' });
	      var flag = null;
	      if (index !== -1) {
	        flag = window.searchArray.length !== 1 ? false : true;
	      } else {
	        flag = window.searchArray.length !== 1 ? false : true;
	      }
	      var ThemeComponent = window.ReactiveTheme[settingsData.theme] ? window.ReactiveTheme[settingsData.theme].bar : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        topbar.topbar === 'true' && _react2.default.createElement(
	          'div',
	          { className: 'reactive-top-bar' },
	          topbar.viewchanger === 'true' || topbar.sorting === 'true' ? _react2.default.createElement(
	            'div',
	            { className: 'view-sorting-option' },
	            topbar.viewchanger === 'true' && _react2.default.createElement(ThemeComponent.viewChanger, { allLayout: this.props.allLayout }),
	            topbar.sorting === 'true' && _react2.default.createElement(ThemeComponent.sorting, { sortingData: sortingData, handleSortBy: this.handleSortBy, handleSortingAttribute: this.handleSortingData })
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            null,
	            topbar.filter === 'true' && _react2.default.createElement(ThemeComponent.searchAttributeShow, _extends({}, this.props, { flag: flag, deleteSearchAttr: this.deleteSearch }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return TopBarBlock;
	}(_react2.default.Component);
	
	TopBarBlock.propTypes = {
	  'searchAttr': _react2.default.PropTypes.array,
	  'allLayout': _react2.default.PropTypes.array,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'barData': _react2.default.PropTypes.object,
	  'results': _react2.default.PropTypes.number,
	  'onListenTopBlock': _react2.default.PropTypes.func,
	  flag: _react2.default.PropTypes.node
	};
	
	exports.default = TopBarBlock;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = jQuery;
	var UrlAction = _reflux2.default.createActions(['push', 'process', 'preProcess']);
	
	UrlAction.push.preEmit = function (data) {
	  $('#LoadTime').fadeIn(300);
	  setTimeout(function () {
	    UrlAction.process(data);
	  }, 500);
	};
	exports.default = UrlAction;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(562);
	
	__webpack_require__(672);
	
	__webpack_require__(673);
	
	__webpack_require__(674);
	
	__webpack_require__(675);
	
	__webpack_require__(676);
	
	__webpack_require__(677);
	
	__webpack_require__(678);
	
	__webpack_require__(681);
	
	__webpack_require__(682);

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var latestGridLayoutThree = function (_Component) {
	  _inherits(latestGridLayoutThree, _Component);
	
	  function latestGridLayoutThree(props) {
	    _classCallCheck(this, latestGridLayoutThree);
	
	    var _this = _possibleConstructorReturn(this, (latestGridLayoutThree.__proto__ || Object.getPrototypeOf(latestGridLayoutThree)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(latestGridLayoutThree, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var post = _props.post;
	      var view = _props.view;
	
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      if (post.thumb_url === null) {
	        post.thumb_url = API.IMG + 'placeholder.png';
	      }
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      var showtag = function showtag(item) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'post-tag' },
	          item
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          { className: 'rq-image-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-grid-normal full-width-bg-image no-border-radius' },
	            _react2.default.createElement(
	              'div',
	              { className: 'post-image-container rq-latest-three-grid' },
	              _react2.default.createElement(
	                'a',
	                { href: post.post_link },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.isotope === false ? "image-hover-coantainer lazyLoading b-lazy rq-absolute-container dark-overlay dummyClass" + post.ID : " image-hover-coantainer rq-absolute-container dark-overlay", style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                  _react2.default.createElement('div', { className: 'img-overlay' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'on-hover-cotnent' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rq-post-title-new center-title' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'rq-title-content' },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        post.post_title
	                      ),
	                      _react2.default.createElement('div', { className: 'rq-hr-line' }),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rq-title-footer' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'post-date' },
	                      (0, _moment2.default)(post.post_date).format('MMM  YYYY')
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link },
	                        _react2.default.createElement('i', { className: 'ion-android-add' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return latestGridLayoutThree;
	}(_react.Component);
	
	ReactiveTemplates['latestGridLayoutThree'] = latestGridLayoutThree;
	
	ReactiveLayouts.push({
	  'key': 'latestGridLayoutThree',
	  // 'image_url': API.IMG + 'effect-steve.jpg',
	  'type': 'all',
	  'gridName': 'Standard'
	});

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.15.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        var k;
	        for (k in obj) {
	            // even if its not own property I'd still call it non-empty
	            return false;
	        }
	        return true;
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return this._months;
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return this._monthsShort;
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return this._weekdays;
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        ordinalParse: defaultOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(565)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, parentConfig = baseConfig;
	            // MERGE
	            if (locales[name] != null) {
	                parentConfig = locales[name]._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	
	            if (tZone === 0) {
	                this.utcOffset(0, true);
	            } else {
	                this.utcOffset(offsetFromString(matchOffset, this._i));
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIOROITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = stringGet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = stringSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.15.1';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(564)(module)))

/***/ },
/* 564 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 566,
		"./af.js": 566,
		"./ar": 567,
		"./ar-ly": 568,
		"./ar-ly.js": 568,
		"./ar-ma": 569,
		"./ar-ma.js": 569,
		"./ar-sa": 570,
		"./ar-sa.js": 570,
		"./ar-tn": 571,
		"./ar-tn.js": 571,
		"./ar.js": 567,
		"./az": 572,
		"./az.js": 572,
		"./be": 573,
		"./be.js": 573,
		"./bg": 574,
		"./bg.js": 574,
		"./bn": 575,
		"./bn.js": 575,
		"./bo": 576,
		"./bo.js": 576,
		"./br": 577,
		"./br.js": 577,
		"./bs": 578,
		"./bs.js": 578,
		"./ca": 579,
		"./ca.js": 579,
		"./cs": 580,
		"./cs.js": 580,
		"./cv": 581,
		"./cv.js": 581,
		"./cy": 582,
		"./cy.js": 582,
		"./da": 583,
		"./da.js": 583,
		"./de": 584,
		"./de-at": 585,
		"./de-at.js": 585,
		"./de.js": 584,
		"./dv": 586,
		"./dv.js": 586,
		"./el": 587,
		"./el.js": 587,
		"./en-au": 588,
		"./en-au.js": 588,
		"./en-ca": 589,
		"./en-ca.js": 589,
		"./en-gb": 590,
		"./en-gb.js": 590,
		"./en-ie": 591,
		"./en-ie.js": 591,
		"./en-nz": 592,
		"./en-nz.js": 592,
		"./eo": 593,
		"./eo.js": 593,
		"./es": 594,
		"./es-do": 595,
		"./es-do.js": 595,
		"./es.js": 594,
		"./et": 596,
		"./et.js": 596,
		"./eu": 597,
		"./eu.js": 597,
		"./fa": 598,
		"./fa.js": 598,
		"./fi": 599,
		"./fi.js": 599,
		"./fo": 600,
		"./fo.js": 600,
		"./fr": 601,
		"./fr-ca": 602,
		"./fr-ca.js": 602,
		"./fr-ch": 603,
		"./fr-ch.js": 603,
		"./fr.js": 601,
		"./fy": 604,
		"./fy.js": 604,
		"./gd": 605,
		"./gd.js": 605,
		"./gl": 606,
		"./gl.js": 606,
		"./he": 607,
		"./he.js": 607,
		"./hi": 608,
		"./hi.js": 608,
		"./hr": 609,
		"./hr.js": 609,
		"./hu": 610,
		"./hu.js": 610,
		"./hy-am": 611,
		"./hy-am.js": 611,
		"./id": 612,
		"./id.js": 612,
		"./is": 613,
		"./is.js": 613,
		"./it": 614,
		"./it.js": 614,
		"./ja": 615,
		"./ja.js": 615,
		"./jv": 616,
		"./jv.js": 616,
		"./ka": 617,
		"./ka.js": 617,
		"./kk": 618,
		"./kk.js": 618,
		"./km": 619,
		"./km.js": 619,
		"./ko": 620,
		"./ko.js": 620,
		"./ky": 621,
		"./ky.js": 621,
		"./lb": 622,
		"./lb.js": 622,
		"./lo": 623,
		"./lo.js": 623,
		"./lt": 624,
		"./lt.js": 624,
		"./lv": 625,
		"./lv.js": 625,
		"./me": 626,
		"./me.js": 626,
		"./mi": 627,
		"./mi.js": 627,
		"./mk": 628,
		"./mk.js": 628,
		"./ml": 629,
		"./ml.js": 629,
		"./mr": 630,
		"./mr.js": 630,
		"./ms": 631,
		"./ms-my": 632,
		"./ms-my.js": 632,
		"./ms.js": 631,
		"./my": 633,
		"./my.js": 633,
		"./nb": 634,
		"./nb.js": 634,
		"./ne": 635,
		"./ne.js": 635,
		"./nl": 636,
		"./nl.js": 636,
		"./nn": 637,
		"./nn.js": 637,
		"./pa-in": 638,
		"./pa-in.js": 638,
		"./pl": 639,
		"./pl.js": 639,
		"./pt": 640,
		"./pt-br": 641,
		"./pt-br.js": 641,
		"./pt.js": 640,
		"./ro": 642,
		"./ro.js": 642,
		"./ru": 643,
		"./ru.js": 643,
		"./se": 644,
		"./se.js": 644,
		"./si": 645,
		"./si.js": 645,
		"./sk": 646,
		"./sk.js": 646,
		"./sl": 647,
		"./sl.js": 647,
		"./sq": 648,
		"./sq.js": 648,
		"./sr": 649,
		"./sr-cyrl": 650,
		"./sr-cyrl.js": 650,
		"./sr.js": 649,
		"./ss": 651,
		"./ss.js": 651,
		"./sv": 652,
		"./sv.js": 652,
		"./sw": 653,
		"./sw.js": 653,
		"./ta": 654,
		"./ta.js": 654,
		"./te": 655,
		"./te.js": 655,
		"./th": 656,
		"./th.js": 656,
		"./tl-ph": 657,
		"./tl-ph.js": 657,
		"./tlh": 658,
		"./tlh.js": 658,
		"./tr": 659,
		"./tr.js": 659,
		"./tzl": 660,
		"./tzl.js": 660,
		"./tzm": 661,
		"./tzm-latn": 662,
		"./tzm-latn.js": 662,
		"./tzm.js": 661,
		"./uk": 663,
		"./uk.js": 663,
		"./uz": 664,
		"./uz.js": 664,
		"./vi": 665,
		"./vi.js": 665,
		"./x-pseudo": 666,
		"./x-pseudo.js": 666,
		"./zh-cn": 667,
		"./zh-cn.js": 667,
		"./zh-hk": 668,
		"./zh-hk.js": 668,
		"./zh-tw": 669,
		"./zh-tw.js": 669
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 565;


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar_ly = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ly;
	
	}));

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es_do = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es_do;
	
	}));

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	}));

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?|MMMM?(\[[^\[\]]*\]|\s+)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	}));

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return pa_in;
	
	}));

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	}));

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return x_pseudo;
	
	}));

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_hk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_hk;
	
	}));

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(563)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  hey, [be]Lazy.js - v1.6.3 - 2016.09.30
	  A fast, small and dependency free lazy load script (https://github.com/dinbror/blazy)
	  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
	*/
	;
	(function(root, blazy) {
	    if (true) {
	        // AMD. Register bLazy as an anonymous module
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = blazy();
	    } else {
	        // Browser globals. Register bLazy on window
	        root.Blazy = blazy();
	    }
	})(this, function() {
	    'use strict';
	
	    //private vars
	    var _source, _viewport, _isRetina, _attrSrc = 'src',
	        _attrSrcset = 'srcset';
	
	    // constructor
	    return function Blazy(options) {
	        //IE7- fallback for missing querySelectorAll support
	        if (!document.querySelectorAll) {
	            var s = document.createStyleSheet();
	            document.querySelectorAll = function(r, c, i, j, a) {
	                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
	                for (i = r.length; i--;) {
	                    s.addRule(r[i], 'k:v');
	                    for (j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
	                    s.removeRule(0);
	                }
	                return c;
	            };
	        }
	
	        //options and helper vars
	        var scope = this;
	        var util = scope._util = {};
	        util.elements = [];
	        util.destroyed = true;
	        scope.options = options || {};
	        scope.options.error = scope.options.error || false;
	        scope.options.offset = scope.options.offset || 100;
	        scope.options.root = scope.options.root || document;
	        scope.options.success = scope.options.success || false;
	        scope.options.selector = scope.options.selector || '.b-lazy';
	        scope.options.separator = scope.options.separator || '|';
	        scope.options.container = scope.options.container ? document.querySelectorAll(scope.options.container) : false;
	        scope.options.errorClass = scope.options.errorClass || 'b-error';
	        scope.options.breakpoints = scope.options.breakpoints || false; // obsolete
	        scope.options.loadInvisible = scope.options.loadInvisible || false;
	        scope.options.successClass = scope.options.successClass || 'b-loaded';
	        scope.options.validateDelay = scope.options.validateDelay || 25;
	        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
	        scope.options.srcset = scope.options.srcset || 'data-srcset';
	        scope.options.src = _source = scope.options.src || 'data-src';
	        _isRetina = window.devicePixelRatio > 1;
	        _viewport = {};
	        _viewport.top = 0 - scope.options.offset;
	        _viewport.left = 0 - scope.options.offset;
	
	
	        /* public functions
	         ************************************/
	        scope.revalidate = function() {
	            initialize(this);
	        };
	        scope.load = function(elements, force) {
	            var opt = this.options;
	            if (elements.length === undefined) {
	                loadElement(elements, force, opt);
	            } else {
	                each(elements, function(element) {
	                    loadElement(element, force, opt);
	                });
	            }
	        };
	        scope.destroy = function() {
	            var self = this;
	            var util = self._util;
	            if (self.options.container) {
	                each(self.options.container, function(object) {
	                    unbindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            unbindEvent(window, 'scroll', util.validateT);
	            unbindEvent(window, 'resize', util.validateT);
	            unbindEvent(window, 'resize', util.saveViewportOffsetT);
	            util.count = 0;
	            util.elements.length = 0;
	            util.destroyed = true;
	        };
	
	        //throttle, ensures that we don't call the functions too often
	        util.validateT = throttle(function() {
	            validate(scope);
	        }, scope.options.validateDelay, scope);
	        util.saveViewportOffsetT = throttle(function() {
	            saveViewportOffset(scope.options.offset);
	        }, scope.options.saveViewportOffsetDelay, scope);
	        saveViewportOffset(scope.options.offset);
	
	        //handle multi-served image src (obsolete)
	        each(scope.options.breakpoints, function(object) {
	            if (object.width >= window.screen.width) {
	                _source = object.src;
	                return false;
	            }
	        });
	
	        // start lazy load
	        setTimeout(function() {
	            initialize(scope);
	        }); // "dom ready" fix
	
	    };
	
	
	    /* Private helper functions
	     ************************************/
	    function initialize(self) {
	        var util = self._util;
	        // First we create an array of elements to lazy load
	        util.elements = toArray(self.options);
	        util.count = util.elements.length;
	        // Then we bind resize and scroll events if not already binded
	        if (util.destroyed) {
	            util.destroyed = false;
	            if (self.options.container) {
	                each(self.options.container, function(object) {
	                    bindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            bindEvent(window, 'resize', util.saveViewportOffsetT);
	            bindEvent(window, 'resize', util.validateT);
	            bindEvent(window, 'scroll', util.validateT);
	        }
	        // And finally, we start to lazy load.
	        validate(self);
	    }
	
	    function validate(self) {
	        var util = self._util;
	        for (var i = 0; i < util.count; i++) {
	            var element = util.elements[i];
	            if (elementInView(element) || hasClass(element, self.options.successClass)) {
	                self.load(element);
	                util.elements.splice(i, 1);
	                util.count--;
	                i--;
	            }
	        }
	        if (util.count === 0) {
	            self.destroy();
	        }
	    }
	
	    function elementInView(ele) {
	        var rect = ele.getBoundingClientRect();
	        return (
	            // Intersection
	            rect.right >= _viewport.left && rect.bottom >= _viewport.top && rect.left <= _viewport.right && rect.top <= _viewport.bottom
	        );
	    }
	
	    function loadElement(ele, force, options) {
	        // if element is visible, not loaded or forced
	        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || (ele.offsetWidth > 0 && ele.offsetHeight > 0))) {
	            var dataSrc = ele.getAttribute(_source) || ele.getAttribute(options.src); // fallback to default 'data-src'
	            if (dataSrc) {
	                var dataSrcSplitted = dataSrc.split(options.separator);
	                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
	                var isImage = equal(ele, 'img');
	                // Image or background image
	                if (isImage || ele.src === undefined) {
	                    var img = new Image();
	                    // using EventListener instead of onerror and onload
	                    // due to bug introduced in chrome v50 
	                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
	                    var onErrorHandler = function() {
	                        if (options.error) options.error(ele, "invalid");
	                        addClass(ele, options.errorClass);
	                        unbindEvent(img, 'error', onErrorHandler);
	                        unbindEvent(img, 'load', onLoadHandler);
	                    };
	                    var onLoadHandler = function() {
	                        // Is element an image
	                        if (isImage) {
	                            setSrc(ele, src); //src
	                            handleSource(ele, _attrSrcset, options.srcset); //srcset
	                            //picture element
	                            var parent = ele.parentNode;
	                            if (parent && equal(parent, 'picture')) {
	                                each(parent.getElementsByTagName('source'), function(source) {
	                                    handleSource(source, _attrSrcset, options.srcset);
	                                });
	                            }
	                        // or background-image
	                        } else {
	                            ele.style.backgroundImage = 'url("' + src + '")';
	                        }
	                        itemLoaded(ele, options);
	                        unbindEvent(img, 'load', onLoadHandler);
	                        unbindEvent(img, 'error', onErrorHandler);
	                    };
	                    bindEvent(img, 'error', onErrorHandler);
	                    bindEvent(img, 'load', onLoadHandler);
	                    setSrc(img, src); //preload
	                } else { // An item with src like iframe, unity, simpelvideo etc
	                    setSrc(ele, src);
	                    itemLoaded(ele, options);
	                }
	            } else {
	                // video with child source
	                if (equal(ele, 'video')) {
	                    each(ele.getElementsByTagName('source'), function(source) {
	                        handleSource(source, _attrSrc, options.src);
	                    });
	                    ele.load();
	                    itemLoaded(ele, options);
	                } else {
	                    if (options.error) options.error(ele, "missing");
	                    addClass(ele, options.errorClass);
	                }
	            }
	        }
	    }
	
	    function itemLoaded(ele, options) {
	        addClass(ele, options.successClass);
	        if (options.success) options.success(ele);
	        // cleanup markup, remove data source attributes
	        ele.removeAttribute(options.src);
	        each(options.breakpoints, function(object) {
	            ele.removeAttribute(object.src);
	        });
	    }
	
	    function setSrc(ele, src) {
	        ele[_attrSrc] = src;
	    }
	
	    function handleSource(ele, attr, dataAttr) {
	        var dataSrc = ele.getAttribute(dataAttr);
	        if (dataSrc) {
	            ele[attr] = dataSrc;
	            ele.removeAttribute(dataAttr);
	        }
	    }
	
	    function equal(ele, str) {
	        return ele.nodeName.toLowerCase() === str;
	    }
	
	    function hasClass(ele, className) {
	        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    function addClass(ele, className) {
	        if (!hasClass(ele, className)) {
	            ele.className += ' ' + className;
	        }
	    }
	
	    function toArray(options) {
	        var array = [];
	        var nodelist = (options.root).querySelectorAll(options.selector);
	        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
	        return array;
	    }
	
	    function saveViewportOffset(offset) {
	        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
	        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
	    }
	
	    function bindEvent(ele, type, fn) {
	        if (ele.attachEvent) {
	            ele.attachEvent && ele.attachEvent('on' + type, fn);
	        } else {
	            ele.addEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function unbindEvent(ele, type, fn) {
	        if (ele.detachEvent) {
	            ele.detachEvent && ele.detachEvent('on' + type, fn);
	        } else {
	            ele.removeEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function each(object, fn) {
	        if (object && fn) {
	            var l = object.length;
	            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
	        }
	    }
	
	    function throttle(fn, minDelay, scope) {
	        var lastCall = 0;
	        return function() {
	            var now = +new Date();
	            if (now - lastCall < minDelay) {
	                return;
	            }
	            lastCall = now;
	            fn.apply(scope, arguments);
	        };
	    }
	});

/***/ },
/* 671 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PostTermClasses = {
	  generatePostClassesWithTerms: function generatePostClassesWithTerms(terms) {
	    var classes = '';
	    for (var key in terms) {
	      if (key in terms) {
	        if (terms[key].length) {
	          classes = classes.concat(' ') + terms[key].join(' ');
	        }
	      }
	    }
	    return classes;
	  }
	};
	
	exports.default = PostTermClasses;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var RedQGoliathGrid = function (_Component) {
	  _inherits(RedQGoliathGrid, _Component);
	
	  function RedQGoliathGrid(props) {
	    _classCallCheck(this, RedQGoliathGrid);
	
	    var _this = _possibleConstructorReturn(this, (RedQGoliathGrid.__proto__ || Object.getPrototypeOf(RedQGoliathGrid)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(RedQGoliathGrid, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var self = this;
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	      this.showPopup(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.showPopup(this.props);
	    }
	  }, {
	    key: 'showPopup',
	    value: function showPopup(props) {
	      var self = this;
	      var post = props.post;
	      jQuery(document).ready(function () {
	        jQuery('.parent-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: false
	          }
	        });
	        jQuery('.parent-gallery-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: true
	          }
	        });
	        if (post.post_format === 'standard') {
	          jQuery('.parent-container').magnificPopup({
	            delegate: 'a',
	            type: 'image',
	            gallery: {
	              enabled: false
	            }
	          });
	        }
	        if (post.post_format === 'gallery') {
	          jQuery('.parent-gallery-container').magnificPopup({
	            delegate: 'a',
	            type: 'image',
	            gallery: {
	              enabled: true
	            }
	          });
	        }
	        if (post.post_format === 'video') {
	          jQuery('.open-popup').magnificPopup({
	            type: 'iframe'
	          });
	        }
	        if (post.post_format === 'audio') {
	          jQuery('.open-audio').magnificPopup({
	            type: 'iframe'
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var post = _props.post;
	      var view = _props.view;
	
	      var thumbAlt = post.thumb_alt !== undefined ? post.thumb_alt : '';
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          // backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-image-grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-grid-normal' },
	              _react2.default.createElement(
	                'div',
	                { className: 'post-image-container' },
	                post.thumb_url && post.post_format === 'standard' ? _react2.default.createElement(
	                  'div',
	                  { className: this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy dummyClass' + post.ID : 'image-hover-coantainer', 'data-src': this.state.isotope === false ? post.thumb_url : null, style: imgStyle },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'img-overlay corner parent-container' },
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'rq-gallery-popup-link', href: post.thumb_url },
	                      _react2.default.createElement('i', { className: 'ion-android-add' }),
	                      _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt })
	                    )
	                  )
	                ) : '',
	                post.meta.post_video !== undefined && post.post_format === 'video' ? _react2.default.createElement(
	                  'a',
	                  { className: 'open-popup rq-post-standard', href: post.meta.post_video },
	                  _react2.default.createElement('img', { src: API.IMG + 'placeholder-video.jpg' })
	                ) : '',
	                post.meta.post_sound !== undefined && post.post_format === 'audio' ? _react2.default.createElement(
	                  'a',
	                  { className: 'open-audio rq-post-standard', href: post.meta.post_sound },
	                  _react2.default.createElement('img', { src: API.IMG + 'placeholder-audio.jpg' })
	                ) : '',
	                post.gallery_image_urls.length > 1 && post.post_format === 'gallery' ? _react2.default.createElement(
	                  Slider,
	                  _extends({ className: 'parent-gallery-container' }, settings),
	                  showGalleryPost
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'post-content' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: post.post_link },
	                    post.post_title
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'post-date' },
	                  (0, _moment2.default)(post.post_date).format('ll')
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', 'data-src': this.state.isotope === false ? post.thumb_url : null, style: imgStyle },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay parent-container' },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'rq-gallery-popup-link', href: post.thumb_url },
	                        _react2.default.createElement('i', { className: 'ion-android-add' }),
	                        _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RedQGoliathGrid;
	}(_react.Component);
	
	ReactiveTemplates['redQGoliathGrid'] = RedQGoliathGrid;
	
	ReactiveLayouts.push({
	  'key': 'redQGoliathGrid',
	  'image_url': API.IMG + 'effect-goliath.jpg',
	  'type': 'all',
	  'format': 'standard',
	  'gridName': 'Golia'
	});

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var latestGridLayoutOne = function (_Component) {
	  _inherits(latestGridLayoutOne, _Component);
	
	  function latestGridLayoutOne(props) {
	    _classCallCheck(this, latestGridLayoutOne);
	
	    var _this = _possibleConstructorReturn(this, (latestGridLayoutOne.__proto__ || Object.getPrototypeOf(latestGridLayoutOne)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(latestGridLayoutOne, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var post = this.props.post;
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var view = this.props.view;
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          { className: 'rq-image-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-grid-normal full-width-bg-image no-border-radius' },
	            _react2.default.createElement(
	              'div',
	              { className: 'post-image-container' },
	              _react2.default.createElement(
	                'div',
	                { className: this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'image-hover-coantainer post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                _react2.default.createElement(
	                  'a',
	                  { href: post.post_link },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'img-overlay white-color' },
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'rq-post-title' },
	                      post.post_title
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link },
	                        _react2.default.createElement('i', { className: 'ion-android-add' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return latestGridLayoutOne;
	}(_react.Component);
	
	ReactiveTemplates['latestGridLayoutOne'] = latestGridLayoutOne;
	
	ReactiveLayouts.push({
	  'key': 'latestGridLayoutOne',
	  'image_url': API.IMG + 'bg-img-blog.jpg',
	  'type': 'all',
	  'gridName': 'WinSton'
	});

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var latestGridLayoutTwo = function (_Component) {
	  _inherits(latestGridLayoutTwo, _Component);
	
	  function latestGridLayoutTwo(props) {
	    _classCallCheck(this, latestGridLayoutTwo);
	
	    var _this = _possibleConstructorReturn(this, (latestGridLayoutTwo.__proto__ || Object.getPrototypeOf(latestGridLayoutTwo)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(latestGridLayoutTwo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var post = this.props.post;
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var view = this.props.view;
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      var showtag = function showtag(item) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'post-tag' },
	          item
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          { className: 'rq-image-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-grid-normal full-width-bg-image no-border-radius' },
	            _react2.default.createElement(
	              'div',
	              { className: 'post-image-container rq-latest-two-grid' },
	              _react2.default.createElement(
	                'a',
	                { href: post.post_link },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.isotope === false ? 'image-hover-coantainer rq-absolute-container lazyLoading b-lazy dummyClass' + post.ID : 'image-hover-coantainer rq-absolute-container', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                  _react2.default.createElement('div', { className: 'img-overlay' })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rq-post-title-new' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    post.post_title
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'post-date' },
	                    (0, _moment2.default)(post.post_date).format('DD  MMM  YYYY')
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'rq-tag-container' },
	                    post.terms.hasOwnProperty('post_tag') ? post.terms.post_tag.map(showtag) : null
	                  )
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link },
	                        _react2.default.createElement('i', { className: 'ion-android-add' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return latestGridLayoutTwo;
	}(_react.Component);
	
	ReactiveTemplates['latestGridLayoutTwo'] = latestGridLayoutTwo;
	
	ReactiveLayouts.push({
	  'key': 'latestGridLayoutTwo',
	  // 'image_url': API.IMG + 'effect-steve.jpg',
	  'type': 'all',
	  'gridName': 'SpaceGray'
	});

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDom = __webpack_require__(31);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var DoPostStandard = function (_Component) {
	  _inherits(DoPostStandard, _Component);
	
	  function DoPostStandard(props) {
	    _classCallCheck(this, DoPostStandard);
	
	    var _this = _possibleConstructorReturn(this, (DoPostStandard.__proto__ || Object.getPrototypeOf(DoPostStandard)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(DoPostStandard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.showPopup(this.props);
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.showPopup(this.props);
	    }
	  }, {
	    key: 'showPopup',
	    value: function showPopup(props) {
	      var self = this;
	      var post = props.post;
	
	      jQuery(document).ready(function () {
	        jQuery('.parent-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: false
	          }
	        });
	        jQuery('.parent-gallery-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: true
	          }
	        });
	        if (post.post_format === 'standard') {
	          jQuery('.parent-container').magnificPopup({
	            delegate: 'a',
	            type: 'image',
	            gallery: {
	              enabled: false
	            }
	          });
	        }
	        if (post.post_format === 'gallery') {
	          jQuery('.parent-gallery-container').magnificPopup({
	            delegate: 'a',
	            type: 'image',
	            gallery: {
	              enabled: true
	            }
	          });
	        }
	        if (post.post_format === 'video') {
	          jQuery('.open-popup').magnificPopup({
	            type: 'iframe'
	          });
	        }
	        if (post.post_format === 'audio') {
	          jQuery('.open-audio').magnificPopup({
	            type: 'iframe'
	          });
	        }
	      });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var post = _props.post;
	      var view = _props.view;
	
	      var thumbAlt = post.thumb_alt !== undefined ? post.thumb_alt : '';
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-image-grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-grid-normal full-width-bg-image no-border-radius top-heading' },
	              _react2.default.createElement(
	                'div',
	                { className: 'post-image-container' },
	                post.thumb_url && post.post_format === 'standard' ? _react2.default.createElement(
	                  'div',
	                  { className: this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy dummyClass' + post.ID : 'image-hover-coantainer', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'img-overlay parent-container' },
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'rq-gallery-popup-link', href: post.thumb_url },
	                      _react2.default.createElement('i', { className: 'ion-android-add' }),
	                      _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt })
	                    )
	                  )
	                ) : '',
	                post.meta.post_video !== undefined && post.post_format === 'video' ? _react2.default.createElement(
	                  'a',
	                  { className: 'open-popup rq-post-standard', href: post.meta.post_video },
	                  _react2.default.createElement('img', { src: API.IMG + 'placeholder-video.jpg' })
	                ) : '',
	                post.meta.post_sound !== undefined && post.post_format === 'audio' ? _react2.default.createElement(
	                  'a',
	                  { className: 'open-audio rq-post-standard', href: post.meta.post_sound },
	                  _react2.default.createElement('img', { src: API.IMG + 'placeholder-audio.jpg' })
	                ) : '',
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rq-img-post-title-content' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: post.post_link },
	                      post.post_title
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'post-date' },
	                    (0, _moment2.default)(post.post_date).format('ll')
	                  )
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay parent-container' },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'rq-gallery-popup-link', href: post.thumb_url },
	                        _react2.default.createElement('i', { className: 'ion-android-add' }),
	                        _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DoPostStandard;
	}(_react.Component);
	
	ReactiveTemplates['doPostStandard'] = DoPostStandard;
	
	ReactiveLayouts.push({
	  'key': 'doPostStandard',
	  'image_url': API.IMG + 'do-post-grid.jpg',
	  'type': 'all',
	  'format': 'standard',
	  'gridName': 'CoverGrid'
	});

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var latestGridLayoutFour = function (_Component) {
	  _inherits(latestGridLayoutFour, _Component);
	
	  function latestGridLayoutFour(props) {
	    _classCallCheck(this, latestGridLayoutFour);
	
	    var _this = _possibleConstructorReturn(this, (latestGridLayoutFour.__proto__ || Object.getPrototypeOf(latestGridLayoutFour)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(latestGridLayoutFour, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var post = this.props.post;
	      var view = this.props.view;
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      var showtag = function showtag(item) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'post-tag' },
	          item
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          { className: 'rq-image-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-grid-normal full-width-bg-image no-border-radius' },
	            _react2.default.createElement(
	              'div',
	              { className: 'post-image-container rq-latest-two-grid' },
	              _react2.default.createElement(
	                'a',
	                { href: post.post_link },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy rq-absolute-container dark-overlay light-overlay dummyClass' + post.ID : 'image-hover-coantainer rq-absolute-container dark-overlay light-overlay', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'img-overlay' },
	                    _react2.default.createElement('i', { className: 'ion-link' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'on-hover-cotnent' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rq-title-footer with-bottom-panel' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'rq-title-content' },
	                      _react2.default.createElement(
	                        'h3',
	                        null,
	                        post.post_title
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'post-date' },
	                      (0, _moment2.default)(post.post_date).format('MMM  YYYY')
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'rq-tag-container' },
	                      post.terms.hasOwnProperty('post_tag') ? post.terms.post_tag.map(showtag) : null
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link },
	                        _react2.default.createElement('i', { className: 'ion-android-add' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return latestGridLayoutFour;
	}(_react.Component);
	
	ReactiveTemplates['latestGridLayoutFour'] = latestGridLayoutFour;
	
	ReactiveLayouts.push({
	  'key': 'latestGridLayoutFour',
	  // 'image_url': API.IMG + 'effect-steve.jpg',
	  'type': 'all',
	  'gridName': 'PrettyGrid'
	
	});

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var latestGridLayoutFive = function (_Component) {
	  _inherits(latestGridLayoutFive, _Component);
	
	  function latestGridLayoutFive(props) {
	    _classCallCheck(this, latestGridLayoutFive);
	
	    var _this = _possibleConstructorReturn(this, (latestGridLayoutFive.__proto__ || Object.getPrototypeOf(latestGridLayoutFive)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(latestGridLayoutFive, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var self = this;
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var post = this.props.post;
	      var view = this.props.view;
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      var showtag = function showtag(item) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'post-tag' },
	          item
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          { className: 'rq-realestate-grid' },
	          _react2.default.createElement(
	            'a',
	            { href: post.post_link },
	            _react2.default.createElement(
	              'div',
	              { className: 'image-hover-container' },
	              _react2.default.createElement('div', { className: this.state.isotope === false ? 'realestate-img-container lazyLoading b-lazy dummyClass' + post.ID : 'realestate-img-container', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'realestate-overlay' },
	              _react2.default.createElement(
	                'p',
	                { className: 'realestate-author-date' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'post-date post-name' },
	                  post.post_author_name
	                ),
	                '  ',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'post-date' },
	                  (0, _moment2.default)(post.post_date).format('MMM YYYY')
	                )
	              ),
	              _react2.default.createElement('i', { className: 'ion-link link-icon' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'realestate-title' },
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  post.post_title
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'rq-tag-container' },
	                  post.terms.hasOwnProperty('post_tag') ? post.terms.post_tag.map(showtag) : null
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link },
	                        _react2.default.createElement('i', { className: 'ion-android-add' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return latestGridLayoutFive;
	}(_react.Component);
	
	ReactiveTemplates['latestGridLayoutFive'] = latestGridLayoutFive;
	
	ReactiveLayouts.push({
	  'key': 'latestGridLayoutFive',
	  // 'image_url': API.IMG + 'effect-steve.jpg',
	  'type': 'all',
	  'format': 'standard',
	  'gridName': 'DownGrid'
	
	});

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRating = __webpack_require__(679);
	
	var _reactRating2 = _interopRequireDefault(_reactRating);
	
	var _accounting = __webpack_require__(680);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var ProductGridOne = function (_Component) {
	  _inherits(ProductGridOne, _Component);
	
	  function ProductGridOne(props) {
	    _classCallCheck(this, ProductGridOne);
	
	    var _this = _possibleConstructorReturn(this, (ProductGridOne.__proto__ || Object.getPrototypeOf(ProductGridOne)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(ProductGridOne, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.showPopup(this.props);
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.showPopup(this.props);
	    }
	  }, {
	    key: 'showPopup',
	    value: function showPopup(props) {
	      var self = this;
	      var post = props.post;
	      jQuery(document).ready(function () {
	        jQuery('.parent-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: false
	          }
	        });
	        jQuery('.parent-gallery-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: true
	          }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currencyPosition = void 0;
	      switch (this.props.helperData.woocommerce.position) {
	        case 'left':
	          currencyPosition = "%s%v";
	          break;
	        case 'right':
	          currencyPosition = "%v%s";
	          break;
	        case 'left_space':
	          currencyPosition = "%s %v";
	          break;
	        case 'right_space':
	          currencyPosition = "%v %s";
	          break;
	      }
	
	      var currencyOptions = {
	        symbol: this.props.helperData.woocommerce.symbol,
	        decimal: this.props.helperData.woocommerce.decimal,
	        thousand: this.props.helperData.woocommerce.thousand,
	        precision: this.props.helperData.woocommerce.number,
	        format: currencyPosition
	      };
	
	      var post = this.props.post;
	      var thumbAlt = post.thumb_alt !== undefined ? post.thumb_alt : '';
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var view = this.props.view;
	      var smallPost = post.post_excerpt.substring(0, 80);
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-image-grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-grid-normal rq-product-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'post-image-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy dummyClass' + post.ID : 'image-hover-coantainer', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'img-overlay corner parent-container' },
	                    _react2.default.createElement(
	                      'a',
	                      { className: 'rq-gallery-popup-link', href: post.thumb_url },
	                      _react2.default.createElement('i', { className: 'ion-android-add' }),
	                      _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'product-rating' },
	                _react2.default.createElement(_reactRating2.default, {
	                  start: 0,
	                  stop: 5,
	                  step: 1,
	                  initialRate: parseFloat(post.meta['_wc_average_rating'], 10),
	                  readonly: true,
	                  empty: 'ion-android-star-outline',
	                  full: 'ion-android-star'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'post-content rq-product-content' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: post.post_link },
	                    post.post_title
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'rq-wc-price' },
	                  this.props.helperData.hasOwnProperty('woocommerce') ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('span', { className: 'amount', dangerouslySetInnerHTML: { __html: _accounting2.default.formatMoney(post.meta['_price'], currencyOptions) } })
	                  ) : null
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay parent-container' },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'rq-gallery-popup-link' },
	                        _react2.default.createElement('i', { className: 'ion-android-add' }),
	                        _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductGridOne;
	}(_react.Component);
	
	ReactiveTemplates['ProductGridOne'] = ProductGridOne;
	
	ReactiveLayouts.push({
	  'key': 'ProductGridOne',
	  'type': 'all',
	  'gridName': 'Product'
	});

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/*! react-rating - 0.2.2 | (c) 2015, 2016  dreyescat | MIT | https://github.com/dreyescat/react-rating */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["ReactRating"] = factory(require("react"));
		else
			root["ReactRating"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/lib";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
		var Style = __webpack_require__(3);
		var Symbol = __webpack_require__(5);
	
		// Returns the index of the rate in the range (start, stop, step).
		// Returns undefined index if the rate is outside the range.
		// NOTE: A range.step of 0 produces an empty range and consequently returns an
		// undefined index.
		var indexOf = function indexOf(range, rate) {
		  // Check the rate is in the proper range [start..stop] according to
		  // the start, stop and step properties in props.
		  var step = range.step;
		  var start = step > 0 ? range.start : range.stop;
		  var stop = step > 0 ? range.stop : range.start;
		  if (step && start <= rate && rate <= stop) {
		    // The index corresponds to the number of steps of size props.step
		    // that fits between rate and start.
		    // This index does not need to be a whole number because we can have
		    // fractional symbols, and consequently fractional/float indexes.
		    return (rate - range.start) / step;
		  }
		};
	
		var Rating = React.createClass({
		  displayName: 'Rating',
	
		  // Define propTypes only in development.
		  propTypes: "boolean" !== 'undefined' && (true) && {
		    start: React.PropTypes.number,
		    stop: React.PropTypes.number,
		    step: React.PropTypes.number,
		    initialRate: React.PropTypes.number,
		    placeholderRate: React.PropTypes.number,
		    empty: React.PropTypes.oneOfType([
		    // Array of class names and/or style objects.
		    React.PropTypes.arrayOf(React.PropTypes.oneOfType[(React.PropTypes.string, React.PropTypes.object)]),
		    // Class names.
		    React.PropTypes.string,
		    // Style objects.
		    React.PropTypes.object]),
		    placeholder: React.PropTypes.oneOfType([
		    // Array of class names and/or style objects.
		    React.PropTypes.arrayOf(React.PropTypes.oneOfType[(React.PropTypes.string, React.PropTypes.object)]),
		    // Class names.
		    React.PropTypes.string,
		    // Style objects.
		    React.PropTypes.object]),
		    full: React.PropTypes.oneOfType([
		    // Array of class names and/or style objects.
		    React.PropTypes.arrayOf(React.PropTypes.oneOfType[(React.PropTypes.string, React.PropTypes.object)]),
		    // Class names.
		    React.PropTypes.string,
		    // Style objects.
		    React.PropTypes.object]),
		    readonly: React.PropTypes.bool,
		    fractions: React.PropTypes.number,
		    scale: React.PropTypes.number,
		    onChange: React.PropTypes.func,
		    onClick: React.PropTypes.func,
		    onRate: React.PropTypes.func
		  },
		  getDefaultProps: function getDefaultProps() {
		    return {
		      start: 0,
		      stop: 5,
		      step: 1,
		      empty: Style.empty,
		      placeholder: Style.placeholder,
		      full: Style.full,
		      fractions: 1,
		      scale: 3,
		      onChange: function onChange(rate) {},
		      onClick: function onClick(rate) {},
		      onRate: function onRate(rate) {}
		    };
		  },
		  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		    var rate = nextProps.initialRate > 0 ? nextProps.initialRate : nextProps.placeholderRate;
		    this.setState({
		      index: indexOf(nextProps, rate)
		    });
		  },
		  getInitialState: function getInitialState() {
		    var index = this.props.initialRate > 0 ? this.props.initialRate : this.props.placeholderRate;
		    return {
		      index: this._rateToIndex(index),
		      indexOver: undefined
		    };
		  },
		  handleMouseDown: function handleMouseDown(i, event) {
		    var index = i + this._fractionalIndex(event);
		    this.props.onClick(this._indexToRate(index));
		    if (this.state.index !== index) {
		      this.props.onChange(this._indexToRate(index));
		      this.setState({
		        index: index,
		        selected: true
		      });
		    }
		  },
		  handleMouseLeave: function handleMouseLeave() {
		    this.props.onRate();
		    this.setState({
		      indexOver: undefined
		    });
		  },
		  handleMouseMove: function handleMouseMove(i, event) {
		    var index = i + this._fractionalIndex(event);
		    if (this.state.indexOver !== index) {
		      this.props.onRate(this._indexToRate(index));
		      this.setState({
		        indexOver: index
		      });
		    }
		  },
		  // Calculate the rate of an index according the the start and step.
		  _indexToRate: function _indexToRate(index) {
		    return this.props.start + Math.floor(index) * this.props.step + this.props.step * this._roundToFraction(index % 1);
		  },
		  // Calculate the corresponding index for a rate according to the provided
		  // props or this.props.
		  _rateToIndex: function _rateToIndex(rate) {
		    return indexOf(this.props, rate);
		  },
		  _roundToFraction: function _roundToFraction(index) {
		    // Get the closest top fraction.
		    var fraction = Math.ceil(index % 1 * this.props.fractions) / this.props.fractions;
		    // Truncate decimal trying to avoid float precission issues.
		    var precision = Math.pow(10, this.props.scale);
		    return Math.floor(index) + Math.floor(fraction * precision) / precision;
		  },
		  _fractionalIndex: function _fractionalIndex(event) {
		    var x = event.clientX - event.currentTarget.getBoundingClientRect().left;
		    return this._roundToFraction(x / event.currentTarget.offsetWidth);
		  },
		  render: function render() {
		    var symbolNodes = [];
		    var empty = [].concat(this.props.empty);
		    var placeholder = [].concat(this.props.placeholder);
		    var full = [].concat(this.props.full);
		    // The symbol with the mouse over prevails over the selected one.
		    var index = this.state.indexOver !== undefined ? this.state.indexOver : this.state.index;
		    // The index of the last full symbol or NaN if index is undefined.
		    var lastFullIndex = Math.floor(index);
		    // Render the number of whole symbols.
	
		    var icon = !this.state.selected && !this.props.initialRate && this.props.placeholderRate > 0 && this.state.indexOver == undefined ? placeholder : full;
	
		    for (var i = 0; i < Math.floor(this._rateToIndex(this.props.stop)); i++) {
		      // Return the percentage of the decimal part of the last full index,
		      // 100 percent for those below the last full index or 0 percent for those
		      // indexes NaN or above the last full index.
		      var percent = i - lastFullIndex === 0 ? index % 1 * 100 : i - lastFullIndex < 0 ? 100 : 0;
	
		      symbolNodes.push(React.createElement(Symbol, {
		        key: i,
		        background: empty[i % empty.length],
		        icon: icon[i % icon.length],
		        percent: percent,
		        onMouseDown: !this.props.readonly && this.handleMouseDown.bind(this, i),
		        onMouseMove: !this.props.readonly && this.handleMouseMove.bind(this, i)
		      }));
		    }
		    return React.createElement(
		      'span',
		      { onMouseLeave: !this.props.readonly && this.handleMouseLeave },
		      symbolNodes
		    );
		  }
		});
	
		module.exports = Rating;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var merge = __webpack_require__(4);
	
		var style = {
		  display: 'inline-block',
		  borderRadius: '50%',
		  border: '5px double white',
		  width: 30,
		  height: 30
		};
	
		module.exports = {
		  empty: merge(style, {
		    backgroundColor: '#ccc'
		  }),
		  full: merge(style, {
		    backgroundColor: 'black'
		  }),
		  placeholder: merge(style, {
		    backgroundColor: 'red'
		  })
		};
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = function () {
		  var res = {};
		  for (var i = 0; i < arguments.length; i++) {
		    var obj = arguments[i];
		    for (var k in obj) {
		      res[k] = obj[k];
		    }
		  }
		  return res;
		};
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var React = __webpack_require__(2);
	
		var PercentageSymbol = React.createClass({
		  displayName: 'PercentageSymbol',
	
		  // Define propTypes only in development. They will be void in production.
		  propTypes: "boolean" !== 'undefined' && (true) && {
		    icon: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object, React.PropTypes.element]),
		    background: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.object, React.PropTypes.element]),
		    percent: React.PropTypes.number
		  },
		  // Return the corresponding React node for an icon.
		  _iconNode: function _iconNode(icon) {
		    // If it is already a React Element just return it.
		    if (React.isValidElement(icon)) {
		      return icon;
		    }
		    // If it is an object, try to use it as a CSS style object.
		    if (typeof icon === 'object' && icon !== null) {
		      return React.createElement('div', { style: icon });
		    }
		    // If it is a string, use it as class names.
		    if (Object.prototype.toString.call(icon) === '[object String]') {
		      return React.createElement('div', { className: icon });
		    }
		  },
		  render: function render() {
		    var backgroundNode = this._iconNode(this.props.background);
		    var iconNode = this._iconNode(this.props.icon);
		    var iconContainerStyle = {
		      display: 'inline-block',
		      position: 'absolute',
		      overflow: 'hidden',
		      top: 0,
		      left: 0,
		      width: this.props.percent !== undefined ? this.props.percent + '%' : 'auto'
		    };
		    var style = {
		      cursor: this.props.onMouseDown || this.props.onMouseOver ? 'pointer' : 'auto',
		      display: 'inline-block',
		      position: 'relative'
		    };
		    return React.createElement(
		      'span',
		      { style: style,
		        onMouseDown: this.props.onMouseDown,
		        onMouseMove: this.props.onMouseMove },
		      backgroundNode,
		      React.createElement(
		        'span',
		        { style: iconContainerStyle },
		        iconNode
		      )
		    );
		  }
		});
	
		module.exports = PercentageSymbol;
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */
	
	(function(root, undefined) {
	
		/* --- Setup --- */
	
		// Create the local library object, to be exported or referenced globally later
		var lib = {};
	
		// Current version
		lib.version = '0.4.1';
	
	
		/* --- Exposed settings --- */
	
		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};
	
	
		/* --- Internal Helper Methods --- */
	
		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}
	
		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}
	
		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}
	
		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;
	
			if (!obj) return results;
	
			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	
			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}
	
		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}
	
	
		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;
	
			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();
	
			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {
	
				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};
	
			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {
	
				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};
	
			}
			// Otherwise, assume format was fine:
			return format;
		}
	
	
		/* --- API Methods --- */
	
		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}
	
			// Fails silently (need decent errors):
			value = value || 0;
	
			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;
	
			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;
	
			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);
	
			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};
	
	
		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);
	
			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};
	
	
		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),
	
				// Clean up precision
				usePrecision = checkPrecision(opts.precision),
	
				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;
	
			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};
	
	
		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),
	
				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
	
			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};
	
	
		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),
	
				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
	
				// Store value for the length of the longest string in the column:
				maxLength = 0,
	
				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);
	
						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
	
							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	
						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});
	
			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};
	
	
		/* --- Module Definition --- */
	
		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);
	
			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}
	
		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRating = __webpack_require__(679);
	
	var _reactRating2 = _interopRequireDefault(_reactRating);
	
	var _accounting = __webpack_require__(680);
	
	var _accounting2 = _interopRequireDefault(_accounting);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var ProductGridTwo = function (_Component) {
	  _inherits(ProductGridTwo, _Component);
	
	  function ProductGridTwo(props) {
	    _classCallCheck(this, ProductGridTwo);
	
	    var _this = _possibleConstructorReturn(this, (ProductGridTwo.__proto__ || Object.getPrototypeOf(ProductGridTwo)).call(this, props));
	
	    _this.hideLoadingGig = _this.hideLoadingGig.bind(_this);
	    _this.state = {
	      isotope: false
	    };
	    return _this;
	  }
	
	  _createClass(ProductGridTwo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var self = this;
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	      this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var bLazy = new _blazy2.default({
	        success: this.hideLoadingGig,
	        error: function error(ele, msg) {
	          // error function
	        }
	      });
	    }
	  }, {
	    key: 'hideLoadingGig',
	    value: function hideLoadingGig(ele) {
	      var id = this.props.post.ID;
	      $('.dummyClass' + id).removeClass('lazyLoading');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var currencyPosition = void 0;
	      var woocommerce = this.props.helperData.woocommerce;
	
	      switch (woocommerce.position) {
	        case 'left':
	          currencyPosition = '%s%v';
	          break;
	        case 'right':
	          currencyPosition = '%v%s';
	          break;
	        case 'left_space':
	          currencyPosition = '%s %v';
	          break;
	        case 'right_space':
	          currencyPosition = '%v %s';
	          break;
	        default:
	          break;
	      }
	
	      var currencyOptions = {
	        symbol: woocommerce.symbol,
	        decimal: woocommerce.decimal,
	        thousand: woocommerce.thousand,
	        precision: woocommerce.number,
	        format: currencyPosition
	      };
	
	      var _props = this.props;
	      var post = _props.post;
	      var view = _props.view;
	
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var smallPost = post.post_excerpt.substring(0, 80);
	      var imgStyle = null;
	      if (this.state.isotope === false) {
	        imgStyle = {
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      } else {
	        imgStyle = {
	          backgroundImage: 'url(' + post.thumb_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center',
	          position: 'relative',
	          width: '100%',
	          height: '100%'
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-image-grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-grid-normal rq-product-grid product-grid-secondary' },
	              _react2.default.createElement(
	                'div',
	                { className: 'post-image-container' },
	                _react2.default.createElement(
	                  'div',
	                  { className: this.state.isotope === false ? 'image-hover-coantainer lazyLoading b-lazy dummyClass' + post.ID : 'image-hover-coantainer', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'img-overlay corner' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: post.post_link },
	                      _react2.default.createElement('i', { className: 'ion-link basic-style' })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'post-content rq-product-content' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'product-title-container' },
	                  _react2.default.createElement(
	                    'h2',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: post.post_link, title: post.post_title },
	                      post.post_title
	                    )
	                  ),
	                  this.props.helperData.hasOwnProperty('woocommerce') ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement('span', { className: 'amount', dangerouslySetInnerHTML: { __html: _accounting2.default.formatMoney(post.meta['_price'], currencyOptions) } })
	                  ) : null
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'product-rating' },
	                  _react2.default.createElement(_reactRating2.default, {
	                    start: 0,
	                    stop: 5,
	                    step: 1,
	                    initialRate: parseFloat(post.meta['_wc_average_rating'], 10),
	                    readonly: true,
	                    empty: 'ion-android-star-outline',
	                    full: 'ion-android-star'
	                  })
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: this.state.isotope === false ? 'flex-md-5 flex-sm-12 flex-xs-12 lazyLoading b-lazy post-image-container-list dummyClass' + post.ID : 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle, 'data-src': this.state.isotope === false ? post.thumb_url : null },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay' },
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link },
	                        _react2.default.createElement('i', { className: 'ion-android-add' })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProductGridTwo;
	}(_react.Component);
	
	ReactiveTemplates['ProductGridTwo'] = ProductGridTwo;
	
	ReactiveLayouts.push({
	  'key': 'ProductGridTwo',
	  'type': 'all',
	  'gridName': 'Product Alt'
	});

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _blazy = __webpack_require__(670);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _generatePostClassesWithTerms = __webpack_require__(671);
	
	var _generatePostClassesWithTerms2 = _interopRequireDefault(_generatePostClassesWithTerms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isotopeGrid = function (_Component) {
	  _inherits(isotopeGrid, _Component);
	
	  function isotopeGrid() {
	    _classCallCheck(this, isotopeGrid);
	
	    return _possibleConstructorReturn(this, (isotopeGrid.__proto__ || Object.getPrototypeOf(isotopeGrid)).apply(this, arguments));
	  }
	
	  _createClass(isotopeGrid, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var post = this.props.post;
	      this.termAsClasses = _generatePostClassesWithTerms2.default.generatePostClassesWithTerms(post.terms);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.showPopup(this.props);
	      var bLazy = new _blazy2.default();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.showPopup(this.props);
	    }
	  }, {
	    key: 'showPopup',
	    value: function showPopup(props) {
	      var self = this;
	      var post = props.post;
	      jQuery(document).ready(function () {
	        jQuery('.parent-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: false
	          }
	        });
	        jQuery('.parent-gallery-container').magnificPopup({
	          delegate: 'a',
	          type: 'image',
	          gallery: {
	            enabled: true
	          }
	        });
	        if (post.post_format === 'standard') {
	          jQuery('.parent-container').magnificPopup({
	            delegate: 'a',
	            type: 'image',
	            gallery: {
	              enabled: false
	            }
	          });
	        }
	        if (post.post_format === 'gallery') {
	          jQuery('.parent-gallery-container').magnificPopup({
	            delegate: 'a',
	            type: 'image',
	            gallery: {
	              enabled: true
	            }
	          });
	        }
	        if (post.post_format === 'video') {
	          jQuery('.open-popup').magnificPopup({
	            type: 'iframe'
	          });
	        }
	        if (post.post_format === 'audio') {
	          jQuery('.open-audio').magnificPopup({
	            type: 'iframe'
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var post = _props.post;
	      var view = _props.view;
	
	      var thumbAlt = post.thumb_alt !== undefined ? post.thumb_alt : '';
	      var termAsClasses = this.termAsClasses;
	      termAsClasses = termAsClasses !== undefined ? termAsClasses : '';
	      var imgStyle = {
	        backgroundImage: 'url(' + post.thumb_url + ')',
	        backgroundSize: 'cover',
	        backgroundPosition: 'center center',
	        position: 'relative',
	        width: '100%',
	        height: '100%'
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        view === 'grid' ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-image-grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-grid-normal' },
	              _react2.default.createElement(
	                'div',
	                { className: '' },
	                post.thumb_url && post.post_format === 'standard' ? _react2.default.createElement(
	                  'div',
	                  { className: 'rq-isotopegrid-image' },
	                  _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt }),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'rq-image-overlay' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: post.post_link },
	                      _react2.default.createElement('i', { className: 'ion-link' })
	                    )
	                  )
	                ) : '',
	                post.meta.post_video !== undefined && post.post_format === 'video' ? _react2.default.createElement(
	                  'a',
	                  { className: 'open-popup rq-post-standard', href: post.meta.post_video },
	                  _react2.default.createElement('img', { src: API.IMG + 'placeholder-video.jpg' })
	                ) : '',
	                post.meta.post_sound !== undefined && post.post_format === 'audio' ? _react2.default.createElement(
	                  'a',
	                  { className: 'open-audio rq-post-standard', href: post.meta.post_sound },
	                  _react2.default.createElement('img', { src: API.IMG + 'placeholder-audio.jpg' })
	                ) : ''
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'post-content' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: post.post_link },
	                    post.post_title
	                  )
	                ),
	                _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'post-date' },
	                  (0, _moment2.default)(post.post_date).format('ll')
	                )
	              )
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          { className: 'flex-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-12 flex-sm-12 flex-xs-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-image-grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-grid-normal with-left-image' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'flex-row' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-5 flex-sm-12 flex-xs-12 post-image-container-list', style: imgStyle },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'img-overlay parent-container' },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'rq-gallery-popup-link', href: post.thumb_url },
	                        _react2.default.createElement('i', { className: 'ion-android-add' }),
	                        _react2.default.createElement('img', { src: post.thumb_url, alt: thumbAlt })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'flex-md-7 flex-sm-12 flex-xs-12' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'post-content' },
	                      _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                          'a',
	                          { href: post.post_link },
	                          post.post_title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'post-date' },
	                        (0, _moment2.default)(post.post_date).format('ll')
	                      ),
	                      _react2.default.createElement('div', { className: 'post-text' + termAsClasses, dangerouslySetInnerHTML: { __html: post.post_excerpt.slice(0, 70) + '...' } }),
	                      _react2.default.createElement(
	                        'a',
	                        { href: post.post_link, className: 'btn btn-blog' },
	                        API.LANG.MORE
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return isotopeGrid;
	}(_react.Component);
	
	ReactiveTemplates['isotopeGrid'] = isotopeGrid;
	
	ReactiveLayouts.push({
	  'key': 'isotopeGrid',
	  'image_url': API.IMG + 'effect-goliath.jpg',
	  'type': 'all',
	  'format': 'standard',
	  'gridName': 'MasonryGrid'
	});

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HoverAction = _reflux2.default.createActions(['pushHoverData']);
	exports.default = HoverAction;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(685);
	
	__webpack_require__(686);
	
	__webpack_require__(687);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryBlock = function (_React$Component) {
	  _inherits(CategoryBlock, _React$Component);
	
	  function CategoryBlock(props) {
	    _classCallCheck(this, CategoryBlock);
	
	    var _this = _possibleConstructorReturn(this, (CategoryBlock.__proto__ || Object.getPrototypeOf(CategoryBlock)).call(this, props));
	
	    _this.displayName = 'CategoryBlock';
	    _this.showAllTerms = _this.showAllTerms.bind(_this);
	    _this.state = {
	      'selectedTemplate': ''
	    };
	    return _this;
	  }
	
	  _createClass(CategoryBlock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadSettings(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.loadSettings(nextProps);
	    }
	  }, {
	    key: 'loadSettings',
	    value: function loadSettings(props) {
	      var _this2 = this;
	
	      var block = props.block.categorySettings !== undefined ? props.block.categorySettings.categoryTemplate : {};
	      if (block.length) {
	        block.map(function (item) {
	          if (item.isChecked === 'true' || item.isChecked === true) {
	            var selectedTemplate = item.value;
	            _this2.setState({ selectedTemplate: selectedTemplate });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'showAllTerms',
	    value: function showAllTerms(taxonomy, index) {
	      var columnSize = void 0;
	      columnSize = (0, _classnames2.default)({
	        'flex-lg-12': this.props.block.categorySettings.desktop_hd === '1',
	        'flex-lg-6': this.props.block.categorySettings.desktop_hd === '2',
	        'flex-lg-4': this.props.block.categorySettings.desktop_hd === '3',
	        'flex-lg-3': this.props.block.categorySettings.desktop_hd === '4',
	        'flex-md-12': this.props.block.categorySettings.desktop === '1',
	        'flex-md-6': this.props.block.categorySettings.desktop === '2',
	        'flex-md-4': this.props.block.categorySettings.desktop === '3',
	        'flex-md-3': this.props.block.categorySettings.desktop === '4',
	        'flex-sm-6': this.props.block.categorySettings.tablet === '2',
	        'flex-sm-12': this.props.block.categorySettings.tablet === '1',
	        'flex-sm-4': this.props.block.categorySettings.tablet === '3',
	        'flex-xs-6': this.props.block.categorySettings.mobile === '2',
	        'flex-xs-12': this.props.block.categorySettings.mobile === '1'
	      });
	      this.ComponentName = ReactiveTemplateCategories[this.state.selectedTemplate];
	      return _react2.default.createElement(
	        'div',
	        { className: columnSize, key: 'templateCategory-' + index },
	        _react2.default.createElement(this.ComponentName, { taxonomy: taxonomy })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var categorySettings = this.props.block.categorySettings ? this.props.block.categorySettings : {};
	      var settingsData = this.props.settingsData;
	
	      var allTermsCategory = [];
	      var numberOfCategories = categorySettings.numberOfCategories ? categorySettings.numberOfCategories : null;
	      var loadMoreOption = categorySettings.loadMoreOption ? categorySettings.loadMoreOption : null;
	      var viewMoreLink = categorySettings.viewMoreLink ? categorySettings.viewMoreLink : null;
	      var categoryLoadMoreOption = {
	        viewMoreLink: viewMoreLink
	      };
	      var ThemeComponent = window.ReactiveTheme[settingsData.theme] !== undefined ? window.ReactiveTheme[settingsData.theme].bar : {};
	      var term = '';
	      if (categorySettings.hasOwnProperty('termName')) {
	        term = categorySettings.termName.value;
	      }
	      var terms = this.props.helperData.terms;
	
	      var allTerms = [];
	      if (terms.hasOwnProperty(term)) {
	        allTerms = terms[term].linear;
	      }
	      for (var i = 0; i < numberOfCategories; i++) {
	        if (allTerms[i] !== undefined) {
	          allTermsCategory[i] = allTerms[i];
	        } else {
	          break;
	        }
	      }
	      var ifOpen = this.props.isToggle ? 'active' + ' ' + 'rq-category-container' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: ifOpen },
	        this.props.isToggle ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-row' },
	            allTermsCategory.map(this.showAllTerms)
	          ),
	          loadMoreOption === 'true' ? _react2.default.createElement(
	            'div',
	            { className: 'rq-loadmore-button' },
	            _react2.default.createElement(ThemeComponent.categoryLoadMore, categoryLoadMoreOption)
	          ) : null,
	          ' '
	        ) : null
	      );
	    }
	  }]);
	
	  return CategoryBlock;
	}(_react2.default.Component);
	
	CategoryBlock.propTypes = {
	  'allLayout': _react2.default.PropTypes.array,
	  'settingsData': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'isToggle': _react2.default.PropTypes.bool
	};
	
	exports.default = CategoryBlock;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShowCategoryTemplateThree = function (_Component) {
	  _inherits(ShowCategoryTemplateThree, _Component);
	
	  function ShowCategoryTemplateThree() {
	    _classCallCheck(this, ShowCategoryTemplateThree);
	
	    return _possibleConstructorReturn(this, (ShowCategoryTemplateThree.__proto__ || Object.getPrototypeOf(ShowCategoryTemplateThree)).apply(this, arguments));
	  }
	
	  _createClass(ShowCategoryTemplateThree, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var showTermMeta = function showTermMeta(TermMeta, index) {
	        var imgStyle = {
	          backgroundImage: 'url(' + TermMeta.thumbnail_image.image_big_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center'
	        };
	        return _react2.default.createElement(
	          'div',
	          { className: 'category-with-img', key: 'metaKey-' + index },
	          _react2.default.createElement(
	            'a',
	            { href: _this2.props.taxonomy.permalink, style: imgStyle, className: 'category-normal' },
	            _react2.default.createElement('div', { className: 'img-overlay' }),
	            _react2.default.createElement(
	              'h5',
	              null,
	              _this2.props.taxonomy.value
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'post-text' },
	              _react2.default.createElement(
	                'p',
	                null,
	                _this2.props.taxonomy.description.slice(0, 100)
	              )
	            )
	          )
	        );
	      };
	      var imgStyle = {
	        backgroundSize: 'cover',
	        backgroundPosition: 'center center'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'rq-image-grid' },
	        this.props.taxonomy.term_meta ? this.props.taxonomy.term_meta.map(showTermMeta) : '',
	        this.props.taxonomy.term_meta.length === 0 ? _react2.default.createElement(
	          'div',
	          { className: 'category-with-img' },
	          _react2.default.createElement(
	            'a',
	            { href: this.props.taxonomy.permalink, style: imgStyle, className: 'category-normal' },
	            _react2.default.createElement(
	              'div',
	              { className: 'img-overlay' },
	              _react2.default.createElement('i', { className: 'fa fa-frown-o' })
	            ),
	            _react2.default.createElement(
	              'h5',
	              { className: this.props.taxonomy.description ? 'with-desc' : '' },
	              this.props.taxonomy.value
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                this.props.taxonomy.description.slice(0, 100)
	              )
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return ShowCategoryTemplateThree;
	}(_react.Component);
	
	ShowCategoryTemplateThree.propTypes = {
	  'taxonomy': _react2.default.PropTypes.object
	};
	ReactiveTemplateCategories['showCategoryTemplateThree'] = ShowCategoryTemplateThree;
	
	ReactiveCategories.push({
	  'key': 'showCategoryTemplateThree',
	  // 'image_url': API.IMG + 'effect-steve.jpg',
	  'type': 'all'
	});

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShowCategoryTemplateTwo = function (_Component) {
	  _inherits(ShowCategoryTemplateTwo, _Component);
	
	  function ShowCategoryTemplateTwo() {
	    _classCallCheck(this, ShowCategoryTemplateTwo);
	
	    return _possibleConstructorReturn(this, (ShowCategoryTemplateTwo.__proto__ || Object.getPrototypeOf(ShowCategoryTemplateTwo)).apply(this, arguments));
	  }
	
	  _createClass(ShowCategoryTemplateTwo, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var showTermMeta = function showTermMeta(TermMeta, index) {
	        var imgStyle = {
	          backgroundImage: 'url(' + TermMeta.thumbnail_image.image_big_url + ')',
	          backgroundSize: 'cover',
	          backgroundPosition: 'center center'
	        };
	        return _react2.default.createElement(
	          'div',
	          { key: 'showCategory-' + index, className: 'category-with-img' },
	          _react2.default.createElement(
	            'a',
	            { style: imgStyle, href: _this2.props.taxonomy.permalink, className: 'category-normal' },
	            _react2.default.createElement('div', { className: 'img-overlay' }),
	            _react2.default.createElement(
	              'h5',
	              null,
	              _this2.props.taxonomy.value
	            )
	          )
	        );
	      };
	      var imgStyle = {
	        backgroundSize: 'cover',
	        backgroundPosition: 'center center'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'rq-image-grid' },
	        this.props.taxonomy.term_meta ? this.props.taxonomy.term_meta.map(showTermMeta) : null,
	        this.props.taxonomy.term_meta.length === 0 ? _react2.default.createElement(
	          'div',
	          { className: 'category-with-img' },
	          _react2.default.createElement(
	            'a',
	            { href: this.props.taxonomy.permalink, className: 'category-normal', style: imgStyle },
	            _react2.default.createElement(
	              'div',
	              { className: 'img-overlay' },
	              _react2.default.createElement('i', { className: 'fa fa-frown-o' })
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              this.props.taxonomy.value
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return ShowCategoryTemplateTwo;
	}(_react.Component);
	
	ShowCategoryTemplateTwo.propTypes = {
	  'taxonomy': _react2.default.PropTypes.object
	};
	ReactiveTemplateCategories['showCategoryTemplateTwo'] = ShowCategoryTemplateTwo;
	
	ReactiveCategories.push({
	  'key': 'showCategoryTemplateTwo',
	  // 'image_url': API.IMG + 'effect-steve.jpg',
	  'type': 'all'
	});

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShowCategoryTemplate = function (_Component) {
	  _inherits(ShowCategoryTemplate, _Component);
	
	  function ShowCategoryTemplate() {
	    _classCallCheck(this, ShowCategoryTemplate);
	
	    return _possibleConstructorReturn(this, (ShowCategoryTemplate.__proto__ || Object.getPrototypeOf(ShowCategoryTemplate)).apply(this, arguments));
	  }
	
	  _createClass(ShowCategoryTemplate, [{
	    key: "handleClick",
	    value: function handleClick(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "rq-image-grid" },
	        _react2.default.createElement(
	          "a",
	          { href: this.props.taxonomy.permalink, className: "category-normal" },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "h5",
	              null,
	              this.props.taxonomy.value
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "post-text" },
	              _react2.default.createElement(
	                "p",
	                null,
	                this.props.taxonomy.description.slice(0, 100)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ShowCategoryTemplate;
	}(_react.Component);
	
	ShowCategoryTemplate.propTypes = {
	  'taxonomy': _react2.default.PropTypes.object
	};
	ReactiveTemplateCategories['showCategoryTemplate'] = ShowCategoryTemplate;
	
	ReactiveCategories.push({
	  'key': 'showCategoryTemplate',
	  'image_url': API.IMG + 'do-post-grid.jpg',
	  'type': 'all'
	});

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(561);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserBlock = function (_React$Component) {
	  _inherits(UserBlock, _React$Component);
	
	  function UserBlock(props) {
	    _classCallCheck(this, UserBlock);
	
	    var _this = _possibleConstructorReturn(this, (UserBlock.__proto__ || Object.getPrototypeOf(UserBlock)).call(this, props));
	
	    _this.displayName = 'UserBlock';
	    _this.showAllPosts = _this.showAllPosts.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserBlock, [{
	    key: 'showAllPosts',
	    value: function showAllPosts(post, index) {
	      this.ComponentName = ReactiveTemplates['doPostStandard'];
	      return _react2.default.createElement(this.ComponentName, { post: post, key: 'userBlock-' + index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var posts = this.props.previewOption ? this.props.previewOption.data : [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex-row' },
	        posts.length ? posts.map(this.showAllPosts) : null
	      );
	    }
	  }]);
	
	  return UserBlock;
	}(_react2.default.Component);
	
	UserBlock.propTypes = {
	  'helperData': _react2.default.PropTypes.object,
	  'previewOption': _react2.default.PropTypes.object,
	  'allLayout': _react2.default.PropTypes.array,
	  'helperData.posts': _react2.default.PropTypes.object,
	  'helperData.posts.data': _react2.default.PropTypes.array
	};
	
	exports.default = UserBlock;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	var _panelActions = __webpack_require__(475);
	
	var _panelActions2 = _interopRequireDefault(_panelActions);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var SearchBlock = function (_React$Component) {
	  _inherits(SearchBlock, _React$Component);
	
	  function SearchBlock(props) {
	    _classCallCheck(this, SearchBlock);
	
	    var _this = _possibleConstructorReturn(this, (SearchBlock.__proto__ || Object.getPrototypeOf(SearchBlock)).call(this, props));
	
	    _this.state = {
	      isEditable: API.isEditable ? true : false
	    };
	    return _this;
	  }
	
	  _createClass(SearchBlock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ isEditable: this.props.isEditable });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.isEditable) {
	        $('.sortable').sortable({
	          handle: '.block-shortable',
	          stop: this.handleSort.bind(this)
	        });
	        $('.sortable').disableSelection();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.allLayout = (0, _clone2.default)(nextProps.allLayout);
	      this.setState({ isEditable: nextProps.isEditable });
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(event) {
	      var _this2 = this;
	
	      var sortedsearchAttr = [];
	      $(event.target).children().each(function (index, item) {
	        var childUid = String($(item).data('uid'));
	        if (childUid !== 'undefined') {
	          var filteredAttr = _.where(_this2.props.searchAttr, { uid: childUid });
	          if (filteredAttr.length) {
	            sortedsearchAttr.push(filteredAttr[0]);
	          }
	        }
	      });
	      var targetLayout = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (targetLayout !== -1) {
	        this.allLayout[targetLayout].searchAttr = sortedsearchAttr;
	      }
	      var pushLayout = {
	        'allLayout': this.allLayout,
	        'shortcodeKey': this.props.shortcodeKey,
	        'return': 'dont'
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	    }
	  }, {
	    key: 'deleteSearch',
	    value: function deleteSearch(uid, e) {
	      e.preventDefault();
	      var find = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      if (find !== -1) {
	        var findSearchAttr = (0, _underscore.findIndex)(this.allLayout[find].searchAttr, { uid: uid });
	        if (findSearchAttr !== -1) {
	          this.allLayout[find].searchAttr.splice(findSearchAttr, 1);
	        }
	      }
	      var pushLayout = {
	        'allLayout': this.allLayout,
	        'shortcodeKey': this.props.shortcodeKey
	      };
	      _builderActions2.default.saveAllBlocks(pushLayout);
	    }
	  }, {
	    key: 'editSearch',
	    value: function editSearch(search, e) {
	      e.preventDefault();
	      _panelActions2.default.togglePanel('search-' + search.viewType, this.props.shortcodeKey, this.props.uid, search.uid);
	    }
	  }, {
	    key: 'capitalize',
	    value: function capitalize(text) {
	      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props;
	      var previewData = _props.previewData;
	      var settingsData = _props.settingsData;
	
	      this.allLayout = (0, _clone2.default)(this.props.allLayout);
	      var indexOfPresentSearchBlock = (0, _underscore.findIndex)(this.allLayout, { uid: this.props.uid });
	      var templateType = this.allLayout[indexOfPresentSearchBlock].styleTemplate === undefined ? 'default' : this.allLayout[indexOfPresentSearchBlock].styleTemplate;
	      var template = null;
	      var customCssClass = this.allLayout[indexOfPresentSearchBlock].customCssClass;
	      switch (templateType) {
	        case 'dropdown':
	          template = 'dropdown';
	          break;
	        default:
	          template = 'default';
	          break;
	      }
	      var showSearchAttr = function showSearchAttr(search, index) {
	        if (_this3.props.isToggle === false || _this3.props.isToggle === 'false') return;
	        var self = _this3;
	        var showSearchComponent = void 0;
	        var presentSearchBlockTemplates = window.ReactiveTheme[settingsData.theme].search[template];
	        var indexOfsearchItem = (0, _underscore.findIndex)(presentSearchBlockTemplates, { type: search.viewType });
	        if (indexOfsearchItem !== -1) {
	          var searchItem = presentSearchBlockTemplates[indexOfsearchItem];
	          showSearchComponent = _react2.default.createElement(searchItem.component, _extends({ previewData: previewData, block: search, dropdonwtoggle: _this3.props.dropdonwtoggle }, _this3.props, { urlData: _this3.props.urlData }));
	        }
	        var customClassName = _this3.allLayout[indexOfPresentSearchBlock].styleType;
	        return _react2.default.createElement(
	          'div',
	          { className: customClassName === 'horizontal' ? 'horizontal-elements' : null, key: 'showSearchElement-' + index, 'data-uid': search.uid, 'data-type': search.viewType, 'data-parent': _this3.props.uid },
	          _this3.state.isEditable ? _react2.default.createElement(
	            'div',
	            { className: 'child-block-handle' },
	            _react2.default.createElement(
	              'a',
	              { href: '#', className: 'block-shortable' },
	              _react2.default.createElement('i', { className: 'fa fa-ellipsis-h' })
	            ),
	            _react2.default.createElement(
	              'label',
	              { style: { marginLeft: '30px' } },
	              _this3.capitalize(search.viewType)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'block-edit-button' },
	              _react2.default.createElement(
	                'a',
	                { className: 'edit-button', href: '#', onClick: self.editSearch.bind(self, search) },
	                _react2.default.createElement('i', { className: 'fa fa-pencil' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'hidden-button-block' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#', onClick: self.deleteSearch.bind(self, search.uid) },
	                    _react2.default.createElement('i', { className: 'fa fa-times' })
	                  )
	                )
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'search-field-content' },
	            _this3.props.urlData ? showSearchComponent : null
	          )
	        );
	      };
	      var parentClass = (0, _classnames2.default)({
	        'sortable': true,
	        'horizontal-parent': this.allLayout[indexOfPresentSearchBlock].styleType === 'horizontal',
	        'horizontal-parent-dropdown': this.allLayout[indexOfPresentSearchBlock].styleTemplate === 'dropdown'
	      });
	      var ifOpen = this.props.isToggle ? 'active' + ' ' + 'rq-reactive-search-container' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: ifOpen + ' ' + parentClass + ' ' },
	        this.props.searchAttr.map(showSearchAttr)
	      );
	    }
	  }]);
	
	  return SearchBlock;
	}(_react2.default.Component);
	
	SearchBlock.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'settingsData': _react2.default.PropTypes.object,
	  'searchAttr': _react2.default.PropTypes.array,
	  'allLayout': _react2.default.PropTypes.array,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'uid': _react2.default.PropTypes.string,
	  'urlData': _react2.default.PropTypes.object,
	  'isToggle': _react2.default.PropTypes.bool
	};
	
	exports.default = SearchBlock;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoverStore = __webpack_require__(691);
	
	var _hoverStore2 = _interopRequireDefault(_hoverStore);
	
	var _underscore = __webpack_require__(205);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var MapBlock = function (_React$Component) {
	  _inherits(MapBlock, _React$Component);
	
	  function MapBlock(props) {
	    _classCallCheck(this, MapBlock);
	
	    var _this = _possibleConstructorReturn(this, (MapBlock.__proto__ || Object.getPrototypeOf(MapBlock)).call(this, props));
	
	    _this.displayName = 'MapBlock';
	
	    _this.setMarkers = _this.setMarkers.bind(_this);
	    _this.closeAllInfoWindow = _this.closeAllInfoWindow.bind(_this);
	    _this.handleGeolocation = _this.handleGeolocation.bind(_this);
	    _this.browserGeolocationSuccess = _this.browserGeolocationSuccess.bind(_this);
	    _this.browserGeolocationFail = _this.browserGeolocationFail.bind(_this);
	    _this.tryAPIGeolocation = _this.tryAPIGeolocation.bind(_this);
	    _this.markers = [];
	    _this.infobox = [];
	    return _this;
	  }
	
	  _createClass(MapBlock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var targetMap = document.getElementById('reactiveMap');
	      var zoom = this.props.block.hasOwnProperty('zoom') ? parseInt(this.props.block.zoom, 10) : 3;
	      this.zoom = zoom;
	      if ($('#reactiveMap')) {
	        window.reactiveMap = new google.maps.Map(targetMap, {
	          zoom: zoom,
	          center: new google.maps.LatLng(47.2532, -37.415),
	          scrollwheel: API.hasOwnProperty('isMobile') && parseInt(API['isMobile'], 10) === 1 ? false : true,
	          mapTypeId: google.maps.MapTypeId.ROADMAP
	        });
	        var input = document.getElementById('myMapGeolocation');
	        window.reactiveMap.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
	      }
	
	      this.setMarkers(this.props.previewOption.data);
	      _hoverStore2.default.listen(this.hoverMarker.bind(this));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setMarkers(nextProps.previewOption.data);
	    }
	  }, {
	    key: 'setMarkers',
	    value: function setMarkers(locations, geolocation) {
	      var _this2 = this;
	
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var markerIcon = 'default';
	      var markerTemplate = 'default';
	      var mapIndex = (0, _underscore.findIndex)(allLayout, { type: 'map' });
	      if (mapIndex !== -1) {
	        if (allLayout[mapIndex].hasOwnProperty('markerIcon')) {
	          markerIcon = allLayout[mapIndex]['markerIcon'];
	        }
	        if (allLayout[mapIndex].hasOwnProperty('markerTemplate')) {
	          markerTemplate = allLayout[mapIndex]['markerTemplate'];
	        }
	      }
	
	      var map = window.reactiveMap;
	      var markerBounds = new google.maps.LatLngBounds();
	      if (this.markers.length) {
	        for (var i = this.markers.length - 1; i >= 0; i--) {
	          this.markers[i].setMap(null);
	        }
	        this.markers = [];
	        this.infobox = [];
	        if (this.markerCluster !== undefined) {
	          this.markerCluster.clearMarkers();
	        }
	      }
	
	      locations.forEach(function (location) {
	        if (!location.meta.hasOwnProperty('latitude')) {
	          return;
	        }
	        if (location.meta.latitude && location.meta.longitude) {
	          (function () {
	            var myLatLng = new google.maps.LatLng(location.meta.latitude, location.meta.longitude);
	            markerBounds.extend(myLatLng);
	            var marker = new RichMarker({
	              position: myLatLng,
	              map: map,
	              ID: location.ID,
	              content: ReactiveMarkerIcon[markerIcon](location) });
	            var content = ReactiveMarkerTemplate[markerTemplate](location); // need to add theme support
	            var infowindow = new google.maps.InfoWindow({ content: content, position: myLatLng });
	            _this2.infobox.push(infowindow);
	            marker.addListener('click', function () {
	              infowindow.close();
	              infowindow.open(map, marker);
	              var iwOuter = $('.gm-style-iw');
	              var iwBackground = iwOuter.prev();
	              iwBackground.children(':nth-child(2)').css({ 'display': 'none' });
	              iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
	              iwBackground.css({ 'display': 'none' });
	              var iwCloseBtn = iwOuter.next();
	              iwCloseBtn.css({ opacity: '1', right: '57px', top: '25px' });
	            });
	            _this2.markers.push(marker);
	          })();
	        }
	      });
	      // for geolocation purpose
	      if (geolocation !== undefined) {
	        (function () {
	          var temp = {};
	          temp.post_title = 'My Current Location';
	          var myLatLng = new google.maps.LatLng(geolocation.latitude, geolocation.longitude);
	          markerBounds.extend(myLatLng);
	          var marker = new google.maps.Marker({
	            position: myLatLng,
	            map: map,
	            content: '<div class="marker-info">My Location</div>'
	          });
	          var content = ReactiveMarkerTemplate.default(temp);
	          var infowindow = new google.maps.InfoWindow({ content: content });
	          marker.addListener('click', function () {
	            infowindow.open(map, marker);
	          });
	          _this2.markers.push(marker);
	          infowindow.open(map, marker);
	        })();
	      }
	
	      this.markerCluster = new MarkerClusterer(map, this.markers);
	      map.fitBounds(markerBounds);
	    }
	  }, {
	    key: 'closeAllInfoWindow',
	    value: function closeAllInfoWindow() {
	      this.infobox.forEach(function (info) {
	        info.close();
	      });
	    }
	  }, {
	    key: 'hoverMarker',
	    value: function hoverMarker(post) {
	      if (post.hide) {
	        this.closeAllInfoWindow();
	      } else {
	        this.closeAllInfoWindow();
	        var findMarkerIndex = (0, _underscore.findIndex)(this.markers, { ID: post.ID });
	        if (findMarkerIndex !== -1) {
	          var marker = this.markers[findMarkerIndex];
	          google.maps.event.trigger(marker, 'click');
	        }
	      }
	    }
	  }, {
	    key: 'browserGeolocationSuccess',
	    value: function browserGeolocationSuccess(position) {
	      var geoData = {};
	      geoData['latitude'] = position.coords.latitude;
	      geoData['longitude'] = position.coords.longitude;
	      this.setMarkers(this.props.previewOption.data, geoData);
	    }
	  }, {
	    key: 'browserGeolocationFail',
	    value: function browserGeolocationFail(error) {
	      switch (error.code) {
	        case error.TIMEOUT:
	          console.log('Browser geolocation error !\n\nTimeout.');
	          break;
	        case error.PERMISSION_DENIED:
	          if (error.message.indexOf('Only secure origins are allowed') === 0) {
	            this.tryAPIGeolocation();
	          }
	          break;
	        case error.POSITION_UNAVAILABLE:
	          console.log('Browser geolocation error !\n\nPosition unavailable.');
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'tryAPIGeolocation',
	    value: function tryAPIGeolocation() {
	      var self = this;
	      jQuery.post('https://www.googleapis.com/geolocation/v1/geolocate?key=' + API.googlemap_key, function (success) {
	        self.browserGeolocationSuccess({ coords: { latitude: success.location.lat, longitude: success.location.lng } });
	      }).fail(function (err) {
	        console.log('API Geolocation error! \n\n' + err);
	      });
	    }
	  }, {
	    key: 'handleGeolocation',
	    value: function handleGeolocation(event) {
	      event.preventDefault();
	      window.navigator.geolocation.getCurrentPosition(this.browserGeolocationSuccess, this.browserGeolocationFail, { maximumAge: 50000, timeout: 20000, enableHighAccuracy: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var settingsData = this.props.settingsData;
	
	      var mapStyle = {
	        width: '100%',
	        height: this.props.block.hight ? parseInt(this.props.block.hight, 10) : '500px'
	      };
	      var ThemeComponent = window.ReactiveTheme[settingsData.theme];
	      var ifOpen = this.props.isToggle ? 'active' + ' ' + 'rq-map-container' : 'toggle-option-map';
	      return _react2.default.createElement(
	        'div',
	        { className: ifOpen },
	        ThemeComponent && _react2.default.createElement(ThemeComponent.map, { styles: mapStyle }),
	        _react2.default.createElement(
	          'button',
	          { type: 'button', className: 'map-location-button', id: 'myMapGeolocation', onClick: this.handleGeolocation },
	          API.LANG.MAP_YOUR_LOC
	        )
	      );
	    }
	  }]);
	
	  return MapBlock;
	}(_react2.default.Component);
	
	MapBlock.propTypes = {
	  block: _react2.default.PropTypes.object,
	  settingsData: _react2.default.PropTypes.object,
	  previewOption: _react2.default.PropTypes.object,
	  isToggle: _react2.default.PropTypes.bool,
	  'allLayout': _react2.default.PropTypes.array
	};
	
	exports.default = MapBlock;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _hoverAction = __webpack_require__(683);
	
	var _hoverAction2 = _interopRequireDefault(_hoverAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  listenables: _hoverAction2.default,
	  onPushHoverData: function onPushHoverData(post) {
	    this.trigger(post);
	  }
	});

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(693);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _createLocation2 = __webpack_require__(694);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _createBrowserHistory = __webpack_require__(698);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	exports.createHistory = _createBrowserHistory2['default'];
	
	var _createHashHistory2 = __webpack_require__(709);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	exports.createHashHistory = _createHashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(710);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];
	
	var _useBasename2 = __webpack_require__(711);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	exports.useBasename = _useBasename3['default'];
	
	var _useBeforeUnload2 = __webpack_require__(712);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	exports.useBeforeUnload = _useBeforeUnload3['default'];
	
	var _useQueries2 = __webpack_require__(713);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	exports.useQueries = _useQueries3['default'];
	
	var _Actions2 = __webpack_require__(695);
	
	var _Actions3 = _interopRequireDefault(_Actions2);
	
	exports.Actions = _Actions3['default'];
	
	// deprecated
	
	var _enableBeforeUnload2 = __webpack_require__(716);
	
	var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);
	
	exports.enableBeforeUnload = _enableBeforeUnload3['default'];
	
	var _enableQueries2 = __webpack_require__(717);
	
	var _enableQueries3 = _interopRequireDefault(_enableQueries2);
	
	exports.enableQueries = _enableQueries3['default'];
	var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
	exports.createLocation = createLocation;

/***/ },
/* 693 */
/***/ function(module, exports) {

	//import warning from 'warning'
	
	"use strict";
	
	exports.__esModule = true;
	function deprecate(fn) {
	  return fn;
	  //return function () {
	  //  warning(false, '[history] ' + message)
	  //  return fn.apply(this, arguments)
	  //}
	}
	
	exports["default"] = deprecate;
	module.exports = exports["default"];

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	//import warning from 'warning'
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Actions = __webpack_require__(695);
	
	var _parsePath = __webpack_require__(696);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _parsePath2['default'](location);
	
	  if (typeof action === 'object') {
	    //warning(
	    //  false,
	    //  'The state (2nd) argument to createLocation is deprecated; use a ' +
	    //  'location descriptor instead'
	    //)
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 695 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _extractPath = __webpack_require__(697);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	function parsePath(path) {
	  var pathname = _extractPath2['default'](path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}
	
	exports['default'] = parsePath;
	module.exports = exports['default'];

/***/ },
/* 697 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	exports["default"] = extractPath;
	module.exports = exports["default"];

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(237);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(695);
	
	var _ExecutionEnvironment = __webpack_require__(699);
	
	var _DOMUtils = __webpack_require__(700);
	
	var _DOMStateStorage = __webpack_require__(701);
	
	var _createDOMHistory = __webpack_require__(702);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(696);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    historyState = historyState || window.history.state || {};
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null, path);
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 699 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 700 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  // FIXME: Work around our browser history not working correctly on Chrome
	  // iOS: https://github.com/rackt/react-router/issues/2565
	  if (ua.indexOf('CriOS') !== -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededError = 'QuotaExceededError';
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (error.name === QuotaExceededError && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(237);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(699);
	
	var _DOMUtils = __webpack_require__(700);
	
	var _createHistory = __webpack_require__(703);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	//import warning from 'warning'
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deepEqual = __webpack_require__(704);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _AsyncUtils = __webpack_require__(707);
	
	var _Actions = __webpack_require__(695);
	
	var _createLocation2 = __webpack_require__(694);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(708);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(696);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(693);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var keyLength = options.keyLength;
	  var getUserConfirmation = options.getUserConfirmation;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	      //warning(
	      //  false,
	      //  'The state (2nd) argument to history.createLocation is deprecated; use a ' +
	      //  'location descriptor instead'
	      //)
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(705);
	var isArguments = __webpack_require__(706);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 705 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 706 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 707 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0;
	  var isDone = false;
	
	  function done() {
	    isDone = true;
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) return;
	
	    if (currentTurn < turns) {
	      work.call(this, currentTurn++, next, done);
	    } else {
	      done.apply(this, arguments);
	    }
	  }
	
	  next();
	}

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(237);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(695);
	
	var _ExecutionEnvironment = __webpack_require__(699);
	
	var _DOMUtils = __webpack_require__(700);
	
	var _DOMStateStorage = __webpack_require__(701);
	
	var _createDOMHistory = __webpack_require__(702);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(696);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(237);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(695);
	
	var _createHistory = __webpack_require__(703);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _parsePath = __webpack_require__(696);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var key = entry.key;
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var state = undefined;
	    if (key) {
	      state = readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	      entry.key = key;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _ExecutionEnvironment = __webpack_require__(699);
	
	var _runTransitionHook = __webpack_require__(708);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _extractPath = __webpack_require__(697);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	var _parsePath = __webpack_require__(696);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(693);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var basename = options.basename;
	
	    var historyOptions = _objectWithoutProperties(options, ['basename']);
	
	    var history = createHistory(historyOptions);
	
	    // Automatically use the value of <base href> in HTML
	    // documents as basename if it's not explicitly given.
	    if (basename == null && _ExecutionEnvironment.canUseDOM) {
	      var base = document.getElementsByTagName('base')[0];
	
	      if (base) basename = _extractPath2['default'](base.href);
	    }
	
	    function addBasename(location) {
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation() {
	      return addBasename(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(699);
	
	var _DOMUtils = __webpack_require__(700);
	
	var _deprecate = __webpack_require__(693);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
	  function listener(event) {
	    var message = getBeforeUnloadPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	  }
	
	  _DOMUtils.addEventListener(window, 'beforeunload', listener);
	
	  return function () {
	    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
	  };
	}
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	function useBeforeUnload(createHistory) {
	  return function (options) {
	    var history = createHistory(options);
	
	    var stopBeforeUnloadListener = undefined;
	    var beforeUnloadHooks = [];
	
	    function getBeforeUnloadPromptMessage() {
	      var message = undefined;
	
	      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
	        message = beforeUnloadHooks[i].call();
	      }return message;
	    }
	
	    function listenBeforeUnload(hook) {
	      beforeUnloadHooks.push(hook);
	
	      if (beforeUnloadHooks.length === 1) {
	        if (_ExecutionEnvironment.canUseDOM) {
	          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	        } else {
	           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
	        }
	      }
	
	      return function () {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
	          stopBeforeUnloadListener();
	          stopBeforeUnloadListener = null;
	        }
	      };
	    }
	
	    // deprecated
	    function registerBeforeUnloadHook(hook) {
	      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
	        beforeUnloadHooks.push(hook);
	
	        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	      }
	    }
	
	    // deprecated
	    function unregisterBeforeUnloadHook(hook) {
	      if (beforeUnloadHooks.length > 0) {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
	      }
	    }
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload,
	
	      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
	      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
	    });
	  };
	}
	
	exports['default'] = useBeforeUnload;
	module.exports = exports['default'];

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(714);
	
	var _runTransitionHook = __webpack_require__(708);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(696);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(693);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    var historyOptions = _objectWithoutProperties(options, ['stringifyQuery', 'parseQueryString']);
	
	    var history = createHistory(historyOptions);
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var queryString = undefined;
	      if (!query || (queryString = stringifyQuery(query)) === '') return location;
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase + (searchBase ? '&' : '?') + queryString;
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	      //warning(
	      //  !query,
	      //  'the query argument to createPath is deprecated; use a location descriptor instead'
	      //)
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	      //warning(
	      //  !query,
	      //  'the query argument to createHref is deprecated; use a location descriptor instead'
	      //)
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation() {
	      return addQuery(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(715);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 715 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(693);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useBeforeUnload = __webpack_require__(712);
	
	var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);
	
	exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
	module.exports = exports['default'];

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(693);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useQueries = __webpack_require__(713);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
	module.exports = exports['default'];

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	var _history = __webpack_require__(692);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var history = (0, _history.useQueries)(_history.createHistory)();
	var _window = window;
	var searchArray = _window.searchArray;
	
	var UrlHandlerStore = _reflux2.default.createStore({
	  listenables: _urlHandlerActions2.default,
	  init: function init() {
	    var _this = this;
	
	    this.allData = {};
	    history.listen(function (location) {
	      _this.allData = location.query;
	    });
	
	    this.itemSearch = [];
	    var hash = '';
	    var hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
	    for (var i = 0; i < hashes.length; i++) {
	      hash = hashes[i].split('=');
	      var temp = {};
	      if (hash[0].length !== 0) {
	        temp.key = hash[0];
	        temp.value = hash[1];
	        this.itemSearch.push(hash[1]);
	        // searchArray.push(temp);
	      }
	    }
	  },
	  processData: function processData(data) {
	    var _this2 = this;
	
	    // Taxonomies handling
	    ReactiveFanoutData.urlData = data;
	    var finalQueryString = '';
	    if (data.searchType === 'taxonomies' || data.searchType === 'metakeys' || data.searchType === 'globalSearch') {
	      (function () {
	        _this2.allData[data.searchItem] = [];
	        var newValues = [];
	
	        (function () {
	          switch (data.searchField) {
	            case 'mapField':
	              var popIndexMap = (0, _underscore.findIndex)(searchArray, { key: data.searchItem });
	              if (popIndexMap !== -1) {
	                var index = _.indexOf(_this2.itemSearch, searchArray[popIndexMap].value);
	                _this2.itemSearch.splice(index, 1);
	                searchArray.splice(popIndexMap, 1);
	              }
	              _this2.allData[data.searchItem] = data.values;
	              var tempMap = {};
	              popIndexMap = (0, _underscore.findIndex)(searchArray, { key: data.searchItem });
	              if (popIndexMap !== -1) {
	                var _index = _.indexOf(_this2.itemSearch, searchArray[popIndexMap].value);
	                _this2.itemSearch.splice(_index, 1);
	                searchArray.splice(popIndexMap, 1);
	              }
	              tempMap.key = data.searchItem;
	              tempMap.value = data.values;
	              _this2.itemSearch.push(data.values);
	              searchArray.push(tempMap);
	              var popIndexPageMap = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPageMap !== -1) {
	                var _index2 = _.indexOf(_this2.itemSearch, searchArray[popIndexPageMap].value);
	                if (_index2 !== -1) {
	                  _this2.itemSearch.splice(_index2, 1);
	                  searchArray.splice(_index2, 1);
	                }
	              }
	              var tempPageMap = {};
	              tempPageMap.key = 'pagenumber';
	              tempPageMap.value = 1;
	              _this2.itemSearch.push(tempPageMap.value);
	              searchArray.push(tempPageMap);
	              break;
	            case 'topListOrGrid':
	              if (data.values.length === 1) {
	                newValues[0] = data.values[0];
	              }
	              _this2.allData[data.searchItem] = newValues;
	              var popIndexForViewType = (0, _underscore.findIndex)(searchArray, { key: data.searchItem });
	              if (popIndexForViewType !== -1) {
	                var _index3 = _.indexOf(_this2.itemSearch, searchArray[popIndexForViewType].value);
	                _this2.itemSearch.splice(_index3, 1);
	                searchArray.splice(popIndexForViewType, 1);
	              }
	              var tempForViewType = {};
	              tempForViewType.key = data.searchItem;
	              tempForViewType.value = newValues[0];
	              _this2.itemSearch.push(newValues[0]);
	              searchArray.push(tempForViewType);
	              var popIndexPageView = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPageView !== -1) {
	                var _index4 = _.indexOf(_this2.itemSearch, searchArray[popIndexPageView].value);
	                if (_index4 !== -1) {
	                  _this2.itemSearch.splice(_index4, 1);
	                  searchArray.splice(_index4, 1);
	                }
	              }
	              var tempPageView = {};
	              tempPageView.key = 'pagenumber';
	              tempPageView.value = 1;
	              _this2.itemSearch.push(tempPageView.value);
	              searchArray.push(tempPageView);
	              break;
	            case 'pagination':
	              if (data.pageNumber) {
	                newValues[0] = data.pageNumber;
	              }
	              _this2.allData[data.searchItem] = newValues;
	              var popIndexForPagination = (0, _underscore.findIndex)(searchArray, { key: data.searchItem });
	              if (popIndexForPagination !== -1) {
	                var _index5 = _.indexOf(_this2.itemSearch, searchArray[popIndexForPagination].value);
	                _this2.itemSearch.splice(_index5, 1);
	                searchArray.splice(popIndexForPagination, 1);
	              }
	              var tempForPagination = {};
	              tempForPagination.key = data.searchItem;
	              tempForPagination.value = newValues[0];
	              _this2.itemSearch.push(newValues[0]);
	              searchArray.push(tempForPagination);
	              break;
	            case 'daterange':
	              if (data.values.length === 2) {
	                newValues.push(data.values[0]);
	                newValues.push(data.values[1]);
	              }
	              delete _this2.allData[data.searchItem];
	              delete _this2.allData[data.searchItem + '[start]'];
	              delete _this2.allData[data.searchItem + '[end]'];
	              if (newValues.length === 2) {
	                _this2.allData[data.searchItem + '[start]'] = newValues[0];
	                _this2.allData[data.searchItem + '[end]'] = newValues[1];
	                var tempForStart = {};
	                tempForStart.metakey = data.searchItem;
	                tempForStart.key = data.searchItem + '[start]';
	                tempForStart.value = newValues[0];
	                var tempForEnd = {};
	                tempForEnd.key = data.searchItem + '[end]';
	                tempForEnd.metakey = data.searchItem;
	                tempForEnd.value = newValues[1];
	                var popIndexForStart = (0, _underscore.findIndex)(searchArray, { key: tempForStart.key });
	                var popIndexForEnd = (0, _underscore.findIndex)(searchArray, { key: tempForEnd.key });
	                if (popIndexForEnd !== -1) {
	                  searchArray.splice(popIndexForEnd, 1);
	                  _this2.itemSearch.splice(popIndexForEnd, 1);
	                }
	                if (popIndexForStart !== -1) {
	                  searchArray.splice(popIndexForStart, 1);
	                  _this2.itemSearch.splice(popIndexForStart, 1);
	                }
	                searchArray.push(tempForStart);
	                searchArray.push(tempForEnd);
	                _this2.itemSearch.push(newValues[0]);
	                _this2.itemSearch.push(newValues[1]);
	              }
	              var popIndexPageDRange = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPageDRange !== -1) {
	                var _index6 = _.indexOf(_this2.itemSearch, searchArray[popIndexPageDRange].value);
	                if (_index6 !== -1) {
	                  _this2.itemSearch.splice(_index6, 1);
	                  searchArray.splice(_index6, 1);
	                }
	              }
	              var tempPageDRange = {};
	              tempPageDRange.key = 'pagenumber';
	              tempPageDRange.value = 1;
	              _this2.itemSearch.push(tempPageDRange.value);
	              searchArray.push(tempPageDRange);
	              break;
	            case 'searchAttrTopBar':
	              if (data.viewType === 'rangeinput') {
	                var _index7 = (0, _underscore.findIndex)(searchArray, { 'metakey': data.rangeKey });
	                searchArray.splice(_index7 + 1, 1);
	                _this2.itemSearch.splice(_index7 + 1, 1);
	                searchArray.splice(_index7, 1);
	                _this2.itemSearch.splice(_index7, 1);
	              } else if (data.viewType === 'rnb-daterange') {
	                var endIndex = null;
	                var startIndex = null;
	                for (var i = 0; i < searchArray.length; i++) {
	                  if (searchArray[i].key.indexOf('[end]') !== -1) {
	                    endIndex = i;
	                  }
	                  if (searchArray[i].key.indexOf('[start]') !== -1) {
	                    startIndex = i;
	                  }
	                }
	                if (startIndex > endIndex) {
	                  searchArray.splice(startIndex, 1);
	                  _this2.itemSearch.splice(startIndex, 1);
	                  searchArray.splice(endIndex, 1);
	                  _this2.itemSearch.splice(endIndex, 1);
	                } else {
	                  searchArray.splice(endIndex, 1);
	                  _this2.itemSearch.splice(endIndex, 1);
	                  searchArray.splice(startIndex, 1);
	                  _this2.itemSearch.splice(startIndex, 1);
	                }
	              } else if (data.viewType === 'daterange') {
	                var _endIndex = null;
	                var _startIndex = null;
	                for (var _i = 0; _i < searchArray.length; _i++) {
	                  if (searchArray[_i].key.indexOf('[end]') !== -1) {
	                    _endIndex = _i;
	                  }
	                  if (searchArray[_i].key.indexOf('[start]') !== -1) {
	                    _startIndex = _i;
	                  }
	                }
	                if (_startIndex > _endIndex) {
	                  searchArray.splice(_startIndex, 1);
	                  _this2.itemSearch.splice(_startIndex, 1);
	                  searchArray.splice(_endIndex, 1);
	                  _this2.itemSearch.splice(_endIndex, 1);
	                } else {
	                  searchArray.splice(_endIndex, 1);
	                  _this2.itemSearch.splice(_endIndex, 1);
	                  searchArray.splice(_startIndex, 1);
	                  _this2.itemSearch.splice(_startIndex, 1);
	                }
	              } else if (data.viewType === 'combobox') {
	                (function () {
	                  var index = (0, _underscore.findIndex)(searchArray, { value: data.value });
	                  searchArray.splice(index, 1); // remove the item that's being clicked on topbar
	                  _this2.itemSearch.splice(index, 1);
	                  var findParentOfChild = function findParentOfChild() {
	                    // Recursive function to find the parent of children
	                    _this2.itemSearch.map(function (item, itemIndex) {
	                      var index1 = (0, _underscore.findIndex)(data.linearData, { slug: item }); // find the item index in liniear array
	                      var index2 = '';
	                      if (index1 !== -1) {
	                        index2 = (0, _underscore.findIndex)(data.linearData, { key: data.linearData[index1].parent }); // find the items parent index in linear array
	                      }
	                      if (index2 !== '') {
	                        if (index2 !== -1) {
	                          var index3 = _.indexOf(_this2.itemSearch, data.linearData[index2].slug); // search the parent item is available on itemsearch array or not
	                          if (index3 === -1) {
	                            // if the parent of child item is not available than remove it from array
	                            searchArray.splice(itemIndex, 1);
	                            _this2.itemSearch.splice(itemIndex, 1);
	                            findParentOfChild(_this2.itemSearch);
	                          }
	                        }
	                      }
	                    });
	                  };
	                  findParentOfChild();
	                })();
	              } else {
	                var searchArrayTemp = (0, _clone2.default)(searchArray);
	                searchArrayTemp.map(function (popItem, popIndex) {
	                  if (popItem.key === data.key && popItem.value === data.value) {
	                    searchArray.splice(popIndex, 1);
	                    _this2.itemSearch.splice(popIndex, 1);
	                  }
	                });
	                // const index = findIndex(searchArray, { value: data.value });
	              }
	              var popIndexPageTopBar = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPageTopBar !== -1) {
	                var _index8 = _.indexOf(_this2.itemSearch, searchArray[popIndexPageTopBar].value);
	                if (_index8 !== -1) {
	                  _this2.itemSearch.splice(_index8, 1);
	                  searchArray.splice(_index8, 1);
	                }
	              }
	              var tempPageTopBar = {};
	              tempPageTopBar.key = 'pagenumber';
	              tempPageTopBar.value = 1;
	              _this2.itemSearch.push(tempPageTopBar.value);
	              searchArray.push(tempPageTopBar);
	              break;
	            case 'rangeInput':
	              // console.log(data);
	              data.values.forEach(function (item) {
	                for (var key in item) {
	                  if (item.hasOwnProperty(key)) {
	                    newValues.push(item[key]);
	                  }
	                }
	              });
	              // console.log(this.allData);
	              // console.log(this.itemSearch);
	              delete _this2.allData[data.searchItem];
	              delete _this2.allData[data.searchItem + '[min]'];
	              delete _this2.allData[data.searchItem + '[max]'];
	              if (newValues.length === 2) {
	                _this2.allData[data.searchItem + '[min]'] = newValues[0];
	                _this2.allData[data.searchItem + '[max]'] = newValues[1];
	                var tempForMin = {};
	                tempForMin.key = data.searchItem + '[min]';
	                tempForMin.metakey = data.searchItem;
	                tempForMin.value = newValues[0];
	                tempForMin.metakey = data.searchItem;
	                var tempForMax = {};
	                tempForMax.key = data.searchItem + '[max]';
	                tempForMax.metakey = data.searchItem;
	                tempForMax.value = newValues[1];
	                tempForMax.metakey = data.searchItem;
	                var popIndexForMin = (0, _underscore.findIndex)(searchArray, { key: tempForMin.key });
	                var popIndexForMax = (0, _underscore.findIndex)(searchArray, { key: tempForMax.key });
	                if (popIndexForMax !== -1) {
	                  searchArray.splice(popIndexForMax, 1);
	                  _this2.itemSearch.splice(popIndexForMax, 1);
	                }
	                if (popIndexForMin !== -1) {
	                  searchArray.splice(popIndexForMin, 1);
	                  _this2.itemSearch.splice(popIndexForMin, 1);
	                }
	                searchArray.push(tempForMin);
	                searchArray.push(tempForMax);
	                _this2.itemSearch.push(newValues[0]);
	                _this2.itemSearch.push(newValues[1]);
	              }
	              var popIndexPageRange = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPageRange !== -1) {
	                var _index9 = _.indexOf(_this2.itemSearch, searchArray[popIndexPageRange].value);
	                if (_index9 !== -1) {
	                  _this2.itemSearch.splice(_index9, 1);
	                  searchArray.splice(_index9, 1);
	                }
	              }
	              var tempPageRange = {};
	              tempPageRange.key = 'pagenumber';
	              tempPageRange.value = 1;
	              _this2.itemSearch.push(tempPageRange.value);
	              searchArray.push(tempPageRange);
	              break;
	            case 'textbox':
	              if (data.values.length === 0) {
	                var _popIndex = (0, _underscore.findIndex)(searchArray, { key: data.searchItem });
	                if (_popIndex !== -1) {
	                  var _index10 = _.indexOf(_this2.itemSearch, searchArray[_popIndex].value);
	                  _this2.itemSearch.splice(_index10, 1);
	                  searchArray.splice(_popIndex, 1);
	                }
	                break;
	              }
	              _this2.allData[data.searchItem] = data.values;
	              var temp = {};
	              var popIndex = (0, _underscore.findIndex)(searchArray, { key: data.searchItem });
	              if (popIndex !== -1) {
	                var _index11 = _.indexOf(_this2.itemSearch, searchArray[popIndex].value);
	                _this2.itemSearch.splice(_index11, 1);
	                searchArray.splice(popIndex, 1);
	              }
	              temp.key = data.searchItem;
	              temp.value = data.values;
	              _this2.itemSearch.push(data.values);
	              searchArray.push(temp);
	              var popIndexPagetextBox = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPagetextBox !== -1) {
	                var _index12 = _.indexOf(_this2.itemSearch, searchArray[popIndexPagetextBox].value);
	                if (_index12 !== -1) {
	                  _this2.itemSearch.splice(_index12, 1);
	                  searchArray.splice(_index12, 1);
	                }
	              }
	              var tempPageText = {};
	              tempPageText.key = 'pagenumber';
	              tempPageText.value = 1;
	              _this2.itemSearch.push(tempPageText.value);
	              searchArray.push(tempPageText);
	              break;
	            case 'comboBox':
	              data.values.forEach(function (item) {
	                if (item.slug) {
	                  newValues.push(item.slug);
	                }
	              });
	              _this2.allData[data.searchItem] = newValues;
	              var comboOptions = [];
	              _this2.itemSearch.map(function (singleItem) {
	                var Index = (0, _underscore.findIndex)(data.options, { slug: singleItem });
	                if (Index !== -1) {
	                  comboOptions.push(singleItem);
	                }
	              });
	              var tempOptions = [];
	              // new item is checked
	              if (newValues.length > comboOptions.length) {
	                tempOptions = _.difference(newValues, comboOptions);
	                tempOptions.map(function (singleItem) {
	                  var tempCombo = {};
	                  tempCombo.key = data.searchItem;
	                  tempCombo.value = singleItem;
	                  _this2.itemSearch.push(singleItem);
	                  searchArray.push(tempCombo);
	                });
	              } else {
	                // Checked item is unchecked
	                tempOptions = _.difference(comboOptions, newValues);
	                tempOptions.map(function (item) {
	                  var index = _.indexOf(_this2.itemSearch, item);
	                  if (index !== -1) {
	                    _this2.itemSearch.splice(index, 1);
	                    searchArray.splice(index, 1);
	                  }
	                });
	              }
	              var popIndexPageCombo = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPageCombo !== -1) {
	                var _index13 = _.indexOf(_this2.itemSearch, searchArray[popIndexPageCombo].value);
	                if (_index13 !== -1) {
	                  _this2.itemSearch.splice(_index13, 1);
	                  searchArray.splice(_index13, 1);
	                }
	              }
	              var tempPageCombo = {};
	              tempPageCombo.key = 'pagenumber';
	              tempPageCombo.value = 1;
	              _this2.itemSearch.push(tempPageCombo.value);
	              searchArray.push(tempPageCombo);
	              break;
	            default:
	              data.values.forEach(function (item) {
	                if (item.slug) {
	                  newValues.push(item.slug);
	                }
	              });
	              _this2.allData[data.searchItem] = newValues;
	              var searchItem = data.searchItem;
	              data.values.forEach(function (item) {
	                var insertNewValue = true;
	                if (item.slug) {
	                  for (var _i2 = 0; _i2 < searchArray.length; _i2++) {
	                    if (searchArray[_i2].key === data.searchItem && item.slug === searchArray[_i2].value) {
	                      insertNewValue = false;
	                    }
	                  }
	                  if (insertNewValue === true) {
	                    var teampDefault = {};
	                    teampDefault.key = searchItem;
	                    teampDefault.value = item.slug;
	                    _this2.itemSearch.push(item.slug);
	                    searchArray.push(teampDefault);
	                  }
	                }
	              });
	              var tempSearchArray = (0, _clone2.default)(searchArray);
	              tempSearchArray.map(function (popItem, tempPopIndex) {
	                if (popItem.key === data.searchItem) {
	                  if (_this2.allData[data.searchItem].indexOf(popItem.value) === -1) {
	                    _this2.itemSearch.splice(tempPopIndex, 1);
	                    searchArray.splice(tempPopIndex, 1);
	                  }
	                }
	              });
	              var popIndexPage = (0, _underscore.findIndex)(searchArray, { key: 'pagenumber' });
	              if (popIndexPage !== -1) {
	                var _index14 = _.indexOf(_this2.itemSearch, searchArray[popIndexPage].value);
	                if (_index14 !== -1) {
	                  _this2.itemSearch.splice(_index14, 1);
	                  searchArray.splice(_index14, 1);
	                }
	              }
	              var tempPage = {};
	              tempPage.key = 'pagenumber';
	              tempPage.value = 1;
	              _this2.itemSearch.push(tempPage.value);
	              searchArray.push(tempPage);
	              break;
	          }
	        })();
	
	        finalQueryString = '?';
	      })();
	    } else {
	      this.allData = {};
	      finalQueryString = '';
	      searchArray = window.searchArray = [];
	      this.itemSearch = [];
	    }
	    searchArray.forEach(function (searchAttr) {
	      if (finalQueryString.length === 1) {
	        finalQueryString += searchAttr.key + '=' + searchAttr.value;
	      } else {
	        finalQueryString += '&' + searchAttr.key + '=' + searchAttr.value;
	      }
	    });
	    history.push({ 'pathname': location.pathname, 'search': finalQueryString, 'query': '' });
	    this.trigger({ query: this.allData });
	  },
	  onProcess: function onProcess(data) {
	    // for changing the event , everyone will use this path
	    // this.allData.push(data);
	    if (data.searchItem === 'view') {
	      window.doAjax = false;
	      window.loadPageNumber = 'nochange';
	      jQuery('#LoadTime').fadeOut(300);
	    } else {
	      window.doAjax = true;
	      window.loadPageNumber = 'change';
	    }
	    this.processData(data);
	    // maybe will use http request in here
	    // this.trigger({ query : this.allData });
	  }
	});
	
	exports.default = UrlHandlerStore;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _underscore = __webpack_require__(205);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _fuse = __webpack_require__(720);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DoFilterOnData = function () {
	  function DoFilterOnData(options) {
	    _classCallCheck(this, DoFilterOnData);
	
	    this.metakey = options.metakey;
	    this.availableData = (0, _clone2.default)(options.availableData);
	    this.urlData = options.urlData;
	    this.filterTermData = options.filterTermData;
	    this.props = options.props;
	    this.isUrlTermKeyInAvailableData = this.isUrlTermKeyInAvailableData.bind(this);
	    this.filterDataLinear = this.filterDataLinear.bind(this);
	    this.filterDataForTree = this.filterDataForTree.bind(this);
	    this.buildTree = this.buildTree.bind(this);
	    this.filterMetaDataForRange = this.filterMetaDataForRange.bind(this);
	    this.filterDataForTextBox = this.filterDataForTextBox.bind(this);
	    this.filterMetaDataForDate = this.filterMetaDataForDate.bind(this);
	    this.filterDataForAllMeta = this.filterDataForAllMeta.bind(this);
	    this.filterDataPrequery = this.filterDataPrequery.bind(this);
	    this.filterMetaDataForRnB = this.filterMetaDataForRnB.bind(this);
	  }
	
	  _createClass(DoFilterOnData, [{
	    key: 'filterDataPrequery',
	    value: function filterDataPrequery() {
	      var data = (0, _clone2.default)(this.availableData);
	      var selectedMeta = [];
	      var selectedTaxonomy = [];
	      if (this.props.settingsData.hasOwnProperty('prequery')) {
	        if (this.props.settingsData.prequery.hasOwnProperty('meta')) {
	          selectedMeta = (0, _clone2.default)(this.props.settingsData['prequery']['meta']);
	        }
	        if (this.props.settingsData.prequery.hasOwnProperty('taxonomy')) {
	          selectedTaxonomy = (0, _clone2.default)(this.props.settingsData['prequery']['taxonomy']);
	        }
	      }
	      var filteredData = [];
	      if (selectedMeta.length === 0 && selectedTaxonomy.length === 0) {
	        filteredData = (0, _clone2.default)(data);
	      } else {
	        data.map(function (item) {
	          // console.log(item);
	          var checkTaxonomy = true;
	          for (var index = 0; index < selectedMeta.length; index++) {
	            if (item.meta.hasOwnProperty(selectedMeta[index])) {
	              filteredData.push(item);
	              checkTaxonomy = false;
	              break;
	            }
	          }
	          if (checkTaxonomy === true) {
	            for (var _index = 0; _index < selectedTaxonomy.length; _index++) {
	              if (item.terms.hasOwnProperty(selectedTaxonomy[_index])) {
	                if (item.terms[selectedTaxonomy[_index]].length !== 0) {
	                  filteredData.push(item);
	                  break;
	                }
	              }
	            }
	          }
	        });
	      }
	      this.availableData = (0, _clone2.default)(filteredData);
	    }
	  }, {
	    key: 'filterDataForTextBox',
	    value: function filterDataForTextBox(searchValue) {
	      var data = (0, _clone2.default)(this.availableData);
	      var filteredData = [];
	      var searchkeys = [];
	      if (data.length > 0) {
	        for (var key in data[0]) {
	          if (data[0].hasOwnProperty(key)) {
	            if (typeof data[0][key] === 'string') {
	              searchkeys.push(key);
	            }
	            if (_.isObject(data[0][key])) {
	              for (var innerkey in data[0][key]) {
	                if (data[0][key].hasOwnProperty(innerkey)) {
	                  searchkeys.push(key + '.' + innerkey);
	                }
	              }
	            }
	          }
	        }
	      }
	      var options = {
	        shouldSort: true,
	        threshold: 0.4,
	        location: 0,
	        distance: 100,
	        maxPatternLength: searchkeys.length,
	        keys: searchkeys
	      };
	      var fuse = new _fuse2.default(data, options); // "list" is the item array
	      filteredData = fuse.search(searchValue);
	      this.availableData = (0, _clone2.default)(filteredData);
	    }
	  }, {
	    key: 'isUrlTermKeyInAvailableData',
	    value: function isUrlTermKeyInAvailableData(item, urlTermKey, urlTermValues) {
	      var termOption = urlTermValues;
	      if (!_.isArray(urlTermValues)) {
	        var singleValue = urlTermValues;
	        termOption = [];
	        termOption.push(singleValue);
	      }
	      var index = _.intersection(item.terms[urlTermKey], termOption);
	      if (index.length !== 0) this.filterTermData.push(item);
	    }
	  }, {
	    key: 'filterDataLinear',
	    value: function filterDataLinear(resultTermData, urlTermKey, urlTermValues) {
	      var _this = this;
	
	      resultTermData.map(function (item) {
	        if (item.terms[urlTermKey] !== undefined) {
	          _this.isUrlTermKeyInAvailableData(item, urlTermKey, urlTermValues);
	        }
	      });
	      this.availableData = (0, _clone2.default)(this.filterTermData);
	      this.filterTermData = [];
	    }
	  }, {
	    key: 'filterDataForAllMeta',
	    value: function filterDataForAllMeta(searchValues, key) {
	      var urlTermValues = [];
	      var filteredData = [];
	      if (!_.isArray(searchValues)) {
	        urlTermValues.push(searchValues.toString());
	      } else {
	        urlTermValues = (0, _clone2.default)(searchValues);
	      }
	      var allData = (0, _clone2.default)(this.availableData);
	      allData.map(function (item) {
	        if (item.meta.hasOwnProperty(key)) {
	          var index = _.indexOf(urlTermValues, item.meta[key]);
	          if (index !== -1) {
	            filteredData.push(item);
	          }
	        }
	      });
	      this.availableData = (0, _clone2.default)(filteredData);
	    }
	  }, {
	    key: 'filterDataForTree',
	    value: function filterDataForTree(resultTermData, urlTermValues) {
	      var _this2 = this;
	
	      var tempfilteredOr = [];
	      resultTermData.map(function (item) {
	        if (_.intersection(item.terms[_this2.selectedTermKey], urlTermValues).length === urlTermValues.length) {
	          tempfilteredOr.push(item);
	        }
	      });
	      this.filteredOr = _.union(this.filteredOr, tempfilteredOr);
	    }
	  }, {
	    key: 'buildTree',
	    value: function buildTree(item, urlTree) {
	      var index = (0, _underscore.findIndex)(this.selectedTerms, { slug: item.slug });
	      if (index !== -1) {
	        urlTree.push(item.slug);
	        if (item.children.length === 0) {
	          this.filterDataForTree(this.availableData, urlTree);
	          return;
	        }
	        for (var i = 0; i < item.children.length; i++) {
	          this.buildTree(item.children[i], (0, _clone2.default)(urlTree));
	        }
	        var isSingle = (0, _underscore.findIndex)(this.selectedTerms, { parent: item.term_id });
	        if (isSingle === -1) {
	          this.filterDataForTree(this.availableData, urlTree);
	        }
	      }
	      if (index === -1) {
	        return;
	      }
	    }
	  }, {
	    key: 'filterMetaDataForRange',
	    value: function filterMetaDataForRange(rangeInput, metaKey) {
	      var filteredData = [];
	      this.availableData.map(function (item) {
	        if (item.meta.hasOwnProperty(metaKey)) {
	          if (parseInt(item.meta[metaKey], 10) >= parseInt(rangeInput.min, 10) && parseInt(item.meta[metaKey], 10) <= parseInt(rangeInput.max, 10)) {
	            filteredData.push(item);
	          }
	        }
	      });
	      this.availableData = (0, _clone2.default)(filteredData);
	    }
	  }, {
	    key: 'filterMetaDataForDate',
	    value: function filterMetaDataForDate(daterange, metaKey) {
	      var filteredData = [];
	      var allData = (0, _clone2.default)(this.availableData);
	      allData.map(function (item) {
	        if (metaKey === 'post_date') {
	          if (item.hasOwnProperty(metaKey)) {
	            var start = (0, _moment2.default)(daterange.start).format('YYYY-MM-DD');
	            var end = (0, _moment2.default)(daterange.end).format('YYYY-MM-DD');
	            var bookedDate = (0, _moment2.default)(item[metaKey]).format('YYYY-MM-DD');
	            if ((0, _moment2.default)(start).isBefore(bookedDate) && (0, _moment2.default)(end).isAfter(bookedDate) || (0, _moment2.default)(start).isSame(bookedDate) || (0, _moment2.default)(end).isSame(bookedDate)) {
	              filteredData.push(item);
	            }
	          }
	        } else {
	          if (item.meta.hasOwnProperty(metaKey)) {
	            var _start = (0, _moment2.default)(daterange.start).format('YYYY-MM-DD');
	            var _end = (0, _moment2.default)(daterange.end).format('YYYY-MM-DD');
	            var _bookedDate = (0, _moment2.default)(item.meta[metaKey], 'DD/MM/YYYY').format('YYYY-MM-DD');
	            if ((0, _moment2.default)(_start).isBefore(_bookedDate) && (0, _moment2.default)(_end).isAfter(_bookedDate) || (0, _moment2.default)(_start).isSame(_bookedDate) || (0, _moment2.default)(_end).isSame(_bookedDate)) {
	              filteredData.push(item);
	            }
	          }
	        }
	      });
	      this.availableData = (0, _clone2.default)(filteredData);
	    }
	  }, {
	    key: 'filterMetaDataForRnB',
	    value: function filterMetaDataForRnB(daterange, metaKey) {
	      var filteredData = [];
	      var allData = (0, _clone2.default)(this.availableData);
	      allData.map(function (item) {
	        if (item.meta.hasOwnProperty(metaKey)) {
	          var start = (0, _moment2.default)(daterange.start).format('MM/DD/YYYY');
	          var end = (0, _moment2.default)(daterange.end).format('MM/DD/YYYY');
	          var bookedDate = (0, _clone2.default)(item.meta[metaKey]);
	          var flag = true;
	          for (var index = 0; index < bookedDate.length; index++) {
	            if ((0, _moment2.default)(start).isBefore(bookedDate[index]) && (0, _moment2.default)(end).isAfter(bookedDate[index]) || (0, _moment2.default)(start).isSame(bookedDate[index]) || (0, _moment2.default)(end).isSame(bookedDate[index])) {
	              flag = false;
	              break;
	            }
	          }
	          if (flag === true) {
	            filteredData.push(item);
	          }
	        }
	      });
	      this.availableData = (0, _clone2.default)(filteredData);
	    }
	  }, {
	    key: 'filterOperation',
	    value: function filterOperation() {
	      var _this3 = this;
	
	      var _loop = function _loop(key) {
	        var isTaxonomy = _.indexOf(_this3.props.helperData.taxonomies, key.toString());
	        if (_this3.urlData.hasOwnProperty(key) && isTaxonomy !== -1) {
	          (function () {
	            var searchType = [];
	            if (!_.isArray(_this3.urlData[key])) {
	              searchType.push(_this3.urlData[key]);
	            } else {
	              searchType = (0, _clone2.default)(_this3.urlData[key]);
	            }
	            _this3.selectedTerms = [];
	            searchType.map(function (item) {
	              var index = (0, _underscore.findIndex)(_this3.props.helperData.terms[key].linear, { slug: item.toString() });
	              if (index !== -1) _this3.selectedTerms.push(_this3.props.helperData.terms[key].linear[index]);
	            });
	            var numberOfParent = 0;
	            _this3.selectedTerms = _.sortBy(_this3.selectedTerms, 'parent');
	            _this3.selectedTerms.map(function (item) {
	              if (item.parent === 0) {
	                numberOfParent++;
	              }
	            });
	            _this3.comboIndex = null;
	            var indexSearchBlock = (0, _underscore.findIndex)(_this3.props.allLayout, { type: 'search' });
	            if (indexSearchBlock !== -1) {
	              var searchAttr = (0, _clone2.default)(_this3.props.allLayout[indexSearchBlock].searchAttr);
	              _this3.comboIndex = (0, _underscore.findIndex)(searchAttr, { selectedTaxonomy: key.toString(), viewType: 'combobox' });
	            }
	            if (numberOfParent === _this3.selectedTerms.length || _this3.comboIndex === -1) {
	              _this3.filterDataLinear(_this3.availableData, key.toString(), _this3.urlData[key]);
	            } else {
	              _this3.filteredOr = [];
	              _this3.selectedTermKey = key;
	              _this3.selectedTerms.map(function (item) {
	                if (item.parent === 0) {
	                  var index = (0, _underscore.findIndex)(_this3.props.helperData.terms[key].complex, { term_id: item.key });
	                  _this3.buildTree(_this3.props.helperData.terms[key].complex[index], []);
	                }
	              });
	              _this3.availableData = _.intersection(_this3.availableData, _this3.filteredOr);
	            }
	          })();
	        } else {
	          var fieldType = null;
	          var rangeInput = {};
	          var dateRangeData = {};
	          var searchValue = null;
	          var isRange = key.indexOf('[min]');
	          var isRangeMax = key.indexOf('[max]');
	          if (isRangeMax !== -1) {
	            fieldType = 'rangeInputMax';
	          }
	          var metaKey = null;
	          if (isRange !== -1) {
	            metaKey = key.split('[min]').length ? key.split('[min]')[0] : null;
	            rangeInput.min = _this3.urlData[key];
	            rangeInput.max = _this3.urlData[metaKey + '[max]'];
	            fieldType = 'rangeInput';
	          }
	          if (key.toString() === 'search_item') {
	            fieldType = 'textbox';
	            searchValue = _this3.urlData[key];
	          }
	          var isDate = key.indexOf('[start]');
	          var isDateEnd = key.indexOf('[end]');
	          if (isDate !== -1) {
	            var tempKey = key.split('[start]').length ? key.split('[start]')[0] : null;
	            fieldType = 'daterange';
	            dateRangeData.start = _this3.urlData[tempKey + '[start]'];
	            dateRangeData.end = _this3.urlData[tempKey + '[end]'];
	            searchValue = _this3.urlData[key];
	            metaKey = tempKey;
	            var allLayout = _this3.props.allLayout;
	
	            for (var i = 0; i < allLayout.length; i++) {
	              if (allLayout[i].type === 'search') {
	                var searchAttr = allLayout[i].searchAttr;
	                var isRnb = (0, _underscore.findIndex)(searchAttr, { viewType: 'rnb-daterange' });
	                if (isRnb !== -1) {
	                  fieldType = 'rnb-daterange';
	                }
	              }
	            }
	          }
	          if (isDateEnd !== -1) {
	            fieldType = 'daterangeEnd';
	          }
	          if (key.toString() === 'pagenumber') {
	            fieldType = 'pagination';
	          }
	          if (key.toString() === 'view') {
	            fieldType = 'view';
	          }
	          if (key.toString() === 'location') {
	            fieldType = 'mapSearch';
	          }
	          switch (fieldType) {
	            case 'rangeInput':
	              _this3.filterMetaDataForRange(rangeInput, metaKey);
	              break;
	            case 'rangeInputMax':
	              break;
	            case 'daterangeEnd':
	              break;
	            case 'pagination':
	              break;
	            case 'view':
	              break;
	            case 'textbox':
	              _this3.filterDataForTextBox(searchValue);
	              break;
	            case 'daterange':
	              _this3.filterMetaDataForDate(dateRangeData, metaKey);
	              break;
	            case 'rnb-daterange':
	              _this3.filterMetaDataForRnB(dateRangeData, metaKey);
	              break;
	            case 'mapSearch':
	              break;
	            default:
	              _this3.filterDataForAllMeta(_this3.urlData[key], key);
	              break;
	          }
	        }
	      };
	
	      for (var key in this.urlData) {
	        _loop(key);
	      }
	      ReactiveFanoutData.availableDataLength = this.availableData.length;
	      return this.availableData;
	    }
	  }]);
	
	  return DoFilterOnData;
	}();
	
	exports.default = DoFilterOnData;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Fuse - Lightweight fuzzy-search
	 *
	 * Copyright (c) 2012-2016 Kirollos Risk <kirollos@gmail.com>.
	 * All Rights Reserved. Apache Software License 2.0
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License")
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	;(function (global) {
	  'use strict'
	
	  function log () {
	    console.log.apply(console, arguments)
	  }
	
	  var defaultOptions = {
	    // The name of the identifier property. If specified, the returned result will be a list
	    // of the items' dentifiers, otherwise it will be a list of the items.
	    id: null,
	
	    // Indicates whether comparisons should be case sensitive.
	
	    caseSensitive: false,
	
	    // An array of values that should be included from the searcher's output. When this array
	    // contains elements, each result in the list will be of the form `{ item: ..., include1: ..., include2: ... }`.
	    // Values you can include are `score`, `matchedLocations`
	    include: [],
	
	    // Whether to sort the result list, by score
	    shouldSort: true,
	
	    // The search function to use
	    // Note that the default search function ([[Function]]) must conform to the following API:
	    //
	    //  @param pattern The pattern string to search
	    //  @param options The search option
	    //  [[Function]].constructor = function(pattern, options)
	    //
	    //  @param text: the string to search in for the pattern
	    //  @return Object in the form of:
	    //    - isMatch: boolean
	    //    - score: Int
	    //  [[Function]].prototype.search = function(text)
	    searchFn: BitapSearcher,
	
	    // Default sort function
	    sortFn: function (a, b) {
	      return a.score - b.score
	    },
	
	    // The get function to use when fetching an object's properties.
	    // The default will search nested paths *ie foo.bar.baz*
	    getFn: deepValue,
	
	    // List of properties that will be searched. This also supports nested properties.
	    keys: [],
	
	    // Will print to the console. Useful for debugging.
	    verbose: false,
	
	    // When true, the search algorithm will search individual words **and** the full string,
	    // computing the final score as a function of both. Note that when `tokenize` is `true`,
	    // the `threshold`, `distance`, and `location` are inconsequential for individual tokens.
	    tokenize: false,
	
	    // When true, the result set will only include records that match all tokens. Will only work
	    // if `tokenize` is also true.
	    matchAllTokens: false,
	
	    // Regex used to separate words when searching. Only applicable when `tokenize` is `true`.
	    tokenSeparator: / +/g
	  }
	
	  function Fuse (list, options) {
	    var i
	    var len
	    var key
	    var keys
	
	    this.list = list
	    this.options = options = options || {}
	
	    // Add boolean type options
	    for (i = 0, keys = ['sort', 'shouldSort', 'verbose', 'tokenize'], len = keys.length; i < len; i++) {
	      key = keys[i]
	      this.options[key] = key in options ? options[key] : defaultOptions[key]
	    }
	    // Add all other options
	    for (i = 0, keys = ['searchFn', 'sortFn', 'keys', 'getFn', 'include', 'tokenSeparator'], len = keys.length; i < len; i++) {
	      key = keys[i]
	      this.options[key] = options[key] || defaultOptions[key]
	    }
	  }
	
	  Fuse.VERSION = '2.5.0'
	
	  /**
	   * Sets a new list for Fuse to match against.
	   * @param {Array} list
	   * @return {Array} The newly set list
	   * @public
	   */
	  Fuse.prototype.set = function (list) {
	    this.list = list
	    return list
	  }
	
	  Fuse.prototype.search = function (pattern) {
	    if (this.options.verbose) log('\nSearch term:', pattern, '\n')
	
	    this.pattern = pattern
	    this.results = []
	    this.resultMap = {}
	    this._keyMap = null
	
	    this._prepareSearchers()
	    this._startSearch()
	    this._computeScore()
	    this._sort()
	
	    var output = this._format()
	    return output
	  }
	
	  Fuse.prototype._prepareSearchers = function () {
	    var options = this.options
	    var pattern = this.pattern
	    var searchFn = options.searchFn
	    var tokens = pattern.split(options.tokenSeparator)
	    var i = 0
	    var len = tokens.length
	
	    if (this.options.tokenize) {
	      this.tokenSearchers = []
	      for (; i < len; i++) {
	        this.tokenSearchers.push(new searchFn(tokens[i], options))
	      }
	    }
	    this.fullSeacher = new searchFn(pattern, options)
	  }
	
	  Fuse.prototype._startSearch = function () {
	    var options = this.options
	    var getFn = options.getFn
	    var list = this.list
	    var listLen = list.length
	    var keys = this.options.keys
	    var keysLen = keys.length
	    var key
	    var weight
	    var item = null
	    var i
	    var j
	
	    // Check the first item in the list, if it's a string, then we assume
	    // that every item in the list is also a string, and thus it's a flattened array.
	    if (typeof list[0] === 'string') {
	      // Iterate over every item
	      for (i = 0; i < listLen; i++) {
	        this._analyze('', list[i], i, i)
	      }
	    } else {
	      this._keyMap = {}
	      // Otherwise, the first item is an Object (hopefully), and thus the searching
	      // is done on the values of the keys of each item.
	      // Iterate over every item
	      for (i = 0; i < listLen; i++) {
	        item = list[i]
	        // Iterate over every key
	        for (j = 0; j < keysLen; j++) {
	          key = keys[j]
	          if (typeof key !== 'string') {
	            weight = (1 - key.weight) || 1
	            this._keyMap[key.name] = {
	              weight: weight
	            }
	            if (key.weight <= 0 || key.weight > 1) {
	              throw new Error('Key weight has to be > 0 and <= 1')
	            }
	            key = key.name
	          } else {
	            this._keyMap[key] = {
	              weight: 1
	            }
	          }
	          this._analyze(key, getFn(item, key, []), item, i)
	        }
	      }
	    }
	  }
	
	  Fuse.prototype._analyze = function (key, text, entity, index) {
	    var options = this.options
	    var words
	    var scores
	    var exists = false
	    var existingResult
	    var averageScore
	    var finalScore
	    var scoresLen
	    var mainSearchResult
	    var tokenSearcher
	    var termScores
	    var word
	    var tokenSearchResult
	    var hasMatchInText
	    var checkTextMatches
	    var i
	    var j
	
	    // Check if the text can be searched
	    if (text === undefined || text === null) {
	      return
	    }
	
	    scores = []
	
	    var numTextMatches = 0
	
	    if (typeof text === 'string') {
	      words = text.split(options.tokenSeparator)
	
	      if (options.verbose) log('---------\nKey:', key)
	
	      if (this.options.tokenize) {
	        for (i = 0; i < this.tokenSearchers.length; i++) {
	          tokenSearcher = this.tokenSearchers[i]
	
	          if (options.verbose) log('Pattern:', tokenSearcher.pattern)
	
	          termScores = []
	          hasMatchInText = false
	
	          for (j = 0; j < words.length; j++) {
	            word = words[j]
	            tokenSearchResult = tokenSearcher.search(word)
	            var obj = {}
	            if (tokenSearchResult.isMatch) {
	              obj[word] = tokenSearchResult.score
	              exists = true
	              hasMatchInText = true
	              scores.push(tokenSearchResult.score)
	            } else {
	              obj[word] = 1
	              if (!this.options.matchAllTokens) {
	                scores.push(1)
	              }
	            }
	            termScores.push(obj)
	          }
	
	          if (hasMatchInText) {
	            numTextMatches++
	          }
	
	          if (options.verbose) log('Token scores:', termScores)
	        }
	
	        averageScore = scores[0]
	        scoresLen = scores.length
	        for (i = 1; i < scoresLen; i++) {
	          averageScore += scores[i]
	        }
	        averageScore = averageScore / scoresLen
	
	        if (options.verbose) log('Token score average:', averageScore)
	      }
	
	      mainSearchResult = this.fullSeacher.search(text)
	      if (options.verbose) log('Full text score:', mainSearchResult.score)
	
	      finalScore = mainSearchResult.score
	      if (averageScore !== undefined) {
	        finalScore = (finalScore + averageScore) / 2
	      }
	
	      if (options.verbose) log('Score average:', finalScore)
	
	      checkTextMatches = (this.options.tokenize && this.options.matchAllTokens) ? numTextMatches >= this.tokenSearchers.length : true
	
	      if (options.verbose) log('Check Matches', checkTextMatches)
	
	      // If a match is found, add the item to <rawResults>, including its score
	      if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
	        // Check if the item already exists in our results
	        existingResult = this.resultMap[index]
	
	        if (existingResult) {
	          // Use the lowest score
	          // existingResult.score, bitapResult.score
	          existingResult.output.push({
	            key: key,
	            score: finalScore,
	            matchedIndices: mainSearchResult.matchedIndices
	          })
	        } else {
	          // Add it to the raw result list
	          this.resultMap[index] = {
	            item: entity,
	            output: [{
	              key: key,
	              score: finalScore,
	              matchedIndices: mainSearchResult.matchedIndices
	            }]
	          }
	
	          this.results.push(this.resultMap[index])
	        }
	      }
	    } else if (isArray(text)) {
	      for (i = 0; i < text.length; i++) {
	        this._analyze(key, text[i], entity, index)
	      }
	    }
	  }
	
	  Fuse.prototype._computeScore = function () {
	    var i
	    var j
	    var keyMap = this._keyMap
	    var totalScore
	    var output
	    var scoreLen
	    var score
	    var weight
	    var results = this.results
	    var bestScore
	    var nScore
	
	    if (this.options.verbose) log('\n\nComputing score:\n')
	
	    for (i = 0; i < results.length; i++) {
	      totalScore = 0
	      output = results[i].output
	      scoreLen = output.length
	
	      bestScore = 1
	
	      for (j = 0; j < scoreLen; j++) {
	        score = output[j].score
	        weight = keyMap ? keyMap[output[j].key].weight : 1
	
	        nScore = score * weight
	
	        if (weight !== 1) {
	          bestScore = Math.min(bestScore, nScore)
	        } else {
	          totalScore += nScore
	          output[j].nScore = nScore
	        }
	      }
	
	      if (bestScore === 1) {
	        results[i].score = totalScore / scoreLen
	      } else {
	        results[i].score = bestScore
	      }
	
	      if (this.options.verbose) log(results[i])
	    }
	  }
	
	  Fuse.prototype._sort = function () {
	    var options = this.options
	    if (options.shouldSort) {
	      if (options.verbose) log('\n\nSorting....')
	      this.results.sort(options.sortFn)
	    }
	  }
	
	  Fuse.prototype._format = function () {
	    var options = this.options
	    var getFn = options.getFn
	    var finalOutput = []
	    var item
	    var i
	    var len
	    var results = this.results
	    var replaceValue
	    var getItemAtIndex
	    var include = options.include
	
	    if (options.verbose) log('\n\nOutput:\n\n', results)
	
	    // Helper function, here for speed-up, which replaces the item with its value,
	    // if the options specifies it,
	    replaceValue = options.id ? function (index) {
	      results[index].item = getFn(results[index].item, options.id, [])[0]
	    } : function () {}
	
	    getItemAtIndex = function (index) {
	      var record = results[index]
	      var data
	      var j
	      var output
	      var _item
	      var _result
	
	      // If `include` has values, put the item in the result
	      if (include.length > 0) {
	        data = {
	          item: record.item
	        }
	        if (include.indexOf('matches') !== -1) {
	          output = record.output
	          data.matches = []
	          for (j = 0; j < output.length; j++) {
	            _item = output[j]
	            _result = {
	              indices: _item.matchedIndices
	            }
	            if (_item.key) {
	              _result.key = _item.key
	            }
	            data.matches.push(_result)
	          }
	        }
	
	        if (include.indexOf('score') !== -1) {
	          data.score = results[index].score
	        }
	
	      } else {
	        data = record.item
	      }
	
	      return data
	    }
	
	    // From the results, push into a new array only the item identifier (if specified)
	    // of the entire item.  This is because we don't want to return the <results>,
	    // since it contains other metadata
	    for (i = 0, len = results.length; i < len; i++) {
	      replaceValue(i)
	      item = getItemAtIndex(i)
	      finalOutput.push(item)
	    }
	
	    return finalOutput
	  }
	
	  // Helpers
	
	  function deepValue (obj, path, list) {
	    var firstSegment
	    var remaining
	    var dotIndex
	    var value
	    var i
	    var len
	
	    if (!path) {
	      // If there's no path left, we've gotten to the object we care about.
	      list.push(obj)
	    } else {
	      dotIndex = path.indexOf('.')
	
	      if (dotIndex !== -1) {
	        firstSegment = path.slice(0, dotIndex)
	        remaining = path.slice(dotIndex + 1)
	      } else {
	        firstSegment = path
	      }
	
	      value = obj[firstSegment]
	      if (value !== null && value !== undefined) {
	        if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
	          list.push(value)
	        } else if (isArray(value)) {
	          // Search each item in the array.
	          for (i = 0, len = value.length; i < len; i++) {
	            deepValue(value[i], remaining, list)
	          }
	        } else if (remaining) {
	          // An object. Recurse further.
	          deepValue(value, remaining, list)
	        }
	      }
	    }
	
	    return list
	  }
	
	  function isArray (obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]'
	  }
	
	  /**
	   * Adapted from "Diff, Match and Patch", by Google
	   *
	   *   http://code.google.com/p/google-diff-match-patch/
	   *
	   * Modified by: Kirollos Risk <kirollos@gmail.com>
	   * -----------------------------------------------
	   * Details: the algorithm and structure was modified to allow the creation of
	   * <Searcher> instances with a <search> method which does the actual
	   * bitap search. The <pattern> (the string that is searched for) is only defined
	   * once per instance and thus it eliminates redundant re-creation when searching
	   * over a list of strings.
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License")
	   * you may not use this file except in compliance with the License.
	   */
	  function BitapSearcher (pattern, options) {
	    options = options || {}
	    this.options = options
	    this.options.location = options.location || BitapSearcher.defaultOptions.location
	    this.options.distance = 'distance' in options ? options.distance : BitapSearcher.defaultOptions.distance
	    this.options.threshold = 'threshold' in options ? options.threshold : BitapSearcher.defaultOptions.threshold
	    this.options.maxPatternLength = options.maxPatternLength || BitapSearcher.defaultOptions.maxPatternLength
	
	    this.pattern = options.caseSensitive ? pattern : pattern.toLowerCase()
	    this.patternLen = pattern.length
	
	    if (this.patternLen <= this.options.maxPatternLength) {
	      this.matchmask = 1 << (this.patternLen - 1)
	      this.patternAlphabet = this._calculatePatternAlphabet()
	    }
	  }
	
	  BitapSearcher.defaultOptions = {
	    // Approximately where in the text is the pattern expected to be found?
	    location: 0,
	
	    // Determines how close the match must be to the fuzzy location (specified above).
	    // An exact letter match which is 'distance' characters away from the fuzzy location
	    // would score as a complete mismatch. A distance of '0' requires the match be at
	    // the exact location specified, a threshold of '1000' would require a perfect match
	    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
	    distance: 100,
	
	    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
	    // (of both letters and location), a threshold of '1.0' would match anything.
	    threshold: 0.6,
	
	    // Machine word size
	    maxPatternLength: 32
	  }
	
	  /**
	   * Initialize the alphabet for the Bitap algorithm.
	   * @return {Object} Hash of character locations.
	   * @private
	   */
	  BitapSearcher.prototype._calculatePatternAlphabet = function () {
	    var mask = {},
	      i = 0
	
	    for (i = 0; i < this.patternLen; i++) {
	      mask[this.pattern.charAt(i)] = 0
	    }
	
	    for (i = 0; i < this.patternLen; i++) {
	      mask[this.pattern.charAt(i)] |= 1 << (this.pattern.length - i - 1)
	    }
	
	    return mask
	  }
	
	  /**
	   * Compute and return the score for a match with `e` errors and `x` location.
	   * @param {number} errors Number of errors in match.
	   * @param {number} location Location of match.
	   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
	   * @private
	   */
	  BitapSearcher.prototype._bitapScore = function (errors, location) {
	    var accuracy = errors / this.patternLen,
	      proximity = Math.abs(this.options.location - location)
	
	    if (!this.options.distance) {
	      // Dodge divide by zero error.
	      return proximity ? 1.0 : accuracy
	    }
	    return accuracy + (proximity / this.options.distance)
	  }
	
	  /**
	   * Compute and return the result of the search
	   * @param {String} text The text to search in
	   * @return {Object} Literal containing:
	   *                          {Boolean} isMatch Whether the text is a match or not
	   *                          {Decimal} score Overall score for the match
	   * @public
	   */
	  BitapSearcher.prototype.search = function (text) {
	    var options = this.options
	    var i
	    var j
	    var textLen
	    var location
	    var threshold
	    var bestLoc
	    var binMin
	    var binMid
	    var binMax
	    var start, finish
	    var bitArr
	    var lastBitArr
	    var charMatch
	    var score
	    var locations
	    var matches
	    var isMatched
	    var matchMask
	    var matchedIndices
	    var matchesLen
	    var match
	
	    text = options.caseSensitive ? text : text.toLowerCase()
	
	    if (this.pattern === text) {
	      // Exact match
	      return {
	        isMatch: true,
	        score: 0,
	        matchedIndices: [[0, text.length - 1]]
	      }
	    }
	
	    // When pattern length is greater than the machine word length, just do a a regex comparison
	    if (this.patternLen > options.maxPatternLength) {
	      matches = text.match(new RegExp(this.pattern.replace(options.tokenSeparator, '|')))
	      isMatched = !!matches
	
	      if (isMatched) {
	        matchedIndices = []
	        for (i = 0, matchesLen = matches.length; i < matchesLen; i++) {
	          match = matches[i]
	          matchedIndices.push([text.indexOf(match), match.length - 1])
	        }
	      }
	
	      return {
	        isMatch: isMatched,
	        // TODO: revisit this score
	        score: isMatched ? 0.5 : 1,
	        matchedIndices: matchedIndices
	      }
	    }
	
	    location = options.location
	    // Set starting location at beginning text and initialize the alphabet.
	    textLen = text.length
	    // Highest score beyond which we give up.
	    threshold = options.threshold
	    // Is there a nearby exact match? (speedup)
	    bestLoc = text.indexOf(this.pattern, location)
	
	    // a mask of the matches
	    matchMask = []
	    for (i = 0; i < textLen; i++) {
	      matchMask[i] = 0
	    }
	
	    if (bestLoc != -1) {
	      threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
	      // What about in the other direction? (speed up)
	      bestLoc = text.lastIndexOf(this.pattern, location + this.patternLen)
	
	      if (bestLoc != -1) {
	        threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
	      }
	    }
	
	    bestLoc = -1
	    score = 1
	    locations = []
	    binMax = this.patternLen + textLen
	
	    for (i = 0; i < this.patternLen; i++) {
	      // Scan for the best match; each iteration allows for one more error.
	      // Run a binary search to determine how far from the match location we can stray
	      // at this error level.
	      binMin = 0
	      binMid = binMax
	      while (binMin < binMid) {
	        if (this._bitapScore(i, location + binMid) <= threshold) {
	          binMin = binMid
	        } else {
	          binMax = binMid
	        }
	        binMid = Math.floor((binMax - binMin) / 2 + binMin)
	      }
	
	      // Use the result from this iteration as the maximum for the next.
	      binMax = binMid
	      start = Math.max(1, location - binMid + 1)
	      finish = Math.min(location + binMid, textLen) + this.patternLen
	
	      // Initialize the bit array
	      bitArr = Array(finish + 2)
	
	      bitArr[finish + 1] = (1 << i) - 1
	
	      for (j = finish; j >= start; j--) {
	        charMatch = this.patternAlphabet[text.charAt(j - 1)]
	
	        if (charMatch) {
	          matchMask[j - 1] = 1
	        }
	
	        if (i === 0) {
	          // First pass: exact match.
	          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch
	        } else {
	          // Subsequent passes: fuzzy match.
	          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch | (((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1) | lastBitArr[j + 1]
	        }
	        if (bitArr[j] & this.matchmask) {
	          score = this._bitapScore(i, j - 1)
	
	          // This match will almost certainly be better than any existing match.
	          // But check anyway.
	          if (score <= threshold) {
	            // Indeed it is
	            threshold = score
	            bestLoc = j - 1
	            locations.push(bestLoc)
	
	            if (bestLoc > location) {
	              // When passing loc, don't exceed our current distance from loc.
	              start = Math.max(1, 2 * location - bestLoc)
	            } else {
	              // Already passed loc, downhill from here on in.
	              break
	            }
	          }
	        }
	      }
	
	      // No hope for a (better) match at greater error levels.
	      if (this._bitapScore(i + 1, location) > threshold) {
	        break
	      }
	      lastBitArr = bitArr
	    }
	
	    matchedIndices = this._getMatchedIndices(matchMask)
	
	    // Count exact matches (those with a score of 0) to be "almost" exact
	    return {
	      isMatch: bestLoc >= 0,
	      score: score === 0 ? 0.001 : score,
	      matchedIndices: matchedIndices
	    }
	  }
	
	  BitapSearcher.prototype._getMatchedIndices = function (matchMask) {
	    var matchedIndices = []
	    var start = -1
	    var end = -1
	    var i = 0
	    var match
	    var len = matchMask.length
	    for (; i < len; i++) {
	      match = matchMask[i]
	      if (match && start === -1) {
	        start = i
	      } else if (!match && start !== -1) {
	        end = i - 1
	        matchedIndices.push([start, end])
	        start = -1
	      }
	    }
	    if (matchMask[i - 1]) {
	      matchedIndices.push([start, i - 1])
	    }
	    return matchedIndices
	  }
	
	  // Export to Common JS Loader
	  if (true) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = Fuse
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(function () {
	      return Fuse
	    })
	  } else {
	    // Browser globals (root is window)
	    global.Fuse = Fuse
	  }
	
	})(this)


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _nprogress = __webpack_require__(192);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _ajax = __webpack_require__(476);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FilterAction = _reflux2.default.createActions(['pushForFilter', 'publishNewData']);
	
	_nprogress2.default.configure({ easing: 'ease', speed: 500 });
	
	FilterAction.pushForFilter.preEmit = function (data) {
	  _nprogress2.default.start();
	  jQuery('#LoadTime').fadeIn(300);
	  _ajax2.default.post('filter_data', data).end(function (error, res) {
	    if (res) {
	      _nprogress2.default.done();
	      jQuery('#LoadTime').fadeOut(300);
	      FilterAction.publishNewData(JSON.parse(res.text));
	    }
	  });
	};
	
	exports.default = FilterAction;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _filterAction = __webpack_require__(721);
	
	var _filterAction2 = _interopRequireDefault(_filterAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  listenables: _filterAction2.default,
	  onPublishNewData: function onPublishNewData(data) {
	    this.trigger(data);
	  }
	});

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _toogleHandlerActions = __webpack_require__(724);
	
	var _toogleHandlerActions2 = _interopRequireDefault(_toogleHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToogleStore = _reflux2.default.createStore({
	  listenables: _toogleHandlerActions2.default,
	  onDropdownToogle: function onDropdownToogle(field) {
	    this.trigger(field);
	  }
	});
	
	exports.default = ToogleStore;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToogleAction = _reflux2.default.createActions(['dropdownToogle']);
	
	exports.default = ToogleAction;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _checkboxpreview = __webpack_require__(726);
	
	var _checkboxpreview2 = _interopRequireDefault(_checkboxpreview);
	
	var _linearcheckboxpreview = __webpack_require__(729);
	
	var _linearcheckboxpreview2 = _interopRequireDefault(_linearcheckboxpreview);
	
	var _checkboxdropdownpreview = __webpack_require__(731);
	
	var _checkboxdropdownpreview2 = _interopRequireDefault(_checkboxdropdownpreview);
	
	var _radioboxpreview = __webpack_require__(732);
	
	var _radioboxpreview2 = _interopRequireDefault(_radioboxpreview);
	
	var _radioboxdropdownpreview = __webpack_require__(734);
	
	var _radioboxdropdownpreview2 = _interopRequireDefault(_radioboxdropdownpreview);
	
	var _selectboxpreview = __webpack_require__(735);
	
	var _selectboxpreview2 = _interopRequireDefault(_selectboxpreview);
	
	var _selectboxdropdownpreview = __webpack_require__(736);
	
	var _selectboxdropdownpreview2 = _interopRequireDefault(_selectboxdropdownpreview);
	
	var _sizeboxpreview = __webpack_require__(737);
	
	var _sizeboxpreview2 = _interopRequireDefault(_sizeboxpreview);
	
	var _sizeboxdropdownpreview = __webpack_require__(739);
	
	var _sizeboxdropdownpreview2 = _interopRequireDefault(_sizeboxdropdownpreview);
	
	var _textboxpreview = __webpack_require__(740);
	
	var _textboxpreview2 = _interopRequireDefault(_textboxpreview);
	
	var _textboxdropdownpreview = __webpack_require__(742);
	
	var _textboxdropdownpreview2 = _interopRequireDefault(_textboxdropdownpreview);
	
	var _tagspreview = __webpack_require__(743);
	
	var _tagspreview2 = _interopRequireDefault(_tagspreview);
	
	var _tagsdropdownpreview = __webpack_require__(745);
	
	var _tagsdropdownpreview2 = _interopRequireDefault(_tagsdropdownpreview);
	
	var _imageselectpreview = __webpack_require__(746);
	
	var _imageselectpreview2 = _interopRequireDefault(_imageselectpreview);
	
	var _imageselectdropdownpreview = __webpack_require__(748);
	
	var _imageselectdropdownpreview2 = _interopRequireDefault(_imageselectdropdownpreview);
	
	var _rangeinputpreview = __webpack_require__(749);
	
	var _rangeinputpreview2 = _interopRequireDefault(_rangeinputpreview);
	
	var _rangeinputdropdownpreview = __webpack_require__(751);
	
	var _rangeinputdropdownpreview2 = _interopRequireDefault(_rangeinputdropdownpreview);
	
	var _scrolltabpreview = __webpack_require__(752);
	
	var _scrolltabpreview2 = _interopRequireDefault(_scrolltabpreview);
	
	var _scrolltabdropdownpreview = __webpack_require__(754);
	
	var _scrolltabdropdownpreview2 = _interopRequireDefault(_scrolltabdropdownpreview);
	
	var _colorboxpreview = __webpack_require__(755);
	
	var _colorboxpreview2 = _interopRequireDefault(_colorboxpreview);
	
	var _colorboxdropdownpreview = __webpack_require__(757);
	
	var _colorboxdropdownpreview2 = _interopRequireDefault(_colorboxdropdownpreview);
	
	var _comboboxpreview = __webpack_require__(758);
	
	var _comboboxpreview2 = _interopRequireDefault(_comboboxpreview);
	
	var _comboboxdropdownpreview = __webpack_require__(760);
	
	var _comboboxdropdownpreview2 = _interopRequireDefault(_comboboxdropdownpreview);
	
	var _mapfieldpreview = __webpack_require__(761);
	
	var _mapfieldpreview2 = _interopRequireDefault(_mapfieldpreview);
	
	var _mapfielddropdownpreview = __webpack_require__(763);
	
	var _mapfielddropdownpreview2 = _interopRequireDefault(_mapfielddropdownpreview);
	
	var _resetbuttonpreview = __webpack_require__(764);
	
	var _resetbuttonpreview2 = _interopRequireDefault(_resetbuttonpreview);
	
	var _resetbuttondropdownpreview = __webpack_require__(766);
	
	var _resetbuttondropdownpreview2 = _interopRequireDefault(_resetbuttondropdownpreview);
	
	var _daterangepickerpreview = __webpack_require__(767);
	
	var _daterangepickerpreview2 = _interopRequireDefault(_daterangepickerpreview);
	
	var _sidebarpreview = __webpack_require__(829);
	
	var _sidebarpreview2 = _interopRequireDefault(_sidebarpreview);
	
	var _daterangepickerdropdownpreview = __webpack_require__(831);
	
	var _daterangepickerdropdownpreview2 = _interopRequireDefault(_daterangepickerdropdownpreview);
	
	var _sortingOption = __webpack_require__(832);
	
	var _sortingOption2 = _interopRequireDefault(_sortingOption);
	
	var _loadMoreOption = __webpack_require__(833);
	
	var _loadMoreOption2 = _interopRequireDefault(_loadMoreOption);
	
	var _searchAttribute = __webpack_require__(834);
	
	var _searchAttribute2 = _interopRequireDefault(_searchAttribute);
	
	var _viewChanger = __webpack_require__(835);
	
	var _viewChanger2 = _interopRequireDefault(_viewChanger);
	
	var _widgetRenderBlock = __webpack_require__(836);
	
	var _widgetRenderBlock2 = _interopRequireDefault(_widgetRenderBlock);
	
	var _mapRenderBlock = __webpack_require__(837);
	
	var _mapRenderBlock2 = _interopRequireDefault(_mapRenderBlock);
	
	var _customPagination = __webpack_require__(838);
	
	var _customPagination2 = _interopRequireDefault(_customPagination);
	
	var _categoryLoadMore = __webpack_require__(839);
	
	var _categoryLoadMore2 = _interopRequireDefault(_categoryLoadMore);
	
	var _mapRadiusPreview = __webpack_require__(840);
	
	var _mapRadiusPreview2 = _interopRequireDefault(_mapRadiusPreview);
	
	var _isotopeBar = __webpack_require__(842);
	
	var _isotopeBar2 = _interopRequireDefault(_isotopeBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// search templates both [ default , dropdown]
	// import SidebarBlock from '../block/sidebarBlock';
	window.ReactiveTheme['reactive'] = {
	  search: {
	    default: [],
	    dropdown: []
	  },
	  bar: {
	    topbarPagniation: _customPagination2.default, // direct component
	    sorting: _sortingOption2.default,
	    viewChanger: _viewChanger2.default,
	    searchAttributeShow: _searchAttribute2.default,
	    bottombarPagination: _customPagination2.default,
	    bottomLoadMore: _loadMoreOption2.default,
	    categoryLoadMore: _categoryLoadMore2.default,
	    isotopBar: _isotopeBar2.default
	  },
	  map: _mapRenderBlock2.default,
	  widget: _widgetRenderBlock2.default,
	  name: 'Reactive'
	};
	
	// map , widget, title, url api
	
	window.ReactiveTheme.reactive.search.default.push({
	  type: 'checkbox',
	  component: _checkboxpreview2.default
	}, {
	  type: 'radio',
	  component: _radioboxpreview2.default
	}, {
	  type: 'imageselect',
	  component: _imageselectpreview2.default
	}, {
	  type: 'select',
	  component: _selectboxpreview2.default
	}, {
	  type: 'sizebox',
	  component: _sizeboxpreview2.default
	}, {
	  type: 'colorbox',
	  component: _colorboxpreview2.default
	}, {
	  type: 'scrollbox',
	  component: _scrolltabpreview2.default
	}, {
	  type: 'text',
	  component: _textboxpreview2.default
	}, {
	  type: 'combobox',
	  component: _comboboxpreview2.default
	}, {
	  type: 'tag',
	  component: _tagspreview2.default
	}, {
	  type: 'rangeinput',
	  component: _rangeinputpreview2.default
	}, {
	  type: 'mapsearch',
	  component: _mapfieldpreview2.default
	}, {
	  type: 'reset',
	  component: _resetbuttonpreview2.default
	}, {
	  type: 'daterange',
	  component: _daterangepickerpreview2.default
	}, {
	  type: 'sidebar',
	  component: _sidebarpreview2.default
	}, {
	  type: 'mapradius',
	  component: _mapRadiusPreview2.default
	}, {
	  type: 'linearcheckbox',
	  component: _linearcheckboxpreview2.default
	}, {
	  type: 'rnb-daterange',
	  component: _daterangepickerpreview2.default
	});
	
	window.ReactiveTheme.reactive.search.dropdown.push({
	  type: 'checkbox',
	  component: _checkboxdropdownpreview2.default
	}, {
	  type: 'radio',
	  component: _radioboxdropdownpreview2.default
	}, {
	  type: 'select',
	  component: _selectboxdropdownpreview2.default
	}, {
	  type: 'sizebox',
	  component: _sizeboxdropdownpreview2.default
	}, {
	  type: 'text',
	  component: _textboxdropdownpreview2.default
	}, {
	  type: 'tag',
	  component: _tagsdropdownpreview2.default
	}, {
	  type: 'imageselect',
	  component: _imageselectdropdownpreview2.default
	}, {
	  type: 'rangeinput',
	  component: _rangeinputdropdownpreview2.default
	}, {
	  type: 'scrollbox',
	  component: _scrolltabdropdownpreview2.default
	}, {
	  type: 'colorbox',
	  component: _colorboxdropdownpreview2.default
	}, {
	  type: 'combobox',
	  component: _comboboxdropdownpreview2.default
	}, {
	  type: 'map',
	  component: _mapfielddropdownpreview2.default
	}, {
	  type: 'reset',
	  component: _resetbuttondropdownpreview2.default
	}, {
	  type: 'daterange',
	  component: _daterangepickerdropdownpreview2.default
	}, {
	  type: 'sidebar',
	  component: _sidebarpreview2.default
	}, {
	  type: 'mapsearch',
	  component: _mapfielddropdownpreview2.default
	}, {
	  type: 'linearcheckbox',
	  component: _linearcheckboxpreview2.default
	}, {
	  type: 'rnb-daterange',
	  component: _daterangepickerdropdownpreview2.default
	});
	
	function showMarker(post) {
	  var content = void 0;
	  if (post.thumb_url) {
	    content = '<div class="map-marker-custom"><div class="marker-content"><div class="marker-img"><img src="' + post.thumb_url + '" /></div><div class="marker-info"> <h4><a href=" ' + post.post_link + ' "> ' + post.post_title + '</a></h4>' + post.wow.slice(0, 50) + '</div></div></div>';
	  } else {
	    content = '<div class="my-location"><h4>' + post.post_title + '</h4></div>';
	  }
	  return content;
	}
	ReactiveMarkerTemplate['default'] = showMarker;
	ReactiveMarkerTemplate['light'] = showMarker;
	
	function showIcon(post) {
	  // its also possible to show different icon based marker.
	  return '<div class="pin"></div><div class="pulse"></div>';
	}
	
	function showDefaultIcon(post) {
	  return '<div class="pin-alt"></div>';
	}
	
	ReactiveMarkerIcon['default'] = showDefaultIcon;
	ReactiveMarkerIcon['shadow'] = showIcon;
	
	ReactiveCategoryTemplate['default'] = 'showCategoryTemplate';
	ReactiveCategoryTemplate['second'] = 'showCategoryTemplateTwo';
	ReactiveCategoryTemplate['three'] = 'showCategoryTemplateThree';

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkbox = __webpack_require__(727);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var CheckBoxPreview = function (_React$Component) {
	  _inherits(CheckBoxPreview, _React$Component);
	
	  function CheckBoxPreview(props) {
	    _classCallCheck(this, CheckBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (CheckBoxPreview.__proto__ || Object.getPrototypeOf(CheckBoxPreview)).call(this, props));
	
	    _this.handleCheckBoxValue = _this.handleCheckBoxValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true,
	      showItem: 10
	    };
	    _this.filterable = API.filterable === 'true' ? true : false;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleLoadMore = _this.handleLoadMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckBoxPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var defaultItem = null;
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            defaultItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	            this.setState({ defaultItem: defaultItem, showItem: defaultItem });
	          } else {
	            this.setState({ defaultItem: defaultItem });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var showItem = null;
	      var allLayout = (0, _clone2.default)(nextprops.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            showItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	          }
	        }
	      }
	      if (showItem !== this.state.defaultItem) {
	        this.setState({ showItem: showItem, defaultItem: showItem });
	      }
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleCheckBoxValue',
	    value: function handleCheckBoxValue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem, // keys
	        'searchType': this.searchType, // taxonomies or metakeys
	        'searchField': 'checkBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handleLoadMore',
	    value: function handleLoadMore(command) {
	      switch (command) {
	        case 'more':
	          this.setState({ showItem: this.options.length });
	          break;
	        case 'less':
	          var showItem = parseInt(this.state.showItem, 10);
	          var allLayout = (0, _clone2.default)(this.props.allLayout);
	          var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	          if (indexOfSearch !== -1) {
	            var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	            var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	            if (indexOfCheckbox !== -1) {
	              if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	                showItem = searchAttr[indexOfCheckbox]['showItem'];
	              }
	            }
	          }
	          this.setState({ showItem: showItem });
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // this.helperData = RE.hasOwnProperty(this.metakey) ? clone(RE[this.metakey].helperData) : {};
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	      var showItem = this.state.showItem;
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var showLoadMore = true;
	      var showLoadLessBlock = true;
	      if (this.options.length <= showItem) {
	        showItem = this.options.length;
	        showLoadMore = false;
	      }
	      if (this.state.defaultItem > showItem) {
	        showLoadLessBlock = false;
	      }
	      if (this.state.defaultItem === null) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      if (this.block.LoadMoreOption === false || this.block.LoadMoreOption === 'false' || this.block.LoadMoreOption === undefined) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_checkbox2.default, {
	              options: this.options,
	              setColumn: this.props.block.setColumn,
	              showNumberOfItems: this.props.block.showNumberOfItems,
	              isOpenElement: ifOpen, searchItem: this.searchItem,
	              previewData: this.props.previewData.data,
	              value: values,
	              onSelectCheckBox: this.handleCheckBoxValue,
	              showItem: showItem,
	              showLoadMore: showLoadMore,
	              showLoadLessBlock: showLoadLessBlock,
	              onHandleShowMore: this.handleLoadMore,
	              block: this.block
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return CheckBoxPreview;
	}(_react2.default.Component);
	
	CheckBoxPreview.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = CheckBoxPreview;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckBox = function (_React$Component) {
	  _inherits(CheckBox, _React$Component);
	
	  function CheckBox(props) {
	    _classCallCheck(this, CheckBox);
	
	    var _this = _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).call(this, props));
	
	    _this.state = {
	      showItem: 3
	    };
	    _this.handleChecked = _this.handleChecked.bind(_this);
	    _this.handleLoad = _this.handleLoad.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckBox, [{
	    key: 'handleLoad',
	    value: function handleLoad(type, e) {
	      e.preventDefault();
	      this.props.onHandleShowMore(type);
	    }
	  }, {
	    key: 'handleChecked',
	    value: function handleChecked(e) {
	      var values = [];
	      this.options.forEach(function (item) {
	        if (item.key === parseInt(e.target.value, 10)) {
	          item.isChecked = e.target.checked;
	        }
	        if (item.isChecked) values.push(item);
	      });
	      this.props.onSelectCheckBox(values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.options = (0, _clone2.default)(this.props.options);
	      this.options.map(function (item) {
	        if (_this2.props.value.indexOf(item.slug) !== -1) {
	          item.isChecked = true;
	        }
	        _this2.props.previewData.map(function (filterItem) {
	          for (var key in filterItem.terms) {
	            if (key === _this2.props.searchItem) {
	              if (filterItem.terms[key].indexOf(item.slug) !== -1) {
	                item.isEnabled = 'enabled';
	              }
	            }
	          }
	        });
	        if (!item.isEnabled) {
	          item.isEnabled = 'disabled';
	        }
	      });
	      //  disabled={item.isEnabled === 'enabled' ? '' : 'disabled'}
	      var singleCheckBoxItem = function singleCheckBoxItem(item, index) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'single-input searchoption', key: 're-checkobx-' + index },
	          _react2.default.createElement('input', { type: 'checkbox', id: item.slug + '-' + _this2.props.block.uid, checked: item.isChecked, value: item.key, onChange: _this2.handleChecked }),
	          _react2.default.createElement(
	            'label',
	            { className: '', htmlFor: item.slug + '-' + _this2.props.block.uid },
	            _react2.default.createElement(
	              'span',
	              { className: 'rq-search-text' },
	              item.value
	            ),
	            _this2.props.showNumberOfItems === 'true' ? _react2.default.createElement(
	              'span',
	              { className: 'pull-right rq-number-of-product' },
	              item.count
	            ) : ''
	          )
	        );
	      };
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      var setColumnStyle = null;
	      if (this.props.setColumn === '1') {
	        setColumnStyle = 'checkbox-input-content';
	      } else if (this.props.setColumn === '2') {
	        setColumnStyle = 'checkbox-input-content split';
	      } else if (this.props.setColumn === '3') {
	        setColumnStyle = 'checkbox-input-content split-2';
	      } else if (this.props.setColumn === '4') {
	        setColumnStyle = 'checkbox-input-content split-3';
	      }
	      var options = [];
	      var showItem = this.props.showItem;
	      for (var key = 0; key < showItem; key++) {
	        options.push(this.options[key]);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement(
	          'span',
	          { className: setColumnStyle },
	          this.options.length ? options.map(singleCheckBoxItem) : null
	        ),
	        this.props.showLoadLessBlock === true ? _react2.default.createElement(
	          'div',
	          null,
	          this.props.showLoadMore === true ? _react2.default.createElement(
	            'a',
	            { className: 'show-less-btn', href: '#', onClick: this.handleLoad.bind(this, 'more') },
	            'Show More'
	          ) : _react2.default.createElement(
	            'a',
	            { className: 'show-less-btn', href: '#', onClick: this.handleLoad.bind(this, 'less') },
	            'Show Less'
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return CheckBox;
	}(_react2.default.Component);
	
	CheckBox.propTypes = {
	  'previewData': _react2.default.PropTypes.array,
	  'searchItem': _react2.default.PropTypes.string,
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'onSelectCheckBox': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string,
	  'showNumberOfItems': _react2.default.PropTypes.string,
	  'setColumn': _react2.default.PropTypes.string,
	  'block': _react2.default.PropTypes.object
	};
	
	exports.default = CheckBox;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _toogleHandlerStore = __webpack_require__(723);
	
	var _toogleHandlerStore2 = _interopRequireDefault(_toogleHandlerStore);
	
	var _toogleHandlerActions = __webpack_require__(724);
	
	var _toogleHandlerActions2 = _interopRequireDefault(_toogleHandlerActions);
	
	var _helperFunction = __webpack_require__(501);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Title = function (_React$Component) {
	  _inherits(Title, _React$Component);
	
	  function Title(props) {
	    _classCallCheck(this, Title);
	
	    var _this = _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).call(this, props));
	
	    _this.switchtoogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Title, [{
	    key: 'switchtoogle',
	    value: function switchtoogle() {
	      if (this.props.dropdown === true) {
	        _toogleHandlerActions2.default.dropdownToogle(this.props.field);
	      } else {
	        this.props.onToogle();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var defaultTitle = this.props.title !== '' ? this.props.title : 'Enter a title!';
	      var defautlSubTitle = this.props.subtitle !== '' ? this.props.subtitle : '';
	      var toggleClass = this.props.toogle ? 'active' : '';
	      var toogleView = {
	        display: this.props.selectedToogleViewType === 'true' ? 'block' : 'none'
	      };
	      if (defaultTitle.length > 0) {
	        defaultTitle = (0, _helperFunction.stringify)(defaultTitle);
	      }
	      if (defautlSubTitle !== undefined) {
	        if (defautlSubTitle.length > 0) {
	          defautlSubTitle = (0, _helperFunction.stringify)(defautlSubTitle);
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'title-content' },
	        this.props.dropdown === true ? _react2.default.createElement(
	          'h3',
	          { className: 'sidebar-title' },
	          _react2.default.createElement(
	            'a',
	            { className: toggleClass, style: toogleView, onClick: this.switchtoogle.bind(this) },
	            _react2.default.createElement(
	              'span',
	              null,
	              defaultTitle
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'sidebar-subtitle' },
	              defautlSubTitle
	            )
	          )
	        ) : _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h3',
	            { className: 'sidebar-title default' },
	            defaultTitle,
	            _react2.default.createElement('a', { className: toggleClass, style: toogleView, onClick: this.switchtoogle.bind(this) })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'sidebar-subtitle' },
	            defautlSubTitle
	          )
	        )
	      );
	    }
	  }]);
	
	  return Title;
	}(_react2.default.Component);
	
	Title.propTypes = {
	  'title': _react2.default.PropTypes.string,
	  'subtitle': _react2.default.PropTypes.string,
	  'onToogle': _react2.default.PropTypes.func,
	  'toogle': _react2.default.PropTypes.bool,
	  'selectedToogleViewType': _react2.default.PropTypes.string
	};
	
	exports.default = Title;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _linearcheckbox = __webpack_require__(730);
	
	var _linearcheckbox2 = _interopRequireDefault(_linearcheckbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var LinearCheckBoxPreview = function (_React$Component) {
	  _inherits(LinearCheckBoxPreview, _React$Component);
	
	  function LinearCheckBoxPreview(props) {
	    _classCallCheck(this, LinearCheckBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (LinearCheckBoxPreview.__proto__ || Object.getPrototypeOf(LinearCheckBoxPreview)).call(this, props));
	
	    _this.handleCheckBoxValue = _this.handleCheckBoxValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true,
	      showItem: 10
	    };
	    _this.filterable = API.filterable === 'true' ? true : false;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleLoadMore = _this.handleLoadMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(LinearCheckBoxPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var defaultItem = null;
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            defaultItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	            this.setState({ defaultItem: defaultItem, showItem: defaultItem });
	          } else {
	            this.setState({ defaultItem: defaultItem });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var showItem = null;
	      var allLayout = (0, _clone2.default)(nextprops.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            showItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	          }
	        }
	      }
	      if (showItem !== this.state.defaultItem) {
	        this.setState({ showItem: showItem, defaultItem: showItem });
	      }
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleCheckBoxValue',
	    value: function handleCheckBoxValue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem, // keys
	        'searchType': this.searchType, // taxonomies or metakeys
	        'searchField': 'linearCheckbox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handleLoadMore',
	    value: function handleLoadMore(command) {
	      switch (command) {
	        case 'more':
	          this.setState({ showItem: this.options.length });
	          break;
	        case 'less':
	          var showItem = parseInt(this.state.showItem, 10);
	          var allLayout = (0, _clone2.default)(this.props.allLayout);
	          var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	          if (indexOfSearch !== -1) {
	            var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	            var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	            if (indexOfCheckbox !== -1) {
	              if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	                showItem = searchAttr[indexOfCheckbox]['showItem'];
	              }
	            }
	          }
	          this.setState({ showItem: showItem });
	          break;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // this.helperData = RE.hasOwnProperty(this.metakey) ? clone(RE[this.metakey].helperData) : {};
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	      var showItem = this.state.showItem;
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var showLoadMore = true;
	      var showLoadLessBlock = true;
	      if (this.options.length <= showItem) {
	        showItem = this.options.length;
	        showLoadMore = false;
	      }
	      if (this.state.defaultItem > showItem) {
	        showLoadLessBlock = false;
	      }
	      if (this.state.defaultItem === null) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      if (this.block.LoadMoreOption === false || this.block.LoadMoreOption === 'false' || this.block.LoadMoreOption === undefined) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_linearcheckbox2.default, {
	              title: this.props.block.title,
	              options: this.options,
	              setColumn: this.props.block.setColumn ? this.props.block.setColumn : 3,
	              showNumberOfItems: this.props.block.showNumberOfItems,
	              isOpenElement: ifOpen, searchItem: this.searchItem,
	              previewData: this.props.previewData.data,
	              value: values,
	              onSelectCheckBox: this.handleCheckBoxValue,
	              showItem: showItem,
	              showLoadMore: showLoadMore,
	              showLoadLessBlock: showLoadLessBlock,
	              onHandleShowMore: this.handleLoadMore,
	              block: this.block
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return LinearCheckBoxPreview;
	}(_react2.default.Component);
	
	LinearCheckBoxPreview.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = LinearCheckBoxPreview;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinearCheckBox = function (_React$Component) {
	  _inherits(LinearCheckBox, _React$Component);
	
	  function LinearCheckBox(props) {
	    _classCallCheck(this, LinearCheckBox);
	
	    var _this = _possibleConstructorReturn(this, (LinearCheckBox.__proto__ || Object.getPrototypeOf(LinearCheckBox)).call(this, props));
	
	    _this.state = {
	      showItem: 3,
	      collapse: false
	    };
	    _this.handleChecked = _this.handleChecked.bind(_this);
	    _this.handleLoad = _this.handleLoad.bind(_this);
	    return _this;
	  }
	
	  _createClass(LinearCheckBox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'handleLoad',
	    value: function handleLoad(type, e) {
	      e.preventDefault();
	      this.setState({ collapse: !this.state.collapse });
	      // this.props.onHandleShowMore(type);
	    }
	  }, {
	    key: 'handleChecked',
	    value: function handleChecked(e) {
	      var values = [];
	      this.options.forEach(function (item) {
	        if (item.key === parseInt(e.target.value, 10)) {
	          item.isChecked = e.target.checked;
	        }
	        if (item.isChecked) values.push(item);
	      });
	      this.props.onSelectCheckBox(values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.options = (0, _clone2.default)(this.props.options);
	      this.options.map(function (item) {
	        if (_this2.props.value.indexOf(item.slug) !== -1) {
	          item.isChecked = true;
	        }
	        _this2.props.previewData.map(function (filterItem) {
	          for (var key in filterItem.terms) {
	            if (key === _this2.props.searchItem) {
	              if (filterItem.terms[key].indexOf(item.slug) !== -1) {
	                item.isEnabled = 'enabled';
	              }
	            }
	          }
	        });
	        if (!item.isEnabled) {
	          item.isEnabled = 'disabled';
	        }
	      });
	      //  disabled={item.isEnabled === 'enabled' ? '' : 'disabled'}
	      var singleCheckBoxItem = function singleCheckBoxItem(item, index) {
	
	        return _react2.default.createElement(
	          'span',
	          { className: 'single-input searchoption', key: 'liCheckbox-' + index },
	          _react2.default.createElement('input', { type: 'checkbox', id: item.slug + '-' + _this2.props.block.uid, checked: item.isChecked, value: item.key, onChange: _this2.handleChecked }),
	          _react2.default.createElement(
	            'label',
	            { className: '', htmlFor: item.slug + '-' + _this2.props.block.uid },
	            _react2.default.createElement(
	              'span',
	              { className: 'rq-search-text' },
	              item.value
	            ),
	            _this2.props.showNumberOfItems === 'true' ? _react2.default.createElement(
	              'span',
	              { className: 'pull-right rq-number-of-product' },
	              item.count
	            ) : ''
	          )
	        );
	      };
	
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      var setColumnStyle = null;
	      if (this.props.setColumn === '1') {
	        setColumnStyle = 'checkbox-input-content';
	      } else if (this.props.setColumn === '2') {
	        setColumnStyle = 'checkbox-input-content split';
	      } else if (this.props.setColumn === '3') {
	        setColumnStyle = 'checkbox-input-content split-2';
	      } else if (this.props.setColumn === '4') {
	        setColumnStyle = 'checkbox-input-content split-3';
	      }
	      var firstRowOptions = [];
	      var remainingRowOptions = [];
	      var showItem = this.props.showItem;
	      for (var key = 0; key < showItem; key++) {
	        if (key < parseInt(this.props.setColumn, 10)) {
	          firstRowOptions.push(this.options[key]);
	        } else if (this.state.collapse === true) {
	          remainingRowOptions.push(this.options[key]);
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row rq-linear-search-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-xs-11 flex-md-3' },
	            _react2.default.createElement(
	              'span',
	              { className: 'linearcheckboxtitle' },
	              this.props.title
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-md-8 flex-xs-12' },
	            _react2.default.createElement(
	              'span',
	              { className: setColumnStyle },
	              firstRowOptions.length !== 0 && this.state.collapse === true ? _react2.default.createElement(
	                'div',
	                { className: 'linear-checkbox-firstrow' },
	                ' ',
	                firstRowOptions.map(singleCheckBoxItem),
	                ' '
	              ) : _react2.default.createElement(
	                'div',
	                null,
	                firstRowOptions.map(singleCheckBoxItem)
	              ),
	              remainingRowOptions.length !== 0 ? remainingRowOptions.map(singleCheckBoxItem) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex-xs-1 flex-md-1' },
	            _react2.default.createElement(
	              'a',
	              { className: 'show-less-btn', href: '#', onClick: this.handleLoad.bind(this, 'more') },
	              this.state.collapse === false ? _react2.default.createElement('i', { className: 'fa fa-chevron-down' }) : _react2.default.createElement('i', { className: 'fa fa-chevron-up' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinearCheckBox;
	}(_react2.default.Component);
	
	LinearCheckBox.propTypes = {
	  'previewData': _react2.default.PropTypes.array,
	  'searchItem': _react2.default.PropTypes.string,
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'onSelectCheckBox': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string,
	  'showNumberOfItems': _react2.default.PropTypes.string,
	  'setColumn': _react2.default.PropTypes.string,
	  'block': _react2.default.PropTypes.object
	};
	
	exports.default = LinearCheckBox;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkbox = __webpack_require__(727);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var CheckBoxPreview = function (_React$Component) {
	  _inherits(CheckBoxPreview, _React$Component);
	
	  function CheckBoxPreview(props) {
	    _classCallCheck(this, CheckBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (CheckBoxPreview.__proto__ || Object.getPrototypeOf(CheckBoxPreview)).call(this, props));
	
	    _this.handleCheckBoxValue = _this.handleCheckBoxValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false,
	      showItem: 10
	    };
	    _this.filterable = API.filterable === 'true' ? true : false;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleLoadMore = _this.handleLoadMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(CheckBoxPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var defaultItem = null;
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            defaultItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	            this.setState({ defaultItem: defaultItem, showItem: defaultItem });
	          } else {
	            this.setState({ defaultItem: defaultItem });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var showItem = null;
	      var allLayout = (0, _clone2.default)(nextprops.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            showItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	          }
	        }
	      }
	      if (showItem !== this.state.defaultItem) {
	        this.setState({ showItem: showItem });
	      }
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleLoadMore',
	    value: function handleLoadMore(command) {
	      switch (command) {
	        case 'more':
	          this.setState({ showItem: this.options.length });
	          break;
	        case 'less':
	          var showItem = parseInt(this.state.showItem, 10);
	          var allLayout = (0, _clone2.default)(this.props.allLayout);
	          var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	          if (indexOfSearch !== -1) {
	            var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	            var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'checkbox' });
	            if (indexOfCheckbox !== -1) {
	              if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	                showItem = searchAttr[indexOfCheckbox]['showItem'];
	              }
	            }
	          }
	          this.setState({ showItem: showItem });
	          break;
	      }
	    }
	  }, {
	    key: 'handleCheckBoxValue',
	    value: function handleCheckBoxValue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem, // keys
	        'searchType': this.searchType, // taxonomies or metakeys
	        'searchField': 'checkBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	      var showItem = this.state.showItem;
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var showLoadMore = true;
	      var showLoadLessBlock = true;
	      if (this.options.length <= showItem) {
	        showItem = this.options.length;
	        showLoadMore = false;
	      }
	      if (this.state.defaultItem > showItem) {
	        showLoadLessBlock = false;
	      }
	      if (this.state.defaultItem === null) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      if (this.block.LoadMoreOption === false || this.block.LoadMoreOption === 'false' || this.block.LoadMoreOption === undefined) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_checkbox2.default, {
	              options: this.options,
	              isOpenElement: ifOpen,
	              setColumn: this.props.block.setColumn,
	              showNumberOfItems: this.props.block.showNumberOfItems,
	              searchItem: this.searchItem,
	              previewData: this.props.previewData.data,
	              value: values,
	              onSelectCheckBox: this.handleCheckBoxValue,
	              showItem: showItem,
	              showLoadMore: showLoadMore,
	              showLoadLessBlock: showLoadLessBlock,
	              onHandleShowMore: this.handleLoadMore,
	              block: this.block
	            })
	          ) : null,
	          this.options.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return CheckBoxPreview;
	}(_react2.default.Component);
	
	CheckBoxPreview.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = CheckBoxPreview;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radiobox = __webpack_require__(733);
	
	var _radiobox2 = _interopRequireDefault(_radiobox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var RadioBoxPreview = function (_React$Component) {
	  _inherits(RadioBoxPreview, _React$Component);
	
	  function RadioBoxPreview(props) {
	    _classCallCheck(this, RadioBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (RadioBoxPreview.__proto__ || Object.getPrototypeOf(RadioBoxPreview)).call(this, props));
	
	    _this.handleRadioBoxValue = _this.handleRadioBoxValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true,
	      showItem: 10
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleLoadMore = _this.handleLoadMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(RadioBoxPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var defaultItem = null;
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'radio' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            defaultItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	            this.setState({ defaultItem: defaultItem, showItem: defaultItem });
	          } else {
	            this.setState({ defaultItem: defaultItem });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var showItem = null;
	      var allLayout = (0, _clone2.default)(nextprops.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'radio' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            showItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	          }
	        }
	      }
	      if (showItem !== this.state.defaultItem) {
	        this.setState({ showItem: showItem });
	      }
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleLoadMore',
	    value: function handleLoadMore(command) {
	      switch (command) {
	        case 'more':
	          this.setState({ showItem: this.options.length });
	          break;
	        case 'less':
	          var showItem = parseInt(this.state.showItem, 10);
	          var allLayout = (0, _clone2.default)(this.props.allLayout);
	          var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	          if (indexOfSearch !== -1) {
	            var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	            var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'radio' });
	            if (indexOfCheckbox !== -1) {
	              if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	                showItem = searchAttr[indexOfCheckbox]['showItem'];
	              }
	            }
	          }
	          this.setState({ showItem: showItem });
	          break;
	      }
	    }
	  }, {
	    key: 'handleRadioBoxValue',
	    value: function handleRadioBoxValue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'radioBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // this.helperData = this.props.hasOwnProperty(this.metakey) ? clone(RE[this.metakey].helperData) : {};
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	        // url case
	        // console.log(this.searchItem);
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	
	      var showItem = this.state.showItem;
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var showLoadMore = true;
	      var showLoadLessBlock = true;
	      if (this.options.length <= showItem) {
	        showItem = this.options.length;
	        showLoadMore = false;
	      }
	      if (this.state.defaultItem > showItem) {
	        showLoadLessBlock = false;
	      }
	      if (this.state.defaultItem === null) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      if (this.block.LoadMoreOption === false || this.block.LoadMoreOption === 'false' || this.block.LoadMoreOption === undefined) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      // console.log(this.options);
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_radiobox2.default, { isOpenElement: ifOpen,
	              setColumn: this.props.block.setColumn,
	              showNumberOfItems: this.props.block.showNumberOfItems,
	              options: this.options,
	              value: values,
	              onSelectRadio: this.handleRadioBoxValue,
	              showItem: showItem,
	              showLoadMore: showLoadMore,
	              showLoadLessBlock: showLoadLessBlock,
	              onHandleShowMore: this.handleLoadMore,
	              block: this.block
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'No Attributes Found'
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return RadioBoxPreview;
	}(_react2.default.Component);
	
	RadioBoxPreview.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = RadioBoxPreview;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioBox = function (_React$Component) {
	  _inherits(RadioBox, _React$Component);
	
	  function RadioBox(props) {
	    _classCallCheck(this, RadioBox);
	
	    var _this = _possibleConstructorReturn(this, (RadioBox.__proto__ || Object.getPrototypeOf(RadioBox)).call(this, props));
	
	    _this.handleRadioBox = _this.handleRadioBox.bind(_this);
	    _this.handleLoad = _this.handleLoad.bind(_this);
	    return _this;
	  }
	
	  _createClass(RadioBox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'handleRadioBox',
	    value: function handleRadioBox(e) {
	      // console.log(e.target);
	      var values = [];
	      this.options.forEach(function (item) {
	        if (item.key === parseInt(e.target.value, 10)) {
	          item.isChecked = e.target.checked;
	          values.push(item);
	        }
	      });
	      // console.log(values);
	      this.props.onSelectRadio(values);
	    }
	  }, {
	    key: 'handleLoad',
	    value: function handleLoad(type, e) {
	      e.preventDefault();
	      this.props.onHandleShowMore(type);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.options = (0, _clone2.default)(this.props.options);
	      // console.log(this.props);
	      this.options.map(function (item) {
	        if (_this2.props.value.indexOf(item.slug) !== -1) {
	          item.isChecked = true;
	        } else {
	          item.isChecked = false;
	        }
	      });
	      var singleRadioBoxItem = function singleRadioBoxItem(item, index) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'single-input searchoption', key: 'radio-' + index },
	          _react2.default.createElement('input', { type: 'radio', id: item.slug + '-' + _this2.props.block.uid, checked: item.isChecked, value: item.key, onChange: _this2.handleRadioBox }),
	          _react2.default.createElement(
	            'label',
	            { className: '', htmlFor: item.slug + '-' + _this2.props.block.uid },
	            _react2.default.createElement(
	              'span',
	              { className: 'rq-search-text' },
	              item.value
	            ),
	            _this2.props.showNumberOfItems === 'true' ? _react2.default.createElement(
	              'span',
	              { className: 'pull-right rq-number-of-product' },
	              item.count
	            ) : ''
	          )
	        );
	      };
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      var setColumnStyle = null;
	      if (this.props.setColumn === '1') {
	        setColumnStyle = 'radio-input-content';
	      } else if (this.props.setColumn === '2') {
	        setColumnStyle = 'radio-input-content split';
	      } else if (this.props.setColumn === '3') {
	        setColumnStyle = 'radio-input-content split-2';
	      } else if (this.props.setColumn === '4') {
	        setColumnStyle = 'radio-input-content split-3';
	      }
	      var options = [];
	      var showItem = this.props.showItem;
	      for (var key = 0; key < showItem; key++) {
	        options.push(this.options[key]);
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement(
	          'span',
	          { className: setColumnStyle },
	          this.options.length ? options.map(singleRadioBoxItem) : null
	        ),
	        this.props.showLoadLessBlock === true ? _react2.default.createElement(
	          'div',
	          null,
	          this.props.showLoadMore === true ? _react2.default.createElement(
	            'a',
	            { className: 'show-less-btn', href: '#', onClick: this.handleLoad.bind(this, 'more') },
	            'Show More'
	          ) : _react2.default.createElement(
	            'a',
	            { className: 'show-less-btn', href: '#', onClick: this.handleLoad.bind(this, 'less') },
	            'Show Less'
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return RadioBox;
	}(_react2.default.Component);
	
	RadioBox.propTypes = {
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'onSelectRadio': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string,
	  'showNumberOfItems': _react2.default.PropTypes.string,
	  'setColumn': _react2.default.PropTypes.string,
	  'block': _react2.default.PropTypes.object
	};
	
	exports.default = RadioBox;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radiobox = __webpack_require__(733);
	
	var _radiobox2 = _interopRequireDefault(_radiobox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var RadioBoxPreview = function (_React$Component) {
	  _inherits(RadioBoxPreview, _React$Component);
	
	  function RadioBoxPreview(props) {
	    _classCallCheck(this, RadioBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (RadioBoxPreview.__proto__ || Object.getPrototypeOf(RadioBoxPreview)).call(this, props));
	
	    _this.handleRadioBoxValue = _this.handleRadioBoxValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false,
	      showItem: 10
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleLoadMore = _this.handleLoadMore.bind(_this);
	    return _this;
	  }
	
	  _createClass(RadioBoxPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var defaultItem = null;
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'radio' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            defaultItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	            this.setState({ defaultItem: defaultItem, showItem: defaultItem });
	          } else {
	            this.setState({ defaultItem: defaultItem });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var showItem = null;
	      var allLayout = (0, _clone2.default)(nextprops.allLayout);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	      if (indexOfSearch !== -1) {
	        var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	        var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'radio' });
	        if (indexOfCheckbox !== -1) {
	          if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	            showItem = parseInt(searchAttr[indexOfCheckbox]['showItem'], 10);
	          }
	        }
	      }
	      if (showItem !== this.state.defaultItem) {
	        this.setState({ showItem: showItem });
	      }
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleLoadMore',
	    value: function handleLoadMore(command) {
	      switch (command) {
	        case 'more':
	          this.setState({ showItem: this.options.length });
	          break;
	        case 'less':
	          var showItem = parseInt(this.state.showItem, 10);
	          var allLayout = (0, _clone2.default)(this.props.allLayout);
	          var indexOfSearch = (0, _underscore.findIndex)(allLayout, { type: 'search' });
	          if (indexOfSearch !== -1) {
	            var searchAttr = (0, _clone2.default)(allLayout[indexOfSearch].searchAttr);
	            var indexOfCheckbox = (0, _underscore.findIndex)(searchAttr, { viewType: 'radio' });
	            if (indexOfCheckbox !== -1) {
	              if (searchAttr[indexOfCheckbox].hasOwnProperty('showItem')) {
	                showItem = searchAttr[indexOfCheckbox]['showItem'];
	              }
	            }
	          }
	          this.setState({ showItem: showItem });
	          break;
	      }
	    }
	  }, {
	    key: 'handleRadioBoxValue',
	    value: function handleRadioBoxValue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'radioBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // this.helperData = this.props.hasOwnProperty(this.metakey) ? clone(RE[this.metakey].helperData) : {};
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	      var showItem = this.state.showItem;
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var showLoadMore = true;
	      var showLoadLessBlock = true;
	      if (this.options.length <= showItem) {
	        showItem = this.options.length;
	        showLoadMore = false;
	      }
	      if (this.state.defaultItem > showItem) {
	        showLoadLessBlock = false;
	      }
	      if (this.state.defaultItem === null) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      if (this.block.LoadMoreOption === false || this.block.LoadMoreOption === 'false' || this.block.LoadMoreOption === undefined) {
	        showLoadMore = false;
	        showLoadLessBlock = false;
	        showItem = this.options.length;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_radiobox2.default, {
	              isOpenElement: ifOpen,
	              setColumn: this.props.block.setColumn,
	              showNumberOfItems: this.props.block.showNumberOfItems,
	              options: this.options,
	              value: values,
	              onSelectRadio: this.handleRadioBoxValue,
	              showItem: showItem,
	              showLoadMore: showLoadMore,
	              showLoadLessBlock: showLoadLessBlock,
	              onHandleShowMore: this.handleLoadMore,
	              block: this.block
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return RadioBoxPreview;
	}(_react2.default.Component);
	
	RadioBoxPreview.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = RadioBoxPreview;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var SelectBoxPreview = function (_React$Component) {
	  _inherits(SelectBoxPreview, _React$Component);
	
	  function SelectBoxPreview(props) {
	    _classCallCheck(this, SelectBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (SelectBoxPreview.__proto__ || Object.getPrototypeOf(SelectBoxPreview)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectBoxPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var index = (0, _underscore.findIndex)(window.searchArray, { viewType: 'select' });
	      if (index !== -1) {
	        this.setState({ values: window.searchArray[index].value });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(multi, values) {
	      if (values === null) {
	        _urlHandlerActions2.default.push({
	          'searchItem': this.searchItem,
	          'searchType': this.searchType,
	          'searchField': 'selectBox',
	          'values': []
	        });
	        return;
	      }
	      var valuesSelected = [];
	      var selectedindex = (0, _underscore.findIndex)(this.options, { key: parseInt(values.value, 10) });
	      if (selectedindex !== -1) {
	        valuesSelected.push(this.options[selectedindex]);
	        var value = values.label;
	        this.setState({ values: value });
	      }
	      // this.setState({ 'values': _.pluck(values, 'key') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'values': valuesSelected,
	        'searchField': 'selectBox'
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      this.options = [];
	      var values = this.state.values;
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	      if ($.isArray(values) === false) {
	        var newValues = [];
	        newValues.push(values);
	        values = (0, _clone2.default)(newValues);
	      }
	      var selectedValue = null;
	      this.selectOptions = [];
	      this.options.map(function (item) {
	        if (item.slug.toString() !== values[0]) {
	          _this2.selectOptions.push({
	            label: item.slug,
	            value: item.key
	          });
	        } else {
	          _this2.selectOptions.push({
	            label: item.slug,
	            value: item.key
	          });
	          selectedValue = item.key;
	        }
	      });
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.selectOptions !== undefined && this.selectOptions.length ? _react2.default.createElement(
	            'div',
	            null,
	            this.state.toogle && this.selectOptions.length ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactSelect2.default, { name: 'form-field-name',
	                options: this.selectOptions,
	                value: selectedValue,
	                onChange: this.handleChange.bind(this, true)
	              })
	            ) : null
	          ) : null,
	          this.selectOptions.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return SelectBoxPreview;
	}(_react2.default.Component);
	
	SelectBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = SelectBoxPreview;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _reactSelect = __webpack_require__(165);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var SelectBoxPreview = function (_React$Component) {
	  _inherits(SelectBoxPreview, _React$Component);
	
	  function SelectBoxPreview(props) {
	    _classCallCheck(this, SelectBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (SelectBoxPreview.__proto__ || Object.getPrototypeOf(SelectBoxPreview)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(SelectBoxPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var index = (0, _underscore.findIndex)(window.searchArray, { viewType: 'select' });
	      if (index !== -1) {
	        this.setState({ values: window.searchArray[index].value });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(multi, values) {
	      if (values === null) {
	        _urlHandlerActions2.default.push({
	          'searchItem': this.searchItem,
	          'searchType': this.searchType,
	          'searchField': 'selectBox',
	          'values': []
	        });
	        return;
	      }
	      var valuesSelected = [];
	      var selectedindex = (0, _underscore.findIndex)(this.options, { key: parseInt(values.value, 10) });
	      if (selectedindex !== -1) {
	        valuesSelected.push(this.options[selectedindex]);
	        var value = values.label;
	        this.setState({ values: value });
	      }
	      // this.setState({ 'values': _.pluck(values, 'key') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'values': valuesSelected
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      this.options = [];
	      var values = this.state.values;
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	      if ($.isArray(values) === false) {
	        var newValues = [];
	        newValues.push(values);
	        values = (0, _clone2.default)(newValues);
	      }
	      var selectedValue = null;
	      this.selectOptions = [];
	      this.options.map(function (item) {
	        if (item.slug.toString() !== values[0]) {
	          _this2.selectOptions.push({
	            label: item.slug,
	            value: item.key
	          });
	        } else {
	          _this2.selectOptions.push({
	            label: item.slug,
	            value: item.key
	          });
	          selectedValue = item.key;
	        }
	      });
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.selectOptions !== undefined && this.selectOptions.length ? _react2.default.createElement(
	            'div',
	            null,
	            this.state.toogle && this.selectOptions.length ? _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactSelect2.default, { name: 'form-field-name',
	                options: this.selectOptions,
	                value: selectedValue,
	                onChange: this.handleChange.bind(this, true)
	              })
	            ) : null
	          ) : null,
	          this.selectOptions.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return SelectBoxPreview;
	}(_react2.default.Component);
	
	SelectBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = SelectBoxPreview;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sizebox = __webpack_require__(738);
	
	var _sizebox2 = _interopRequireDefault(_sizebox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var SizeBoxPreview = function (_React$Component) {
	  _inherits(SizeBoxPreview, _React$Component);
	
	  function SizeBoxPreview(props) {
	    _classCallCheck(this, SizeBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (SizeBoxPreview.__proto__ || Object.getPrototypeOf(SizeBoxPreview)).call(this, props));
	
	    _this.handleSizeBoxValue = _this.handleSizeBoxValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(SizeBoxPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleSizeBoxValue',
	    value: function handleSizeBoxValue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'sizeBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        }
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var sizeBoxClassName = this.props.block.dynamicNameClassSizeBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: sizeBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_sizebox2.default, {
	              isOpenElement: ifOpen,
	              type: this.props.block.selectedViewType,
	              options: this.options,
	              value: values,
	              onSelectSizeBox: this.handleSizeBoxValue
	            })
	          ) : null,
	          this.options !== undefined ? _react2.default.createElement(
	            'div',
	            null,
	            this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	              'div',
	              { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	              _react2.default.createElement(
	                'h3',
	                null,
	                API.LANG.NO_ATTR_FOUND
	              )
	            ) : ''
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return SizeBoxPreview;
	}(_react2.default.Component);
	
	SizeBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = SizeBoxPreview;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SizeBox = function (_React$Component) {
	  _inherits(SizeBox, _React$Component);
	
	  function SizeBox(props) {
	    _classCallCheck(this, SizeBox);
	
	    var _this = _possibleConstructorReturn(this, (SizeBox.__proto__ || Object.getPrototypeOf(SizeBox)).call(this, props));
	
	    _this.handleChecked = _this.handleChecked.bind(_this);
	    return _this;
	  }
	
	  _createClass(SizeBox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'handleChecked',
	    value: function handleChecked(e) {
	      var values = [];
	      this.options.forEach(function (item) {
	        if (item.key === parseInt(e.target.value, 10)) {
	          item.isChecked = e.target.checked;
	          values.push(item);
	        }
	      });
	      this.props.onSelectSizeBox(values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.options = (0, _clone2.default)(this.props.options);
	      this.options.map(function (item) {
	        if (_this2.props.value.indexOf(item.slug) !== -1) {
	          item.isChecked = true;
	        }
	      });
	      var CustomClassNameMainSpan = (0, _classnames2.default)({
	        'radio-input-content': true,
	        'size-box-list': this.props.type === 'list'
	      });
	      var CustomClassName = (0, _classnames2.default)({
	        'single-input size-box': true,
	        'big': this.props.type === 'big',
	        'list': this.props.type === 'list'
	
	      });
	      var singleSizeBoxItem = function singleSizeBoxItem(item, index) {
	        return _react2.default.createElement(
	          'span',
	          { className: CustomClassName, key: 'sizebox-' + index },
	          _react2.default.createElement('input', { type: 'radio', id: 'sizebox-' + item.slug, checked: item.isChecked, value: item.key, onChange: _this2.handleChecked }),
	          _react2.default.createElement(
	            'label',
	            { className: '', htmlFor: 'sizebox-' + item.slug },
	            item.value
	          )
	        );
	      };
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement(
	          'span',
	          { className: CustomClassNameMainSpan },
	          this.options.length ? this.options.map(singleSizeBoxItem) : null
	        )
	      );
	    }
	  }]);
	
	  return SizeBox;
	}(_react2.default.Component);
	
	SizeBox.propTypes = {
	  'type': _react2.default.PropTypes.string,
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'onSelectSizeBox': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string
	};
	
	exports.default = SizeBox;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sizebox = __webpack_require__(738);
	
	var _sizebox2 = _interopRequireDefault(_sizebox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var SizeBoxPreview = function (_React$Component) {
	  _inherits(SizeBoxPreview, _React$Component);
	
	  function SizeBoxPreview(props) {
	    _classCallCheck(this, SizeBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (SizeBoxPreview.__proto__ || Object.getPrototypeOf(SizeBoxPreview)).call(this, props));
	
	    _this.handleSizeBoxValue = _this.handleSizeBoxValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(SizeBoxPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	    }
	  }, {
	    key: 'handleSizeBoxValue',
	    value: function handleSizeBoxValue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'sizeBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        }
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var sizeBoxClassName = this.props.block.dynamicNameClassSizeBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: sizeBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_sizebox2.default, {
	              isOpenElement: ifOpen,
	              type: this.props.block.selectedViewType,
	              options: this.options,
	              value: values,
	              onSelectSizeBox: this.handleSizeBoxValue
	            })
	          ) : null,
	          this.options !== undefined ? _react2.default.createElement(
	            'div',
	            null,
	            this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	              'div',
	              { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	              _react2.default.createElement(
	                'h3',
	                null,
	                API.LANG.NO_ATTR_FOUND
	              )
	            ) : ''
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return SizeBoxPreview;
	}(_react2.default.Component);
	
	SizeBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = SizeBoxPreview;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _textbox = __webpack_require__(741);
	
	var _textbox2 = _interopRequireDefault(_textbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBoxPreview = function (_React$Component) {
	  _inherits(TextBoxPreview, _React$Component);
	
	  function TextBoxPreview(props) {
	    _classCallCheck(this, TextBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (TextBoxPreview.__proto__ || Object.getPrototypeOf(TextBoxPreview)).call(this, props));
	
	    _this.state = {
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleTextbox = _this.handleTextbox.bind(_this);
	    return _this;
	  }
	
	  _createClass(TextBoxPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handleTextbox',
	    value: function handleTextbox(values) {
	      _urlHandlerActions2.default.push({
	        'searchItem': 'search_item',
	        'searchType': 'globalSearch',
	        'searchField': 'textbox',
	        values: values
	      });
	      this.setState({ values: values });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var values = this.props.urlData.search_item;
	      var textBoxClassName = this.props.block.dynamicNameClassTextBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: textBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          _react2.default.createElement(_textbox2.default, { value: values, grabTextBoxValue: this.handleTextbox })
	        ) : null
	      );
	    }
	  }]);
	
	  return TextBoxPreview;
	}(_react2.default.Component);
	
	TextBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = TextBoxPreview;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBox = function (_React$Component) {
	  _inherits(TextBox, _React$Component);
	
	  function TextBox(props) {
	    _classCallCheck(this, TextBox);
	
	    var _this = _possibleConstructorReturn(this, (TextBox.__proto__ || Object.getPrototypeOf(TextBox)).call(this, props));
	
	    _this.state = {
	      value: _this.props.value ? _this.props.value : ''
	    };
	    _this.handleTextBoxValue = _this.handleTextBoxValue.bind(_this);
	    _this.handleSubmitTextBoxValue = _this.handleSubmitTextBoxValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(TextBox, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ value: nextProps.value !== undefined ? nextProps.value : '' });
	    }
	  }, {
	    key: 'handleTextBoxValue',
	    value: function handleTextBoxValue(e) {
	      if (e.key === 'Enter') {
	        this.props.grabTextBoxValue(e.target.value);
	      }
	      this.setState({ value: e.target.value });
	    }
	  }, {
	    key: 'handleSubmitTextBoxValue',
	    value: function handleSubmitTextBoxValue() {
	      this.props.grabTextBoxValue(this.state.value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const value = this.props.value !== undefined ? this.state.value : '';
	      return _react2.default.createElement(
	        'div',
	        { className: 'searchbox-input' },
	        _react2.default.createElement('input', { type: 'text', ref: 'textInput', placeholder: API.LANG.PLACE_SEARCH, className: 'reactive-input', value: this.state.value, onChange: this.handleTextBoxValue, onKeyPress: this.handleTextBoxValue }),
	        _react2.default.createElement(
	          'button',
	          { type: 'submit', onClick: this.handleSubmitTextBoxValue },
	          _react2.default.createElement('i', { className: 'fa fa-search' })
	        )
	      );
	    }
	  }]);
	
	  return TextBox;
	}(_react2.default.Component);
	
	TextBox.propTypes = {
	  'value': _react2.default.PropTypes.string,
	  'grabTextBoxValue': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string
	};
	exports.default = TextBox;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _textbox = __webpack_require__(741);
	
	var _textbox2 = _interopRequireDefault(_textbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBoxPreview = function (_React$Component) {
	  _inherits(TextBoxPreview, _React$Component);
	
	  function TextBoxPreview(props) {
	    _classCallCheck(this, TextBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (TextBoxPreview.__proto__ || Object.getPrototypeOf(TextBoxPreview)).call(this, props));
	
	    _this.state = {
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleTextbox = _this.handleTextbox.bind(_this);
	    return _this;
	  }
	
	  _createClass(TextBoxPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handleTextbox',
	    value: function handleTextbox(values) {
	      _urlHandlerActions2.default.push({
	        'searchItem': 'search_item',
	        'searchType': 'globalSearch',
	        'searchField': 'textbox',
	        values: values
	      });
	      this.setState({ values: values });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var values = this.props.urlData.search_item;
	      var textBoxClassName = this.props.block.dynamicNameClassTextBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: textBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          _react2.default.createElement(_textbox2.default, { value: values, grabTextBoxValue: this.handleTextbox })
	        ) : null
	      );
	    }
	  }]);
	
	  return TextBoxPreview;
	}(_react2.default.Component);
	
	TextBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = TextBoxPreview;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__(744);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var TagsPreview = function (_React$Component) {
	  _inherits(TagsPreview, _React$Component);
	
	  function TagsPreview(props) {
	    _classCallCheck(this, TagsPreview);
	
	    var _this = _possibleConstructorReturn(this, (TagsPreview.__proto__ || Object.getPrototypeOf(TagsPreview)).call(this, props));
	
	    _this.handleTagValue = _this.handleTagValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagsPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var block = (0, _clone2.default)(this.props.block);
	      this.processData(block);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var block = (0, _clone2.default)(nextprops.block);
	      this.processData(block);
	    }
	  }, {
	    key: 'processData',
	    value: function processData(block) {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = block;
	      var options = [];
	      var values = [];
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	          // url case
	          for (var indexOfArray = 0; indexOfArray < window.searchArray.length; indexOfArray++) {
	            if (window.searchArray[indexOfArray].key === this.searchItem) {
	              values.push(window.searchArray[indexOfArray].value);
	            }
	          }
	          // if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          //   // if (this.state.values.length < 1) {
	          //   values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          //   // }
	          // } else {
	          //   values = [];
	          // }
	        }
	      }
	      options.map(function (item) {
	        item.isActive = false;
	        if (_this2.block.selectedType !== undefined) {
	          if (_this2.block.selectedType.value === 'singleselect' && item.slug === values[0]) {
	            item.isActive = true;
	          }
	        } else if (item.slug === values[0]) {
	          item.isActive = true;
	        }
	      });
	      if (this.block.selectedType !== undefined) {
	        if (this.block.selectedType.value === 'multiselect') {
	          options.map(function (item) {
	            if (values.indexOf(item.slug) !== -1) {
	              item.isActive = true;
	            }
	          });
	        }
	      }
	      this.setState({
	        values: values, options: options
	      });
	    }
	  }, {
	    key: 'handleTagValue',
	    value: function handleTagValue(e, tagItem) {
	      e.preventDefault();
	      var options = this.state.options;
	      var values = [];
	      if (this.props.block.selectedType !== undefined) {
	        if (this.props.block.selectedType.value === 'singleselect') {
	          options.map(function (item) {
	            if (item.slug === tagItem.slug) {
	              item.isActive = !item.isActive;
	            } else {
	              item.isActive = false;
	            }
	            if (item.isActive) values.push(item);
	          });
	        } else {
	          options.map(function (item) {
	            if (item.slug === tagItem.slug) {
	              item.isActive = !item.isActive;
	            }
	            if (item.isActive) values.push(item);
	          });
	        }
	      }
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'tags',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.state.options !== undefined && this.state.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_tag2.default, { options: this.state.options, isOpenElement: ifOpen, onSelectTags: this.handleTagValue })
	          ) : null,
	          this.state.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return TagsPreview;
	}(_react2.default.Component);
	
	TagsPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = TagsPreview;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tags = function (_React$Component) {
	  _inherits(Tags, _React$Component);
	
	  function Tags(props) {
	    _classCallCheck(this, Tags);
	
	    var _this = _possibleConstructorReturn(this, (Tags.__proto__ || Object.getPrototypeOf(Tags)).call(this, props));
	
	    _this.state = {
	      options: []
	    };
	    return _this;
	  }
	
	  _createClass(Tags, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ options: this.props.options });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      // console.log(nextprops.options);
	      this.setState({ options: nextprops.options });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var options = (0, _clone2.default)(this.state.options);
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'taglists' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            options.length ? options.map(function (tagItem, index) {
	              var CustomClassNameActive = (0, _classnames2.default)({
	                'active-tag': tagItem.isActive === true
	              });
	              return _react2.default.createElement(
	                'li',
	                { key: 'tag-' + index, className: CustomClassNameActive },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'tag-link', href: '#', onClick: function onClick(e) {
	                      return _this2.props.onSelectTags(e, tagItem);
	                    } },
	                  tagItem.value
	                )
	              );
	            }) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tags;
	}(_react2.default.Component);
	
	Tags.propTypes = {
	  'type': _react2.default.PropTypes.string,
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'onSelectTags': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string
	};
	
	exports.default = Tags;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tag = __webpack_require__(744);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var TagsPreview = function (_React$Component) {
	  _inherits(TagsPreview, _React$Component);
	
	  function TagsPreview(props) {
	    _classCallCheck(this, TagsPreview);
	
	    var _this = _possibleConstructorReturn(this, (TagsPreview.__proto__ || Object.getPrototypeOf(TagsPreview)).call(this, props));
	
	    _this.handleTagValue = _this.handleTagValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(TagsPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var block = (0, _clone2.default)(this.props.block);
	      this.processData(block);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var block = (0, _clone2.default)(nextprops.block);
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	      this.processData(block);
	    }
	  }, {
	    key: 'processData',
	    value: function processData(block) {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = block;
	      var options = [];
	      var values = [];
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	          // url case
	          for (var indexOfArray = 0; indexOfArray < window.searchArray.length; indexOfArray++) {
	            if (window.searchArray[indexOfArray].key === this.searchItem) {
	              values.push(window.searchArray[indexOfArray].value);
	            }
	          }
	          // if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          //   // if (this.state.values.length < 1) {
	          //   values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          //   // }
	          // } else {
	          //   values = [];
	          // }
	        }
	      }
	      options.map(function (item) {
	        item.isActive = false;
	        if (_this2.block.selectedType !== undefined) {
	          if (_this2.block.selectedType.value === 'singleselect' && item.slug === values[0]) {
	            item.isActive = true;
	          }
	        } else if (item.slug === values[0]) {
	          item.isActive = true;
	        }
	      });
	      if (this.block.selectedType !== undefined) {
	        if (this.block.selectedType.value === 'multiselect') {
	          options.map(function (item) {
	            if (values.indexOf(item.slug) !== -1) {
	              item.isActive = true;
	            }
	          });
	        }
	      }
	      this.setState({
	        values: values, options: options
	      });
	    }
	  }, {
	    key: 'handleTagValue',
	    value: function handleTagValue(e, tagItem) {
	      e.preventDefault();
	      var options = this.state.options;
	      var values = [];
	      if (this.props.block.selectedType !== undefined) {
	        if (this.props.block.selectedType.value === 'singleselect') {
	          options.map(function (item) {
	            if (item.slug === tagItem.slug) {
	              item.isActive = !item.isActive;
	            } else {
	              item.isActive = false;
	            }
	            if (item.isActive) values.push(item);
	          });
	        } else {
	          options.map(function (item) {
	            if (item.slug === tagItem.slug) {
	              item.isActive = !item.isActive;
	            }
	            if (item.isActive) values.push(item);
	          });
	        }
	      }
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'tags',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.state.options !== undefined && this.state.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_tag2.default, { options: this.state.options, isOpenElement: ifOpen, onSelectTags: this.handleTagValue })
	          ) : null,
	          this.state.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return TagsPreview;
	}(_react2.default.Component);
	
	TagsPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = TagsPreview;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageselect = __webpack_require__(747);
	
	var _imageselect2 = _interopRequireDefault(_imageselect);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var ImageSelectPreview = function (_React$Component) {
	  _inherits(ImageSelectPreview, _React$Component);
	
	  function ImageSelectPreview(props) {
	    _classCallCheck(this, ImageSelectPreview);
	
	    var _this = _possibleConstructorReturn(this, (ImageSelectPreview.__proto__ || Object.getPrototypeOf(ImageSelectPreview)).call(this, props));
	
	    _this.handleTagValue = _this.handleTagValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ImageSelectPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var block = (0, _clone2.default)(this.props.block);
	      this.processData(block);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var block = (0, _clone2.default)(nextprops.block);
	      this.processData(block);
	    }
	  }, {
	    key: 'processData',
	    value: function processData(block) {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = block;
	      var options = [];
	      var values = this.state.values;
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	          // url case
	          if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	            // if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	            // }
	          } else {
	            values = [];
	          }
	        }
	      }
	      options.map(function (item) {
	        for (var key in item.term_meta[0]) {
	          if (item.term_meta[0].hasOwnProperty(key)) {
	            item.image_url = item.term_meta[0][key].image_small_url;
	          }
	        }
	      });
	      options.map(function (item) {
	        item.isActive = false;
	        if (_this2.block.selectedType !== undefined) {
	          if (_this2.block.selectedType === 'singleselect' && item.slug === values[0]) {
	            item.isActive = true;
	          }
	        } else if (item.slug === values[0]) {
	          item.isActive = true;
	        }
	      });
	      if (this.block.selectedType !== undefined) {
	        if (this.block.selectedType === 'multiselect') {
	          options.map(function (item) {
	            if (values.indexOf(item.slug) !== -1) {
	              item.isActive = true;
	            }
	          });
	        }
	      }
	      this.setState({
	        values: values, options: options
	      });
	    }
	  }, {
	    key: 'handleTagValue',
	    value: function handleTagValue(e, tagItem) {
	      e.preventDefault();
	      var options = this.state.options;
	      var values = [];
	      if (this.props.block.selectedType !== undefined) {
	        if (this.props.block.selectedType === 'singleselect') {
	          options.map(function (item) {
	            if (item.slug === tagItem.slug) {
	              item.isActive = !item.isActive;
	            } else {
	              item.isActive = false;
	            }
	            if (item.isActive) values.push(item);
	          });
	        } else {
	          options.map(function (item) {
	            if (item.slug === tagItem.slug) {
	              item.isActive = !item.isActive;
	            }
	            if (item.isActive) values.push(item);
	          });
	        }
	      }
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'imageSelect',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.state.options !== undefined && this.state.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_imageselect2.default, { options: this.state.options, isOpenElement: ifOpen, onSelectImage: this.handleTagValue })
	          ) : null,
	          this.state.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ImageSelectPreview;
	}(_react2.default.Component);
	
	ImageSelectPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'helperData': _react2.default.PropTypes.object
	};
	
	exports.default = ImageSelectPreview;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageSelect = function (_React$Component) {
	  _inherits(ImageSelect, _React$Component);
	
	  function ImageSelect(props) {
	    _classCallCheck(this, ImageSelect);
	
	    return _possibleConstructorReturn(this, (ImageSelect.__proto__ || Object.getPrototypeOf(ImageSelect)).call(this, props));
	  }
	
	  _createClass(ImageSelect, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var singleImage = function singleImage(item) {
	        if (item.image_url) {
	          return _react2.default.createElement(
	            "span",
	            { className: "single-input image-select", key: item.key },
	            _react2.default.createElement("input", { type: "checkbox", checked: item.isActive, id: item.key, value: item.key, onChange: function onChange(e) {
	                return _this2.props.onSelectImage(e, item);
	              } }),
	            _react2.default.createElement(
	              "label",
	              { htmlFor: item.key },
	              _react2.default.createElement("img", { src: item.image_url, alt: item.key })
	            )
	          );
	        }
	      };
	      return _react2.default.createElement(
	        "span",
	        { className: "checkbox-input-content" },
	        this.props.options.length ? this.props.options.map(singleImage) : null
	      );
	    }
	  }]);
	
	  return ImageSelect;
	}(_react2.default.Component);
	
	ImageSelect.propTypes = {
	  'multiselect': _react2.default.PropTypes.string,
	  'options': _react2.default.PropTypes.array,
	  'defaultvalue': _react2.default.PropTypes.array,
	  'onSelectImage': _react2.default.PropTypes.func
	};
	
	exports.default = ImageSelect;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageselect = __webpack_require__(747);
	
	var _imageselect2 = _interopRequireDefault(_imageselect);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var ImageSelectPreview = function (_React$Component) {
	  _inherits(ImageSelectPreview, _React$Component);
	
	  function ImageSelectPreview(props) {
	    _classCallCheck(this, ImageSelectPreview);
	
	    var _this = _possibleConstructorReturn(this, (ImageSelectPreview.__proto__ || Object.getPrototypeOf(ImageSelectPreview)).call(this, props));
	
	    _this.handleTagValue = _this.handleTagValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ImageSelectPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var block = (0, _clone2.default)(this.props.block);
	      this.processData(block);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      var block = (0, _clone2.default)(nextprops.block);
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	      this.processData(block);
	    }
	  }, {
	    key: 'processData',
	    value: function processData(block) {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = block;
	      var options = [];
	      var values = this.state.values;
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	          // url case
	          if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	            if (this.state.values.length < 1) {
	              values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	            }
	          } else {
	            values = [];
	          }
	        }
	      }
	      options.map(function (item) {
	        for (var key in item.term_meta[0]) {
	          if (item.term_meta[0].hasOwnProperty(key)) {
	            item.image_url = item.term_meta[0][key].image_small_url;
	          }
	        }
	      });
	      options.map(function (item) {
	        item.isActive = false;
	        if (_this2.block.selectedType === 'singleselect' && item.slug === values[0]) {
	          item.isActive = true;
	        }
	      });
	      if (this.block.selectedType === 'multiselect') {
	        options.map(function (item) {
	          if (values.indexOf(item.slug) !== -1) {
	            item.isActive = true;
	          }
	        });
	      }
	      this.setState({
	        values: values, options: options
	      });
	    }
	  }, {
	    key: 'handleTagValue',
	    value: function handleTagValue(e, tagItem) {
	      e.preventDefault();
	      var options = this.state.options;
	      var values = [];
	      if (this.props.block.selectedType === 'singleselect') {
	        options.map(function (item) {
	          if (item.slug === tagItem.slug) {
	            item.isActive = !item.isActive;
	          } else {
	            item.isActive = false;
	          }
	          if (item.isActive) values.push(item);
	        });
	      } else {
	        options.map(function (item) {
	          if (item.slug === tagItem.slug) {
	            item.isActive = !item.isActive;
	          }
	          if (item.isActive) values.push(item);
	        });
	      }
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'imageSelect',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.state.options !== undefined && this.state.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_imageselect2.default, { options: this.state.options, isOpenElement: ifOpen, onSelectImage: this.handleTagValue })
	          ) : null,
	          this.state.options.length === 0 ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ImageSelectPreview;
	}(_react2.default.Component);
	
	ImageSelectPreview.propTypes = {
	  'helperData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ImageSelectPreview;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rangeinput = __webpack_require__(750);
	
	var _rangeinput2 = _interopRequireDefault(_rangeinput);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var RangeInputPreview = function (_React$Component) {
	  _inherits(RangeInputPreview, _React$Component);
	
	  function RangeInputPreview(props) {
	    _classCallCheck(this, RangeInputPreview);
	
	    var _this = _possibleConstructorReturn(this, (RangeInputPreview.__proto__ || Object.getPrototypeOf(RangeInputPreview)).call(this, props));
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'rangeValues': {},
	      'toogle': true
	    };
	    _this.isEditable = API.isEditable ? true : false;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleRangeSelect = _this.handleRangeSelect.bind(_this);
	    _this.errorMessage = null;
	    return _this;
	  }
	
	  _createClass(RangeInputPreview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var block = (0, _clone2.default)(this.props.block);
	      this.processData(this.props, block);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.processData(nextprops, nextprops.block);
	    }
	  }, {
	    key: 'processData',
	    value: function processData(props, block) {
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = block;
	      this.props = props;
	      var options = [];
	      var values = this.state.values;
	      var rangeValues = {};
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	        } else {
	          options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData !== undefined) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	      // console.log(this.props.block.selectedMetakey);
	      for (var key in this.props.urlData) {
	        var flag = false;
	        var keyPartition = key.split(this.block.selectedMetakey);
	        if (keyPartition.length === 2 && keyPartition[0].length === 0) {
	          flag = true;
	        }
	        if (this.props.urlData.hasOwnProperty(key)) {
	          if (key.includes('min') && flag) {
	            rangeValues.min = parseInt(this.props.urlData[key], 10);
	          }
	          if (key.includes('max') && flag) {
	            rangeValues.max = parseInt(this.props.urlData[key], 10);
	          }
	        }
	      }
	      this.setState({
	        options: options, values: values, rangeValues: rangeValues
	      });
	    }
	  }, {
	    key: 'handleRangeSelect',
	    value: function handleRangeSelect(from, to) {
	      var values = [{ start: from !== undefined ? from : 0 }, { end: to !== undefined ? to : 100 }];
	      if (this.searchItem) {
	        _urlHandlerActions2.default.push({
	          'searchItem': this.searchItem, // keys
	          'searchType': this.searchType,
	          'searchField': 'rangeInput', // taxonomies or metakeys,
	          'metakey': this.searchItem,
	          values: values
	        });
	        this.errorMessage = null;
	      } else {
	        this.errorMessage = 'Please select your metadata first from edit panel';
	      }
	      this.setState({ rangeValues: { min: from, max: to } });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
	      if (REBUILDER.hasOwnProperty(this.metakey)) {
	        this.previewData = REBUILDER[this.metakey].previewData ? REBUILDER[this.metakey].previewData : {};
	      }
	      var rangeClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var max = Number(this.props.block.maxvalue);
	      var min = Number(this.props.block.minvalue);
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var options = [];
	      var isDataTypeSet = false;
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        var indexOfRange = (0, _underscore.findIndex)(allLayout[index].searchAttr, { viewType: 'rangeinput' });
	        if (allLayout[index].searchAttr[indexOfRange].selectedDataType === undefined) {
	          this.errorMessage = 'Please select your metadata first from edit panel';
	          isDataTypeSet = false;
	        } else {
	          if (allLayout[index].searchAttr[indexOfRange].selectedDataType.length === 0) {
	            this.errorMessage = 'Please select your metadata first from edit panel';
	            isDataTypeSet = false;
	          } else {
	            this.errorMessage = null;
	            isDataTypeSet = true;
	          }
	        }
	      }
	      if (this.props.block.maxvalue === undefined) {
	        max = parseInt(100, 10);
	      }
	      if (this.props.block.minvalue === undefined) {
	        min = parseInt(0, 10);
	      }
	      if (this.state.rangeValues.min === undefined) {
	        this.state.rangeValues.min = parseInt(min, 10);
	      }
	      if (this.state.rangeValues.max === undefined) {
	        this.state.rangeValues.max = parseInt(max, 10);
	      }
	      var selectedMetakey = this.props.block.selectedMetakey;
	      // for (let i = min; i <= max; i++) {
	      //   options[i] = 0;
	      // }
	      // if (this.props.previewData.data !== undefined && selectedMetakey !== undefined && this.props.block.histogramToggle === 'true') {
	      //   for (let i = min; i <= max; i++) {
	      //     this.props.previewData.data.map((item) => {
	      //       if (item.meta[selectedMetakey] === String(i)) {
	      //         options[i] += 1;
	      //         options[i + 1] = options[i];
	      //         options[i + 2] = options[i];
	      //         options[i + 3] = options[i];
	      //         options[i + 4] = options[i];
	      //       }
	      //     });
	      //   }
	      // }
	      return _react2.default.createElement(
	        'div',
	        { className: rangeClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.errorMessage !== null && this.isEditable ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              this.errorMessage
	            )
	          ) : null,
	          isDataTypeSet ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_rangeinput2.default, { values: this.state.rangeValues, block: this.props.block, maxvalue: max, minvalue: min, grabRangeSelectValue: this.handleRangeSelect, unit: this.props.block.unit, unitFix: this.props.block.hasOwnProperty('selectedUnitFix') ? this.props.block.selectedUnitFix : 'postfix' })
	          ) : null
	        ) : null
	      );
	    }
	  }]);
	
	  return RangeInputPreview;
	}(_react2.default.Component);
	
	RangeInputPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = RangeInputPreview;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import InputRange from 'react-input-range';
	
	var RangeInput = function (_React$Component) {
	  _inherits(RangeInput, _React$Component);
	
	  function RangeInput(props) {
	    _classCallCheck(this, RangeInput);
	
	    var _this = _possibleConstructorReturn(this, (RangeInput.__proto__ || Object.getPrototypeOf(RangeInput)).call(this, props));
	
	    _this.handleValueChange = _this.handleValueChange.bind(_this);
	    _this.initRange = _this.initRange.bind(_this);
	    return _this;
	  }
	
	  _createClass(RangeInput, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initRange(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.block.hasOwnProperty('selectedRangeType')) {
	        if (nextProps.block.selectedRangeType === 'single') {
	          this.slider.update({
	            from: nextProps.values.max
	          });
	        } else {
	          this.slider.update({
	            from: nextProps.values.min,
	            to: nextProps.values.max
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getHistogram',
	    value: function getHistogram(countEachMetaDataValue) {
	      var bars = countEachMetaDataValue.map(function (item, index) {
	        var className = 'bar-chart__bar';
	        return _react2.default.createElement('div', { className: className,
	          key: 'rangeinput-' + index,
	          style: { height: item * 3 }
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'bar-chart' },
	        bars
	      );
	    }
	  }, {
	    key: 'initRange',
	    value: function initRange(props) {
	      var self = this;
	      var target = _reactDom2.default.findDOMNode(this);
	      var fix = null;
	      if (props.unitFix === 'postfix') {
	        fix = props.unit ? ' ' + props.unit : '';
	      } else {
	        fix = props.unit ? props.unit + ' ' : '';
	      }
	      var type = null;
	      if (this.props.block.hasOwnProperty('selectedRangeType')) {
	        type = this.props.block.selectedRangeType;
	      } else {
	        type = 'single';
	      };
	      jQuery(target).ionRangeSlider({
	        type: type,
	        grid: true,
	        min: Number(props.minvalue),
	        max: Number(props.maxvalue),
	        from: Number(props.values.min),
	        to: Number(props.values.max),
	        prefix: props.unitFix === 'prefix' ? fix : '',
	        postfix: props.unitFix === 'postfix' ? fix : '',
	        onFinish: self.handleValueChange
	      });
	      this.slider = jQuery(target).data('ionRangeSlider');
	    }
	  }, {
	    key: 'handleValueChange',
	    value: function handleValueChange(val) {
	      if (this.props.block.selectedRangeType === 'single') {
	        this.props.grabRangeSelectValue(0, val.from);
	      } else {
	        this.props.grabRangeSelectValue(val.from, val.to);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('input', { type: 'text', id: 'rangeInput-' + this.props.block.uid, name: 'example_name', value: '' });
	    }
	  }]);
	
	  return RangeInput;
	}(_react2.default.Component);
	
	RangeInput.propTypes = {
	  'maxvalue': _react2.default.PropTypes.number,
	  'minvalue': _react2.default.PropTypes.number,
	  'values': _react2.default.PropTypes.object,
	  'options': _react2.default.PropTypes.array,
	  'grabRangeSelectValue': _react2.default.PropTypes.func,
	  'block': _react2.default.PropTypes.object
	};
	exports.default = RangeInput;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rangeinput = __webpack_require__(750);
	
	var _rangeinput2 = _interopRequireDefault(_rangeinput);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var RangeInputPreview = function (_React$Component) {
	  _inherits(RangeInputPreview, _React$Component);
	
	  function RangeInputPreview(props) {
	    _classCallCheck(this, RangeInputPreview);
	
	    var _this = _possibleConstructorReturn(this, (RangeInputPreview.__proto__ || Object.getPrototypeOf(RangeInputPreview)).call(this, props));
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'rangeValues': {},
	      'toogle': false
	    };
	    _this.isEditable = API.isEditable ? true : false;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleRangeSelect = _this.handleRangeSelect.bind(_this);
	    _this.errorMessage = null;
	    return _this;
	  }
	
	  _createClass(RangeInputPreview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var block = (0, _clone2.default)(this.props.block);
	      this.processData(this.props, block);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.processData(nextprops, nextprops.block);
	    }
	  }, {
	    key: 'processData',
	    value: function processData(props, block) {
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = block;
	      this.props = props;
	      var options = [];
	      var values = this.state.values;
	      var rangeValues = {};
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	        } else {
	          options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData !== undefined) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	
	      for (var key in this.props.urlData) {
	        var flag = false;
	        var keyPartition = key.split(this.block.selectedMetakey);
	        if (keyPartition.length === 2 && keyPartition[0].length === 0) {
	          flag = true;
	        }
	        if (this.props.urlData.hasOwnProperty(key)) {
	          if (key.includes('min') && flag) {
	            rangeValues.min = parseInt(this.props.urlData[key], 10);
	          }
	          if (key.includes('max') && flag) {
	            rangeValues.max = parseInt(this.props.urlData[key], 10);
	          }
	        }
	      }
	      this.setState({
	        options: options, values: values, rangeValues: rangeValues, toogle: props.dropdonwtoggle[props.block['uid']]
	      });
	    }
	  }, {
	    key: 'handleRangeSelect',
	    value: function handleRangeSelect(from, to) {
	      var values = [{ start: from !== undefined ? from : 0 }, { end: to !== undefined ? to : 100 }];
	      if (this.searchItem) {
	        _urlHandlerActions2.default.push({
	          'searchItem': this.searchItem, // keys
	          'searchType': this.searchType,
	          'searchField': 'rangeInput', // taxonomies or metakeys,
	          'metakey': this.searchItem,
	          values: values
	        });
	        this.errorMessage = null;
	      } else {
	        this.errorMessage = 'Please select your metadata first from edit panel';
	      }
	      this.setState({ rangeValues: { min: from, max: to } });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
	      if (REBUILDER.hasOwnProperty(this.metakey)) {
	        this.previewData = REBUILDER[this.metakey].previewData ? REBUILDER[this.metakey].previewData : {};
	      }
	      var rangeClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var max = Number(this.props.block.maxvalue);
	      var min = Number(this.props.block.minvalue);
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var options = [];
	      var isDataTypeSet = false;
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (index !== -1) {
	        var indexOfRange = (0, _underscore.findIndex)(allLayout[index].searchAttr, { viewType: 'rangeinput' });
	        if (allLayout[index].searchAttr[indexOfRange].selectedDataType === undefined) {
	          this.errorMessage = 'Please select your metadata first from edit panel';
	          isDataTypeSet = false;
	        } else {
	          if (allLayout[index].searchAttr[indexOfRange].selectedDataType.length === 0) {
	            this.errorMessage = 'Please select your metadata first from edit panel';
	            isDataTypeSet = false;
	          } else {
	            this.errorMessage = null;
	            isDataTypeSet = true;
	          }
	        }
	      }
	      if (this.props.block.maxvalue === undefined) {
	        max = parseInt(100, 10);
	      }
	      if (this.props.block.minvalue === undefined) {
	        min = parseInt(0, 10);
	      }
	      if (this.state.rangeValues.min === undefined) {
	        this.state.rangeValues.min = parseInt(min, 10);
	      }
	      if (this.state.rangeValues.max === undefined) {
	        this.state.rangeValues.max = parseInt(max, 10);
	      }
	      var selectedMetakey = this.props.block.selectedMetakey;
	      return _react2.default.createElement(
	        'div',
	        { className: rangeClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          dropdown: true,
	          selectedToogleViewType: 'true',
	          field: this.props.block.uid
	        }),
	        this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.errorMessage !== null && this.isEditable ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              this.errorMessage
	            )
	          ) : null,
	          isDataTypeSet ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_rangeinput2.default, { values: this.state.rangeValues, block: this.props.block, maxvalue: max, minvalue: min, grabRangeSelectValue: this.handleRangeSelect, unit: this.props.block.unit, unitFix: this.props.block.hasOwnProperty('selectedUnitFix') ? this.props.block.selectedUnitFix : 'postfix' })
	          ) : null
	        ) : null
	      );
	    }
	  }]);
	
	  return RangeInputPreview;
	}(_react2.default.Component);
	
	RangeInputPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = RangeInputPreview;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollbox = __webpack_require__(753);
	
	var _scrollbox2 = _interopRequireDefault(_scrollbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var ScrollTabPreview = function (_React$Component) {
	  _inherits(ScrollTabPreview, _React$Component);
	
	  function ScrollTabPreview(props) {
	    _classCallCheck(this, ScrollTabPreview);
	
	    var _this = _possibleConstructorReturn(this, (ScrollTabPreview.__proto__ || Object.getPrototypeOf(ScrollTabPreview)).call(this, props));
	
	    _this.handleScrollBox = _this.handleScrollBox.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollTabPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleScrollBox',
	    value: function handleScrollBox(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'scrollTab',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // this.helperData = RE.hasOwnProperty(this.metakey) ? clone(RE[this.metakey].helperData) : {};
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var scrollBoxClassName = this.props.block.dynamicNameClassCheckBox;
	
	      return _react2.default.createElement(
	        'div',
	        { className: scrollBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_scrollbox2.default, {
	              isOpenElement: ifOpen,
	              options: this.options,
	              value: values,
	              handleScrollBox: this.handleScrollBox
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ScrollTabPreview;
	}(_react2.default.Component);
	
	ScrollTabPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ScrollTabPreview;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollTab = function (_React$Component) {
	  _inherits(ScrollTab, _React$Component);
	
	  function ScrollTab(props) {
	    _classCallCheck(this, ScrollTab);
	
	    return _possibleConstructorReturn(this, (ScrollTab.__proto__ || Object.getPrototypeOf(ScrollTab)).call(this, props));
	  }
	
	  _createClass(ScrollTab, [{
	    key: 'handleScrollClick',
	    value: function handleScrollClick(item) {
	      var values = [];
	      this.options.forEach(function (singleitem) {
	        if (singleitem.key === parseInt(item.key, 10)) {
	          singleitem.isChecked = !singleitem.isChecked;
	        }
	        if (singleitem.isChecked) values.push(singleitem);
	      });
	      this.props.handleScrollBox(values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.options = (0, _clone2.default)(this.props.options);
	      this.options.map(function (item) {
	        if (_this2.props.value.indexOf(item.slug) !== -1) {
	          item.isChecked = true;
	          item.CustomIconClass = (0, _classnames2.default)({
	            'brandlist-icon ion-android-checkmark-circle': true
	          });
	        } else {
	          item.isChecked = false;
	          item.CustomIconClass = (0, _classnames2.default)({
	            'brandlist-icon ion-ios-circle-outline': true
	          });
	        }
	      });
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      var height = { MaxHeight: '200px' };
	      return _react2.default.createElement(
	        'div',
	        { className: 'brandlist', style: height },
	        _react2.default.createElement(
	          'div',
	          { className: childInputClass },
	          _react2.default.createElement(
	            'ul',
	            { className: 'brandlist-group', style: { listStyle: 'none' } },
	            this.options.map(function (item, index) {
	              return _react2.default.createElement(
	                'li',
	                { key: 'brand-' + index, id: item.slug, onClick: _this2.handleScrollClick.bind(_this2, item) },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  item.value
	                ),
	                _react2.default.createElement('i', { className: item.CustomIconClass })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ScrollTab;
	}(_react2.default.Component);
	
	ScrollTab.propTypes = {
	  'type': _react2.default.PropTypes.string,
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'handleScrollBox': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string
	};
	
	exports.default = ScrollTab;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollbox = __webpack_require__(753);
	
	var _scrollbox2 = _interopRequireDefault(_scrollbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var ScrollTabPreview = function (_React$Component) {
	  _inherits(ScrollTabPreview, _React$Component);
	
	  function ScrollTabPreview(props) {
	    _classCallCheck(this, ScrollTabPreview);
	
	    var _this = _possibleConstructorReturn(this, (ScrollTabPreview.__proto__ || Object.getPrototypeOf(ScrollTabPreview)).call(this, props));
	
	    _this.handleScrollBox = _this.handleScrollBox.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollTabPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	    }
	  }, {
	    key: 'handleScrollBox',
	    value: function handleScrollBox(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'scrollTab',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // this.helperData = RE.hasOwnProperty(this.metakey) ? clone(RE[this.metakey].helperData) : {};
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var scrollBoxClassName = this.props.block.dynamicNameClassCheckBox;
	
	      return _react2.default.createElement(
	        'div',
	        { className: scrollBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_scrollbox2.default, {
	              isOpenElement: ifOpen,
	              options: this.options,
	              value: values,
	              handleScrollBox: this.handleScrollBox
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ScrollTabPreview;
	}(_react2.default.Component);
	
	ScrollTabPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ScrollTabPreview;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colorbox = __webpack_require__(756);
	
	var _colorbox2 = _interopRequireDefault(_colorbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var ColorBoxPreview = function (_React$Component) {
	  _inherits(ColorBoxPreview, _React$Component);
	
	  function ColorBoxPreview(props) {
	    _classCallCheck(this, ColorBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (ColorBoxPreview.__proto__ || Object.getPrototypeOf(ColorBoxPreview)).call(this, props));
	
	    _this.handleColorBoxvalue = _this.handleColorBoxvalue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ColorBoxPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleColorBoxvalue',
	    value: function handleColorBoxvalue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'colorBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);;
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var colorBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: colorBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_colorbox2.default, {
	              isOpenElement: ifOpen,
	              options: this.options,
	              setColumn: this.props.block.setColumn,
	              showItemColorName: this.props.block.showItemColorName,
	              value: values,
	              onSelectColorBox: this.handleColorBoxvalue,
	              block: this.block
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ColorBoxPreview;
	}(_react2.default.Component);
	
	ColorBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ColorBoxPreview;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorBox = function (_React$Component) {
	  _inherits(ColorBox, _React$Component);
	
	  function ColorBox(props) {
	    _classCallCheck(this, ColorBox);
	
	    var _this = _possibleConstructorReturn(this, (ColorBox.__proto__ || Object.getPrototypeOf(ColorBox)).call(this, props));
	
	    _this.handleChecked = _this.handleChecked.bind(_this);
	    return _this;
	  }
	
	  _createClass(ColorBox, [{
	    key: 'handleChecked',
	    value: function handleChecked(item) {
	      var values = [];
	      this.options.forEach(function (singleitem) {
	        if (singleitem.key === parseInt(item.key, 10)) {
	          singleitem.isChecked = !singleitem.isChecked;
	        }
	        if (singleitem.isChecked) values.push(singleitem);
	      });
	      this.props.onSelectColorBox(values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.options = (0, _clone2.default)(this.props.options);
	      this.options.map(function (item) {
	        if (_this2.props.value.indexOf(item.slug) !== -1) {
	          item.isChecked = true;
	        }
	      });
	      var CustomClassName = (0, _classnames2.default)({
	        'single-input big-box': this.props.type === 'big',
	        'single-input rq-name-of-product-color': this.props.showItemColorName === 'true',
	        'single-input': this.props.showItemColorName !== 'true'
	      });
	
	      var singleColorBoxItem = function singleColorBoxItem(item, index) {
	        var CustomClassNameHover = (0, _classnames2.default)({
	          'hover-effect': _this2.props.type === 'hover',
	          'color-white': _this2.props.type !== 'hover' && item.value === '#FFFFFF'
	        });
	        var CustomStyle = {
	          backgroundColor: item.value
	        };
	        return _react2.default.createElement(
	          'span',
	          { className: CustomClassName + ' ' + ' ' + 'colorbox', key: index },
	          _react2.default.createElement('input', { type: 'checkbox', checked: item.isChecked, id: 'color-box-' + item.slug + '-' + _this2.props.block.uid, value: item.key, onChange: _this2.handleChecked.bind(_this2, item) }),
	          _react2.default.createElement('label', { style: CustomStyle, className: CustomClassNameHover, htmlFor: 'color-box-' + item.slug + '-' + _this2.props.block.uid }),
	          _this2.props.showItemColorName === 'true' ? _react2.default.createElement(
	            'span',
	            { className: 'rq-color-of-product' },
	            item.value
	          ) : ''
	        );
	      };
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      var setColumnStyle = null;
	      if (this.props.setColumn === '1') {
	        setColumnStyle = 'checkbox-input-content';
	      } else if (this.props.setColumn === '2') {
	        setColumnStyle = 'checkbox-input-content split';
	      } else if (this.props.setColumn === '3') {
	        setColumnStyle = 'checkbox-input-content split-2';
	      } else if (this.props.setColumn === '4') {
	        setColumnStyle = 'checkbox-input-content split-3';
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement(
	          'span',
	          { className: setColumnStyle },
	          this.options.length ? this.options.map(singleColorBoxItem) : null
	        )
	      );
	    }
	  }]);
	
	  return ColorBox;
	}(_react2.default.Component);
	
	ColorBox.propTypes = {
	  'type': _react2.default.PropTypes.string,
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'onSelectColorBox': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string,
	  'showItemColorName': _react2.default.PropTypes.string,
	  'setColumn': _react2.default.PropTypes.string,
	  'block': _react2.default.PropTypes.object
	};
	
	exports.default = ColorBox;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colorbox = __webpack_require__(756);
	
	var _colorbox2 = _interopRequireDefault(_colorbox);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var ColorBoxPreview = function (_React$Component) {
	  _inherits(ColorBoxPreview, _React$Component);
	
	  function ColorBoxPreview(props) {
	    _classCallCheck(this, ColorBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (ColorBoxPreview.__proto__ || Object.getPrototypeOf(ColorBoxPreview)).call(this, props));
	
	    _this.handleColorBoxvalue = _this.handleColorBoxvalue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ColorBoxPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleColorBoxvalue',
	    value: function handleColorBoxvalue(values) {
	      this.setState({ 'values': _.pluck(values, 'slug') });
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'colorBox',
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            var tempOptions = [];
	            if (topKey !== null && _this2.filterable !== true) {
	              (function () {
	                var selectedOptions = [];
	                var self = _this2;
	                if (_this2.searchItem !== topKey) {
	                  // the searchItem is not the top
	                  if (urlData.hasOwnProperty(self.searchItem)) {
	                    if (!_.isArray(urlData[self.searchItem])) {
	                      selectedOptions.push(urlData[self.searchItem]); // previous selected Options
	                    } else {
	                      selectedOptions = (0, _clone2.default)(urlData[self.searchItem]);
	                    }
	                  }
	                  _this2.options.map(function (item) {
	                    _this2.props.previewData.data.map(function (singleItem) {
	                      var isAlreadyATakenOption = (0, _underscore.findIndex)(tempOptions, { slug: item.slug });
	                      var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                      if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                        tempOptions.push(item);
	                      }
	                    });
	                    var selectedIndex = _.indexOf(selectedOptions, item.slug);
	                    if (selectedIndex !== -1) {
	                      var temp = [];
	                      temp.push(item);
	                      tempOptions = _.union(tempOptions, temp);
	                    }
	                  });
	                  _this2.options = (0, _clone2.default)(tempOptions);
	                } else {
	                  if (Object.keys(urlData).length === 1) {
	                    _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	                  }
	                  if (Object.keys(urlData).length !== 1) {
	                    if (previousOptions !== undefined) {
	                      _this2.options = (0, _clone2.default)(previousOptions);
	                    }
	                  }
	                }
	              })();
	            }
	          })();
	        } else {
	          this.options = this.props.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          // if (this.state.values.length < 1) {
	          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          // }
	        } else {
	          values = [];
	        }
	      }
	
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var colorBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: colorBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_colorbox2.default, {
	              isOpenElement: ifOpen,
	              setColumn: this.props.block.setColumn,
	              showItemColorName: this.props.block.showItemColorName,
	              options: this.options,
	              value: values,
	              onSelectColorBox: this.handleColorBoxvalue,
	              block: this.block
	            })
	          ) : null,
	          this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return ColorBoxPreview;
	}(_react2.default.Component);
	
	ColorBoxPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ColorBoxPreview;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _comboboxCheck = __webpack_require__(759);
	
	var _comboboxCheck2 = _interopRequireDefault(_comboboxCheck);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var ComboBoxPreview = function (_React$Component) {
	  _inherits(ComboBoxPreview, _React$Component);
	
	  function ComboBoxPreview(props) {
	    _classCallCheck(this, ComboBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (ComboBoxPreview.__proto__ || Object.getPrototypeOf(ComboBoxPreview)).call(this, props));
	
	    _this.handleComboBox = _this.handleComboBox.bind(_this);
	    _this.optionsInAdaptiveSearch = _this.optionsInAdaptiveSearch.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ComboBoxPreview, [{
	    key: 'handleComboBox',
	    value: function handleComboBox(values) {
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'comboBox',
	        options: this.helperData.terms[this.block.selectedTaxonomy].linear,
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'optionsInAdaptiveSearch',
	    value: function optionsInAdaptiveSearch(item, optionsArray) {
	      var isThere = (0, _underscore.findIndex)(this.tempOptions, { slug: item.slug });
	      if (isThere === -1) {
	        var indexOfSlug = (0, _underscore.findIndex)(optionsArray, { slug: item.slug });
	        optionsArray.splice(indexOfSlug, 1);
	        return;
	      }
	      if (item.children.length === 0) {
	        return;
	      }
	      for (var i = item.children.length - 1; i >= 0; i--) {
	        this.optionsInAdaptiveSearch(item.children[i], item.children);
	      }
	      return;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      // let options = [];
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].complex : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var optionsInLinear = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            _this2.tempOptions = [];
	            var availableDataForGrid = _this2.props.previewData.data;
	            if (topKey !== null && _this2.filterable !== true) {
	              if (_this2.searchItem !== topKey) {
	                // the searchItem is not the top
	                optionsInLinear.map(function (item) {
	                  availableDataForGrid.map(function (singleItem) {
	                    var isAlreadyATakenOption = (0, _underscore.findIndex)(_this2.tempOptions, { slug: item.slug });
	                    var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                    if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                      _this2.tempOptions.push(item);
	                    }
	                  });
	                });
	                for (var i = _this2.options.length - 1; i >= 0; i--) {
	                  _this2.optionsInAdaptiveSearch(_this2.options[i], _this2.options);
	                }
	              } else {
	                if (Object.keys(urlData).length === 1) {
	                  _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].complex : [];
	                }
	                if (Object.keys(urlData).length !== 1) {
	                  if (previousOptions !== undefined) {
	                    _this2.options = (0, _clone2.default)(previousOptions);
	                  }
	                }
	              }
	            }
	            // url case
	            if (_this2.props.urlData.hasOwnProperty(_this2.searchItem)) {
	              // if (this.state.values.length < 1) {
	              values = $.isArray(_this2.props.urlData[_this2.searchItem]) ? _this2.props.urlData[_this2.searchItem] : [_this2.props.urlData[_this2.searchItem]];
	              // }
	            } else {
	              values = [];
	            }
	          })();
	        }
	      }
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_comboboxCheck2.default, {
	              options: this.options,
	              isOpenElement: ifOpen,
	              value: values,
	              onSelectComboBox: this.handleComboBox,
	              block: this.block
	            })
	          ) : null,
	          this.options !== undefined ? _react2.default.createElement(
	            'div',
	            null,
	            this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	              'div',
	              { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	              _react2.default.createElement(
	                'h3',
	                null,
	                API.LANG.NO_ATTR_FOUND
	              )
	            ) : ''
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ComboBoxPreview;
	}(_react2.default.Component);
	
	ComboBoxPreview.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ComboBoxPreview;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(205);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComboBox = function (_React$Component) {
	  _inherits(ComboBox, _React$Component);
	
	  function ComboBox(props) {
	    _classCallCheck(this, ComboBox);
	
	    var _this = _possibleConstructorReturn(this, (ComboBox.__proto__ || Object.getPrototypeOf(ComboBox)).call(this, props));
	
	    _this.state = {
	      value: (0, _clone2.default)(_this.props.value)
	    };
	    _this.options = (0, _clone2.default)(_this.props.options);
	    _this.handleComboBoxChecked = _this.handleComboBoxChecked.bind(_this);
	    return _this;
	  }
	
	  _createClass(ComboBox, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.options = (0, _clone2.default)(nextprops.options);
	      this.setState({ value: (0, _clone2.default)(nextprops.value) });
	    }
	  }, {
	    key: 'handleComboBoxChecked',
	    value: function handleComboBoxChecked(e) {
	      var _this2 = this;
	
	      var values = [];
	      var handleCheck = function handleCheck(item) {
	        if (item.children.length) {
	          if (item.term_id === parseInt(e.target.value, 10)) {
	            item.isChecked = e.target.checked;
	          }
	          if (item.isChecked) {
	            var index = (0, _underscore.findIndex)(_this2.linearOptions, { term_id: item.parent });
	            if (item.parent === 0) {
	              values.push(item);
	            }
	            if (index !== -1 && _this2.linearOptions[index].isChecked === true) values.push(item);else if (index !== -1) item.isChecked = false;
	          }
	          item.children.map(handleCheck);
	        }
	        if (item.children.length === 0) {
	          if (item.term_id === parseInt(e.target.value, 10)) {
	            item.isChecked = e.target.checked;
	          }
	          if (item.isChecked) {
	            var _index = (0, _underscore.findIndex)(_this2.linearOptions, { term_id: item.parent });
	            if (item.parent === 0) {
	              values.push(item);
	            }
	            if (_index !== -1 && _this2.linearOptions[_index].isChecked === true) values.push(item);else item.isChecked = false;
	          }
	        }
	      };
	      this.options.map(handleCheck);
	      this.props.onSelectComboBox(values);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      this.linearOptions = [];
	      // this.options = this.props.options;
	      var addToogle = function addToogle(item) {
	        if (item.children.length) {
	          if (_this3.state.value.indexOf(item.slug.toString()) !== -1) {
	            item.isChecked = true;
	          }
	          _this3.linearOptions.push(item);
	          item.children.map(addToogle);
	        }
	        if (_this3.state.value.indexOf(item.slug.toString()) !== -1) {
	          item.isChecked = true;
	        }
	        _this3.linearOptions.push(item);
	      };
	      this.options.map(addToogle);
	      var singleItem = function singleItem(term) {
	        if (term.children.length) {
	          var ifOpen = term.isChecked ? 'active' : 'toggle-option';
	          var CombochildInputClass = (0, _classnames2.default)('input-container', ifOpen);
	          return _react2.default.createElement(
	            'span',
	            { className: 'single-input searchoption', key: term.term_id },
	            _react2.default.createElement('input', { type: 'checkbox', id: term.slug + '-' + _this3.props.block.uid, value: term.term_id, checked: term.isChecked, onChange: _this3.handleComboBoxChecked }),
	            _react2.default.createElement(
	              'label',
	              { className: '', htmlFor: term.slug + '-' + _this3.props.block.uid },
	              term.name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: CombochildInputClass },
	              term.children.map(singleItem)
	            )
	          );
	        }
	        if (term.children.length === 0) {
	          return _react2.default.createElement(
	            'span',
	            { className: 'combo-child', key: term.term_id },
	            _react2.default.createElement(
	              'span',
	              { className: 'single-input searchoption' },
	              _react2.default.createElement('input', { type: 'checkbox', id: term.slug + '-' + _this3.props.block.uid, value: term.term_id, checked: term.isChecked, onChange: _this3.handleComboBoxChecked }),
	              _react2.default.createElement(
	                'label',
	                { className: '', htmlFor: term.slug + '-' + _this3.props.block.uid },
	                term.name
	              )
	            )
	          );
	        }
	      };
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'checkbox-input-content' },
	          this.options.map(singleItem)
	        )
	      );
	    }
	  }]);
	
	  return ComboBox;
	}(_react2.default.Component);
	
	ComboBox.propTypes = {
	  'options': _react2.default.PropTypes.array,
	  'onSelectComboBox': _react2.default.PropTypes.func,
	  'value': _react2.default.PropTypes.array,
	  'isOpenElement': _react2.default.PropTypes.string,
	  'block': _react2.default.PropTypes.object
	};
	
	module.exports = ComboBox;
	
	// @Refat Rafi

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _comboboxCheck = __webpack_require__(759);
	
	var _comboboxCheck2 = _interopRequireDefault(_comboboxCheck);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var ComboBoxPreview = function (_React$Component) {
	  _inherits(ComboBoxPreview, _React$Component);
	
	  function ComboBoxPreview(props) {
	    _classCallCheck(this, ComboBoxPreview);
	
	    var _this = _possibleConstructorReturn(this, (ComboBoxPreview.__proto__ || Object.getPrototypeOf(ComboBoxPreview)).call(this, props));
	
	    _this.handleComboBox = _this.handleComboBox.bind(_this);
	    _this.optionsInAdaptiveSearch = _this.optionsInAdaptiveSearch.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.filterable = API.filterable === 'true' ? true : false;
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(ComboBoxPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleComboBox',
	    value: function handleComboBox(values) {
	      _urlHandlerActions2.default.push({
	        'searchItem': this.searchItem,
	        'searchType': this.searchType,
	        'searchField': 'comboBox',
	        options: this.helperData.terms[this.block.selectedTaxonomy].linear,
	        values: values
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'optionsInAdaptiveSearch',
	    value: function optionsInAdaptiveSearch(item, optionsArray) {
	      var isThere = (0, _underscore.findIndex)(this.tempOptions, { slug: item.slug });
	      if (isThere === -1) {
	        var indexOfSlug = (0, _underscore.findIndex)(optionsArray, { slug: item.slug });
	        optionsArray.splice(indexOfSlug, 1);
	        return;
	      }
	      if (item.children.length === 0) {
	        return;
	      }
	      for (var i = item.children.length - 1; i >= 0; i--) {
	        this.optionsInAdaptiveSearch(item.children[i], item.children);
	      }
	      return;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      // let options = [];
	      var values = this.state.values;
	      var urlData = this.props.urlData;
	      if (urlData.hasOwnProperty('pagenumber')) {
	        delete urlData['pagenumber'];
	      }
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          (function () {
	            var previousOptions = _this2.options;
	            _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].complex : [];
	            _this2.searchType = 'taxonomies';
	            _this2.searchItem = _this2.block.selectedTaxonomy;
	            var optionsInLinear = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].linear : [];
	            var allUrlData = [];
	            window.searchArray.map(function (item) {
	              if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
	                allUrlData.push(item);
	              }
	            });
	            var topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
	            _this2.tempOptions = [];
	            var availableDataForGrid = _this2.props.previewData.data;
	            if (topKey !== null && _this2.filterable !== true) {
	              if (_this2.searchItem !== topKey) {
	                // the searchItem is not the top
	                optionsInLinear.map(function (item) {
	                  availableDataForGrid.map(function (singleItem) {
	                    var isAlreadyATakenOption = (0, _underscore.findIndex)(_this2.tempOptions, { slug: item.slug });
	                    var optionIndex = _.indexOf(singleItem.terms[_this2.searchItem], item.slug);
	                    if (optionIndex !== -1 && isAlreadyATakenOption === -1) {
	                      _this2.tempOptions.push(item);
	                    }
	                  });
	                });
	                for (var i = _this2.options.length - 1; i >= 0; i--) {
	                  _this2.optionsInAdaptiveSearch(_this2.options[i], _this2.options);
	                }
	              } else {
	                if (Object.keys(urlData).length === 1) {
	                  _this2.options = _this2.helperData.terms[_this2.block.selectedTaxonomy] ? _this2.helperData.terms[_this2.block.selectedTaxonomy].complex : [];
	                }
	                if (Object.keys(urlData).length !== 1) {
	                  if (previousOptions !== undefined) {
	                    _this2.options = (0, _clone2.default)(previousOptions);
	                  }
	                }
	              }
	            }
	            // url case
	            if (_this2.props.urlData.hasOwnProperty(_this2.searchItem)) {
	              if (_this2.state.values.length < 1) {
	                values = $.isArray(_this2.props.urlData[_this2.searchItem]) ? _this2.props.urlData[_this2.searchItem] : [_this2.props.urlData[_this2.searchItem]];
	              }
	            } else {
	              values = [];
	            }
	          })();
	        }
	      }
	
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_comboboxCheck2.default, {
	              options: this.options,
	              isOpenElement: ifOpen,
	              value: values,
	              onSelectComboBox: this.handleComboBox,
	              block: this.block
	            })
	          ) : null,
	          this.options !== undefined ? _react2.default.createElement(
	            'div',
	            null,
	            this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	              'div',
	              { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'No attributes found'
	              )
	            ) : ''
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'rq-no-attributes-found' + ' ' + ifOpen },
	            _react2.default.createElement(
	              'h3',
	              null,
	              API.LANG.NO_ATTR_FOUND
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ComboBoxPreview;
	}(_react2.default.Component);
	
	ComboBoxPreview.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ComboBoxPreview;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mapsearch = __webpack_require__(762);
	
	var _mapsearch2 = _interopRequireDefault(_mapsearch);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var MapFieldPreview = function (_React$Component) {
	  _inherits(MapFieldPreview, _React$Component);
	
	  function MapFieldPreview(props) {
	    _classCallCheck(this, MapFieldPreview);
	
	    var _this = _possibleConstructorReturn(this, (MapFieldPreview.__proto__ || Object.getPrototypeOf(MapFieldPreview)).call(this, props));
	
	    _this.handleMapSearchValue = _this.handleMapSearchValue.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    return _this;
	  }
	
	  _createClass(MapFieldPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleMapSearchValue',
	    value: function handleMapSearchValue(values) {
	      // this.setState({ 'values': _.pluck(values, 'slug') });
	      var formatedValue = '';
	      for (var index = 0; index < values.length; index++) {
	        if (values[index] === ',') {
	          formatedValue += '--';
	          index++;
	        } else if (values[index] === ' ') {
	          formatedValue += '-';
	        } else {
	          formatedValue += values[index];
	        }
	      }
	      _urlHandlerActions2.default.push({
	        // 'searchField': 'mapAutocomplete',
	        'searchItem': 'location', // keys
	        'searchType': 'globalSearch', // taxonomies or metakeys
	        'searchField': 'mapField',
	        values: formatedValue
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var options = [];
	      var values = this.state.values;
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	        } else {
	          options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          _react2.default.createElement(_mapsearch2.default, { block: this.props.block, urlData: this.props.urlData, options: options, submitMapSearch: this.handleMapSearchValue, isOpenElement: ifOpen, value: values })
	        )
	      );
	    }
	  }]);
	
	  return MapFieldPreview;
	}(_react2.default.Component);
	
	MapFieldPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'helperData': _react2.default.PropTypes.object
	};
	
	exports.default = MapFieldPreview;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var MapSearch = function (_React$Component) {
	  _inherits(MapSearch, _React$Component);
	
	  function MapSearch(props) {
	    _classCallCheck(this, MapSearch);
	
	    var _this = _possibleConstructorReturn(this, (MapSearch.__proto__ || Object.getPrototypeOf(MapSearch)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleMapData = _this.handleMapData.bind(_this);
	    return _this;
	  }
	
	  _createClass(MapSearch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var input = document.getElementById('location');
	      var self = this;
	      var autocomplete = new google.maps.places.Autocomplete(input);
	      var geocoder = new google.maps.Geocoder();
	      google.maps.event.addListener(autocomplete, 'place_changed', function () {
	        var place = autocomplete.getPlace();
	        if (place.geometry === undefined) {
	          return;
	        }
	        geocoder.geocode({ latLng: place.geometry.location }, function (responses) {
	          self.props.submitMapSearch(place.formatted_address);
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = '';
	      if (nextProps.urlData.hasOwnProperty('location')) {
	        for (var index = 0; index < nextProps.urlData['location'].length; index++) {
	          if (nextProps.urlData['location'][index] === '-') {
	            if (nextProps.urlData['location'][index + 1] === '-') {
	              value += ', ';
	              index++;
	            } else {
	              value += ' ';
	            }
	          } else {
	            value += nextProps.urlData['location'][index];
	          }
	        }
	      }
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var value = $('#location').val();
	      this.setState({ value: value });
	      e.preventDefault();
	    }
	  }, {
	    key: 'handleMapData',
	    value: function handleMapData(e) {
	      this.setState({ value: e.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      return _react2.default.createElement(
	        'div',
	        { className: childInputClass },
	        _react2.default.createElement('input', { type: 'text', name: 'location', value: this.state.value, onClick: this.handleClick, onChange: this.handleMapData, className: 'textbox reactive-input', id: 'location', onSelect: this.handleClick })
	      );
	    }
	  }]);
	
	  return MapSearch;
	}(_react2.default.Component);
	
	MapSearch.propTypes = {
	  'value': _react2.default.PropTypes.array,
	  'options': _react2.default.PropTypes.array,
	  'isOpenElement': _react2.default.PropTypes.string,
	  'block': _react2.default.PropTypes.object
	};
	
	exports.default = MapSearch;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mapsearch = __webpack_require__(762);
	
	var _mapsearch2 = _interopRequireDefault(_mapsearch);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var MapFieldPreview = function (_React$Component) {
	  _inherits(MapFieldPreview, _React$Component);
	
	  function MapFieldPreview(props) {
	    _classCallCheck(this, MapFieldPreview);
	
	    var _this = _possibleConstructorReturn(this, (MapFieldPreview.__proto__ || Object.getPrototypeOf(MapFieldPreview)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.state = {
	      'values': [],
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleMapSearchValue = _this.handleMapSearchValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(MapFieldPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	      this.block = nextprops.block;
	    }
	  }, {
	    key: 'handleMapSearchValue',
	    value: function handleMapSearchValue(values) {
	      // this.setState({ 'values': _.pluck(values, 'slug') });
	      var formatedValue = '';
	      for (var index = 0; index < values.length; index++) {
	        if (values[index] === ',') {
	          formatedValue += '--';
	          index++;
	        } else if (values[index] === ' ') {
	          formatedValue += '-';
	        } else {
	          formatedValue += values[index];
	        }
	      }
	      _urlHandlerActions2.default.push({
	        'searchField': 'mapField',
	        'searchItem': 'location', // keys
	        'searchType': 'globalSearch', // taxonomies or metakeys
	        values: formatedValue
	      });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = this.props.block;
	      var options = [];
	      var values = this.state.values;
	
	      if (this.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
	          options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
	          this.searchType = 'taxonomies';
	          this.searchItem = this.block.selectedTaxonomy;
	        } else {
	          options = this.helperData.metadata[this.block.selectedMetakey] ? this.helperData.metadata[this.block.selectedMetakey] : [];
	          this.searchType = 'metakeys';
	          this.searchItem = this.block.selectedMetakey;
	        }
	
	        // url case
	        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
	          if (this.state.values.length < 1) {
	            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
	          }
	        } else {
	          values = [];
	        }
	      }
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: checkBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          _react2.default.createElement(_mapsearch2.default, { block: this.props.block, urlData: this.props.urlData, options: options, submitMapSearch: this.handleMapSearchValue, isOpenElement: ifOpen, value: values })
	        )
	      );
	    }
	  }]);
	
	  return MapFieldPreview;
	}(_react2.default.Component);
	
	MapFieldPreview.propTypes = {
	  'helperData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = MapFieldPreview;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _resetbutton = __webpack_require__(765);
	
	var _resetbutton2 = _interopRequireDefault(_resetbutton);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetButtonPreview = function (_React$Component) {
	  _inherits(ResetButtonPreview, _React$Component);
	
	  function ResetButtonPreview(props) {
	    _classCallCheck(this, ResetButtonPreview);
	
	    // this.handlebutton = this.handlebutton.bind(this);
	    var _this = _possibleConstructorReturn(this, (ResetButtonPreview.__proto__ || Object.getPrototypeOf(ResetButtonPreview)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'options': [],
	      'toogle': true
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handlebutton = _this.handlebutton.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResetButtonPreview, [{
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handlebutton',
	    value: function handlebutton() {
	      _urlHandlerActions2.default.push({
	        'searchType': 'url_reset',
	        'searchField': 'reset'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var scrollBoxClassName = this.props.block.dynamicNameClassScrollBox;
	      // const HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: scrollBoxClassName },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_resetbutton2.default, { isOpenElement: ifOpen, handlebutton: this.handlebutton, buttontitle: this.props.block.hasOwnProperty('buttontitle') ? this.props.block.buttontitle : 'Reset Url', buttonstyle: this.props.block.buttonstyle })
	        )
	      );
	    }
	  }]);
	
	  return ResetButtonPreview;
	}(_react2.default.Component);
	
	ResetButtonPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ResetButtonPreview;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetButton = function (_React$Component) {
	  _inherits(ResetButton, _React$Component);
	
	  function ResetButton(props) {
	    _classCallCheck(this, ResetButton);
	
	    return _possibleConstructorReturn(this, (ResetButton.__proto__ || Object.getPrototypeOf(ResetButton)).call(this, props));
	  }
	
	  _createClass(ResetButton, [{
	    key: 'handleReset',
	    value: function handleReset() {
	      this.props.handlebutton();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var childInputClass = (0, _classnames2.default)('input-container', this.props.isOpenElement);
	      var defaultButtonTitle = this.props.buttontitle !== '' ? this.props.buttontitle : 'Reset URl';
	      var defaultButtonStyle = this.props.buttonstyle !== '' ? this.props.buttonstyle : null;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: childInputClass },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', className: defaultButtonStyle + ' ' + 'reset-button' + ' ' + 'fluid', onClick: this.handleReset.bind(this) },
	            defaultButtonTitle
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetButton;
	}(_react2.default.Component);
	
	ResetButton.propTypes = {
	  'buttontitle': _react2.default.PropTypes.string,
	  'buttonstyle': _react2.default.PropTypes.string,
	  'type': _react2.default.PropTypes.string,
	  'buttonClass': _react2.default.PropTypes.string,
	  'handlebutton': _react2.default.PropTypes.func,
	  'isOpenElement': _react2.default.PropTypes.string
	
	};
	
	exports.default = ResetButton;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _resetbutton = __webpack_require__(765);
	
	var _resetbutton2 = _interopRequireDefault(_resetbutton);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetButtonPreview = function (_React$Component) {
	  _inherits(ResetButtonPreview, _React$Component);
	
	  function ResetButtonPreview(props) {
	    _classCallCheck(this, ResetButtonPreview);
	
	    // this.handlebutton = this.handlebutton.bind(this);
	    var _this = _possibleConstructorReturn(this, (ResetButtonPreview.__proto__ || Object.getPrototypeOf(ResetButtonPreview)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	
	    _this.state = {
	      'options': [],
	      'toogle': false
	    };
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handlebutton = _this.handlebutton.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResetButtonPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.setState({ toogle: nextprops.dropdonwtoggle['reset'] });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handlebutton',
	    value: function handlebutton() {
	      _urlHandlerActions2.default.push({
	        'searchType': 'url_reset',
	        'searchField': 'reset'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var ifOpen = this.state.toogle ? 'active' : 'active';
	      var scrollBoxClassName = this.props.block.dynamicNameClassScrollBox;
	      //const HelperClass = this.state.toogle ? 'single-component' : 'single-component';
	      return _react2.default.createElement(
	        'div',
	        { className: scrollBoxClassName },
	        _react2.default.createElement(
	          'div',
	          { className: 'single-component' + ' ' + 'reset-button-stylefix' + ' ' + 'dropdown-template' },
	          _react2.default.createElement(_resetbutton2.default, { isOpenElement: ifOpen, handlebutton: this.handlebutton, buttontitle: this.props.block.buttontitle, buttonstyle: this.props.block.buttonstyle })
	        )
	      );
	    }
	  }]);
	
	  return ResetButtonPreview;
	}(_react2.default.Component);
	
	ResetButtonPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = ResetButtonPreview;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _daterangepicker = __webpack_require__(768);
	
	var _daterangepicker2 = _interopRequireDefault(_daterangepicker);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRangePickerPreview = function (_React$Component) {
	  _inherits(DateRangePickerPreview, _React$Component);
	
	  function DateRangePickerPreview(props) {
	    _classCallCheck(this, DateRangePickerPreview);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePickerPreview.__proto__ || Object.getPrototypeOf(DateRangePickerPreview)).call(this, props));
	
	    _this.state = {
	      'values': 'Demo Input',
	      'options': [],
	      'toogle': true
	    };
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleDateRange = _this.handleDateRange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePickerPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.block = this.props.block;
	      var datepickertype = this.block.hasOwnProperty('selectedCalenderViewType') ? this.block.selectedCalenderViewType : 'single';
	      this.setState({ datepickertype: datepickertype });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	      var datepickertype = nextprops.block.hasOwnProperty('selectedCalenderViewType') ? nextprops.block.selectedCalenderViewType : 'single';
	      this.setState({ datepickertype: datepickertype });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handleDateRange',
	    value: function handleDateRange(values) {
	      if (this.block !== undefined) {
	        if (this.block.selectedMetakey) {
	          _urlHandlerActions2.default.push({
	            'searchItem': this.block.selectedMetakey,
	            'searchType': 'metakeys',
	            'searchField': 'daterange',
	            values: values
	          });
	        }
	      }
	      // this.setState({ values });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log(this.state.datepickertype);
	      var allUrlData = window.searchArray;
	      var defaultValue = {};
	      allUrlData.map(function (item) {
	        var isDateRangeStart = item.key.indexOf('[start]');
	        if (isDateRangeStart !== -1) {
	          defaultValue.start = item.value;
	        }
	        var isDateRangeEnd = item.key.indexOf('[end]');
	        if (isDateRangeEnd !== -1) {
	          defaultValue.end = item.value;
	        }
	      });
	      var ifOpen = this.state.toogle ? 'active' : 'toggle-option';
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var textBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      return _react2.default.createElement(
	        'div',
	        { className: textBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          _react2.default.createElement(_daterangepicker2.default, _extends({}, this.props, { monthView: this.block.selectedMonthViewType !== undefined ? this.block.selectedMonthViewType : 'single', 'default': defaultValue, dateFormat: this.block.dateFormat !== undefined ? this.block.dateFormat : 'MM-DD-YYYY', datepickertype: this.state.datepickertype, grabDateRangeValue: this.handleDateRange }))
	        ) : null
	      );
	    }
	  }]);
	
	  return DateRangePickerPreview;
	}(_react2.default.Component);
	
	DateRangePickerPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = DateRangePickerPreview;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(205);
	
	var _reactDates = __webpack_require__(769);
	
	__webpack_require__(825);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomDateRangePicker = function (_React$Component) {
	  _inherits(CustomDateRangePicker, _React$Component);
	
	  function CustomDateRangePicker(props) {
	    _classCallCheck(this, CustomDateRangePicker);
	
	    var _this = _possibleConstructorReturn(this, (CustomDateRangePicker.__proto__ || Object.getPrototypeOf(CustomDateRangePicker)).call(this, props));
	
	    _this.state = {
	      focused: false,
	      date: null,
	      focusedInput: null,
	      startDate: null,
	      endDate: null,
	      enableOutsideDays: true
	    };
	
	    _this.onDateChange = _this.onDateChange.bind(_this);
	    _this.onFocusChange = _this.onFocusChange.bind(_this);
	    _this.onFocusChangeRange = _this.onFocusChangeRange.bind(_this);
	    _this.isOutsideRange = _this.isOutsideRange.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomDateRangePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var datepickertype = this.props.datepickertype;
	      this.setState({ datepickertype: datepickertype, startDate: this.props.default.hasOwnProperty('start') ? (0, _moment2.default)(this.props.default.start) : null, endDate: this.props.default.hasOwnProperty('end') ? (0, _moment2.default)(this.props.default.end) : null });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var datepickertype = nextProps.datepickertype;
	      this.setState({ datepickertype: datepickertype, startDate: nextProps.default.hasOwnProperty('start') ? (0, _moment2.default)(nextProps.default.start) : null, endDate: nextProps.default.hasOwnProperty('end') ? (0, _moment2.default)(nextProps.default.end) : null });
	    }
	  }, {
	    key: 'onDateChange',
	    value: function onDateChange(date) {
	      if (this.state.datepickertype === 'single') {
	        var values = [];
	        var startDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        var endDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	        values.push(startDate);
	        values.push(endDate);
	        this.props.grabDateRangeValue(values);
	        this.setState({ startDate: (0, _moment2.default)(startDate) });
	      } else {
	        if (date.startDate !== null && date.endDate !== null) {
	          var _values = [];
	          var _startDate = (0, _moment2.default)(date.startDate).format('YYYY-MM-DD');
	          var _endDate = (0, _moment2.default)(date.endDate).format('YYYY-MM-DD');
	          _values.push(_startDate);
	          _values.push(_endDate);
	          this.props.grabDateRangeValue(_values);
	        }
	        this.setState({ startDate: date.startDate, endDate: date.endDate });
	      }
	      // this.setState({ date });
	    }
	  }, {
	    key: 'onFocusChange',
	    value: function onFocusChange(data) {
	      this.setState({ focused: data.focused });
	    }
	  }, {
	    key: 'onFocusChangeRange',
	    value: function onFocusChangeRange(focusedInput) {
	      this.setState({ focusedInput: focusedInput });
	    }
	  }, {
	    key: 'isOutsideRange',
	    value: function isOutsideRange() {
	      return false;
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state;
	      var focused = _state.focused;
	      var startDate = _state.startDate;
	      var endDate = _state.endDate;
	      var focusedInput = _state.focusedInput;
	      var datepickertype = _state.datepickertype;
	
	      var monthnumber = this.props.monthView === 'single' ? 1 : 2;
	      return _react2.default.createElement(
	        'div',
	        null,
	        datepickertype === 'single' ? _react2.default.createElement(_reactDates.SingleDatePicker, {
	          id: 'date_input',
	          date: startDate,
	          focused: focused,
	          displayFormat: this.props.dateFormat,
	          numberOfMonths: monthnumber,
	          isOutsideRange: this.isOutsideRange,
	          onDateChange: this.onDateChange,
	          onFocusChange: this.onFocusChange,
	          orientation: monthnumber === 1 ? 'vertical' : 'horizontal'
	        }) : _react2.default.createElement(_reactDates.DateRangePicker, _extends({}, this.props, {
	          onDatesChange: this.onDateChange,
	          onFocusChange: this.onFocusChangeRange,
	          isOutsideRange: this.isOutsideRange,
	          displayFormat: this.props.dateFormat,
	          focusedInput: focusedInput,
	          numberOfMonths: monthnumber,
	          startDate: startDate,
	          endDate: endDate,
	          orientation: monthnumber === 1 ? 'vertical' : 'horizontal'
	        }))
	      );
	    }
	  }]);
	
	  return CustomDateRangePicker;
	}(_react2.default.Component);
	
	CustomDateRangePicker.propTypes = {
	  'multiselect': _react2.default.PropTypes.string,
	  'option': _react2.default.PropTypes.array,
	  'defaultvalue': _react2.default.PropTypes.array,
	  'grabDateRangeValue': _react2.default.PropTypes.func,
	  'block': _react2.default.PropTypes.object
	};
	
	exports.default = CustomDateRangePicker;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var DateRangePicker = __webpack_require__(770).default;
	var DateRangePickerInput = __webpack_require__(806).default;
	var SingleDatePicker = __webpack_require__(821).default;
	var SingleDatePickerInput = __webpack_require__(822).default;
	var DayPicker = __webpack_require__(808).default;
	var CalendarMonthGrid = __webpack_require__(812).default;
	var CalendarMonth = __webpack_require__(815).default;
	var CalendarDay = __webpack_require__(816).default;
	
	var DateRangePickerShape = __webpack_require__(819).default;
	var SingleDatePickerShape = __webpack_require__(823).default;
	
	var isInclusivelyAfterDay = __webpack_require__(801).default;
	var isInclusivelyBeforeDay = __webpack_require__(803).default;
	var isNextDay = __webpack_require__(804).default;
	var isSameDay = __webpack_require__(802).default;
	
	var toISODateString = __webpack_require__(824).default;
	var toLocalizedDateString = __webpack_require__(800).default;
	var toMomentObject = __webpack_require__(799).default;
	
	
	module.exports = {
	  DateRangePicker: DateRangePicker,
	  SingleDatePicker: SingleDatePicker,
	
	  DateRangePickerInput: DateRangePickerInput,
	  SingleDatePickerInput: SingleDatePickerInput,
	  DayPicker: DayPicker,
	  CalendarMonthGrid: CalendarMonthGrid,
	  CalendarMonth: CalendarMonth,
	  CalendarDay: CalendarDay,
	
	  DateRangePickerShape: DateRangePickerShape,
	  SingleDatePickerShape: SingleDatePickerShape,
	
	  isInclusivelyAfterDay: isInclusivelyAfterDay,
	  isInclusivelyBeforeDay: isInclusivelyBeforeDay,
	  isNextDay: isNextDay,
	  isSameDay: isSameDay,
	
	  toISODateString: toISODateString,
	  toLocalizedDateString: toLocalizedDateString,
	  toMomentObject: toMomentObject,
	};


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _reactPortal = __webpack_require__(15);
	
		var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
		var _arrayIncludes = __webpack_require__(16);
	
		var _arrayIncludes2 = _interopRequireDefault(_arrayIncludes);
	
		var _isTouchDevice = __webpack_require__(14);
	
		var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
		var _toMomentObject = __webpack_require__(17);
	
		var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
		var _toLocalizedDateString = __webpack_require__(18);
	
		var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
		var _isInclusivelyAfterDay = __webpack_require__(19);
	
		var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
		var _isInclusivelyBeforeDay = __webpack_require__(20);
	
		var _isInclusivelyBeforeDay2 = _interopRequireDefault(_isInclusivelyBeforeDay);
	
		var _isNextDay = __webpack_require__(21);
	
		var _isNextDay2 = _interopRequireDefault(_isNextDay);
	
		var _isSameDay = __webpack_require__(22);
	
		var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
		var _OutsideClickHandler = __webpack_require__(23);
	
		var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
		var _DateRangePickerInput = __webpack_require__(24);
	
		var _DateRangePickerInput2 = _interopRequireDefault(_DateRangePickerInput);
	
		var _DayPicker = __webpack_require__(25);
	
		var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
		var _close = __webpack_require__(26);
	
		var _close2 = _interopRequireDefault(_close);
	
		var _DateRangePickerShape = __webpack_require__(27);
	
		var _DateRangePickerShape2 = _interopRequireDefault(_DateRangePickerShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = _DateRangePickerShape2['default'];
	
		var defaultProps = {
		  startDateId: _constants.START_DATE,
		  endDateId: _constants.END_DATE,
		  focusedInput: null,
		  minimumNights: 1,
		  isDayBlocked: function () {
		    function isDayBlocked() {
		      return false;
		    }
	
		    return isDayBlocked;
		  }(),
		  disabledDays: [],
		  isOutsideRange: function () {
		    function isOutsideRange(day) {
		      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
		    }
	
		    return isOutsideRange;
		  }(),
		  enableOutsideDays: false,
		  numberOfMonths: 2,
		  showClearDates: false,
		  disabled: false,
		  reopenPickerOnClearDates: false,
	
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  withPortal: false,
		  withFullScreenPortal: false,
	
		  onDatesChange: function () {
		    function onDatesChange() {}
	
		    return onDatesChange;
		  }(),
		  onFocusChange: function () {
		    function onFocusChange() {}
	
		    return onFocusChange;
		  }(),
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }(),
	
		  // i18n
		  displayFormat: function () {
		    function displayFormat() {
		      return _moment2['default'].localeData().longDateFormat('L');
		    }
	
		    return displayFormat;
		  }(),
		  monthFormat: 'MMMM YYYY',
		  phrases: {
		    closeDatePicker: 'Close',
		    clearDates: 'Clear Dates'
		  }
		};
	
		var DateRangePicker = function (_React$Component) {
		  _inherits(DateRangePicker, _React$Component);
	
		  function DateRangePicker(props) {
		    _classCallCheck(this, DateRangePicker);
	
		    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
		    _this.state = {
		      hoverDate: null
		    };
	
		    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
	
		    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
		    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
		    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
		    _this.onDayClick = _this.onDayClick.bind(_this);
	
		    _this.onClearFocus = _this.onClearFocus.bind(_this);
		    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
		    _this.onStartDateFocus = _this.onStartDateFocus.bind(_this);
		    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
		    _this.onEndDateFocus = _this.onEndDateFocus.bind(_this);
		    _this.clearDates = _this.clearDates.bind(_this);
		    return _this;
		  }
	
		  _createClass(DateRangePicker, [{
		    key: 'onClearFocus',
		    value: function () {
		      function onClearFocus() {
		        this.props.onFocusChange(null);
		      }
	
		      return onClearFocus;
		    }()
		  }, {
		    key: 'onDayClick',
		    value: function () {
		      function onDayClick(day, modifiers, e) {
		        if (e) e.preventDefault();
		        if ((0, _arrayIncludes2['default'])(modifiers, 'blocked')) return;
	
		        var focusedInput = this.props.focusedInput;
		        var _props = this.props;
		        var startDate = _props.startDate;
		        var endDate = _props.endDate;
	
		        if (focusedInput === _constants.START_DATE) {
		          this.props.onFocusChange(_constants.END_DATE);
	
		          startDate = day;
		          if ((0, _isInclusivelyAfterDay2['default'])(day, endDate)) {
		            endDate = null;
		          }
		        } else if (focusedInput === _constants.END_DATE) {
		          if ((0, _isInclusivelyBeforeDay2['default'])(day, startDate)) {
		            startDate = day;
		            endDate = null;
		          } else {
		            endDate = day;
		            if (!startDate) {
		              this.props.onFocusChange(_constants.START_DATE);
		            } else {
		              this.props.onFocusChange(null);
		            }
		          }
		        }
	
		        this.props.onDatesChange({ startDate: startDate, endDate: endDate });
		      }
	
		      return onDayClick;
		    }()
		  }, {
		    key: 'onDayMouseEnter',
		    value: function () {
		      function onDayMouseEnter(day) {
		        if (this.isTouchDevice) return;
	
		        this.setState({
		          hoverDate: day
		        });
		      }
	
		      return onDayMouseEnter;
		    }()
		  }, {
		    key: 'onDayMouseLeave',
		    value: function () {
		      function onDayMouseLeave() {
		        if (this.isTouchDevice) return;
	
		        this.setState({
		          hoverDate: null
		        });
		      }
	
		      return onDayMouseLeave;
		    }()
		  }, {
		    key: 'onEndDateChange',
		    value: function () {
		      function onEndDateChange(endDateString) {
		        var _props2 = this.props;
		        var startDate = _props2.startDate;
		        var isOutsideRange = _props2.isOutsideRange;
		        var onDatesChange = _props2.onDatesChange;
		        var onFocusChange = _props2.onFocusChange;
	
		        var endDate = (0, _toMomentObject2['default'])(endDateString, this.getDisplayFormat());
	
		        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(0, _isInclusivelyBeforeDay2['default'])(endDate, startDate);
		        if (isEndDateValid) {
		          onDatesChange({ startDate: startDate, endDate: endDate });
		          onFocusChange(null);
		        } else {
		          onDatesChange({
		            startDate: startDate,
		            endDate: null
		          });
		        }
		      }
	
		      return onEndDateChange;
		    }()
		  }, {
		    key: 'onEndDateFocus',
		    value: function () {
		      function onEndDateFocus() {
		        var _props3 = this.props;
		        var startDate = _props3.startDate;
		        var onFocusChange = _props3.onFocusChange;
		        var orientation = _props3.orientation;
		        var disabled = _props3.disabled;
	
		        if (!startDate && orientation === _constants.VERTICAL_ORIENTATION && !disabled) {
		          // Since the vertical datepicker is full screen, we never want to focus the end date first
		          // because there's no indication that that is the case once the datepicker is open and it
		          // might confuse the user
		          onFocusChange(_constants.START_DATE);
		        } else if (!disabled) {
		          onFocusChange(_constants.END_DATE);
		        }
		      }
	
		      return onEndDateFocus;
		    }()
		  }, {
		    key: 'onOutsideClick',
		    value: function () {
		      function onOutsideClick() {
		        var _props4 = this.props;
		        var focusedInput = _props4.focusedInput;
		        var onFocusChange = _props4.onFocusChange;
	
		        if (!focusedInput) return;
	
		        onFocusChange(null);
		      }
	
		      return onOutsideClick;
		    }()
		  }, {
		    key: 'onStartDateChange',
		    value: function () {
		      function onStartDateChange(startDateString) {
		        var startDate = (0, _toMomentObject2['default'])(startDateString, this.getDisplayFormat());
	
		        var endDate = this.props.endDate;
		        var _props5 = this.props;
		        var isOutsideRange = _props5.isOutsideRange;
		        var onDatesChange = _props5.onDatesChange;
		        var onFocusChange = _props5.onFocusChange;
	
		        var isStartDateValid = startDate && !isOutsideRange(startDate);
		        if (isStartDateValid) {
		          if ((0, _isInclusivelyBeforeDay2['default'])(endDate, startDate)) {
		            endDate = null;
		          }
	
		          onDatesChange({ startDate: startDate, endDate: endDate });
		          onFocusChange(_constants.END_DATE);
		        } else {
		          onDatesChange({
		            startDate: null,
		            endDate: endDate
		          });
		        }
		      }
	
		      return onStartDateChange;
		    }()
		  }, {
		    key: 'onStartDateFocus',
		    value: function () {
		      function onStartDateFocus() {
		        if (!this.props.disabled) {
		          this.props.onFocusChange(_constants.START_DATE);
		        }
		      }
	
		      return onStartDateFocus;
		    }()
		  }, {
		    key: 'getDateString',
		    value: function () {
		      function getDateString(date) {
		        var displayFormat = this.getDisplayFormat();
		        if (date && displayFormat) {
		          return date && date.format(displayFormat);
		        }
		        return (0, _toLocalizedDateString2['default'])(date);
		      }
	
		      return getDateString;
		    }()
		  }, {
		    key: 'getDayPickerContainerClasses',
		    value: function () {
		      function getDayPickerContainerClasses() {
		        var _props6 = this.props;
		        var focusedInput = _props6.focusedInput;
		        var orientation = _props6.orientation;
		        var withPortal = _props6.withPortal;
		        var withFullScreenPortal = _props6.withFullScreenPortal;
		        var hoverDate = this.state.hoverDate;
	
		        var showDatepicker = focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
	
		        var dayPickerClassName = (0, _classnames2['default'])('DateRangePicker__picker', {
		          'DateRangePicker__picker--show': showDatepicker,
		          'DateRangePicker__picker--invisible': !showDatepicker,
		          'DateRangePicker__picker--start': focusedInput === _constants.START_DATE,
		          'DateRangePicker__picker--end': focusedInput === _constants.END_DATE,
		          'DateRangePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		          'DateRangePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
		          'DateRangePicker__picker--portal': withPortal || withFullScreenPortal,
		          'DateRangePicker__picker--full-screen-portal': withFullScreenPortal,
		          'DateRangePicker__picker--valid-date-hovered': hoverDate && !this.isBlocked(hoverDate)
		        });
	
		        return dayPickerClassName;
		      }
	
		      return getDayPickerContainerClasses;
		    }()
		  }, {
		    key: 'getDayPickerDOMNode',
		    value: function () {
		      function getDayPickerDOMNode() {
		        return _reactDom2['default'].findDOMNode(this.dayPicker);
		      }
	
		      return getDayPickerDOMNode;
		    }()
		  }, {
		    key: 'getDisplayFormat',
		    value: function () {
		      function getDisplayFormat() {
		        var displayFormat = this.props.displayFormat;
	
		        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
		      }
	
		      return getDisplayFormat;
		    }()
		  }, {
		    key: 'clearDates',
		    value: function () {
		      function clearDates() {
		        var _props7 = this.props;
		        var onDatesChange = _props7.onDatesChange;
		        var reopenPickerOnClearDates = _props7.reopenPickerOnClearDates;
		        var onFocusChange = _props7.onFocusChange;
	
		        onDatesChange({ startDate: null, endDate: null });
		        if (reopenPickerOnClearDates) {
		          onFocusChange(_constants.START_DATE);
		        }
		      }
	
		      return clearDates;
		    }()
		  }, {
		    key: 'doesNotMeetMinimumNights',
		    value: function () {
		      function doesNotMeetMinimumNights(day) {
		        var _props8 = this.props;
		        var startDate = _props8.startDate;
		        var isOutsideRange = _props8.isOutsideRange;
		        var focusedInput = _props8.focusedInput;
		        var minimumNights = _props8.minimumNights;
	
		        if (focusedInput !== _constants.END_DATE) return false;
	
		        if (startDate) {
		          var dayDiff = day.diff(startDate, 'days');
		          return dayDiff < minimumNights && dayDiff >= 0;
		        }
		        return isOutsideRange((0, _moment2['default'])(day).subtract(minimumNights, 'days'));
		      }
	
		      return doesNotMeetMinimumNights;
		    }()
		  }, {
		    key: 'isDayAfterHoveredStartDate',
		    value: function () {
		      function isDayAfterHoveredStartDate(day) {
		        var _props9 = this.props;
		        var startDate = _props9.startDate;
		        var endDate = _props9.endDate;
		        var hoverDate = this.state.hoverDate;
	
		        return !!startDate && !endDate && (0, _isNextDay2['default'])(hoverDate, day) && (0, _isSameDay2['default'])(hoverDate, startDate);
		      }
	
		      return isDayAfterHoveredStartDate;
		    }()
		  }, {
		    key: 'isEndDate',
		    value: function () {
		      function isEndDate(day) {
		        return (0, _isSameDay2['default'])(day, this.props.endDate);
		      }
	
		      return isEndDate;
		    }()
		  }, {
		    key: 'isHovered',
		    value: function () {
		      function isHovered(day) {
		        return (0, _isSameDay2['default'])(day, this.state.hoverDate);
		      }
	
		      return isHovered;
		    }()
		  }, {
		    key: 'isInHoveredSpan',
		    value: function () {
		      function isInHoveredSpan(day) {
		        var _props10 = this.props;
		        var startDate = _props10.startDate;
		        var endDate = _props10.endDate;
		        var hoverDate = this.state.hoverDate;
	
		        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay2['default'])(hoverDate, day));
		        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay2['default'])(hoverDate, day));
	
		        return isForwardRange || isBackwardRange;
		      }
	
		      return isInHoveredSpan;
		    }()
		  }, {
		    key: 'isInSelectedSpan',
		    value: function () {
		      function isInSelectedSpan(day) {
		        var _props11 = this.props;
		        var startDate = _props11.startDate;
		        var endDate = _props11.endDate;
	
		        return day.isBetween(startDate, endDate);
		      }
	
		      return isInSelectedSpan;
		    }()
		  }, {
		    key: 'isLastInRange',
		    value: function () {
		      function isLastInRange(day) {
		        return this.isInSelectedSpan(day) && (0, _isNextDay2['default'])(day, this.props.endDate);
		      }
	
		      return isLastInRange;
		    }()
		  }, {
		    key: 'isStartDate',
		    value: function () {
		      function isStartDate(day) {
		        return (0, _isSameDay2['default'])(day, this.props.startDate);
		      }
	
		      return isStartDate;
		    }()
		  }, {
		    key: 'isBlocked',
		    value: function () {
		      function isBlocked(day) {
		        var _props12 = this.props;
		        var isDayBlocked = _props12.isDayBlocked;
		        var isOutsideRange = _props12.isOutsideRange;
	
		        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
		      }
	
		      return isBlocked;
		    }()
		  }, {
		    key: 'maybeRenderDayPickerWithPortal',
		    value: function () {
		      function maybeRenderDayPickerWithPortal() {
		        var _props13 = this.props;
		        var focusedInput = _props13.focusedInput;
		        var withPortal = _props13.withPortal;
		        var withFullScreenPortal = _props13.withFullScreenPortal;
	
		        if (withPortal || withFullScreenPortal) {
		          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: focusedInput !== null }, this.renderDayPicker());
		        }
	
		        return this.renderDayPicker();
		      }
	
		      return maybeRenderDayPickerWithPortal;
		    }()
		  }, {
		    key: 'renderDayPicker',
		    value: function () {
		      function renderDayPicker() {
		        var _this2 = this;
	
		        var _props14 = this.props;
		        var isDayBlocked = _props14.isDayBlocked;
		        var isOutsideRange = _props14.isOutsideRange;
		        var numberOfMonths = _props14.numberOfMonths;
		        var orientation = _props14.orientation;
		        var monthFormat = _props14.monthFormat;
		        var onPrevMonthClick = _props14.onPrevMonthClick;
		        var onNextMonthClick = _props14.onNextMonthClick;
		        var withPortal = _props14.withPortal;
		        var withFullScreenPortal = _props14.withFullScreenPortal;
		        var enableOutsideDays = _props14.enableOutsideDays;
	
		        var modifiers = {
		          blocked: function () {
		            function blocked(day) {
		              return _this2.isBlocked(day);
		            }
	
		            return blocked;
		          }(),
		          'blocked-calendar': function () {
		            function blockedCalendar(day) {
		              return isDayBlocked(day);
		            }
	
		            return blockedCalendar;
		          }(),
		          'blocked-out-of-range': function () {
		            function blockedOutOfRange(day) {
		              return isOutsideRange(day);
		            }
	
		            return blockedOutOfRange;
		          }(),
		          'blocked-minimum-nights': function () {
		            function blockedMinimumNights(day) {
		              return _this2.doesNotMeetMinimumNights(day);
		            }
	
		            return blockedMinimumNights;
		          }(),
		          valid: function () {
		            function valid(day) {
		              return !_this2.isBlocked(day);
		            }
	
		            return valid;
		          }(),
		          // before anything has been set or after both are set
		          hovered: function () {
		            function hovered(day) {
		              return _this2.isHovered(day);
		            }
	
		            return hovered;
		          }(),
	
		          // while start date has been set, but end date has not been
		          'hovered-span': function () {
		            function hoveredSpan(day) {
		              return _this2.isInHoveredSpan(day);
		            }
	
		            return hoveredSpan;
		          }(),
		          'after-hovered-start': function () {
		            function afterHoveredStart(day) {
		              return _this2.isDayAfterHoveredStartDate(day);
		            }
	
		            return afterHoveredStart;
		          }(),
		          'last-in-range': function () {
		            function lastInRange(day) {
		              return _this2.isLastInRange(day);
		            }
	
		            return lastInRange;
		          }(),
	
		          // once a start date and end date have been set
		          'selected-start': function () {
		            function selectedStart(day) {
		              return _this2.isStartDate(day);
		            }
	
		            return selectedStart;
		          }(),
		          'selected-end': function () {
		            function selectedEnd(day) {
		              return _this2.isEndDate(day);
		            }
	
		            return selectedEnd;
		          }(),
		          'selected-span': function () {
		            function selectedSpan(day) {
		              return _this2.isInSelectedSpan(day);
		            }
	
		            return selectedSpan;
		          }()
		        };
	
		        var onOutsideClick = withPortal ? this.onOutsideClick : function () {};
	
		        return _react2['default'].createElement('div', { className: this.getDayPickerContainerClasses() }, _react2['default'].createElement(_DayPicker2['default'], {
		          ref: function () {
		            function ref(_ref) {
		              _this2.dayPicker = _ref;
		            }
	
		            return ref;
		          }(),
		          orientation: orientation,
		          enableOutsideDays: enableOutsideDays,
		          modifiers: modifiers,
		          numberOfMonths: numberOfMonths,
		          onDayMouseEnter: this.onDayMouseEnter,
		          onDayMouseLeave: this.onDayMouseLeave,
		          onDayMouseDown: this.onDayClick,
		          onDayTouchTap: this.onDayClick,
		          onPrevMonthClick: onPrevMonthClick,
		          onNextMonthClick: onNextMonthClick,
		          monthFormat: monthFormat,
		          withPortal: withPortal || withFullScreenPortal,
		          onOutsideClick: onOutsideClick
		        }), withFullScreenPortal && _react2['default'].createElement('button', {
		          className: 'DateRangePicker__close',
		          type: 'button',
		          onClick: this.onOutsideClick
		        }, _react2['default'].createElement('span', { className: 'screen-reader-only' }, this.props.phrases.closeDatePicker), _react2['default'].createElement(_close2['default'], null)));
		      }
	
		      return renderDayPicker;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _props15 = this.props;
		        var startDate = _props15.startDate;
		        var endDate = _props15.endDate;
		        var focusedInput = _props15.focusedInput;
		        var showClearDates = _props15.showClearDates;
		        var disabled = _props15.disabled;
		        var startDateId = _props15.startDateId;
		        var endDateId = _props15.endDateId;
		        var phrases = _props15.phrases;
		        var withPortal = _props15.withPortal;
		        var withFullScreenPortal = _props15.withFullScreenPortal;
	
		        var startDateString = this.getDateString(startDate);
		        var endDateString = this.getDateString(endDate);
	
		        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onOutsideClick : function () {};
	
		        return _react2['default'].createElement('div', { className: 'DateRangePicker' }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement(_DateRangePickerInput2['default'], {
		          startDateId: startDateId,
		          startDatePlaceholderText: this.props.startDatePlaceholderText,
		          isStartDateFocused: focusedInput === _constants.START_DATE,
		          endDateId: endDateId,
		          endDatePlaceholderText: this.props.endDatePlaceholderText,
		          isEndDateFocused: focusedInput === _constants.END_DATE,
		          onStartDateChange: this.onStartDateChange,
		          onStartDateFocus: this.onStartDateFocus,
		          onStartDateShiftTab: this.onClearFocus,
		          onEndDateChange: this.onEndDateChange,
		          onEndDateFocus: this.onEndDateFocus,
		          onEndDateTab: this.onClearFocus,
		          startDate: startDateString,
		          endDate: endDateString,
		          showClearDates: showClearDates,
		          onClearDates: this.clearDates,
		          disabled: disabled,
		          phrases: phrases
		        }), this.maybeRenderDayPickerWithPortal()));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DateRangePicker;
		}(_react2['default'].Component);
	
		exports['default'] = DateRangePicker;
	
		DateRangePicker.propTypes = propTypes;
		DateRangePicker.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */,
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(167);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */,
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(771);
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(31);
	
	/***/ },
	/* 11 */,
	/* 12 */,
	/* 13 */,
	/* 14 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(772);
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(773);
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(774);
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(799);
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(800);
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(801);
	
	/***/ },
	/* 20 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(803);
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(804);
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(802);
	
	/***/ },
	/* 23 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(805);
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(806);
	
	/***/ },
	/* 25 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(808);
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 12 12" }, this.props),
		          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	/* 27 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(819);
	
	/***/ }
	/******/ ]);

/***/ },
/* 771 */
/***/ function(module, exports) {

	module.exports = {
	  DISPLAY_FORMAT: 'L',
	  ISO_FORMAT: 'YYYY-MM-DD',
	
	  START_DATE: 'startDate',
	  END_DATE: 'endDate',
	
	  HORIZONTAL_ORIENTATION: 'horizontal',
	  VERTICAL_ORIENTATION: 'vertical'
	};


/***/ },
/* 772 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTouchDevice;
	function isTouchDevice() {
	  return !!(typeof window !== 'undefined' && 'ontouchstart' in window) || !!(typeof navigator !== 'undefined' && navigator.maxTouchPoints);
	}

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _CSSPropertyOperations = __webpack_require__(88);
	
	var _CSSPropertyOperations2 = _interopRequireDefault(_CSSPropertyOperations);
	
	var _shallowCompare = __webpack_require__(488);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Portal).call(this));
	
	    _this.state = { active: false };
	    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    _this.portal = null;
	    _this.node = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mouseup', this.handleOutsideMouseClick);
	        document.addEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      if (this.props.isOpened) {
	        this.openPortal();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // portal's 'is open' state is handled through the prop isOpened
	      if (typeof newProps.isOpened !== 'undefined') {
	        if (newProps.isOpened) {
	          if (this.state.active) {
	            this.renderPortal(newProps);
	          } else {
	            this.openPortal(newProps);
	          }
	        }
	        if (!newProps.isOpened && this.state.active) {
	          this.closePortal();
	        }
	      }
	
	      // portal handles its own 'is open' state
	      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
	        this.renderPortal(newProps);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shallowCompare2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
	        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      this.closePortal(true);
	    }
	  }, {
	    key: 'handleWrapperClick',
	    value: function handleWrapperClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (this.state.active) {
	        return;
	      }
	      this.openPortal();
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal() {
	      var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	      this.setState({ active: true });
	      this.renderPortal(props);
	      this.props.onOpen(this.node);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      var _this2 = this;
	
	      var isUnmounted = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	      var resetPortalState = function resetPortalState() {
	        if (_this2.node) {
	          _reactDom2.default.unmountComponentAtNode(_this2.node);
	          document.body.removeChild(_this2.node);
	        }
	        _this2.portal = null;
	        _this2.node = null;
	        if (isUnmounted !== true) {
	          _this2.setState({ active: false });
	        }
	      };
	
	      if (this.state.active) {
	        if (this.props.beforeClose) {
	          this.props.beforeClose(this.node, resetPortalState);
	        } else {
	          resetPortalState();
	        }
	
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	
	      var root = (0, _reactDom.findDOMNode)(this.portal);
	      if (root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	
	      e.stopPropagation();
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'applyClassNameAndStyle',
	    value: function applyClassNameAndStyle(props) {
	      if (props.className) {
	        this.node.className = props.className;
	      }
	      if (props.style) {
	        // React 15.1.0+ requires third parameter in debug mode
	        /* eslint-disable no-underscore-dangle */
	        _CSSPropertyOperations2.default.setValueForStyles(this.node, props.style, this._reactInternalInstance);
	        /* eslint-enable no-underscore-dangle */
	      }
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.node) {
	        this.node = document.createElement('div');
	        // apply CSS before the node is added to the DOM to avoid needless reflows
	        this.applyClassNameAndStyle(props);
	        document.body.appendChild(this.node);
	      } else {
	        // update CSS when new props arrive
	        this.applyClassNameAndStyle(props);
	      }
	
	      var children = props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof props.children.type === 'function') {
	        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.openByClickOn) {
	        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  className: _react2.default.PropTypes.string,
	  style: _react2.default.PropTypes.object,
	  children: _react2.default.PropTypes.element.isRequired,
	  openByClickOn: _react2.default.PropTypes.element,
	  closeOnEsc: _react2.default.PropTypes.bool,
	  closeOnOutsideClick: _react2.default.PropTypes.bool,
	  isOpened: _react2.default.PropTypes.bool,
	  onOpen: _react2.default.PropTypes.func,
	  onClose: _react2.default.PropTypes.func,
	  beforeClose: _react2.default.PropTypes.func,
	  onUpdate: _react2.default.PropTypes.func
	};
	
	Portal.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  onUpdate: function onUpdate() {}
	};
	module.exports = exports['default'];


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(775);
	var ES = __webpack_require__(779);
	
	var implementation = __webpack_require__(796);
	var getPolyfill = __webpack_require__(797);
	var polyfill = getPolyfill();
	var shim = __webpack_require__(798);
	
	var slice = Array.prototype.slice;
	
	/* eslint-disable no-unused-vars */
	var boundIncludesShim = function includes(array, searchElement) {
	/* eslint-enable no-unused-vars */
		ES.RequireObjectCoercible(array);
		return polyfill.apply(array, slice.call(arguments, 1));
	};
	define(boundIncludesShim, {
		implementation: implementation,
		getPolyfill: getPolyfill,
		shim: shim
	});
	
	module.exports = boundIncludesShim;


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(776);
	var foreach = __webpack_require__(778);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(777);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 777 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 778 */
/***/ function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	var symbolToStr = hasSymbols ? Symbol.prototype.toString : toStr;
	
	var $isNaN = __webpack_require__(780);
	var $isFinite = __webpack_require__(781);
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(782);
	var sign = __webpack_require__(783);
	var mod = __webpack_require__(784);
	var isPrimitive = __webpack_require__(785);
	var toPrimitive = __webpack_require__(786);
	var parseInteger = parseInt;
	var bind = __webpack_require__(791);
	var strSlice = bind.call(Function.call, String.prototype.slice);
	var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[\-\+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(793);
	
	var hasRegExpMatcher = __webpack_require__(795);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, 'number');
			if (typeof value === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = Math.floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a string');
			}
			return String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, String);
			return typeof key === 'symbol' ? symbolToStr.call(key) : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr.call(argument) !== '[object String]') {
				throw new TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: Array.isArray || function IsArray(argument) {
			return toStr.call(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: function IsExtensible(obj) {
			if (!Object.preventExtensions) { return true; }
			if (isPrimitive(obj)) {
				return false;
			}
			return Object.isExtensible(obj);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = Math.abs(argument);
			return Math.floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && Symbol.species ? C[Symbol.species] : undefined;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new TypeError('no constructor found');
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ },
/* 780 */
/***/ function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 781 */
/***/ function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ },
/* 782 */
/***/ function(module, exports) {

	var has = Object.prototype.hasOwnProperty;
	module.exports = Object.assign || function assign(target, source) {
		for (var key in source) {
			if (has.call(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ },
/* 783 */
/***/ function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ },
/* 784 */
/***/ function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ },
/* 785 */
/***/ function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(787);
	var isCallable = __webpack_require__(788);
	var isDate = __webpack_require__(789);
	var isSymbol = __webpack_require__(790);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (PreferredType === String) {
				hint = 'string';
			} else if (PreferredType === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ },
/* 787 */
785,
/* 788 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class /;
	var isES6ClassFn = function isES6ClassFn(value) {
		try {
			var fnStr = fnToStr.call(value);
			var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
			var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
			var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
			return constructorRegex.test(spaceStripped);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionObject(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ },
/* 789 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 790 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') { return false; }
			return symStringRegex.test(symToStr.call(value));
		};
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') { return true; }
			if (toStr.call(value) !== '[object Symbol]') { return false; }
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false;
		};
	}


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	var implementation = __webpack_require__(792);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 792 */
/***/ function(module, exports) {

	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(780);
	var $isFinite = __webpack_require__(781);
	
	var sign = __webpack_require__(783);
	var mod = __webpack_require__(784);
	
	var IsCallable = __webpack_require__(788);
	var toPrimitive = __webpack_require__(794);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return Boolean(value);
		},
		ToNumber: function ToNumber(value) {
			return Number(value);
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// http://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		}
	};
	
	module.exports = ES5;


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(787);
	
	var isCallable = __webpack_require__(788);
	
	// https://es5.github.io/#x8.12
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O, hint) {
			var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// https://es5.github.io/#x9
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
	};


/***/ },
/* 795 */
/***/ function(module, exports) {

	'use strict';
	
	var regexExec = RegExp.prototype.exec;
	var tryRegexExec = function tryRegexExec(value) {
		try {
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (typeof value !== 'object') { return false; }
		return hasToStringTag ? tryRegexExec(value) : toStr.call(value) === regexClass;
	};


/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var ES = __webpack_require__(779);
	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	var $isFinite = Number.isFinite || function (n) { return typeof n === 'number' && global.isFinite(n); };
	var indexOf = Array.prototype.indexOf;
	
	module.exports = function includes(searchElement) {
		var fromIndex = arguments.length > 1 ? ES.ToInteger(arguments[1]) : 0;
		if (indexOf && !$isNaN(searchElement) && $isFinite(fromIndex) && typeof searchElement !== 'undefined') {
			return indexOf.apply(this, arguments) > -1;
		}
	
		var O = ES.ToObject(this);
		var length = ES.ToLength(O.length);
		if (length === 0) {
			return false;
		}
		var k = fromIndex >= 0 ? fromIndex : Math.max(0, length + fromIndex);
		while (k < length) {
			if (ES.SameValueZero(searchElement, O[k])) {
				return true;
			}
			k += 1;
		}
		return false;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(796);
	
	module.exports = function getPolyfill() {
		return Array.prototype.includes || implementation;
	};


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(775);
	var getPolyfill = __webpack_require__(797);
	
	module.exports = function shimArrayPrototypeIncludes() {
		var polyfill = getPolyfill();
		if (Array.prototype.includes !== polyfill) {
			define(Array.prototype, { includes: polyfill });
		}
		return polyfill;
	};


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toMomentObject;
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(771);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toMomentObject(dateString, customFormat) {
	  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
	
	  var date = (0, _moment2['default'])(dateString, dateFormats, true);
	  return date.isValid() ? date : null;
	}

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toLocalizedDateString;
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(799);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(771);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.DISPLAY_FORMAT);
	}

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyAfterDay;
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(802);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return a.isAfter(b) || (0, _isSameDay2['default'])(a, b);
	}

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isSameDay;
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSameDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return a.isSame(b, 'day');
	}

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyBeforeDay;
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(802);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return a.isBefore(b) || (0, _isSameDay2['default'])(a, b);
	}

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isNextDay;
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(802);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isNextDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  var nextDay = (0, _moment2['default'])(a).add(1, 'day');
	  return (0, _isSameDay2['default'])(nextDay, b);
	}

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  children: _react.PropTypes.node,
		  onOutsideClick: _react.PropTypes.func
		};
	
		var defaultProps = {
		  children: _react2['default'].createElement('span', null),
		  onOutsideClick: function () {
		    function onOutsideClick() {}
	
		    return onOutsideClick;
		  }()
		};
	
		var OutsideClickHandler = function (_React$Component) {
		  _inherits(OutsideClickHandler, _React$Component);
	
		  function OutsideClickHandler(props) {
		    _classCallCheck(this, OutsideClickHandler);
	
		    var _this = _possibleConstructorReturn(this, (OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call(this, props));
	
		    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
		    return _this;
		  }
	
		  _createClass(OutsideClickHandler, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        if (document.addEventListener) {
		          // `useCapture` flag is set to true so that a `stopPropagation` in the children will
		          // not prevent all outside click handlers from firing - maja
		          document.addEventListener('click', this.onOutsideClick, true);
		        } else {
		          document.attachEvent('onclick', this.onOutsideClick);
		        }
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'componentWillUnmount',
		    value: function () {
		      function componentWillUnmount() {
		        if (document.removeEventListener) {
		          document.removeEventListener('click', this.onOutsideClick, true);
		        } else {
		          document.detachEvent('onclick', this.onOutsideClick);
		        }
		      }
	
		      return componentWillUnmount;
		    }()
		  }, {
		    key: 'onOutsideClick',
		    value: function () {
		      function onOutsideClick(e) {
		        var isDescendantOfRoot = _reactDom2['default'].findDOMNode(this.refs.childNode).contains(e.target);
		        if (!isDescendantOfRoot) {
		          this.props.onOutsideClick(e);
		        }
		      }
	
		      return onOutsideClick;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        return _react2['default'].createElement('div', { ref: 'childNode' }, this.props.children);
		      }
	
		      return render;
		    }()
		  }]);
	
		  return OutsideClickHandler;
		}(_react2['default'].Component);
	
		exports['default'] = OutsideClickHandler;
	
		OutsideClickHandler.propTypes = propTypes;
		OutsideClickHandler.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 10:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(31);
	
	/***/ }
	
	/******/ });

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _DateInput = __webpack_require__(28);
	
		var _DateInput2 = _interopRequireDefault(_DateInput);
	
		var _arrowRight = __webpack_require__(29);
	
		var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
		var _close = __webpack_require__(26);
	
		var _close2 = _interopRequireDefault(_close);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  startDateId: _react.PropTypes.string,
		  startDatePlaceholderText: _react.PropTypes.string,
	
		  endDateId: _react.PropTypes.string,
		  endDatePlaceholderText: _react.PropTypes.string,
	
		  onStartDateFocus: _react.PropTypes.func,
		  onEndDateFocus: _react.PropTypes.func,
		  onStartDateChange: _react.PropTypes.func,
		  onEndDateChange: _react.PropTypes.func,
		  onStartDateShiftTab: _react.PropTypes.func,
		  onEndDateTab: _react.PropTypes.func,
		  onClearDates: _react.PropTypes.func,
	
		  startDate: _react.PropTypes.string,
		  endDate: _react.PropTypes.string,
	
		  isStartDateFocused: _react.PropTypes.bool,
		  isEndDateFocused: _react.PropTypes.bool,
		  showClearDates: _react.PropTypes.bool,
		  disabled: _react.PropTypes.bool,
	
		  // i18n
		  phrases: _react.PropTypes.shape({
		    clearDates: _react.PropTypes.node
		  })
		};
	
		var defaultProps = {
		  startDateId: _constants.START_DATE,
		  endDateId: _constants.END_DATE,
		  startDatePlaceholderText: 'Start Date',
		  endDatePlaceholderText: 'End Date',
		  onStartDateFocus: function () {
		    function onStartDateFocus() {}
	
		    return onStartDateFocus;
		  }(),
		  onEndDateFocus: function () {
		    function onEndDateFocus() {}
	
		    return onEndDateFocus;
		  }(),
		  onStartDateChange: function () {
		    function onStartDateChange() {}
	
		    return onStartDateChange;
		  }(),
		  onEndDateChange: function () {
		    function onEndDateChange() {}
	
		    return onEndDateChange;
		  }(),
		  onStartDateShiftTab: function () {
		    function onStartDateShiftTab() {}
	
		    return onStartDateShiftTab;
		  }(),
		  onEndDateTab: function () {
		    function onEndDateTab() {}
	
		    return onEndDateTab;
		  }(),
		  onClearDates: function () {
		    function onClearDates() {}
	
		    return onClearDates;
		  }(),
	
		  isStartDateFocused: false,
		  isEndDateFocused: false,
		  showClearDates: false,
		  disabled: false,
	
		  // i18n
		  phrases: {
		    clearDates: 'Clear Dates'
		  }
		};
	
		var DateRangePickerInput = function (_React$Component) {
		  _inherits(DateRangePickerInput, _React$Component);
	
		  function DateRangePickerInput(props) {
		    _classCallCheck(this, DateRangePickerInput);
	
		    var _this = _possibleConstructorReturn(this, (DateRangePickerInput.__proto__ || Object.getPrototypeOf(DateRangePickerInput)).call(this, props));
	
		    _this.state = {
		      isClearDatesHovered: false
		    };
	
		    _this.onClearDatesMouseEnter = _this.onClearDatesMouseEnter.bind(_this);
		    _this.onClearDatesMouseLeave = _this.onClearDatesMouseLeave.bind(_this);
		    return _this;
		  }
	
		  _createClass(DateRangePickerInput, [{
		    key: 'onClearDatesMouseEnter',
		    value: function () {
		      function onClearDatesMouseEnter() {
		        this.setState({
		          isClearDatesHovered: true
		        });
		      }
	
		      return onClearDatesMouseEnter;
		    }()
		  }, {
		    key: 'onClearDatesMouseLeave',
		    value: function () {
		      function onClearDatesMouseLeave() {
		        this.setState({
		          isClearDatesHovered: false
		        });
		      }
	
		      return onClearDatesMouseLeave;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _state = this.state;
		        var startDateString = _state.startDateString;
		        var endDateString = _state.endDateString;
		        var isClearDatesHovered = _state.isClearDatesHovered;
		        var _props = this.props;
		        var startDate = _props.startDate;
		        var startDateId = _props.startDateId;
		        var startDatePlaceholderText = _props.startDatePlaceholderText;
		        var isStartDateFocused = _props.isStartDateFocused;
		        var onStartDateChange = _props.onStartDateChange;
		        var onStartDateFocus = _props.onStartDateFocus;
		        var onStartDateShiftTab = _props.onStartDateShiftTab;
		        var endDate = _props.endDate;
		        var endDateId = _props.endDateId;
		        var endDatePlaceholderText = _props.endDatePlaceholderText;
		        var isEndDateFocused = _props.isEndDateFocused;
		        var onEndDateChange = _props.onEndDateChange;
		        var onEndDateFocus = _props.onEndDateFocus;
		        var onEndDateTab = _props.onEndDateTab;
		        var onClearDates = _props.onClearDates;
		        var showClearDates = _props.showClearDates;
		        var disabled = _props.disabled;
		        var phrases = _props.phrases;
	
		        var startDateValue = startDate || startDateString;
		        var endDateValue = endDate || endDateString;
	
		        return _react2['default'].createElement('div', {
		          className: (0, _classnames2['default'])('DateRangePickerInput', {
		            'DateRangePickerInput--disabled': disabled
		          })
		        }, _react2['default'].createElement(_DateInput2['default'], {
		          id: startDateId,
		          placeholder: startDatePlaceholderText,
		          dateValue: startDateValue,
		          focused: isStartDateFocused,
		          disabled: disabled,
	
		          onChange: onStartDateChange,
		          onFocus: onStartDateFocus,
		          onKeyDownShiftTab: onStartDateShiftTab
		        }), _react2['default'].createElement('div', { className: 'DateRangePickerInput__arrow' }, _react2['default'].createElement(_arrowRight2['default'], null)), _react2['default'].createElement(_DateInput2['default'], {
		          id: endDateId,
		          placeholder: endDatePlaceholderText,
		          dateValue: endDateValue,
		          focused: isEndDateFocused,
		          disabled: disabled,
	
		          onChange: onEndDateChange,
		          onFocus: onEndDateFocus,
		          onKeyDownTab: onEndDateTab
		        }), showClearDates && _react2['default'].createElement('button', {
		          type: 'button',
		          className: (0, _classnames2['default'])('DateRangePickerInput__clear-dates', {
		            'DateRangePickerInput__clear-dates--hide': !(startDateValue || endDateValue),
		            'DateRangePickerInput__clear-dates--hover': isClearDatesHovered
		          }),
		          onMouseEnter: this.onClearDatesMouseEnter,
		          onMouseLeave: this.onClearDatesMouseLeave,
		          onClick: onClearDates
		        }, _react2['default'].createElement('span', { className: 'screen-reader-only' }, phrases.clearDates), _react2['default'].createElement(_close2['default'], null)));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DateRangePickerInput;
		}(_react2['default'].Component);
	
		exports['default'] = DateRangePickerInput;
	
		DateRangePickerInput.propTypes = propTypes;
		DateRangePickerInput.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 5:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(167);
	
	/***/ },
	
	/***/ 9:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(771);
	
	/***/ },
	
	/***/ 26:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 12 12" }, this.props),
		          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	
	/***/ 28:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(807);
	
	/***/ },
	
	/***/ 29:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ }
	
	/******/ });

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _isTouchDevice = __webpack_require__(14);
	
		var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  id: _react.PropTypes.string.isRequired,
		  placeholder: _react.PropTypes.string, // also used as label
		  dateValue: _react.PropTypes.string,
		  focused: _react.PropTypes.bool,
		  disabled: _react.PropTypes.bool,
	
		  onChange: _react.PropTypes.func,
		  onFocus: _react.PropTypes.func,
		  onKeyDownShiftTab: _react.PropTypes.func,
		  onKeyDownTab: _react.PropTypes.func
		};
	
		var defaultProps = {
		  placeholder: 'Select Date',
		  dateValue: '',
		  focused: false,
		  disabled: false,
	
		  onChange: function () {
		    function onChange() {}
	
		    return onChange;
		  }(),
		  onFocus: function () {
		    function onFocus() {}
	
		    return onFocus;
		  }(),
		  onKeyDownShiftTab: function () {
		    function onKeyDownShiftTab() {}
	
		    return onKeyDownShiftTab;
		  }(),
		  onKeyDownTab: function () {
		    function onKeyDownTab() {}
	
		    return onKeyDownTab;
		  }()
		};
	
		var DateInput = function (_React$Component) {
		  _inherits(DateInput, _React$Component);
	
		  function DateInput(props) {
		    _classCallCheck(this, DateInput);
	
		    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));
	
		    _this.state = {
		      dateString: ''
		    };
	
		    _this.onChange = _this.onChange.bind(_this);
		    _this.onKeyDown = _this.onKeyDown.bind(_this);
	
		    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
		    return _this;
		  }
	
		  _createClass(DateInput, [{
		    key: 'componentWillReceiveProps',
		    value: function () {
		      function componentWillReceiveProps(nextProps) {
		        if (!this.props.dateValue && nextProps.dateValue) {
		          this.setState({
		            dateString: ''
		          });
		        }
		      }
	
		      return componentWillReceiveProps;
		    }()
		  }, {
		    key: 'componentDidUpdate',
		    value: function () {
		      function componentDidUpdate(prevProps) {
		        var focused = this.props.focused;
	
		        if (prevProps.focused !== focused && focused) {
		          var startDateInput = _reactDom2['default'].findDOMNode(this.inputRef);
		          startDateInput.focus();
		          startDateInput.select();
		        }
		      }
	
		      return componentDidUpdate;
		    }()
		  }, {
		    key: 'onChange',
		    value: function () {
		      function onChange(e) {
		        var dateString = e.target.value;
	
		        this.setState({ dateString: dateString });
		        this.props.onChange(dateString);
		      }
	
		      return onChange;
		    }()
		  }, {
		    key: 'onKeyDown',
		    value: function () {
		      function onKeyDown(e) {
		        var _props = this.props;
		        var onKeyDownShiftTab = _props.onKeyDownShiftTab;
		        var onKeyDownTab = _props.onKeyDownTab;
	
		        if (e.key === 'Tab') {
		          if (e.shiftKey) {
		            onKeyDownShiftTab(e);
		          } else {
		            onKeyDownTab(e);
		          }
		        }
		      }
	
		      return onKeyDown;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _this2 = this;
	
		        var dateString = this.state.dateString;
		        var _props2 = this.props;
		        var id = _props2.id;
		        var placeholder = _props2.placeholder;
		        var dateValue = _props2.dateValue;
		        var focused = _props2.focused;
		        var onFocus = _props2.onFocus;
		        var disabled = _props2.disabled;
	
		        var value = dateValue || dateString;
	
		        return _react2['default'].createElement('div', {
		          className: (0, _classnames2['default'])('DateInput', {
		            'DateInput--disabled': disabled
		          }),
		          onClick: onFocus
		        }, _react2['default'].createElement('label', { className: 'DateInput__label', htmlFor: id }, placeholder), _react2['default'].createElement('input', {
		          className: 'DateInput__input',
		          type: 'text',
		          id: id,
		          name: id,
		          ref: function () {
		            function ref(_ref) {
		              _this2.inputRef = _ref;
		            }
	
		            return ref;
		          }(),
		          value: value,
		          onChange: this.onChange,
		          onKeyDown: this.onKeyDown,
		          onFocus: onFocus,
		          placeholder: placeholder,
		          autoComplete: 'off',
		          maxLength: 10,
		          disabled: disabled || this.isTouchDevice
		        }), _react2['default'].createElement('div', {
		          className: (0, _classnames2['default'])('DateInput__display-text', {
		            'DateInput__display-text--has-input': !!value,
		            'DateInput__display-text--focused': focused,
		            'DateInput__display-text--disabled': disabled
		          })
		        }, value || placeholder));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DateInput;
		}(_react2['default'].Component);
	
		exports['default'] = DateInput;
	
		DateInput.propTypes = propTypes;
		DateInput.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */,
	/* 4 */,
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(167);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */,
	/* 9 */,
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(31);
	
	/***/ },
	/* 11 */,
	/* 12 */,
	/* 13 */,
	/* 14 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(772);
	
	/***/ }
	/******/ ]);

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactAddonsShallowCompare = __webpack_require__(2);
	
		var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _OutsideClickHandler = __webpack_require__(23);
	
		var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
		var _CalendarMonthGrid = __webpack_require__(30);
	
		var _CalendarMonthGrid2 = _interopRequireDefault(_CalendarMonthGrid);
	
		var _arrowLeft = __webpack_require__(31);
	
		var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
		var _arrowRight = __webpack_require__(29);
	
		var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
		var _chevronUp = __webpack_require__(32);
	
		var _chevronUp2 = _interopRequireDefault(_chevronUp);
	
		var _chevronDown = __webpack_require__(33);
	
		var _chevronDown2 = _interopRequireDefault(_chevronDown);
	
		var _getTransformStyles = __webpack_require__(13);
	
		var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);
	
		var _OrientationShape = __webpack_require__(8);
	
		var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _toConsumableArray(arr) {
		  if (Array.isArray(arr)) {
		    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
		      arr2[i] = arr[i];
		    }return arr2;
		  } else {
		    return Array.from(arr);
		  }
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var CALENDAR_MONTH_WIDTH = 300;
		var DAY_PICKER_PADDING = 9;
		var MONTH_PADDING = 23;
		var PREV_TRANSITION = 'prev';
		var NEXT_TRANSITION = 'next';
	
		var propTypes = {
		  enableOutsideDays: _react.PropTypes.bool,
		  numberOfMonths: _react.PropTypes.number,
		  modifiers: _react.PropTypes.object,
		  orientation: _OrientationShape2['default'],
		  withPortal: _react.PropTypes.bool,
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func,
		  onPrevMonthClick: _react.PropTypes.func,
		  onNextMonthClick: _react.PropTypes.func,
		  onOutsideClick: _react.PropTypes.func,
	
		  // i18n
		  monthFormat: _react.PropTypes.string
		};
	
		var defaultProps = {
		  enableOutsideDays: false,
		  numberOfMonths: 1,
		  modifiers: {},
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  withPortal: false,
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }(),
		  onOutsideClick: function () {
		    function onOutsideClick() {}
	
		    return onOutsideClick;
		  }(),
	
		  // i18n
		  monthFormat: 'MMMM YYYY'
		};
	
		var DayPicker = function (_React$Component) {
		  _inherits(DayPicker, _React$Component);
	
		  function DayPicker(props) {
		    _classCallCheck(this, DayPicker);
	
		    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
		    _this.state = {
		      currentMonth: (0, _moment2['default'])(),
		      monthTransition: null,
		      translationValue: 0
		    };
	
		    _this.handlePrevMonthClick = _this.handlePrevMonthClick.bind(_this);
		    _this.handleNextMonthClick = _this.handleNextMonthClick.bind(_this);
		    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_this);
		    return _this;
		  }
	
		  _createClass(DayPicker, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        if (this.isHorizontal()) {
		          this.adjustDayPickerHeight();
		          this.initializeDayPickerWidth();
		        }
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function () {
		      function shouldComponentUpdate(nextProps, nextState) {
		        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
		      }
	
		      return shouldComponentUpdate;
		    }()
		  }, {
		    key: 'componentDidUpdate',
		    value: function () {
		      function componentDidUpdate() {
		        if (this.state.monthTransition) {
		          if (this.isHorizontal()) {
		            this.adjustDayPickerHeight();
		          }
		        }
		      }
	
		      return componentDidUpdate;
		    }()
		  }, {
		    key: 'getMonthHeightByIndex',
		    value: function () {
		      function getMonthHeightByIndex(i) {
		        return this.getMonthHeight(_reactDom2['default'].findDOMNode(this.refs.transitionContainer).querySelectorAll('.CalendarMonth')[i]);
		      }
	
		      return getMonthHeightByIndex;
		    }()
		  }, {
		    key: 'getMonthHeight',
		    value: function () {
		      function getMonthHeight(el) {
		        var caption = el.querySelector('.js-CalendarMonth__caption');
		        var grid = el.querySelector('.js-CalendarMonth__grid');
	
		        // Need to separate out table children for FF
		        // Add an additional +1 for the border
		        return this.calculateDimension(caption, 'height', true, true) + this.calculateDimension(grid, 'height') + 1;
		      }
	
		      return getMonthHeight;
		    }()
		  }, {
		    key: 'applyTransformStyles',
		    value: function () {
		      function applyTransformStyles(el, transform) {
		        var opacity = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
	
		        var transformStyles = (0, _getTransformStyles2['default'])(transform);
		        transformStyles.opacity = opacity;
	
		        Object.keys(transformStyles).forEach(function (styleKey) {
		          // eslint-disable-next-line no-param-reassign
		          el.style[styleKey] = transformStyles[styleKey];
		        });
		      }
	
		      return applyTransformStyles;
		    }()
		  }, {
		    key: 'calculateDimension',
		    value: function () {
		      function calculateDimension(el, axis) {
		        var borderBox = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
		        var withMargin = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
		        if (!el) {
		          return 0;
		        }
	
		        var axisStart = axis === 'width' ? 'Left' : 'Top';
		        var axisEnd = axis === 'width' ? 'Right' : 'Bottom';
	
		        // Only read styles if we need to
		        var style = !borderBox || withMargin ? window.getComputedStyle(el) : {};
	
		        // Offset includes border and padding
		        var size = axis === 'width' ? el.offsetWidth : el.offsetHeight;
	
		        // Get the inner size
		        if (!borderBox) {
		          size -= parseFloat(style['padding' + axisStart]) + parseFloat(style['padding' + axisEnd]) + parseFloat(style['border' + axisStart + 'Width']) + parseFloat(style['border' + axisEnd + 'Width']);
		        }
	
		        // Apply margin
		        if (withMargin) {
		          size += parseFloat(style['margin' + axisStart]) + parseFloat(style['margin' + axisEnd]);
		        }
	
		        return size;
		      }
	
		      return calculateDimension;
		    }()
		  }, {
		    key: 'isHorizontal',
		    value: function () {
		      function isHorizontal() {
		        return this.props.orientation === _constants.HORIZONTAL_ORIENTATION;
		      }
	
		      return isHorizontal;
		    }()
		  }, {
		    key: 'isVertical',
		    value: function () {
		      function isVertical() {
		        return this.props.orientation === _constants.VERTICAL_ORIENTATION;
		      }
	
		      return isVertical;
		    }()
		  }, {
		    key: 'initializeDayPickerWidth',
		    value: function () {
		      function initializeDayPickerWidth() {
		        this.dayPickerWidth = this.calculateDimension(_reactDom2['default'].findDOMNode(this.refs.calendarMonthGrid).querySelector('.CalendarMonth'), 'width', true);
		      }
	
		      return initializeDayPickerWidth;
		    }()
		  }, {
		    key: 'updateStateAfterMonthTransition',
		    value: function () {
		      function updateStateAfterMonthTransition() {
		        var _state = this.state;
		        var currentMonth = _state.currentMonth;
		        var monthTransition = _state.monthTransition;
	
		        var newMonth = currentMonth;
		        if (monthTransition === PREV_TRANSITION) {
		          newMonth = currentMonth.clone().subtract(1, 'month');
		        } else if (monthTransition === NEXT_TRANSITION) {
		          newMonth = currentMonth.clone().add(1, 'month');
		        }
	
		        // clear the previous transforms
		        this.applyTransformStyles(_reactDom2['default'].findDOMNode(this.refs.calendarMonthGrid).querySelector('.CalendarMonth'), 'none');
	
		        this.setState({
		          currentMonth: newMonth,
		          monthTransition: null,
		          translationValue: 0
		        });
		      }
	
		      return updateStateAfterMonthTransition;
		    }()
		  }, {
		    key: 'handlePrevMonthClick',
		    value: function () {
		      function handlePrevMonthClick(e) {
		        if (e) e.preventDefault();
	
		        if (this.props.onPrevMonthClick) {
		          this.props.onPrevMonthClick(e);
		        }
	
		        var translationValue = this.isVertical() ? this.getMonthHeightByIndex(0) : this.dayPickerWidth;
	
		        // The first CalendarMonth is always positioned absolute at top: 0 or left: 0
		        // so we need to transform it to the appropriate location before the animation.
		        // This behavior is because we would otherwise need a double-render in order to
		        // adjust the container position once we had the height the first calendar
		        // (ie first draw all the calendar, then in a second render, use the first calendar's
		        // height to position the container). Variable calendar heights, amirite? <3 Maja
		        this.translateFirstDayPickerForAnimation(translationValue);
	
		        this.setState({
		          monthTransition: PREV_TRANSITION,
		          translationValue: translationValue
		        });
		      }
	
		      return handlePrevMonthClick;
		    }()
		  }, {
		    key: 'handleNextMonthClick',
		    value: function () {
		      function handleNextMonthClick(e) {
		        if (e) e.preventDefault();
		        if (this.props.onNextMonthClick) {
		          this.props.onNextMonthClick(e);
		        }
	
		        var translationValue = this.isVertical() ? -this.getMonthHeightByIndex(1) : -this.dayPickerWidth;
	
		        this.setState({
		          monthTransition: NEXT_TRANSITION,
		          translationValue: translationValue
		        });
		      }
	
		      return handleNextMonthClick;
		    }()
		  }, {
		    key: 'adjustDayPickerHeight',
		    value: function () {
		      function adjustDayPickerHeight() {
		        var _this2 = this;
	
		        var transitionContainer = _reactDom2['default'].findDOMNode(this.refs.transitionContainer);
		        var heights = [];
	
		        // convert node list to array
		        [].concat(_toConsumableArray(transitionContainer.querySelectorAll('.CalendarMonth'))).forEach(function (el) {
		          if (el.getAttribute('data-visible') === 'true') {
		            heights.push(_this2.getMonthHeight(el));
		          }
		        });
	
		        var newMonthHeight = Math.max.apply(Math, heights) + MONTH_PADDING;
	
		        if (newMonthHeight !== this.calculateDimension(transitionContainer, 'height')) {
		          this.monthHeight = newMonthHeight;
		          transitionContainer.style.height = String(newMonthHeight) + 'px';
		        }
		      }
	
		      return adjustDayPickerHeight;
		    }()
		  }, {
		    key: 'translateFirstDayPickerForAnimation',
		    value: function () {
		      function translateFirstDayPickerForAnimation(translationValue) {
		        var transformType = this.isVertical() ? 'translateY' : 'translateX';
		        var transformValue = transformType + '(-' + String(translationValue) + 'px)';
	
		        this.applyTransformStyles(_reactDom2['default'].findDOMNode(this.refs.transitionContainer).querySelector('.CalendarMonth'), transformValue, 1);
		      }
	
		      return translateFirstDayPickerForAnimation;
		    }()
		  }, {
		    key: 'renderNavigation',
		    value: function () {
		      function renderNavigation() {
		        var isVertical = this.isVertical();
	
		        return _react2['default'].createElement('div', { className: 'DayPicker__nav' }, _react2['default'].createElement('span', {
		          className: 'DayPicker__nav--prev',
		          onClick: this.handlePrevMonthClick
		        }, isVertical ? _react2['default'].createElement(_chevronUp2['default'], null) : _react2['default'].createElement(_arrowLeft2['default'], null)), _react2['default'].createElement('span', {
		          className: 'DayPicker__nav--next',
		          onClick: this.handleNextMonthClick
		        }, isVertical ? _react2['default'].createElement(_chevronDown2['default'], null) : _react2['default'].createElement(_arrowRight2['default'], null)));
		      }
	
		      return renderNavigation;
		    }()
		  }, {
		    key: 'renderWeekHeader',
		    value: function () {
		      function renderWeekHeader(index) {
		        var numberOfMonths = this.props.numberOfMonths;
	
		        var widthPercentage = 100 / numberOfMonths;
		        var horizontalStyle = {
		          width: widthPercentage + '%',
		          left: widthPercentage * index + '%'
		        };
	
		        var style = this.isHorizontal() ? horizontalStyle : {};
	
		        var header = [];
		        for (var i = 0; i < 7; i++) {
		          header.push(_react2['default'].createElement('li', { key: i }, _react2['default'].createElement('small', null, (0, _moment2['default'])().weekday(i).format('dd'))));
		        }
	
		        return _react2['default'].createElement('div', {
		          className: 'DayPicker__week-header',
		          key: 'week-' + String(index),
		          style: style
		        }, _react2['default'].createElement('ul', null, header));
		      }
	
		      return renderWeekHeader;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _state2 = this.state;
		        var currentMonth = _state2.currentMonth;
		        var monthTransition = _state2.monthTransition;
		        var translationValue = _state2.translationValue;
		        var _props = this.props;
		        var enableOutsideDays = _props.enableOutsideDays;
		        var numberOfMonths = _props.numberOfMonths;
		        var orientation = _props.orientation;
		        var modifiers = _props.modifiers;
		        var withPortal = _props.withPortal;
		        var onDayClick = _props.onDayClick;
		        var onDayMouseDown = _props.onDayMouseDown;
		        var onDayMouseUp = _props.onDayMouseUp;
		        var onDayTouchStart = _props.onDayTouchStart;
		        var onDayTouchEnd = _props.onDayTouchEnd;
		        var onDayTouchTap = _props.onDayTouchTap;
		        var onDayMouseEnter = _props.onDayMouseEnter;
		        var onDayMouseLeave = _props.onDayMouseLeave;
		        var onOutsideClick = _props.onOutsideClick;
		        var monthFormat = _props.monthFormat;
	
		        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
		        var weekHeaders = [];
		        for (var i = 0; i < numOfWeekHeaders; i++) {
		          weekHeaders.push(this.renderWeekHeader(i));
		        }
	
		        var firstVisibleMonthIndex = 1;
		        if (monthTransition === PREV_TRANSITION) {
		          firstVisibleMonthIndex -= 1;
		        } else if (monthTransition === NEXT_TRANSITION) {
		          firstVisibleMonthIndex += 1;
		        }
	
		        var dayPickerClassNames = (0, _classnames2['default'])('DayPicker', {
		          'DayPicker--horizontal': this.isHorizontal(),
		          'DayPicker--vertical': this.isVertical(),
		          'DayPicker--portal': withPortal
		        });
	
		        var transitionContainerClasses = (0, _classnames2['default'])('transition-container', {
		          'transition-container--horizontal': this.isHorizontal(),
		          'transition-container--vertical': this.isVertical()
		        });
	
		        var horizontalWidth = CALENDAR_MONTH_WIDTH * numberOfMonths + 2 * DAY_PICKER_PADDING;
	
		        // this is a kind of made-up value that generally looks good. we'll
		        // probably want to let the user set this explicitly.
		        var verticalHeight = 1.75 * CALENDAR_MONTH_WIDTH;
	
		        var dayPickerStyle = {
		          width: this.isHorizontal() && horizontalWidth,
	
		          // These values are to center the datepicker (approximately) on the page
		          marginLeft: this.isHorizontal() && withPortal && -horizontalWidth / 2,
		          marginTop: this.isHorizontal() && withPortal && -CALENDAR_MONTH_WIDTH / 2
		        };
	
		        var transitionContainerStyle = {
		          width: this.isHorizontal() && horizontalWidth,
		          height: this.isVertical() && !withPortal && verticalHeight
		        };
	
		        var isCalendarMonthGridAnimating = monthTransition !== null;
		        var transformType = this.isVertical() ? 'translateY' : 'translateX';
		        var transformValue = transformType + '(' + String(translationValue) + 'px)';
	
		        return _react2['default'].createElement('div', { className: dayPickerClassNames, style: dayPickerStyle }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, this.renderNavigation(), _react2['default'].createElement('div', { className: 'DayPicker__week-headers' }, weekHeaders), _react2['default'].createElement('div', {
		          className: transitionContainerClasses,
		          ref: 'transitionContainer',
		          style: transitionContainerStyle
		        }, _react2['default'].createElement(_CalendarMonthGrid2['default'], {
		          ref: 'calendarMonthGrid',
		          transformValue: transformValue,
		          enableOutsideDays: enableOutsideDays,
		          firstVisibleMonthIndex: firstVisibleMonthIndex,
		          initialMonth: currentMonth,
		          isAnimating: isCalendarMonthGridAnimating,
		          modifiers: modifiers,
		          orientation: orientation,
		          withPortal: withPortal,
		          numberOfMonths: numberOfMonths,
		          onDayClick: onDayClick,
		          onDayMouseDown: onDayMouseDown,
		          onDayMouseUp: onDayMouseUp,
		          onDayTouchStart: onDayTouchStart,
		          onDayTouchEnd: onDayTouchEnd,
		          onDayTouchTap: onDayTouchTap,
		          onDayMouseEnter: onDayMouseEnter,
		          onDayMouseLeave: onDayMouseLeave,
		          onMonthTransitionEnd: this.updateStateAfterMonthTransition,
		          monthFormat: monthFormat
		        }))));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return DayPicker;
		}(_react2['default'].Component);
	
		exports['default'] = DayPicker;
	
		DayPicker.propTypes = propTypes;
		DayPicker.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(809);
	
	/***/ },
	/* 3 */,
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(167);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(810);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(771);
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(31);
	
	/***/ },
	/* 11 */,
	/* 12 */,
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(811);
	
	/***/ },
	/* 14 */,
	/* 15 */,
	/* 16 */,
	/* 17 */,
	/* 18 */,
	/* 19 */,
	/* 20 */,
	/* 21 */,
	/* 22 */,
	/* 23 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(805);
	
	/***/ },
	/* 24 */,
	/* 25 */,
	/* 26 */,
	/* 27 */,
	/* 28 */,
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	/* 30 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(812);
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 1000 1000" }, this.props),
		          _react2["default"].createElement("path", { d: "M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ }
	/******/ ]);

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(488);

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(771);
	
	exports['default'] = _react.PropTypes.oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

/***/ },
/* 811 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getTransformStyles;
	function getTransformStyles(transformValue) {
	  return {
	    transform: transformValue,
	    msTransform: transformValue,
	    MozTransform: transformValue,
	    WebkitTransform: transformValue
	  };
	}

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactDom = __webpack_require__(10);
	
		var _reactDom2 = _interopRequireDefault(_reactDom);
	
		var _reactAddonsShallowCompare = __webpack_require__(2);
	
		var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _CalendarMonth = __webpack_require__(11);
	
		var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
		var _isTransitionEndSupported = __webpack_require__(12);
	
		var _isTransitionEndSupported2 = _interopRequireDefault(_isTransitionEndSupported);
	
		var _getTransformStyles = __webpack_require__(13);
	
		var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);
	
		var _OrientationShape = __webpack_require__(8);
	
		var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = {
		  enableOutsideDays: _react.PropTypes.bool,
		  firstVisibleMonthIndex: _react.PropTypes.number,
		  initialMonth: _reactMomentProptypes2['default'].momentObj,
		  isAnimating: _react.PropTypes.bool,
		  numberOfMonths: _react.PropTypes.number,
		  modifiers: _react.PropTypes.object,
		  orientation: _OrientationShape2['default'],
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func,
		  onMonthTransitionEnd: _react.PropTypes.func,
		  transformValue: _react.PropTypes.string,
	
		  // i18n
		  monthFormat: _react.PropTypes.string
		};
	
		var defaultProps = {
		  enableOutsideDays: false,
		  firstVisibleMonthIndex: 0,
		  initialMonth: (0, _moment2['default'])(),
		  isAnimating: false,
		  numberOfMonths: 1,
		  modifiers: {},
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }(),
		  onMonthTransitionEnd: function () {
		    function onMonthTransitionEnd() {}
	
		    return onMonthTransitionEnd;
		  }(),
	
		  transform: 'none',
	
		  // i18n
		  monthFormat: 'MMMM YYYY' };
	
		var CalendarMonthGrid = function (_React$Component) {
		  _inherits(CalendarMonthGrid, _React$Component);
	
		  function CalendarMonthGrid(props) {
		    _classCallCheck(this, CalendarMonthGrid);
	
		    var _this = _possibleConstructorReturn(this, (CalendarMonthGrid.__proto__ || Object.getPrototypeOf(CalendarMonthGrid)).call(this, props));
	
		    _this.isTransitionEndSupported = (0, _isTransitionEndSupported2['default'])();
		    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
		    return _this;
		  }
	
		  _createClass(CalendarMonthGrid, [{
		    key: 'componentDidMount',
		    value: function () {
		      function componentDidMount() {
		        this.container = _reactDom2['default'].findDOMNode(this.containerRef);
		        this.container.addEventListener('transitionend', this.onTransitionEnd);
		      }
	
		      return componentDidMount;
		    }()
		  }, {
		    key: 'shouldComponentUpdate',
		    value: function () {
		      function shouldComponentUpdate(nextProps, nextState) {
		        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
		      }
	
		      return shouldComponentUpdate;
		    }()
		  }, {
		    key: 'componentDidUpdate',
		    value: function () {
		      function componentDidUpdate() {
		        var _props = this.props;
		        var isAnimating = _props.isAnimating;
		        var onMonthTransitionEnd = _props.onMonthTransitionEnd;
	
		        // For IE9, immediately call onMonthTransitionEnd instead of
		        // waiting for the animation to complete
	
		        if (!this.isTransitionEndSupported && isAnimating) {
		          onMonthTransitionEnd();
		        }
		      }
	
		      return componentDidUpdate;
		    }()
		  }, {
		    key: 'componentWillUnmount',
		    value: function () {
		      function componentWillUnmount() {
		        this.container.removeEventListener('transitionend', this.onTransitionEnd);
		      }
	
		      return componentWillUnmount;
		    }()
		  }, {
		    key: 'onTransitionEnd',
		    value: function () {
		      function onTransitionEnd() {
		        this.props.onMonthTransitionEnd();
		      }
	
		      return onTransitionEnd;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _this2 = this;
	
		        var _props2 = this.props;
		        var enableOutsideDays = _props2.enableOutsideDays;
		        var firstVisibleMonthIndex = _props2.firstVisibleMonthIndex;
		        var initialMonth = _props2.initialMonth;
		        var isAnimating = _props2.isAnimating;
		        var modifiers = _props2.modifiers;
		        var numberOfMonths = _props2.numberOfMonths;
		        var monthFormat = _props2.monthFormat;
		        var orientation = _props2.orientation;
		        var transformValue = _props2.transformValue;
		        var onDayMouseEnter = _props2.onDayMouseEnter;
		        var onDayMouseLeave = _props2.onDayMouseLeave;
		        var onDayMouseDown = _props2.onDayMouseDown;
		        var onDayMouseUp = _props2.onDayMouseUp;
		        var onDayClick = _props2.onDayClick;
		        var onDayTouchStart = _props2.onDayTouchStart;
		        var onDayTouchEnd = _props2.onDayTouchEnd;
		        var onDayTouchTap = _props2.onDayTouchTap;
		        var onMonthTransitionEnd = _props2.onMonthTransitionEnd;
	
		        var month = initialMonth.clone().subtract(1, 'month');
	
		        var months = [];
		        for (var i = 0; i < numberOfMonths + 2; i++) {
		          var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
	
		          months.push(_react2['default'].createElement(_CalendarMonth2['default'], {
		            key: month.format('MM-YY'),
		            month: month,
		            isVisible: isVisible,
		            enableOutsideDays: enableOutsideDays,
		            modifiers: modifiers,
		            monthFormat: monthFormat,
		            orientation: orientation,
		            onDayMouseEnter: onDayMouseEnter,
		            onDayMouseLeave: onDayMouseLeave,
		            onDayMouseDown: onDayMouseDown,
		            onDayMouseUp: onDayMouseUp,
		            onDayClick: onDayClick,
		            onDayTouchStart: onDayTouchStart,
		            onDayTouchEnd: onDayTouchEnd,
		            onDayTouchTap: onDayTouchTap
		          }));
		          month = month.clone().add(1, 'month');
		        }
	
		        var className = (0, _classnames2['default'])('CalendarMonthGrid', {
		          'CalendarMonthGrid--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		          'CalendarMonthGrid--vertical': orientation === _constants.VERTICAL_ORIENTATION,
		          'CalendarMonthGrid--animating': isAnimating
		        });
	
		        return _react2['default'].createElement('div', {
		          ref: function () {
		            function ref(_ref) {
		              _this2.containerRef = _ref;
		            }
	
		            return ref;
		          }(),
		          className: className,
		          style: (0, _getTransformStyles2['default'])(transformValue),
		          onTransitionEnd: onMonthTransitionEnd
		        }, months);
		      }
	
		      return render;
		    }()
		  }]);
	
		  return CalendarMonthGrid;
		}(_react2['default'].Component);
	
		exports['default'] = CalendarMonthGrid;
	
		CalendarMonthGrid.propTypes = propTypes;
		CalendarMonthGrid.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(809);
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(813);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(167);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(810);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(771);
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(31);
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(815);
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(818);
	
	/***/ },
	/* 13 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(811);
	
	/***/ }
	/******/ ]);

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(563);
	var momentValidationWrapper = __webpack_require__(814);
	
	moment.createFromInputFallback = function(config) {
	  config._d = new Date(config._i);
	};
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypeLocationNames = {
	  prop : 'prop',
	  context : 'context',
	  childContext : 'child context',
	};
	
	function createMomentChecker(type, typeValidator, validator, momentType) {
	
	  function propValidator(isRequired, props, propName, componentName, location, propFullName) {
	
	    if (isRequired) {
	      var locationName = ReactPropTypeLocationNames[ location ];
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	      if (!props.hasOwnProperty(propName)) {
	        return new Error(
	          'Required ' + locationName + ' `' + propFullName +
	          '` was not specified in `' +
	          componentName + '`.'
	        );
	      }
	    }
	
	    var propValue = props[ propName ];
	    var propType = typeof propValue;
	
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return null;
	    }
	
	    if (typeValidator && !typeValidator(propValue)) {
	      return new Error(
	        'Invalid input type: `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + type + '`.'
	      );
	    }
	
	    if (! validator(propValue)) {
	      return new Error(
	        'Invalid ' + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
	      );
	    }
	
	    return null;
	
	  }
	
	  var requiredPropValidator = propValidator.bind(null, false);
	  requiredPropValidator.isRequired = propValidator.bind(null, true);
	
	  return requiredPropValidator;
	
	}
	
	module.exports = {
	
	  momentObj : createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(value);
	    },
	    'Moment'
	  ),
	
	  momentString : createMomentChecker(
	    'string',
	    function(str) {
	      return typeof str === 'string';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(moment(value));
	    },
	    'Moment'
	  ),
	
	  momentDurationObj : createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return moment.isDuration(value);
	    },
	    'Duration'
	  ),
	
	};


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(563);
	
	function isValidMoment(testMoment) {
	  if (typeof testMoment.isValid === 'function') {
	    // moment 1.7.0+
	    return testMoment.isValid();
	  }
	
	  return ! isNaN(testMoment);
	}
	
	module.exports = {
	  isValidMoment : isValidMoment,
	}


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getModifiersForDay = getModifiersForDay;
		exports['default'] = CalendarMonth;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _CalendarDay = __webpack_require__(6);
	
		var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
		var _getCalendarMonthWeeks = __webpack_require__(7);
	
		var _getCalendarMonthWeeks2 = _interopRequireDefault(_getCalendarMonthWeeks);
	
		var _OrientationShape = __webpack_require__(8);
	
		var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		var propTypes = {
		  month: _reactMomentProptypes2['default'].momentObj,
		  isVisible: _react.PropTypes.bool,
		  enableOutsideDays: _react.PropTypes.bool,
		  modifiers: _react.PropTypes.object,
		  orientation: _OrientationShape2['default'],
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func,
	
		  // i18n
		  monthFormat: _react.PropTypes.string
		};
	
		var defaultProps = {
		  month: (0, _moment2['default'])(),
		  isVisible: true,
		  enableOutsideDays: false,
		  modifiers: {},
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }(),
	
		  // i18n
		  monthFormat: 'MMMM YYYY' };
	
		function getModifiersForDay(modifiers, day) {
		  return day ? Object.keys(modifiers).filter(function (key) {
		    return modifiers[key](day);
		  }) : [];
		}
	
		function CalendarMonth(props) {
		  var month = props.month;
		  var monthFormat = props.monthFormat;
		  var orientation = props.orientation;
		  var isVisible = props.isVisible;
		  var modifiers = props.modifiers;
		  var enableOutsideDays = props.enableOutsideDays;
		  var onDayClick = props.onDayClick;
		  var onDayMouseDown = props.onDayMouseDown;
		  var onDayMouseUp = props.onDayMouseUp;
		  var onDayMouseEnter = props.onDayMouseEnter;
		  var onDayMouseLeave = props.onDayMouseLeave;
		  var onDayTouchStart = props.onDayTouchStart;
		  var onDayTouchEnd = props.onDayTouchEnd;
		  var onDayTouchTap = props.onDayTouchTap;
	
		  var monthTitle = month.format(monthFormat);
	
		  var calendarMonthClasses = (0, _classnames2['default'])('CalendarMonth', {
		    'CalendarMonth--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		    'CalendarMonth--vertical': orientation === _constants.VERTICAL_ORIENTATION
		  });
	
		  return _react2['default'].createElement('div', { className: calendarMonthClasses, 'data-visible': isVisible }, _react2['default'].createElement('table', null, _react2['default'].createElement('caption', { className: 'CalendarMonth__caption js-CalendarMonth__caption' }, _react2['default'].createElement('strong', null, monthTitle)), _react2['default'].createElement('tbody', { className: 'js-CalendarMonth__grid' }, (0, _getCalendarMonthWeeks2['default'])(month, enableOutsideDays).map(function (week, i) {
		    return _react2['default'].createElement('tr', { key: i }, week.map(function (day, j) {
		      var modifiersForDay = getModifiersForDay(modifiers, day);
		      var className = (0, _classnames2['default'])('CalendarMonth__day', {
		        'CalendarMonth__day--outside': !day || day.month() !== month.month()
		      }, modifiersForDay.map(function (mod) {
		        return 'CalendarMonth__day--' + String(mod);
		      }));
	
		      return _react2['default'].createElement('td', { className: className, key: j }, day && _react2['default'].createElement(_CalendarDay2['default'], {
		        day: day,
		        modifiers: modifiersForDay,
		        onDayMouseEnter: onDayMouseEnter,
		        onDayMouseLeave: onDayMouseLeave,
		        onDayMouseDown: onDayMouseDown,
		        onDayMouseUp: onDayMouseUp,
		        onDayClick: onDayClick,
		        onDayTouchStart: onDayTouchStart,
		        onDayTouchEnd: onDayTouchEnd,
		        onDayTouchTap: onDayTouchTap
		      }));
		    }));
		  }))));
		}
	
		CalendarMonth.propTypes = propTypes;
		CalendarMonth.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(813);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(167);
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(816);
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(817);
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(810);
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(771);
	
	/***/ }
	/******/ ]);

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.TOUCHSTART_TIMEOUT = undefined;
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _reactAddonsShallowCompare = __webpack_require__(2);
	
		var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
		var _reactMomentProptypes = __webpack_require__(3);
	
		var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var TOUCHSTART_TIMEOUT = exports.TOUCHSTART_TIMEOUT = 200;
	
		var propTypes = {
		  day: _reactMomentProptypes2['default'].momentObj,
		  modifiers: _react.PropTypes.arrayOf(_react.PropTypes.string),
		  onDayClick: _react.PropTypes.func,
		  onDayMouseDown: _react.PropTypes.func,
		  onDayMouseUp: _react.PropTypes.func,
		  onDayMouseEnter: _react.PropTypes.func,
		  onDayMouseLeave: _react.PropTypes.func,
		  onDayTouchStart: _react.PropTypes.func,
		  onDayTouchEnd: _react.PropTypes.func,
		  onDayTouchTap: _react.PropTypes.func
		};
	
		var defaultProps = {
		  day: (0, _moment2['default'])(),
		  modifiers: [],
		  onDayClick: function () {
		    function onDayClick() {}
	
		    return onDayClick;
		  }(),
		  onDayMouseDown: function () {
		    function onDayMouseDown() {}
	
		    return onDayMouseDown;
		  }(),
		  onDayMouseUp: function () {
		    function onDayMouseUp() {}
	
		    return onDayMouseUp;
		  }(),
		  onDayMouseEnter: function () {
		    function onDayMouseEnter() {}
	
		    return onDayMouseEnter;
		  }(),
		  onDayMouseLeave: function () {
		    function onDayMouseLeave() {}
	
		    return onDayMouseLeave;
		  }(),
		  onDayTouchStart: function () {
		    function onDayTouchStart() {}
	
		    return onDayTouchStart;
		  }(),
		  onDayTouchEnd: function () {
		    function onDayTouchEnd() {}
	
		    return onDayTouchEnd;
		  }(),
		  onDayTouchTap: function () {
		    function onDayTouchTap() {}
	
		    return onDayTouchTap;
		  }()
		};
	
		var CalendarDay = function (_React$Component) {
		  _inherits(CalendarDay, _React$Component);
	
		  function CalendarDay(props) {
		    _classCallCheck(this, CalendarDay);
	
		    var _this = _possibleConstructorReturn(this, (CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).call(this, props));
	
		    _this.hasActiveTouchStart = false;
		    return _this;
		  }
	
		  _createClass(CalendarDay, [{
		    key: 'shouldComponentUpdate',
		    value: function () {
		      function shouldComponentUpdate(nextProps, nextState) {
		        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
		      }
	
		      return shouldComponentUpdate;
		    }()
		  }, {
		    key: 'handleDayClick',
		    value: function () {
		      function handleDayClick(day, modifiers, e) {
		        this.props.onDayClick(day, modifiers, e);
		      }
	
		      return handleDayClick;
		    }()
		  }, {
		    key: 'handleDayMouseDown',
		    value: function () {
		      function handleDayMouseDown(day, modifiers, e) {
		        this.props.onDayMouseDown(day, modifiers, e);
		      }
	
		      return handleDayMouseDown;
		    }()
		  }, {
		    key: 'handleDayMouseUp',
		    value: function () {
		      function handleDayMouseUp(day, modifiers, e) {
		        this.props.onDayMouseUp(day, modifiers, e);
		      }
	
		      return handleDayMouseUp;
		    }()
		  }, {
		    key: 'handleDayMouseEnter',
		    value: function () {
		      function handleDayMouseEnter(day, modifiers, e) {
		        this.props.onDayMouseEnter(day, modifiers, e);
		      }
	
		      return handleDayMouseEnter;
		    }()
		  }, {
		    key: 'handleDayMouseLeave',
		    value: function () {
		      function handleDayMouseLeave(day, modifiers, e) {
		        this.props.onDayMouseLeave(day, modifiers, e);
		      }
	
		      return handleDayMouseLeave;
		    }()
		  }, {
		    key: 'handleDayTouchStart',
		    value: function () {
		      function handleDayTouchStart(day, modifiers, e) {
		        var _this2 = this;
	
		        this.hasActiveTouchStart = true;
		        setTimeout(function () {
		          _this2.hasActiveTouchStart = false;
		        }, TOUCHSTART_TIMEOUT);
	
		        this.props.onDayTouchStart(day, modifiers, e);
		      }
	
		      return handleDayTouchStart;
		    }()
		  }, {
		    key: 'handleDayTouchEnd',
		    value: function () {
		      function handleDayTouchEnd(day, modifiers, e) {
		        if (this.hasActiveTouchStart) {
		          this.hasActiveTouchStart = false;
		          this.handleDayTouchTap(day, modifiers, e);
		        }
	
		        this.props.onDayTouchEnd(day, modifiers, e);
		      }
	
		      return handleDayTouchEnd;
		    }()
		  }, {
		    key: 'handleDayTouchTap',
		    value: function () {
		      function handleDayTouchTap(day, modifiers, e) {
		        this.props.onDayTouchTap(day, modifiers, e);
		      }
	
		      return handleDayTouchTap;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _this3 = this;
	
		        var _props = this.props;
		        var day = _props.day;
		        var modifiers = _props.modifiers;
	
		        return _react2['default'].createElement('div', {
		          className: 'CalendarDay',
		          onMouseEnter: function () {
		            function onMouseEnter(e) {
		              return _this3.handleDayMouseEnter(day, modifiers, e);
		            }
	
		            return onMouseEnter;
		          }(),
		          onMouseLeave: function () {
		            function onMouseLeave(e) {
		              return _this3.handleDayMouseLeave(day, modifiers, e);
		            }
	
		            return onMouseLeave;
		          }(),
		          onMouseDown: function () {
		            function onMouseDown(e) {
		              return _this3.handleDayMouseDown(day, modifiers, e);
		            }
	
		            return onMouseDown;
		          }(),
		          onMouseUp: function () {
		            function onMouseUp(e) {
		              return _this3.handleDayMouseUp(day, modifiers, e);
		            }
	
		            return onMouseUp;
		          }(),
		          onClick: function () {
		            function onClick(e) {
		              return _this3.handleDayClick(day, modifiers, e);
		            }
	
		            return onClick;
		          }(),
		          onTouchStart: function () {
		            function onTouchStart(e) {
		              return _this3.handleDayTouchStart(day, modifiers, e);
		            }
	
		            return onTouchStart;
		          }(),
		          onTouchEnd: function () {
		            function onTouchEnd(e) {
		              return _this3.handleDayTouchEnd(day, modifiers, e);
		            }
	
		            return onTouchEnd;
		          }()
		        }, _react2['default'].createElement('span', { className: 'CalendarDay__day' }, day.format('D')));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return CalendarDay;
		}(_react2['default'].Component);
	
		exports['default'] = CalendarDay;
	
		CalendarDay.propTypes = propTypes;
		CalendarDay.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(809);
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(813);
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ }
	/******/ ]);

/***/ },
/* 817 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getCalendarMonthWeeks;
	function getCalendarMonthWeeks(month, enableOutsideDays) {
	  // set utc offset to get correct dates in future (when timezone changes)
	  var baseDate = month.clone().utcOffset(month.utcOffset());
	  var firstOfMonth = baseDate.clone().startOf('month');
	  var lastOfMonth = baseDate.clone().endOf('month');
	
	  var currentDay = firstOfMonth.clone();
	  var currentWeek = [];
	  var weeksInMonth = [];
	
	  // days belonging to the previous month
	  for (var i = 0; i < currentDay.weekday(); i++) {
	    var prevDay = enableOutsideDays && currentDay.clone().subtract(i + 1, 'day');
	    currentWeek.unshift(prevDay);
	  }
	
	  while (currentDay < lastOfMonth) {
	    currentWeek.push(currentDay.clone());
	    currentDay.add(1, 'd');
	
	    if (currentDay.weekday() === 0) {
	      weeksInMonth.push(currentWeek);
	      currentWeek = [];
	    }
	  }
	
	  // weekday() returns the index of the day of the week according to the locale
	  // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
	  if (currentDay.weekday() !== 0) {
	    // days belonging to the next month
	    for (var k = currentDay.weekday(), count = 0; k < 7; k++, count++) {
	      var nextDay = enableOutsideDays && currentDay.clone().add(count, 'day');
	      currentWeek.push(nextDay);
	    }
	
	    weeksInMonth.push(currentWeek);
	  }
	
	  return weeksInMonth;
	}

/***/ },
/* 818 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTransitionEndSupported;
	function isTransitionEndSupported() {
	  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
	}

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactMomentProptypes = __webpack_require__(813);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _FocusedInputShape = __webpack_require__(820);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _OrientationShape = __webpack_require__(810);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  focusedInput: _FocusedInputShape2['default'],
	  minimumNights: _react.PropTypes.number,
	  isDayBlocked: _react.PropTypes.func,
	  isOutsideRange: _react.PropTypes.func,
	  enableOutsideDays: _react.PropTypes.bool,
	  reopenPickerOnClearDates: _react.PropTypes.bool,
	  numberOfMonths: _react.PropTypes.number,
	  showClearDates: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	
	  orientation: _OrientationShape2['default'],
	
	  // portal options
	  withPortal: _react.PropTypes.bool,
	  withFullScreenPortal: _react.PropTypes.bool,
	
	  startDateId: _react.PropTypes.string,
	  startDatePlaceholderText: _react.PropTypes.string,
	  endDateId: _react.PropTypes.string,
	  endDatePlaceholderText: _react.PropTypes.string,
	
	  onDatesChange: _react.PropTypes.func,
	  onFocusChange: _react.PropTypes.func,
	  onPrevMonthClick: _react.PropTypes.func,
	  onNextMonthClick: _react.PropTypes.func,
	
	  // i18n
	  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	  monthFormat: _react.PropTypes.string,
	  phrases: _react.PropTypes.shape({
	    closeDatePicker: _react.PropTypes.node,
	    clearDates: _react.PropTypes.node
	  })
	};

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(771);
	
	exports['default'] = _react.PropTypes.oneOf([_constants.START_DATE, _constants.END_DATE]);

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _moment = __webpack_require__(4);
	
		var _moment2 = _interopRequireDefault(_moment);
	
		var _classnames = __webpack_require__(5);
	
		var _classnames2 = _interopRequireDefault(_classnames);
	
		var _reactPortal = __webpack_require__(15);
	
		var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
		var _arrayIncludes = __webpack_require__(16);
	
		var _arrayIncludes2 = _interopRequireDefault(_arrayIncludes);
	
		var _toMomentObject = __webpack_require__(17);
	
		var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
		var _toLocalizedDateString = __webpack_require__(18);
	
		var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
		var _OutsideClickHandler = __webpack_require__(23);
	
		var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
		var _SingleDatePickerInput = __webpack_require__(34);
	
		var _SingleDatePickerInput2 = _interopRequireDefault(_SingleDatePickerInput);
	
		var _DayPicker = __webpack_require__(25);
	
		var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
		var _close = __webpack_require__(26);
	
		var _close2 = _interopRequireDefault(_close);
	
		var _isInclusivelyAfterDay = __webpack_require__(19);
	
		var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
		var _isSameDay = __webpack_require__(22);
	
		var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
		var _SingleDatePickerShape = __webpack_require__(35);
	
		var _SingleDatePickerShape2 = _interopRequireDefault(_SingleDatePickerShape);
	
		var _constants = __webpack_require__(9);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		}
	
		function _possibleConstructorReturn(self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
		}
	
		function _inherits(subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
		  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
		}
	
		var propTypes = _SingleDatePickerShape2['default'];
	
		var defaultProps = {
		  date: null,
		  focused: false,
		  disabled: false,
	
		  onDateChange: function () {
		    function onDateChange() {}
	
		    return onDateChange;
		  }(),
		  onFocusChange: function () {
		    function onFocusChange() {}
	
		    return onFocusChange;
		  }(),
	
		  isDayBlocked: function () {
		    function isDayBlocked() {
		      return false;
		    }
	
		    return isDayBlocked;
		  }(),
		  disabledDays: [],
		  isOutsideRange: function () {
		    function isOutsideRange(day) {
		      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
		    }
	
		    return isOutsideRange;
		  }(),
		  enableOutsideDays: false,
		  numberOfMonths: 2,
		  orientation: _constants.HORIZONTAL_ORIENTATION,
		  withPortal: false,
		  withFullScreenPortal: false,
	
		  onPrevMonthClick: function () {
		    function onPrevMonthClick() {}
	
		    return onPrevMonthClick;
		  }(),
		  onNextMonthClick: function () {
		    function onNextMonthClick() {}
	
		    return onNextMonthClick;
		  }(),
	
		  // i18n
		  displayFormat: function () {
		    function displayFormat() {
		      return _moment2['default'].localeData().longDateFormat('L');
		    }
	
		    return displayFormat;
		  }(),
		  monthFormat: 'MMMM YYYY',
		  phrases: {
		    closeDatePicker: 'Close'
		  }
		};
	
		var SingleDatePicker = function (_React$Component) {
		  _inherits(SingleDatePicker, _React$Component);
	
		  function SingleDatePicker(props) {
		    _classCallCheck(this, SingleDatePicker);
	
		    var _this = _possibleConstructorReturn(this, (SingleDatePicker.__proto__ || Object.getPrototypeOf(SingleDatePicker)).call(this, props));
	
		    _this.state = {
		      hoverDate: null
		    };
	
		    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
		    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
		    _this.onDayClick = _this.onDayClick.bind(_this);
	
		    _this.onChange = _this.onChange.bind(_this);
		    _this.onFocus = _this.onFocus.bind(_this);
		    _this.onClearFocus = _this.onClearFocus.bind(_this);
		    return _this;
		  }
	
		  _createClass(SingleDatePicker, [{
		    key: 'onChange',
		    value: function () {
		      function onChange(dateString) {
		        var _props = this.props;
		        var isOutsideRange = _props.isOutsideRange;
		        var onDateChange = _props.onDateChange;
		        var onFocusChange = _props.onFocusChange;
	
		        var date = (0, _toMomentObject2['default'])(dateString, this.getDisplayFormat());
	
		        var isValid = date && !isOutsideRange(date);
		        if (isValid) {
		          onDateChange(date);
		          onFocusChange({ focused: false });
		        } else {
		          onDateChange(null);
		        }
		      }
	
		      return onChange;
		    }()
		  }, {
		    key: 'onDayClick',
		    value: function () {
		      function onDayClick(day, modifiers, e) {
		        if (e) e.preventDefault();
		        if ((0, _arrayIncludes2['default'])(modifiers, 'blocked')) return;
	
		        this.props.onDateChange(day);
		        this.props.onFocusChange({ focused: null });
		      }
	
		      return onDayClick;
		    }()
		  }, {
		    key: 'onDayMouseEnter',
		    value: function () {
		      function onDayMouseEnter(day) {
		        this.setState({
		          hoverDate: day
		        });
		      }
	
		      return onDayMouseEnter;
		    }()
		  }, {
		    key: 'onDayMouseLeave',
		    value: function () {
		      function onDayMouseLeave() {
		        this.setState({
		          hoverDate: null
		        });
		      }
	
		      return onDayMouseLeave;
		    }()
		  }, {
		    key: 'onFocus',
		    value: function () {
		      function onFocus() {
		        if (!this.props.disabled) {
		          this.props.onFocusChange({ focused: true });
		        }
		      }
	
		      return onFocus;
		    }()
		  }, {
		    key: 'onClearFocus',
		    value: function () {
		      function onClearFocus() {
		        var _props2 = this.props;
		        var focused = _props2.focused;
		        var onFocusChange = _props2.onFocusChange;
	
		        if (!focused) return;
	
		        onFocusChange({ focused: false });
		      }
	
		      return onClearFocus;
		    }()
		  }, {
		    key: 'getDateString',
		    value: function () {
		      function getDateString(date) {
		        var displayFormat = this.getDisplayFormat();
		        if (date && displayFormat) {
		          return date && date.format(displayFormat);
		        }
		        return (0, _toLocalizedDateString2['default'])(date);
		      }
	
		      return getDateString;
		    }()
		  }, {
		    key: 'getDayPickerContainerClasses',
		    value: function () {
		      function getDayPickerContainerClasses() {
		        var _props3 = this.props;
		        var focused = _props3.focused;
		        var orientation = _props3.orientation;
		        var withPortal = _props3.withPortal;
		        var withFullScreenPortal = _props3.withFullScreenPortal;
		        var hoverDate = this.state.hoverDate;
	
		        var dayPickerClassName = (0, _classnames2['default'])('SingleDatePicker__picker', {
		          'SingleDatePicker__picker--show': focused,
		          'SingleDatePicker__picker--invisible': !focused,
		          'SingleDatePicker__picker--horizontal': orientation === _constants.HORIZONTAL_ORIENTATION,
		          'SingleDatePicker__picker--vertical': orientation === _constants.VERTICAL_ORIENTATION,
		          'SingleDatePicker__picker--portal': withPortal || withFullScreenPortal,
		          'SingleDatePicker__picker--full-screen-portal': withFullScreenPortal,
		          'SingleDatePicker__picker--valid-date-hovered': hoverDate && !this.isBlocked(hoverDate)
		        });
	
		        return dayPickerClassName;
		      }
	
		      return getDayPickerContainerClasses;
		    }()
		  }, {
		    key: 'getDisplayFormat',
		    value: function () {
		      function getDisplayFormat() {
		        var displayFormat = this.props.displayFormat;
	
		        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
		      }
	
		      return getDisplayFormat;
		    }()
		  }, {
		    key: 'isBlocked',
		    value: function () {
		      function isBlocked(day) {
		        var _props4 = this.props;
		        var isDayBlocked = _props4.isDayBlocked;
		        var isOutsideRange = _props4.isOutsideRange;
	
		        return isDayBlocked(day) || isOutsideRange(day);
		      }
	
		      return isBlocked;
		    }()
		  }, {
		    key: 'isHovered',
		    value: function () {
		      function isHovered(day) {
		        return (0, _isSameDay2['default'])(day, this.state.hoverDate);
		      }
	
		      return isHovered;
		    }()
		  }, {
		    key: 'isSelected',
		    value: function () {
		      function isSelected(day) {
		        return (0, _isSameDay2['default'])(day, this.props.date);
		      }
	
		      return isSelected;
		    }()
		  }, {
		    key: 'maybeRenderDayPickerWithPortal',
		    value: function () {
		      function maybeRenderDayPickerWithPortal() {
		        var _props5 = this.props;
		        var focused = _props5.focused;
		        var withPortal = _props5.withPortal;
		        var withFullScreenPortal = _props5.withFullScreenPortal;
	
		        if (withPortal || withFullScreenPortal) {
		          return _react2['default'].createElement(_reactPortal2['default'], { isOpened: focused }, this.renderDayPicker());
		        }
	
		        return this.renderDayPicker();
		      }
	
		      return maybeRenderDayPickerWithPortal;
		    }()
		  }, {
		    key: 'renderDayPicker',
		    value: function () {
		      function renderDayPicker() {
		        var _this2 = this;
	
		        var _props6 = this.props;
		        var isDayBlocked = _props6.isDayBlocked;
		        var isOutsideRange = _props6.isOutsideRange;
		        var enableOutsideDays = _props6.enableOutsideDays;
		        var numberOfMonths = _props6.numberOfMonths;
		        var orientation = _props6.orientation;
		        var monthFormat = _props6.monthFormat;
		        var onPrevMonthClick = _props6.onPrevMonthClick;
		        var onNextMonthClick = _props6.onNextMonthClick;
		        var withPortal = _props6.withPortal;
		        var withFullScreenPortal = _props6.withFullScreenPortal;
	
		        var modifiers = {
		          blocked: function () {
		            function blocked(day) {
		              return _this2.isBlocked(day);
		            }
	
		            return blocked;
		          }(),
		          'blocked-calendar': function () {
		            function blockedCalendar(day) {
		              return isDayBlocked(day);
		            }
	
		            return blockedCalendar;
		          }(),
		          'blocked-out-of-range': function () {
		            function blockedOutOfRange(day) {
		              return isOutsideRange(day);
		            }
	
		            return blockedOutOfRange;
		          }(),
		          valid: function () {
		            function valid(day) {
		              return !_this2.isBlocked(day);
		            }
	
		            return valid;
		          }(),
		          hovered: function () {
		            function hovered(day) {
		              return _this2.isHovered(day);
		            }
	
		            return hovered;
		          }(),
		          selected: function () {
		            function selected(day) {
		              return _this2.isSelected(day);
		            }
	
		            return selected;
		          }()
		        };
	
		        var onOutsideClick = withPortal ? this.onClearFocus : function () {};
	
		        return _react2['default'].createElement('div', { className: this.getDayPickerContainerClasses() }, _react2['default'].createElement(_DayPicker2['default'], {
		          orientation: orientation,
		          enableOutsideDays: enableOutsideDays,
		          modifiers: modifiers,
		          numberOfMonths: numberOfMonths,
		          onDayMouseEnter: this.onDayMouseEnter,
		          onDayMouseLeave: this.onDayMouseLeave,
		          onDayMouseDown: this.onDayClick,
		          onDayTouchTap: this.onDayClick,
		          onPrevMonthClick: onPrevMonthClick,
		          onNextMonthClick: onNextMonthClick,
		          monthFormat: monthFormat,
		          withPortal: withPortal || withFullScreenPortal,
		          onOutsideClick: onOutsideClick
		        }), withFullScreenPortal && _react2['default'].createElement('button', {
		          className: 'SingleDatePicker__close',
		          type: 'button',
		          onClick: this.onClearFocus
		        }, _react2['default'].createElement('span', { className: 'screen-reader-only' }, this.props.phrases.closeDatePicker), _react2['default'].createElement(_close2['default'], null)));
		      }
	
		      return renderDayPicker;
		    }()
		  }, {
		    key: 'render',
		    value: function () {
		      function render() {
		        var _props7 = this.props;
		        var id = _props7.id;
		        var placeholder = _props7.placeholder;
		        var focused = _props7.focused;
		        var disabled = _props7.disabled;
		        var date = _props7.date;
		        var withPortal = _props7.withPortal;
		        var withFullScreenPortal = _props7.withFullScreenPortal;
	
		        var onOutsideClick = withPortal || withFullScreenPortal ? function () {} : this.onClearFocus;
	
		        var dateString = this.getDateString(date);
	
		        return _react2['default'].createElement('div', { className: 'SingleDatePicker' }, _react2['default'].createElement(_OutsideClickHandler2['default'], { onOutsideClick: onOutsideClick }, _react2['default'].createElement(_SingleDatePickerInput2['default'], {
		          id: id,
		          placeholder: placeholder,
		          focused: focused,
		          disabled: disabled,
		          dateValue: dateString,
		          onChange: this.onChange,
		          onFocus: this.onFocus,
		          onKeyDownShiftTab: this.onClearFocus,
		          onKeyDownTab: this.onClearFocus,
		          border: true
		        }), this.maybeRenderDayPickerWithPortal()));
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SingleDatePicker;
		}(_react2['default'].Component);
	
		exports['default'] = SingleDatePicker;
	
		SingleDatePicker.propTypes = propTypes;
		SingleDatePicker.defaultProps = defaultProps;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	/* 2 */,
	/* 3 */,
	/* 4 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(563);
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(167);
	
	/***/ },
	/* 6 */,
	/* 7 */,
	/* 8 */,
	/* 9 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(771);
	
	/***/ },
	/* 10 */,
	/* 11 */,
	/* 12 */,
	/* 13 */,
	/* 14 */,
	/* 15 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(773);
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(774);
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(799);
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(800);
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(801);
	
	/***/ },
	/* 20 */,
	/* 21 */,
	/* 22 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(802);
	
	/***/ },
	/* 23 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(805);
	
	/***/ },
	/* 24 */,
	/* 25 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(808);
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var SVG = function (_React$Component) {
		  _inherits(SVG, _React$Component);
	
		  function SVG() {
		    _classCallCheck(this, SVG);
	
		    return _possibleConstructorReturn(this, (SVG.__proto__ || Object.getPrototypeOf(SVG)).apply(this, arguments));
		  }
	
		  _createClass(SVG, [{
		    key: "render",
		    value: function () {
		      function render() {
		        return _react2["default"].createElement(
		          "svg",
		          _extends({ viewBox: "0 0 12 12" }, this.props),
		          _react2["default"].createElement("path", { fillRule: "evenodd", d: "M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z" })
		        );
		      }
	
		      return render;
		    }()
		  }]);
	
		  return SVG;
		}(_react2["default"].Component);
	
		exports["default"] = SVG;
	
	/***/ },
	/* 27 */,
	/* 28 */,
	/* 29 */,
	/* 30 */,
	/* 31 */,
	/* 32 */,
	/* 33 */,
	/* 34 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(822);
	
	/***/ },
	/* 35 */
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(823);
	
	/***/ }
	/******/ ]);

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ 0:
	/***/ function(module, exports, __webpack_require__) {
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports['default'] = SingleDatePickerInput;
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _DateInput = __webpack_require__(28);
	
		var _DateInput2 = _interopRequireDefault(_DateInput);
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		var propTypes = {
		  id: _react.PropTypes.string.isRequired,
		  placeholder: _react.PropTypes.string, // also used as label
		  dateValue: _react.PropTypes.string,
		  border: _react.PropTypes.bool,
		  focused: _react.PropTypes.bool,
		  disabled: _react.PropTypes.bool,
	
		  onChange: _react.PropTypes.func,
		  onFocus: _react.PropTypes.func,
		  onKeyDownShiftTab: _react.PropTypes.func,
		  onKeyDownTab: _react.PropTypes.func
		};
	
		var defaultProps = {
		  placeholder: 'Select Date',
		  dateValue: '',
		  border: false,
		  focused: false,
		  disabled: false,
	
		  onChange: function () {
		    function onChange() {}
	
		    return onChange;
		  }(),
		  onFocus: function () {
		    function onFocus() {}
	
		    return onFocus;
		  }(),
		  onKeyDownShiftTab: function () {
		    function onKeyDownShiftTab() {}
	
		    return onKeyDownShiftTab;
		  }(),
		  onKeyDownTab: function () {
		    function onKeyDownTab() {}
	
		    return onKeyDownTab;
		  }()
		};
	
		function SingleDatePickerInput(props) {
		  var id = props.id;
		  var placeholder = props.placeholder;
		  var dateValue = props.dateValue;
		  var focused = props.focused;
		  var disabled = props.disabled;
		  var onChange = props.onChange;
		  var onFocus = props.onFocus;
		  var onKeyDownShiftTab = props.onKeyDownShiftTab;
		  var onKeyDownTab = props.onKeyDownTab;
	
		  return _react2['default'].createElement('div', { className: 'SingleDatePickerInput' }, _react2['default'].createElement(_DateInput2['default'], {
		    id: id,
		    placeholder: placeholder // also used as label
		    , dateValue: dateValue,
		    focused: focused,
		    disabled: disabled,
	
		    onChange: onChange,
		    onFocus: onFocus,
		    onKeyDownShiftTab: onKeyDownShiftTab,
		    onKeyDownTab: onKeyDownTab
		  }));
		}
	
		SingleDatePickerInput.propTypes = propTypes;
		SingleDatePickerInput.defaultProps = defaultProps;
	
	/***/ },
	
	/***/ 1:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(1);
	
	/***/ },
	
	/***/ 28:
	/***/ function(module, exports) {
	
		module.exports = __webpack_require__(807);
	
	/***/ }
	
	/******/ });

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactMomentProptypes = __webpack_require__(813);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _OrientationShape = __webpack_require__(810);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  id: _react.PropTypes.string.isRequired,
	  placeholder: _react.PropTypes.string,
	  date: _reactMomentProptypes2['default'].momentObj,
	  focused: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	
	  onDateChange: _react.PropTypes.func,
	  onFocusChange: _react.PropTypes.func,
	
	  isDayBlocked: _react.PropTypes.func,
	  isOutsideRange: _react.PropTypes.func,
	  enableOutsideDays: _react.PropTypes.bool,
	  numberOfMonths: _react.PropTypes.number,
	  orientation: _OrientationShape2['default'],
	
	  // portal options
	  withPortal: _react.PropTypes.bool,
	  withFullScreenPortal: _react.PropTypes.bool,
	
	  onPrevMonthClick: _react.PropTypes.func,
	  onNextMonthClick: _react.PropTypes.func,
	
	  // i18n
	  displayFormat: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	  monthFormat: _react.PropTypes.string,
	  phrases: _react.PropTypes.shape({
	    closeDatePicker: _react.PropTypes.node
	  })
	};

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toLocalizedDateString;
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(799);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(771);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_FORMAT);
	}

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(826);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(828)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../css-loader/index.js!./_datepicker.css", function() {
				var newContent = require("!!./../../../css-loader/index.js!./_datepicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(827)();
	// imports
	
	
	// module
	exports.push([module.id, ".CalendarDay{position:relative;display:table;height:100%;width:100%}.CalendarDay__day{display:table-cell;vertical-align:middle;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}.CalendarMonth{text-align:center;padding:0 13px;vertical-align:top}.CalendarMonth:first-of-type{position:absolute;z-index:-1;opacity:0}.CalendarMonth table{border-collapse:collapse;border-spacing:0}.CalendarMonth--horizontal{display:inline-block;min-height:100%}.CalendarMonth--vertical{display:block}.CalendarMonth__caption{color:#3c3f40;margin-top:7px;font-size:18px;padding:15px 0 35px;text-align:center;margin-bottom:2px}.CalendarMonth__day{border:1px solid #e4e7e7;padding:0;box-sizing:border-box;color:#565a5c;cursor:pointer;width:39px;height:38px}.CalendarMonth__day:active{background:#f2f2f2}.CalendarMonth__day--outside{border:0;cursor:default}.CalendarMonth__day--outside:active{background:#fff}.CalendarMonth__day--hovered{background:#e4e7e7;border:1px double #d4d9d9;color:inherit}.CalendarMonth__day--blocked-minimum-nights{color:#cacccd;background:#fff;border:1px solid #e4e7e7;cursor:default}.CalendarMonth__day--blocked-minimum-nights:active{background:#fff}.CalendarMonth__day--selected-span{background:#66e2da;border:1px double #33dacd;color:#fff}.CalendarMonth__day--selected-span.CalendarMonth__day--hovered,.CalendarMonth__day--selected-span:active{background:#33dacd;border:1px double #00a699}.CalendarMonth__day--selected-span.CalendarMonth__day--last-in-range{border-right:#00a699}.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--after-hovered-start,.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--hovered-span{background:#b2f1ec;border:1px double #80e8e0;color:#007a87}.CalendarMonth__day--selected,.CalendarMonth__day--selected-end,.CalendarMonth__day--selected-start,.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--selected-end,.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--selected-start{background:#00a699;border:1px double #00a699;color:#fff}.CalendarMonth__day--selected-end:active,.CalendarMonth__day--selected-start:active,.CalendarMonth__day--selected:active,.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--selected-end:active,.DateRangePicker__picker--valid-date-hovered .CalendarMonth__day--selected-start:active{background:#00a699}.CalendarMonth__day--blocked-calendar{background:#cacccd;color:#82888a;cursor:default}.CalendarMonth__day--blocked-calendar:active{background:#cacccd}.CalendarMonth__day--blocked-out-of-range{color:#cacccd;background:#fff;border:1px solid #e4e7e7;cursor:default}.CalendarMonth__day--blocked-out-of-range:active{background:#fff}.CalendarMonthGrid{background:#fff;z-index:0}.CalendarMonthGrid--animating{transition:transform .2s ease-in-out;z-index:1}.CalendarMonthGrid--horizontal{position:absolute;left:9px;width:1200px}.CalendarMonthGrid--vertical{width:300px;margin:0 auto}.DayPicker{background:#fff;position:relative}.DayPicker--horizontal{background:#fff;box-shadow:0 2px 6px rgba(0,0,0,.05),0 0 0 1px rgba(0,0,0,.07);border-radius:3px}.DayPicker--horizontal.DayPicker--portal{box-shadow:none;position:absolute;left:50%;top:50%}.DayPicker--vertical.DayPicker--portal{position:static}.DayPicker__nav--next,.DayPicker__nav--prev{border:1px solid #dce0e0;background-color:#fff;color:#757575;cursor:pointer;line-height:.78;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.DayPicker__nav--next:focus,.DayPicker__nav--next:hover,.DayPicker__nav--prev:focus,.DayPicker__nav--prev:hover{border:1px solid #c4c4c4}.DayPicker__nav--next:active,.DayPicker__nav--prev:active{background:#f2f2f2}.DayPicker--horizontal .DayPicker__nav{position:relative}.DayPicker--horizontal .DayPicker__nav--next,.DayPicker--horizontal .DayPicker__nav--prev{border-radius:3px;padding:6px 9px;top:18px;z-index:2;position:absolute}.DayPicker--horizontal .DayPicker__nav--prev{left:22px}.DayPicker--horizontal .DayPicker__nav--next{right:22px}.DayPicker--horizontal svg{height:19px;width:19px;fill:#82888a}.DayPicker--vertical .DayPicker__nav{background:#fff;box-shadow:0 0 5px 2px rgba(0,0,0,.1);position:absolute;bottom:0;left:0;height:52px;width:100%;z-index:2}.DayPicker--vertical .DayPicker__nav--next,.DayPicker--vertical .DayPicker__nav--prev{text-align:center;font-size:2.5em;padding:5px;display:inline-block;position:relative;height:100%;width:50%}.DayPicker--vertical .DayPicker__nav--next{border-left:0}.DayPicker--vertical svg{height:42px;width:42px;fill:#484848}.DayPicker__week-headers{position:relative}.DayPicker__week-header{color:#757575;position:absolute;top:62px;z-index:2;text-align:left}.DayPicker__week-header ul{list-style:none;margin:1px 0;padding-left:0}.DayPicker__week-header li{display:inline-block;width:39px;text-align:center}.DayPicker--horizontal .DayPicker__week-header{padding:0 22px 0 13px}.DayPicker--horizontal .DayPicker__week-header:first-of-type{padding:0 13px 0 22px}.DayPicker--vertical .DayPicker__week-header{margin-left:-150px;padding:0 13px;width:300px;left:50%}.transition-container{position:relative;overflow:hidden;border-radius:3px}.transition-container--horizontal{transition:height .2s ease-in-out}.transition-container--vertical{width:100%}.DateInput{font-weight:200;font-size:18px;line-height:24px;color:#757575;margin:0;padding:8px;background:#fff;position:relative;display:inline-block;width:130px;vertical-align:middle}.DateInput--disabled{background:#cacccd}.DateInput__label{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.DateInput__input{opacity:0;position:absolute;top:0;left:0;border:0;height:100%;width:100%}.DateInput__display-text{padding:4px 8px;white-space:nowrap;overflow:hidden}.DateInput__display-text--has-input{color:#484848}.DateInput__display-text--focused{background:#99ede6;border-color:#99ede6;border-radius:3px;color:#007a87}.DateInput__display-text--disabled{font-style:italic}.screen-reader-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.DateRangePicker{position:relative;display:inline-block}.DateRangePicker__picker{background-color:#fff;z-index:1;position:absolute;top:145%;left:0}.DateRangePicker__picker:after,.DateRangePicker__picker:before{content:\"\";display:inline-block;position:absolute;bottom:auto}.DateRangePicker__picker--show{visibility:visible}.DateRangePicker__picker--invisible{visibility:hidden}.DateRangePicker__picker--portal{background-color:rgba(0,0,0,.3);position:fixed;top:0;left:0;height:100%;width:100%}.DateRangePicker__picker--full-screen-portal{background-color:#fff}.DateRangePicker__picker--end:before,.DateRangePicker__picker--start:before{top:-10px;border:10px solid transparent;border-top:0;border-bottom-color:rgba(0,0,0,.1)}.DateRangePicker__picker--start:before{left:22px}.DateRangePicker__picker--end:before{left:162px}.DateRangePicker__picker--end:after,.DateRangePicker__picker--start:after{top:-9px;border:9px solid transparent;border-top:0;border-bottom-color:#fff}.DateRangePicker__picker--start:after{left:23px}.DateRangePicker__picker--end:after{left:163px}.DateRangePicker__close{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2}.DateRangePicker__close svg{height:15px;width:15px;fill:#cacccd}.DateRangePicker__close:focus,.DateRangePicker__close:hover{color:#b0b3b4;text-decoration:none}.DateRangePickerInput{background-color:#fff;border:1px solid #cacccd;display:inline-block}.DateRangePickerInput--disabled{background:#cacccd}.DateRangePickerInput__arrow{display:inline-block;vertical-align:middle}.DateRangePickerInput__arrow svg{vertical-align:middle;fill:#484848;height:24px;width:24px}.DateRangePickerInput__clear-dates{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;cursor:pointer;display:inline-block;vertical-align:middle;padding:10px;margin:0 10px 0 5px}.DateRangePickerInput__clear-dates svg{fill:#82888a;height:12px;width:15px;vertical-align:middle}.DateRangePickerInput__clear-dates--hide{visibility:hidden}.DateRangePickerInput__clear-dates--hover,.DateRangePickerInput__clear-dates:focus{background:#dbdbdb;border-radius:50%}.SingleDatePicker{position:relative;display:inline-block}.SingleDatePicker__picker{background-color:#fff;z-index:1;position:absolute;top:145%;left:0}.SingleDatePicker__picker:after,.SingleDatePicker__picker:before{content:\"\";display:inline-block;position:absolute;bottom:auto}.SingleDatePicker__picker:before{top:-10px;border:10px solid transparent;border-top:0;border-bottom-color:rgba(0,0,0,.1);left:22px}.SingleDatePicker__picker:after{top:-9px;border:9px solid transparent;border-top:0;border-bottom-color:#fff;left:23px}.SingleDatePicker__picker--show{visibility:visible}.SingleDatePicker__picker--invisible{visibility:hidden}.SingleDatePicker__picker--portal{background-color:rgba(0,0,0,.3);position:fixed;top:0;left:0;height:100%;width:100%}.SingleDatePicker__picker--full-screen-portal{background-color:#fff}.SingleDatePicker__close{background:none;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;cursor:pointer;position:absolute;top:0;right:0;padding:15px;z-index:2}.SingleDatePicker__close svg{height:15px;width:15px;fill:#cacccd}.SingleDatePicker__close:focus,.SingleDatePicker__close:hover{color:#b0b3b4;text-decoration:none}.SingleDatePickerInput{border:1px solid #dbdbdb}", ""]);
	
	// exports


/***/ },
/* 827 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _underscore = __webpack_require__(205);
	
	var _sidebarAction = __webpack_require__(504);
	
	var _sidebarAction2 = _interopRequireDefault(_sidebarAction);
	
	var _sidebarStore = __webpack_require__(830);
	
	var _sidebarStore2 = _interopRequireDefault(_sidebarStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SidebarBlock = function (_React$Component) {
	  _inherits(SidebarBlock, _React$Component);
	
	  function SidebarBlock(props) {
	    _classCallCheck(this, SidebarBlock);
	
	    return _possibleConstructorReturn(this, (SidebarBlock.__proto__ || Object.getPrototypeOf(SidebarBlock)).call(this, props));
	  }
	
	  _createClass(SidebarBlock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var uid = (0, _clone2.default)(this.props.uid);
	      var indexOfSearch = (0, _underscore.findIndex)(allLayout, { uid: uid.toString() });
	      if (indexOfSearch !== -1) {
	        var indexOfSidebar = (0, _underscore.findIndex)(allLayout[indexOfSearch].searchAttr, { viewType: 'sidebar' });
	        if (indexOfSidebar !== -1) {
	          var name = allLayout[indexOfSearch].searchAttr[indexOfSidebar].sidebarName;
	          _sidebarAction2.default.getSidebarWidget({ name: name });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _sidebarStore2.default.listen(this.renderSidebar.bind(this));
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(data) {
	      var target = _reactDom2.default.findDOMNode(this);
	      jQuery(target).html(data);
	      // alike
	      window.loadAlike();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var settingsData = this.props.settingsData;
	
	      var ThemeComponent = window.ReactiveTheme[settingsData.theme];
	      return _react2.default.createElement(ThemeComponent.widget, null);
	    }
	  }]);
	
	  return SidebarBlock;
	}(_react2.default.Component);
	
	exports.default = SidebarBlock;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _sidebarAction = __webpack_require__(504);
	
	var _sidebarAction2 = _interopRequireDefault(_sidebarAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  listenables: _sidebarAction2.default,
	  onPublishAllWidget: function onPublishAllWidget(data) {
	    this.trigger(data);
	  }
	});

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _daterangepicker = __webpack_require__(768);
	
	var _daterangepicker2 = _interopRequireDefault(_daterangepicker);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateRangePickerDropDownPreview = function (_React$Component) {
	  _inherits(DateRangePickerDropDownPreview, _React$Component);
	
	  function DateRangePickerDropDownPreview(props) {
	    _classCallCheck(this, DateRangePickerDropDownPreview);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePickerDropDownPreview.__proto__ || Object.getPrototypeOf(DateRangePickerDropDownPreview)).call(this, props));
	
	    _this.state = {
	      'values': 'Demo Input',
	      'options': [],
	      'toogle': false
	    };
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.handleDateRange = _this.handleDateRange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePickerDropDownPreview, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.block = nextprops.block;
	      var datepickertype = nextprops.block.hasOwnProperty('selectedCalenderViewType') ? nextprops.block.selectedCalenderViewType : 'single';
	      this.setState({ datepickertype: datepickertype, toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'handleDateRange',
	    value: function handleDateRange(values) {
	      if (this.block !== undefined) {
	        if (this.block.selectedMetakey) {
	          _urlHandlerActions2.default.push({
	            'searchItem': this.block.selectedMetakey,
	            'searchType': 'metakeys',
	            'searchField': 'daterange',
	            values: values
	          });
	        }
	      }
	      // this.setState({ values });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var allUrlData = window.searchArray;
	      var defaultValue = {};
	      allUrlData.map(function (item) {
	        var isDateRangeStart = item.key.indexOf('[start]');
	        if (isDateRangeStart !== -1) {
	          defaultValue.start = item.value;
	        }
	        var isDateRangeEnd = item.key.indexOf('[end]');
	        if (isDateRangeEnd !== -1) {
	          defaultValue.end = item.value;
	        }
	      });
	      var textBoxClassName = this.props.block.dynamicNameClassCheckBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      return _react2.default.createElement(
	        'div',
	        { className: textBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: 'true',
	          dropdown: true,
	          field: this.props.block.uid
	        }),
	        this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: HelperClass + ' ' + 'dropdown-template' },
	          _react2.default.createElement(_daterangepicker2.default, _extends({}, this.props, { dateFormat: this.block.dateFormat !== undefined ? this.block.dateFormat : 'MM-DD-YYYY', 'default': defaultValue, datepickertype: this.state.datepickertype, grabDateRangeValue: this.handleDateRange }))
	        ) : null
	      );
	    }
	  }]);
	
	  return DateRangePickerDropDownPreview;
	}(_react2.default.Component);
	
	DateRangePickerDropDownPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = DateRangePickerDropDownPreview;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortingOption = function (_React$Component) {
	  _inherits(SortingOption, _React$Component);
	
	  function SortingOption(props) {
	    _classCallCheck(this, SortingOption);
	
	    var _this = _possibleConstructorReturn(this, (SortingOption.__proto__ || Object.getPrototypeOf(SortingOption)).call(this, props));
	
	    _this.handleSortingAttribute = _this.handleSortingAttribute.bind(_this);
	    _this.handleSortBy = _this.handleSortBy.bind(_this);
	    _this.state = {
	      sortingAttr: '',
	      sortBy: 'asc'
	    };
	    return _this;
	  }
	
	  _createClass(SortingOption, [{
	    key: 'handleSortingAttribute',
	    value: function handleSortingAttribute(event) {
	      if (event.target.value !== '') {
	        this.props.handleSortingAttribute(event.target.value);
	      }
	      this.setState({ sortingAttr: event.target.value });
	    }
	  }, {
	    key: 'handleSortBy',
	    value: function handleSortBy(type, event) {
	      event.preventDefault();
	      this.props.handleSortBy(type);
	      this.setState({ sortBy: type });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var sortingData = this.props.sortingData;
	
	      var showSorting = function showSorting(data, index) {
	        return _react2.default.createElement(
	          'option',
	          { value: data.value, key: 'sorting-' + index },
	          data.title
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'right-block' },
	        _react2.default.createElement(
	          'div',
	          null,
	          'Sort by:',
	          _react2.default.createElement(
	            'select',
	            { className: 'rq-selectbox', onChange: this.handleSortingAttribute },
	            _react2.default.createElement(
	              'option',
	              { value: '' },
	              'Default'
	            ),
	            sortingData.map(showSorting)
	          )
	        ),
	        this.state.sortingAttr !== '' && _react2.default.createElement(
	          'div',
	          null,
	          this.state.sortBy === 'desc' && _react2.default.createElement(
	            'button',
	            { className: 'sorting-button', type: 'button', onClick: this.handleSortBy.bind(this, 'asc') },
	            _react2.default.createElement('i', { className: 'fa fa-chevron-down', 'aria-hidden': 'true' })
	          ),
	          this.state.sortBy === 'asc' && _react2.default.createElement(
	            'button',
	            { className: 'sorting-button', type: 'button', onClick: this.handleSortBy.bind(this, 'desc') },
	            _react2.default.createElement('i', { className: 'fa fa-chevron-up', 'aria-hidden': 'true' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SortingOption;
	}(_react2.default.Component);
	
	SortingOption.propTypes = {
	  'sortingData': _react2.default.PropTypes.array,
	  'handleSortBy': _react2.default.PropTypes.func,
	  'handleSortingAttribute': _react2.default.PropTypes.func
	};
	
	exports.default = SortingOption;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadMoreOption = function (_React$Component) {
	  _inherits(LoadMoreOption, _React$Component);
	
	  function LoadMoreOption(props) {
	    _classCallCheck(this, LoadMoreOption);
	
	    var _this = _possibleConstructorReturn(this, (LoadMoreOption.__proto__ || Object.getPrototypeOf(LoadMoreOption)).call(this, props));
	
	    _this.state = {
	      msg: 'Load More'
	    };
	    return _this;
	  }
	
	  _createClass(LoadMoreOption, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ msg: 'Load More' });
	    }
	  }, {
	    key: 'handleOnClick',
	    value: function handleOnClick(event) {
	      event.preventDefault();
	      this.setState({ msg: 'Loading' });
	      this.props.onClick();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.show === true) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'rq-loadmore-button' },
	          _react2.default.createElement(
	            'button',
	            { type: 'button', onClick: this.handleOnClick.bind(this) },
	            this.state.msg
	          )
	        );
	      }
	      return _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return LoadMoreOption;
	}(_react2.default.Component);
	
	LoadMoreOption.propTypes = {
	  'onClick': _react2.default.PropTypes.func,
	  'show': _react2.default.PropTypes.bool
	};
	
	exports.default = LoadMoreOption;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchAttrShow = function (_React$Component) {
	  _inherits(SearchAttrShow, _React$Component);
	
	  function SearchAttrShow(props) {
	    _classCallCheck(this, SearchAttrShow);
	
	    var _this = _possibleConstructorReturn(this, (SearchAttrShow.__proto__ || Object.getPrototypeOf(SearchAttrShow)).call(this, props));
	
	    _this.minRangeValue = null;
	    _this.maxRangeValue = null;
	    _this.showSearchItemForTopBar = _this.showSearchItemForTopBar.bind(_this);
	    _this.deleteSearch = _this.deleteSearch.bind(_this);
	    return _this;
	  }
	
	  _createClass(SearchAttrShow, [{
	    key: 'deleteSearch',
	    value: function deleteSearch(index, item, event) {
	      event.preventDefault();
	      this.props.deleteSearchAttr(index, item);
	    }
	  }, {
	    key: 'showSearchItemForTopBar',
	    value: function showSearchItemForTopBar(searchItem, index) {
	      if (searchItem.key.toString() === 'pagenumber' || searchItem.key.toString() === 'view' || searchItem.key.indexOf('[min]') !== -1 || searchItem.key.indexOf('[start]') !== -1) {
	        return false;
	      }
	      var minValue = null;
	      var maxValue = null;
	      if (searchItem.key.indexOf('[max]') !== -1) {
	        maxValue = searchItem.value;
	        var maxKey = searchItem['metakey'] + '[min]';
	        var indexOfMin = (0, _underscore.findIndex)(window.searchArray, { key: maxKey });
	        if (indexOfMin !== -1) {
	          minValue = window.searchArray[indexOfMin].value;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { key: 'searchResult-' + index, className: 'search-result-selected' },
	        searchItem.key.indexOf('[') === -1 ? _react2.default.createElement(
	          'p',
	          { className: 'rq-search-item-single' },
	          searchItem.value + '  ',
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'attrClose', onClick: this.deleteSearch.bind(this, index, searchItem) },
	            _react2.default.createElement('i', { className: 'ion-android-close' })
	          )
	        ) : null,
	        searchItem.key.indexOf('[') !== -1 && searchItem.key.indexOf('[max]') !== -1 ? _react2.default.createElement(
	          'p',
	          null,
	          minValue,
	          ' - ',
	          maxValue,
	          ' ',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'attrClose', onClick: this.deleteSearch.bind(this, index, searchItem) },
	            _react2.default.createElement('i', { className: 'ion-android-close' })
	          )
	        ) : null,
	        searchItem.key.indexOf('[') !== -1 && searchItem.key.indexOf('[end]') !== -1 ? _react2.default.createElement(
	          'p',
	          null,
	          (0, _moment2.default)(this.startDateRange).format('ll') + ' ',
	          ' - ',
	          ' ' + (0, _moment2.default)(this.endDateRange).format('ll'),
	          ' ',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: '#', className: 'attrClose', onClick: this.deleteSearch.bind(this, index, searchItem) },
	            _react2.default.createElement('i', { className: 'ion-android-close' })
	          )
	        ) : null
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      for (var index = 0; index < window.searchArray.length; index++) {
	        var indexOfKeyMin = window.searchArray[index].key.indexOf('[min]');
	        if (indexOfKeyMin !== -1) {
	          this.minRangeValue = window.searchArray[index].value;
	        }
	        var indexOfKeyMax = window.searchArray[index].key.indexOf('[max]');
	        if (indexOfKeyMax !== -1) {
	          this.maxRangeValue = window.searchArray[index].value;
	        }
	        var indexOfKeyStart = window.searchArray[index].key.indexOf('[start]');
	        if (indexOfKeyStart !== -1) {
	          this.startDateRange = window.searchArray[index].value;
	        }
	        var indexOfKeyEnd = window.searchArray[index].key.indexOf('[end]');
	        if (indexOfKeyEnd !== -1) {
	          this.endDateRange = window.searchArray[index].value;
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'search-attribute' },
	        _react2.default.createElement(
	          'p',
	          { className: 'result-text' },
	          _react2.default.createElement(
	            'span',
	            null,
	            this.props.results
	          ),
	          this.props.results > 1 ? API.LANG.RESULTS : API.LANG.RESULT,
	          ' ',
	          API.LANG.FOUND
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.flag !== null ? 'filter-option' : 'no-filter-option' },
	          _react2.default.createElement(
	            'div',
	            { className: 'filter-result-item' },
	            window.searchArray.length ? window.searchArray.map(this.showSearchItemForTopBar) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return SearchAttrShow;
	}(_react2.default.Component);
	
	SearchAttrShow.propTypes = {
	  'results': _react2.default.PropTypes.node,
	  'deleteSearchAttr': _react2.default.PropTypes.func
	};
	
	exports.default = SearchAttrShow;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ViewChanger = function (_Component) {
	  _inherits(ViewChanger, _Component);
	
	  function ViewChanger(props) {
	    _classCallCheck(this, ViewChanger);
	
	    return _possibleConstructorReturn(this, (ViewChanger.__proto__ || Object.getPrototypeOf(ViewChanger)).call(this, props));
	  }
	
	  _createClass(ViewChanger, [{
	    key: 'handleChnagedView',
	    value: function handleChnagedView(view, e) {
	      e.preventDefault();
	      var values = [];
	      values.push(view);
	      var index = (0, _underscore.findIndex)(window.searchArray, { key: 'view' });
	      if (index !== -1) {
	        if (window.searchArray[index].value.toString() === view) {
	          return;
	        }
	      }
	      _urlHandlerActions2.default.push({
	        'searchItem': 'view',
	        'searchType': 'globalSearch',
	        'searchField': 'topListOrGrid',
	        values: values
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var index = (0, _underscore.findIndex)(window.searchArray, { key: 'view' });
	      var viewType = null;
	      if (index !== -1) {
	        viewType = window.searchArray[index].value;
	      }
	      var viewChangerButtonGrid = (0, _classnames2.default)({
	        'view-change-btn': true,
	        'active': viewType === 'grid'
	      });
	      var viewChangerButtonList = (0, _classnames2.default)({
	        'view-change-btn': true,
	        'active': viewType === 'list'
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'left-block' },
	        _react2.default.createElement(
	          'button',
	          { className: viewChangerButtonGrid, onClick: this.handleChnagedView.bind(this, 'grid') },
	          _react2.default.createElement('i', { className: 'fa fa-th', 'aria-hidden': 'true' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: viewChangerButtonList, onClick: this.handleChnagedView.bind(this, 'list') },
	          _react2.default.createElement('i', { className: 'fa fa-bars', 'aria-hidden': 'true' })
	        )
	      );
	    }
	  }]);
	
	  return ViewChanger;
	}(_react.Component);
	
	exports.default = ViewChanger;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetRenderBlock = function (_React$Component) {
	  _inherits(WidgetRenderBlock, _React$Component);
	
	  function WidgetRenderBlock(props) {
	    _classCallCheck(this, WidgetRenderBlock);
	
	    var _this = _possibleConstructorReturn(this, (WidgetRenderBlock.__proto__ || Object.getPrototypeOf(WidgetRenderBlock)).call(this, props));
	
	    _this.displayName = 'WidgetBlock';
	    return _this;
	  }
	
	  _createClass(WidgetRenderBlock, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return WidgetRenderBlock;
	}(_react2.default.Component);
	
	exports.default = WidgetRenderBlock;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MapRenderBlock = function (_React$Component) {
	  _inherits(MapRenderBlock, _React$Component);
	
	  function MapRenderBlock(props) {
	    _classCallCheck(this, MapRenderBlock);
	
	    return _possibleConstructorReturn(this, (MapRenderBlock.__proto__ || Object.getPrototypeOf(MapRenderBlock)).call(this, props));
	  }
	
	  _createClass(MapRenderBlock, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { id: "reactiveMap", style: this.props.styles });
	    }
	  }]);
	
	  return MapRenderBlock;
	}(_react2.default.Component);
	
	exports.default = MapRenderBlock;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	var Pagination = React.createClass({
	  displayName: 'Pagination',
	
	  propTypes: {
	    totalPage: React.PropTypes.number.isRequired,
	    selectPage: React.PropTypes.func.isRequired
	  },
	  getInitialState: function getInitialState() {
	    return {
	      current: 1
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    this.setState({ current: parseInt(this.props.startPage, 10) });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (props.startPage === 1) {
	      this.setState({ current: 1 });
	    } else {
	      this.setState({ current: parseInt(props.startPage, 10) });
	    }
	  },
	  _renderPaginate: function _renderPaginate(current) {
	    var totalPage = this.props.totalPage;
	    var pageArr = [];
	    var pageCont = [];
	    if (totalPage <= 7) {
	      for (var p = 1; p <= totalPage; p++) {
	        pageArr.push({
	          page: p,
	          currentPage: p === current
	        });
	      }
	    } else {
	      if (current < 4) {
	        for (var _p = 1; _p <= 6; _p++) {
	          pageArr.push({
	            page: _p,
	            currentPage: _p === current
	          });
	        }
	        pageArr.push({
	          page: '...',
	          dot: true,
	          currentPage: false
	        });
	        pageArr.push({
	          page: totalPage,
	          currentPage: false
	        });
	      } else {
	        if (current - 3 <= 1) {
	          for (var i = 1; i <= current; i++) {
	            pageArr.push({
	              page: i,
	              currentPage: i === current
	            });
	          }
	        } else {
	          pageArr.push({
	            page: 1,
	            currentPage: false
	          });
	          pageArr.push({
	            page: '...',
	            dot: true,
	            currentPage: false
	          });
	          if (totalPage - current >= 3) {
	            for (var j = current - 2; j <= current; j++) {
	              pageArr.push({
	                page: j,
	                currentPage: j === current
	              });
	            }
	          } else {
	            for (var _j = current - (5 - (totalPage - current)); _j <= current; _j++) {
	              pageArr.push({
	                page: _j,
	                currentPage: _j === current
	              });
	            }
	          }
	        }
	        if (current + 3 >= totalPage) {
	          for (var m = current + 1; m <= totalPage; m++) {
	            pageArr.push({
	              page: m,
	              currentPage: false
	            });
	          }
	        } else {
	          for (var n = current + 1; n <= current + 2; n++) {
	            pageArr.push({
	              page: n,
	              currentPage: false
	            });
	          }
	          pageArr.push({
	            page: '...',
	            dot: true,
	            currentPage: false
	          });
	          pageArr.push({
	            page: totalPage,
	            currentPage: false
	          });
	        }
	      }
	    }
	    pageCont = pageArr.map(function (item, index) {
	      var pageClass = item.dot ? 'paginate-dot' : '';
	      pageClass += item.currentPage ? ' paginate-current' : '';
	      return React.createElement(
	        'li',
	        { className: pageClass, key: index },
	        item.page
	      );
	    });
	    return pageCont;
	  },
	  _handlePageClick: function _handlePageClick(e) {
	    var target = e.target;
	    if (target.tagName !== 'LI' || /paginate-current/.test(target.className) || /paginate-dot/.test(target.className)) return;
	    var page = parseInt(target.innerHTML, 10);
	    this.setState({
	      current: page
	    });
	    this.props.selectPage(page);
	  },
	  _handlePrevClick: function _handlePrevClick() {
	    var current = parseInt(this.state.current, 10);
	    if (current === 1) return;
	    this.setState({
	      current: current - 1
	    });
	    this.props.selectPage(current - 1);
	  },
	  _handleNextClick: function _handleNextClick() {
	    var current = parseInt(this.state.current, 10);
	    if (current === this.props.totalPage) return;
	    this.setState({
	      current: current + 1
	    });
	    this.props.selectPage(current + 1);
	  },
	  render: function render() {
	    var paginate = this._renderPaginate(this.state.current);
	    var prevClass = this.state.current === 1 ? 'prev-page unavailable' : 'prev-page';
	    var nextClass = this.state.current === this.props.totalPage ? 'next-page unavailable' : 'next-page';
	    return React.createElement(
	      'div',
	      { id: 'rq-pagination' },
	      React.createElement(
	        'span',
	        { className: nextClass, onClick: this._handleNextClick },
	        React.createElement('i', null)
	      ),
	      React.createElement(
	        'ul',
	        { onClick: this._handlePageClick },
	        paginate
	      ),
	      React.createElement(
	        'span',
	        { className: prevClass, onClick: this._handlePrevClick },
	        React.createElement('i', null)
	      )
	    );
	  }
	});
	module.exports = Pagination;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryLoadMore = function (_React$Component) {
	  _inherits(CategoryLoadMore, _React$Component);
	
	  function CategoryLoadMore(props) {
	    _classCallCheck(this, CategoryLoadMore);
	
	    return _possibleConstructorReturn(this, (CategoryLoadMore.__proto__ || Object.getPrototypeOf(CategoryLoadMore)).call(this, props));
	  }
	
	  _createClass(CategoryLoadMore, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'rq-loadmore-button' },
	        _react2.default.createElement(
	          'a',
	          { href: this.props.viewMoreLink, className: 'load-more-link' },
	          API.LANG.LOAD_MORE_BUTTON
	        )
	      );
	      return _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return CategoryLoadMore;
	}(_react2.default.Component);
	
	CategoryLoadMore.propTypes = {
	  'onClick': _react2.default.PropTypes.func,
	  'show': _react2.default.PropTypes.node
	};
	
	exports.default = CategoryLoadMore;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mapRadius = __webpack_require__(841);
	
	var _mapRadius2 = _interopRequireDefault(_mapRadius);
	
	var _title = __webpack_require__(728);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _urlHandlerActions = __webpack_require__(560);
	
	var _urlHandlerActions2 = _interopRequireDefault(_urlHandlerActions);
	
	var _underscore = __webpack_require__(205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var $ = jQuery;
	
	var MapRadiusPreview = function (_React$Component) {
	  _inherits(MapRadiusPreview, _React$Component);
	
	  function MapRadiusPreview(props) {
	    _classCallCheck(this, MapRadiusPreview);
	
	    var _this = _possibleConstructorReturn(this, (MapRadiusPreview.__proto__ || Object.getPrototypeOf(MapRadiusPreview)).call(this, props));
	
	    _this.state = {
	      'values': [],
	      'options': [],
	      'rangeValues': {},
	      'toogle': true
	    };
	    _this.isEditable = API.isEditable ? true : false;
	    _this.changeToogle = _this.changeToogle.bind(_this);
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.handleRangeSelect = _this.handleRangeSelect.bind(_this);
	    _this.errorMessage = null;
	    return _this;
	  }
	
	  _createClass(MapRadiusPreview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var block = (0, _clone2.default)(this.props.block);
	      this.processData(this.props, block);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextprops) {
	      this.processData(nextprops, nextprops.block);
	    }
	  }, {
	    key: 'processData',
	    value: function processData(props, block) {
	      this.helperData = (0, _clone2.default)(this.props.helperData);
	      this.block = block;
	      this.props = props;
	      var options = [];
	      var values = this.state.values;
	      var rangeValues = {};
	      this.setState({
	        options: options, values: values, rangeValues: rangeValues
	      });
	    }
	  }, {
	    key: 'handleRangeSelect',
	    value: function handleRangeSelect(from) {
	      var values = [{ start: from !== undefined ? from : 100 }];
	      if (this.searchItem) {
	        _urlHandlerActions2.default.push({
	          'searchItem': this.searchItem, // keys
	          'searchType': this.searchType,
	          'searchField': 'rangeInput', // taxonomies or metakeys,
	          'metakey': this.searchItem,
	          values: values
	        });
	        this.errorMessage = null;
	      } else {
	        this.errorMessage = 'Please select your metadata first from edit panel';
	      }
	      this.setState({ rangeValues: { min: from } });
	    }
	  }, {
	    key: 'changeToogle',
	    value: function changeToogle() {
	      var toogle = !this.state.toogle;
	      this.setState({ toogle: toogle });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
	      if (REBUILDER.hasOwnProperty(this.metakey)) {
	        this.previewData = REBUILDER[this.metakey].previewData ? REBUILDER[this.metakey].previewData : {};
	      }
	      var textBoxClassName = this.props.block.dynamicNameClassTextBox;
	      var HelperClass = this.state.toogle ? 'single-component' : '';
	      var max = Number(this.props.block.maxvalue);
	      var min = Number(this.props.block.minvalue);
	      var allLayout = (0, _clone2.default)(this.props.allLayout);
	      var options = [];
	      var isDataTypeSet = false;
	      var index = (0, _underscore.findIndex)(allLayout, { uid: this.props.uid });
	      if (this.props.block.maxvalue === undefined) {
	        max = parseInt(100, 10);
	      }
	      if (this.props.block.minvalue === undefined) {
	        min = parseInt(0, 10);
	      }
	      if (this.state.rangeValues.min === undefined) {
	        this.state.rangeValues.min = parseInt(min, 10);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: textBoxClassName },
	        _react2.default.createElement(_title2.default, {
	          title: this.props.block.title,
	          subtitle: this.props.block.subtitle,
	          toogle: this.state.toogle,
	          onToogle: this.changeToogle,
	          selectedToogleViewType: this.props.block.selectedToogleViewType
	        }),
	        this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: HelperClass },
	          _react2.default.createElement(_mapRadius2.default, { values: this.state.rangeValues, maxvalue: max, minvalue: min, grabRangeSelectValue: this.handleRangeSelect, unit: this.props.block.unit })
	        ) : null
	      );
	    }
	  }]);
	
	  return MapRadiusPreview;
	}(_react2.default.Component);
	
	MapRadiusPreview.propTypes = {
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number
	};
	
	exports.default = MapRadiusPreview;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(31);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import InputRange from 'react-input-range';
	
	var MapRadius = function (_React$Component) {
	  _inherits(MapRadius, _React$Component);
	
	  function MapRadius(props) {
	    _classCallCheck(this, MapRadius);
	
	    var _this = _possibleConstructorReturn(this, (MapRadius.__proto__ || Object.getPrototypeOf(MapRadius)).call(this, props));
	
	    _this.handleValueChange = _this.handleValueChange.bind(_this);
	    _this.initRange = _this.initRange.bind(_this);
	    return _this;
	  }
	
	  _createClass(MapRadius, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initRange(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.slider.update({
	        from: nextProps.values.min
	      });
	    }
	  }, {
	    key: 'getHistogram',
	    value: function getHistogram(countEachMetaDataValue) {
	      var bars = countEachMetaDataValue.map(function (item, index) {
	        var className = 'bar-chart__bar';
	        return _react2.default.createElement('div', { className: className,
	          key: 'mapradius-' + index,
	          style: { height: item * 3 }
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'bar-chart' },
	        bars
	      );
	    }
	  }, {
	    key: 'initRange',
	    value: function initRange(props) {
	      var self = this;
	      var target = _reactDom2.default.findDOMNode(this);
	      jQuery(target).ionRangeSlider({
	        type: 'single',
	        grid: true,
	        min: Number(props.minvalue),
	        max: Number(props.maxvalue),
	        from: Number(props.values.min),
	        prefix: props.unit ? props.unit + ' ' : '',
	        onFinish: self.handleValueChange
	      });
	      this.slider = jQuery(target).data('ionRangeSlider');
	    }
	  }, {
	    key: 'handleValueChange',
	    value: function handleValueChange(val) {
	      this.props.grabRangeSelectValue(val.from);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('input', { type: 'text', id: 'rangeInput', name: 'example_name', value: '' });
	    }
	  }]);
	
	  return MapRadius;
	}(_react2.default.Component);
	
	MapRadius.propTypes = {
	  'maxvalue': _react2.default.PropTypes.number,
	  'minvalue': _react2.default.PropTypes.number,
	  'values': _react2.default.PropTypes.object,
	  'options': _react2.default.PropTypes.array,
	  'grabRangeSelectValue': _react2.default.PropTypes.func
	};
	exports.default = MapRadius;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _;
	var findIndex = _ref.findIndex;
	
	var $ = jQuery;
	var RE = REBUILDER;
	
	var IsotopBar = function (_React$Component) {
	  _inherits(IsotopBar, _React$Component);
	
	  function IsotopBar(props) {
	    _classCallCheck(this, IsotopBar);
	
	    var _this = _possibleConstructorReturn(this, (IsotopBar.__proto__ || Object.getPrototypeOf(IsotopBar)).call(this, props));
	
	    _this.metakey = '_reactive_builder_' + _this.props.shortcodeKey;
	    _this.state = {
	      'options': [],
	      selected: '*'
	    };
	    return _this;
	  }
	
	  _createClass(IsotopBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initIsotope();
	    }
	  }, {
	    key: 'initIsotope',
	    value: function initIsotope() {
	      setTimeout(function () {
	        return IsotopeGrid = $('.rq-isotope-grid').isotope({
	          itemSelector: '.rq-element-item',
	          layoutMode: 'masonry',
	          percentage: true
	        });
	      }, 0);
	    }
	  }, {
	    key: 'handleFilterButton',
	    value: function handleFilterButton(item, e) {
	      e.preventDefault();
	      var filterValue = e.currentTarget.dataset.filter;
	      IsotopeGrid.isotope({ filter: filterValue });
	      if (item.slug !== undefined) {
	        this.setState({ selected: item.slug });
	      } else {
	        this.setState({ selected: item });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked(value) {
	      return 'rq-filter-link ' + (value === this.state.selected ? 'is-checked' : '');
	    }
	  }, {
	    key: 'capitalize',
	    value: function capitalize(text) {
	      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      this.helperData = RE.hasOwnProperty(this.metakey) ? (0, _clone2.default)(RE[this.metakey].helperData) : {};
	      if (this.props.block.selectedDataType !== null) {
	        // taxonomies
	        if (this.props.block.selectedDataType === 'taxonomies' && this.helperData) {
	          this.options = this.helperData.terms[this.props.block.selectedTaxonomy] ? this.helperData.terms[this.props.block.selectedTaxonomy].linear : [];
	        }
	      }
	      var showCatagory = function showCatagory(item, index) {
	        return _react2.default.createElement(
	          'a',
	          { type: 'text', key: 'showcategory-' + index, className: _this2.isChecked(item.slug), 'data-filter': '.' + item.slug, onClick: _this2.handleFilterButton.bind(_this2, item) },
	          _this2.capitalize(item.value.trim())
	        );
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          this.options !== undefined && this.options.length ? _react2.default.createElement(
	            'div',
	            { id: 'filters', className: 'rq-isotope-filters-content' },
	            _react2.default.createElement(
	              'a',
	              { type: 'text', className: this.isChecked('*'), 'data-filter': '*', onClick: this.handleFilterButton.bind(this, '*') },
	              'Show all'
	            ),
	            this.options.map(showCatagory)
	          ) : null
	        ),
	        this.options !== undefined && this.options.length === 0 && this.state.toogle ? _react2.default.createElement(
	          'div',
	          { className: 'rq-no-attributes-found' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            API.LANG.NO_ATTR_FOUND
	          )
	        ) : ''
	      );
	    }
	  }]);
	
	  return IsotopBar;
	}(_react2.default.Component);
	
	IsotopBar.propTypes = {
	  'previewData': _react2.default.PropTypes.object,
	  'urlData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'shortcodeKey': _react2.default.PropTypes.number,
	  'selectedDataType': _react2.default.PropTypes.string,
	  'selectedTaxonomy': _react2.default.PropTypes.string
	};
	exports.default = IsotopBar;

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(200);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _classnames = __webpack_require__(167);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(561);
	
	__webpack_require__(844);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ref = _;
	var findIndex = _ref.findIndex;
	var sortBy = _ref.sortBy;
	
	var $ = jQuery;
	
	var IsotopeBlock = function (_React$Component) {
	  _inherits(IsotopeBlock, _React$Component);
	
	  function IsotopeBlock(props) {
	    _classCallCheck(this, IsotopeBlock);
	
	    var _this = _possibleConstructorReturn(this, (IsotopeBlock.__proto__ || Object.getPrototypeOf(IsotopeBlock)).call(this, props));
	
	    _this.displayName = 'IsotopeBlock';
	    _this.state = {
	      'posts': _this.props.previewData ? _this.props.previewData.data : [],
	      option: {
	        sortBy: 'asc'
	      }
	    };
	    return _this;
	  }
	
	  _createClass(IsotopeBlock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initIsotope();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.handleFilterBySearch(nextProps.previewOptions);
	    }
	  }, {
	    key: 'initIsotope',
	    value: function initIsotope() {
	      // setTimeout(() =>
	      $('.rq-isotope-grid').imagesLoaded(function () {
	        IsotopeGrid = $('.rq-isotope-grid').isotope({
	          itemSelector: '.rq-element-item',
	          layoutMode: 'masonry',
	          percentage: true
	        });
	      });
	
	      // , 0);
	    }
	  }, {
	    key: 'handleFilterBySearch',
	    value: function handleFilterBySearch(previewOptions) {
	      var self = this;
	      IsotopeGrid.isotope({ filter: function filter() {
	          var postId = $(this).data('postid');
	          var key = findIndex(previewOptions.data, { ID: postId });
	          if (key !== -1) {
	            return true;
	          }
	        } });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var posts = this.state.posts;
	      var settingsData = this.props.settingsData;
	
	      var allPosts = function allPosts(item, index) {
	        var allTerms = item.terms[_this2.props.block.selectedTaxonomy];
	        var isotopeColumn = _this2.props.block.isotope_column;
	        var allTermsValue = null;
	        if (allTerms !== undefined) {
	          allTermsValue = allTerms.join(' ');
	        }
	        var view = 'grid';
	        var indexLayout = findIndex(_this2.props.allLayout, { uid: _this2.props.block.uid });
	        if (indexLayout !== -1) {
	          if (_this2.props.allLayout[indexLayout].previewLayouts !== undefined) {
	            _this2.ComponentName = ReactiveTemplates[_this2.props.allLayout[indexLayout].previewLayouts];
	          } else {
	            _this2.ComponentName = ReactiveTemplates.latestGridLayoutThree;
	          }
	        }
	        var rqIsotopItemWidth = {
	          width: '50%'
	        };
	        if (isotopeColumn === '1') {
	          rqIsotopItemWidth = { width: '100%' };
	        }
	        if (isotopeColumn === '2') {
	          rqIsotopItemWidth = { width: '50%' };
	        }
	        if (isotopeColumn === '3') {
	          rqIsotopItemWidth = { width: '33.3%' };
	        }
	        if (isotopeColumn === '4') {
	          rqIsotopItemWidth = { width: '25%' };
	        }
	        return _react2.default.createElement(
	          'div',
	          { className: 'rq-element-item ' + allTermsValue, style: rqIsotopItemWidth, key: 'isotopeElement-' + index, 'data-postid': item.ID, 'data-category': allTermsValue },
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-isotop-img' },
	            indexLayout !== -1 ? _react2.default.createElement(_this2.ComponentName, _extends({ post: item, view: view }, _this2.props)) : ''
	          )
	        );
	      };
	      var sortingData = [];
	      if ('sorting' in this.props.block) {
	        sortingData = this.props.block.sorting;
	      }
	      var ifOpen = this.props.isToggle ? 'active ' + 'rq-grid-container' : '';
	      var ThemeComponent = window.ReactiveTheme[settingsData.theme] !== undefined ? window.ReactiveTheme[settingsData.theme].bar : {};
	      return _react2.default.createElement(
	        'div',
	        { className: ifOpen },
	        this.props.isToggle && _react2.default.createElement(
	          'div',
	          null,
	          settingsData !== undefined || settingsData !== null ? _react2.default.createElement(ThemeComponent.isotopBar, this.props) : '',
	          _react2.default.createElement(
	            'div',
	            { className: 'rq-grid-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'rq-isotope-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'rq-isotope-grid' },
	                posts.map(allPosts)
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IsotopeBlock;
	}(_react2.default.Component);
	
	IsotopeBlock.propTypes = {
	  'allLayout': _react2.default.PropTypes.array,
	  'settingsData': _react2.default.PropTypes.object,
	  'helperData': _react2.default.PropTypes.object,
	  'block': _react2.default.PropTypes.object,
	  'previewData': _react2.default.PropTypes.object,
	  'isToggle': _react2.default.PropTypes.bool
	};
	
	exports.default = IsotopeBlock;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * imagesLoaded v4.1.1
	 * JavaScript is all like "You images are done yet or what?"
	 * MIT License
	 */
	
	( function( window, factory ) { 'use strict';
	  // universal module definition
	
	  /*global define: false, module: false, require: false */
	
	  if ( true ) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	      __webpack_require__(845)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function( EvEmitter ) {
	      return factory( window, EvEmitter );
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS
	    module.exports = factory(
	      window,
	      require('ev-emitter')
	    );
	  } else {
	    // browser global
	    window.imagesLoaded = factory(
	      window,
	      window.EvEmitter
	    );
	  }
	
	})( window,
	
	// --------------------------  factory -------------------------- //
	
	function factory( window, EvEmitter ) {
	
	'use strict';
	
	var $ = window.jQuery;
	var console = window.console;
	
	// -------------------------- helpers -------------------------- //
	
	// extend objects
	function extend( a, b ) {
	  for ( var prop in b ) {
	    a[ prop ] = b[ prop ];
	  }
	  return a;
	}
	
	// turn element or nodeList into an array
	function makeArray( obj ) {
	  var ary = [];
	  if ( Array.isArray( obj ) ) {
	    // use object if already an array
	    ary = obj;
	  } else if ( typeof obj.length == 'number' ) {
	    // convert nodeList to array
	    for ( var i=0; i < obj.length; i++ ) {
	      ary.push( obj[i] );
	    }
	  } else {
	    // array of single index
	    ary.push( obj );
	  }
	  return ary;
	}
	
	// -------------------------- imagesLoaded -------------------------- //
	
	/**
	 * @param {Array, Element, NodeList, String} elem
	 * @param {Object or Function} options - if function, use as callback
	 * @param {Function} onAlways - callback function
	 */
	function ImagesLoaded( elem, options, onAlways ) {
	  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
	  if ( !( this instanceof ImagesLoaded ) ) {
	    return new ImagesLoaded( elem, options, onAlways );
	  }
	  // use elem as selector string
	  if ( typeof elem == 'string' ) {
	    elem = document.querySelectorAll( elem );
	  }
	
	  this.elements = makeArray( elem );
	  this.options = extend( {}, this.options );
	
	  if ( typeof options == 'function' ) {
	    onAlways = options;
	  } else {
	    extend( this.options, options );
	  }
	
	  if ( onAlways ) {
	    this.on( 'always', onAlways );
	  }
	
	  this.getImages();
	
	  if ( $ ) {
	    // add jQuery Deferred object
	    this.jqDeferred = new $.Deferred();
	  }
	
	  // HACK check async to allow time to bind listeners
	  setTimeout( function() {
	    this.check();
	  }.bind( this ));
	}
	
	ImagesLoaded.prototype = Object.create( EvEmitter.prototype );
	
	ImagesLoaded.prototype.options = {};
	
	ImagesLoaded.prototype.getImages = function() {
	  this.images = [];
	
	  // filter & find items if we have an item selector
	  this.elements.forEach( this.addElementImages, this );
	};
	
	/**
	 * @param {Node} element
	 */
	ImagesLoaded.prototype.addElementImages = function( elem ) {
	  // filter siblings
	  if ( elem.nodeName == 'IMG' ) {
	    this.addImage( elem );
	  }
	  // get background image on element
	  if ( this.options.background === true ) {
	    this.addElementBackgroundImages( elem );
	  }
	
	  // find children
	  // no non-element nodes, #143
	  var nodeType = elem.nodeType;
	  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
	    return;
	  }
	  var childImgs = elem.querySelectorAll('img');
	  // concat childElems to filterFound array
	  for ( var i=0; i < childImgs.length; i++ ) {
	    var img = childImgs[i];
	    this.addImage( img );
	  }
	
	  // get child background images
	  if ( typeof this.options.background == 'string' ) {
	    var children = elem.querySelectorAll( this.options.background );
	    for ( i=0; i < children.length; i++ ) {
	      var child = children[i];
	      this.addElementBackgroundImages( child );
	    }
	  }
	};
	
	var elementNodeTypes = {
	  1: true,
	  9: true,
	  11: true
	};
	
	ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
	  var style = getComputedStyle( elem );
	  if ( !style ) {
	    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
	    return;
	  }
	  // get url inside url("...")
	  var reURL = /url\((['"])?(.*?)\1\)/gi;
	  var matches = reURL.exec( style.backgroundImage );
	  while ( matches !== null ) {
	    var url = matches && matches[2];
	    if ( url ) {
	      this.addBackground( url, elem );
	    }
	    matches = reURL.exec( style.backgroundImage );
	  }
	};
	
	/**
	 * @param {Image} img
	 */
	ImagesLoaded.prototype.addImage = function( img ) {
	  var loadingImage = new LoadingImage( img );
	  this.images.push( loadingImage );
	};
	
	ImagesLoaded.prototype.addBackground = function( url, elem ) {
	  var background = new Background( url, elem );
	  this.images.push( background );
	};
	
	ImagesLoaded.prototype.check = function() {
	  var _this = this;
	  this.progressedCount = 0;
	  this.hasAnyBroken = false;
	  // complete if no images
	  if ( !this.images.length ) {
	    this.complete();
	    return;
	  }
	
	  function onProgress( image, elem, message ) {
	    // HACK - Chrome triggers event before object properties have changed. #83
	    setTimeout( function() {
	      _this.progress( image, elem, message );
	    });
	  }
	
	  this.images.forEach( function( loadingImage ) {
	    loadingImage.once( 'progress', onProgress );
	    loadingImage.check();
	  });
	};
	
	ImagesLoaded.prototype.progress = function( image, elem, message ) {
	  this.progressedCount++;
	  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
	  // progress event
	  this.emitEvent( 'progress', [ this, image, elem ] );
	  if ( this.jqDeferred && this.jqDeferred.notify ) {
	    this.jqDeferred.notify( this, image );
	  }
	  // check if completed
	  if ( this.progressedCount == this.images.length ) {
	    this.complete();
	  }
	
	  if ( this.options.debug && console ) {
	    console.log( 'progress: ' + message, image, elem );
	  }
	};
	
	ImagesLoaded.prototype.complete = function() {
	  var eventName = this.hasAnyBroken ? 'fail' : 'done';
	  this.isComplete = true;
	  this.emitEvent( eventName, [ this ] );
	  this.emitEvent( 'always', [ this ] );
	  if ( this.jqDeferred ) {
	    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
	    this.jqDeferred[ jqMethod ]( this );
	  }
	};
	
	// --------------------------  -------------------------- //
	
	function LoadingImage( img ) {
	  this.img = img;
	}
	
	LoadingImage.prototype = Object.create( EvEmitter.prototype );
	
	LoadingImage.prototype.check = function() {
	  // If complete is true and browser supports natural sizes,
	  // try to check for image status manually.
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    // report based on naturalWidth
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    return;
	  }
	
	  // If none of the checks above matched, simulate loading on detached element.
	  this.proxyImage = new Image();
	  this.proxyImage.addEventListener( 'load', this );
	  this.proxyImage.addEventListener( 'error', this );
	  // bind to image as well for Firefox. #191
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.proxyImage.src = this.img.src;
	};
	
	LoadingImage.prototype.getIsImageComplete = function() {
	  return this.img.complete && this.img.naturalWidth !== undefined;
	};
	
	LoadingImage.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.img, message ] );
	};
	
	// ----- events ----- //
	
	// trigger specified handler for event type
	LoadingImage.prototype.handleEvent = function( event ) {
	  var method = 'on' + event.type;
	  if ( this[ method ] ) {
	    this[ method ]( event );
	  }
	};
	
	LoadingImage.prototype.onload = function() {
	  this.confirm( true, 'onload' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.onerror = function() {
	  this.confirm( false, 'onerror' );
	  this.unbindEvents();
	};
	
	LoadingImage.prototype.unbindEvents = function() {
	  this.proxyImage.removeEventListener( 'load', this );
	  this.proxyImage.removeEventListener( 'error', this );
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	// -------------------------- Background -------------------------- //
	
	function Background( url, element ) {
	  this.url = url;
	  this.element = element;
	  this.img = new Image();
	}
	
	// inherit LoadingImage prototype
	Background.prototype = Object.create( LoadingImage.prototype );
	
	Background.prototype.check = function() {
	  this.img.addEventListener( 'load', this );
	  this.img.addEventListener( 'error', this );
	  this.img.src = this.url;
	  // check if image is already complete
	  var isComplete = this.getIsImageComplete();
	  if ( isComplete ) {
	    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
	    this.unbindEvents();
	  }
	};
	
	Background.prototype.unbindEvents = function() {
	  this.img.removeEventListener( 'load', this );
	  this.img.removeEventListener( 'error', this );
	};
	
	Background.prototype.confirm = function( isLoaded, message ) {
	  this.isLoaded = isLoaded;
	  this.emitEvent( 'progress', [ this, this.element, message ] );
	};
	
	// -------------------------- jQuery -------------------------- //
	
	ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
	  jQuery = jQuery || window.jQuery;
	  if ( !jQuery ) {
	    return;
	  }
	  // set local variable
	  $ = jQuery;
	  // $().imagesLoaded()
	  $.fn.imagesLoaded = function( options, callback ) {
	    var instance = new ImagesLoaded( this, options, callback );
	    return instance.jqDeferred.promise( $(this) );
	  };
	};
	// try making plugin
	ImagesLoaded.makeJQueryPlugin();
	
	// --------------------------  -------------------------- //
	
	return ImagesLoaded;
	
	});


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * EvEmitter v1.0.3
	 * Lil' event emitter
	 * MIT License
	 */
	
	/* jshint unused: true, undef: true, strict: true */
	
	( function( global, factory ) {
	  // universal module definition
	  /* jshint strict: false */ /* globals define, module, window */
	  if ( true ) {
	    // AMD - RequireJS
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if ( typeof module == 'object' && module.exports ) {
	    // CommonJS - Browserify, Webpack
	    module.exports = factory();
	  } else {
	    // Browser globals
	    global.EvEmitter = factory();
	  }
	
	}( typeof window != 'undefined' ? window : this, function() {
	
	"use strict";
	
	function EvEmitter() {}
	
	var proto = EvEmitter.prototype;
	
	proto.on = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // set events hash
	  var events = this._events = this._events || {};
	  // set listeners array
	  var listeners = events[ eventName ] = events[ eventName ] || [];
	  // only add once
	  if ( listeners.indexOf( listener ) == -1 ) {
	    listeners.push( listener );
	  }
	
	  return this;
	};
	
	proto.once = function( eventName, listener ) {
	  if ( !eventName || !listener ) {
	    return;
	  }
	  // add event
	  this.on( eventName, listener );
	  // set once flag
	  // set onceEvents hash
	  var onceEvents = this._onceEvents = this._onceEvents || {};
	  // set onceListeners object
	  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
	  // set flag
	  onceListeners[ listener ] = true;
	
	  return this;
	};
	
	proto.off = function( eventName, listener ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var index = listeners.indexOf( listener );
	  if ( index != -1 ) {
	    listeners.splice( index, 1 );
	  }
	
	  return this;
	};
	
	proto.emitEvent = function( eventName, args ) {
	  var listeners = this._events && this._events[ eventName ];
	  if ( !listeners || !listeners.length ) {
	    return;
	  }
	  var i = 0;
	  var listener = listeners[i];
	  args = args || [];
	  // once stuff
	  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];
	
	  while ( listener ) {
	    var isOnce = onceListeners && onceListeners[ listener ];
	    if ( isOnce ) {
	      // remove listener
	      // remove before trigger to prevent recursion
	      this.off( eventName, listener );
	      // unset once flag
	      delete onceListeners[ listener ];
	    }
	    // trigger listener
	    listener.apply( this, args );
	    // get next listener
	    i += isOnce ? 0 : 1;
	    listener = listeners[i];
	  }
	
	  return this;
	};
	
	return EvEmitter;
	
	}));


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QucikSort = function () {
	  function QucikSort(options) {
	    _classCallCheck(this, QucikSort);
	
	    this.startSorting = this.startSorting.bind(this);
	    this.swap = this.swap.bind(this);
	    this.partition = this.partition.bind(this);
	    this.quickSort = this.quickSort.bind(this);
	    this.key = options.key;
	    this.type = options.type;
	  }
	
	  _createClass(QucikSort, [{
	    key: 'swap',
	    value: function swap(items, firstIndex, secondIndex) {
	      var temp = items[firstIndex];
	      items[firstIndex] = items[secondIndex];
	      items[secondIndex] = temp;
	    }
	  }, {
	    key: 'partition',
	    value: function partition(items, left, right) {
	      var pivot = null;
	      switch (this.key) {
	        case 'comment_count':
	          pivot = parseInt(items[Math.floor((right + left) / 2)][this.key], 10);
	          break;
	        case 'post_date':
	          pivot = items[Math.floor((right + left) / 2)][this.key];
	          break;
	        case 'post_title':
	          pivot = items[Math.floor((right + left) / 2)][this.key];
	        default:
	          break;
	
	      }
	      var i = left;
	      var j = right;
	      while (i <= j) {
	        if (this.key === 'comment_count') {
	          while (parseInt(items[i][this.key], 10) < pivot) {
	            i++;
	          }
	        } else if (this.key === 'post_date') {
	          while ((0, _moment2.default)(items[i][this.key]).isBefore(pivot)) {
	            // moment(date_time).isAfter('2014-03-24T01:14:00Z');
	            i++;
	          }
	        } else if (this.key === 'post_title') {
	          while (items[i][this.key] < pivot) {
	            i++;
	          }
	        }
	
	        if (this.key === 'comment_count') {
	          while (parseInt(items[j][this.key], 10) > pivot) {
	            j--;
	          }
	        } else if (this.key === 'post_date') {
	          while ((0, _moment2.default)(items[j][this.key]).isAfter(pivot)) {
	            j--;
	          }
	        } else if (this.key === 'post_title') {
	          while (items[j][this.key] > pivot) {
	            j--;
	          }
	        }
	
	        if (i <= j) {
	          this.swap(items, i, j);
	          i++;
	          j--;
	        }
	      }
	      return i;
	    }
	  }, {
	    key: 'quickSort',
	    value: function quickSort(items, left, right) {
	      var index = void 0;
	      if (items.length > 1) {
	        index = this.partition(items, left, right);
	        if (left < index - 1) {
	          this.quickSort(items, left, index - 1);
	        }
	        if (index < right) {
	          this.quickSort(items, index, right);
	        }
	      }
	      return items;
	    }
	  }, {
	    key: 'startSorting',
	    value: function startSorting(items) {
	      var result = this.quickSort(items, 0, items.length - 1);
	      var finalResult = [];
	      if (this.type === 'dsc') {
	        for (var index = result.length - 1; index >= 0; index--) {
	          finalResult.push(result[index]);
	        }
	        return finalResult;
	      }
	      return result;
	    }
	  }]);
	
	  return QucikSort;
	}();
	
	exports.default = QucikSort;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _moment = __webpack_require__(563);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Sortify = function () {
	  function Sortify(opts) {
	    _classCallCheck(this, Sortify);
	
	    this.bubbleSort = this.bubbleSort.bind(this);
	    this.selectionSort = this.selectionSort.bind(this);
	    this.insertionSort = this.insertionSort.bind(this);
	    this.quickSort = this.quickSort.bind(this);
	    this.mergeSort = this.mergeSort.bind(this);
	    this.bubbleSort = this.bubbleSort.bind(this);
	    this.compare = this.compare.bind(this);
	    this.quickSortSwap = this.quickSortSwap.bind(this);
	    this.quickSortPartition = this.quickSortPartition.bind(this);
	    this.merge = this.merge.bind(this);
	    this.keyCheck = this.keyCheck.bind(this);
	  }
	
	  _createClass(Sortify, [{
	    key: 'sort',
	    value: function sort(opts) {
	      if (opts.hasOwnProperty('algo')) {
	        this.algo = opts.algo;
	      } else {
	        this.algo = 'default';
	      }
	      if (!this.keyCheck(opts)) {
	        return false;
	      }
	      this.key = opts.key;
	      this.orderBy = opts.orderBy === 'desc' ? true : false;
	      this.isDate = opts.date;
	      this.comppareCount = 0;
	
	      if (opts.array instanceof Array) {
	        switch (this.algo) {
	          case 'bubble':
	            return this.bubbleSort(opts.array);
	          case 'selection':
	            return this.selectionSort(opts.array);
	          case 'insertion':
	            return this.insertionSort(opts.array);
	          case 'quick':
	            return this.quickSort(opts.array, 0, opts.array.length - 1);
	          case 'merge':
	            return this.mergeSort(opts.array);
	          default:
	            return this.bubbleSort(opts.array);
	        };
	      }
	    }
	  }, {
	    key: 'keyCheck',
	    value: function keyCheck(opts) {
	      if (!opts.hasOwnProperty('key') || opts.array.length === 0 || !opts.array[0].hasOwnProperty(opts.key)) {
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: 'compare',
	    value: function compare(firstItem, secondItem) {
	      if (this.isDate === true) {
	        if (this.orderBy) {
	          if ((0, _moment2.default)(firstItem[this.key]).isBefore(secondItem[this.key])) {
	            this.comppareCount++;
	            return true;
	          }
	        } else {
	          if ((0, _moment2.default)(firstItem[this.key]).isAfter(secondItem[this.key])) {
	            this.comppareCount++;
	            return true;
	          }
	        }
	        return false;
	      }
	      if (!this.orderBy && firstItem[this.key] > secondItem[this.key]) {
	        this.comppareCount++;
	        return true;
	      }
	      if (this.orderBy && firstItem[this.key] < secondItem[this.key]) {
	        this.comppareCount++;
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'bubbleSort',
	    value: function bubbleSort(array) {
	      var swapped = void 0;
	      do {
	        swapped = false;
	        for (var i = 0; i < array.length - 1; i++) {
	          if (this.compare(array[i], array[i + 1])) {
	            var temp = array[i];
	            array[i] = array[i + 1];
	            array[i + 1] = temp;
	            swapped = true;
	          }
	        }
	      } while (swapped);
	      return array;
	    }
	  }, {
	    key: 'selectionSort',
	    value: function selectionSort(array) {
	      var minIdx = void 0,
	          temp = void 0,
	          len = array.length;
	      for (var i = 0; i < len; i++) {
	        minIdx = i;
	        for (var j = i + 1; j < len; j++) {
	          if (this.compare(array[j], array[minIdx])) {
	            minIdx = j;
	          }
	        }
	        temp = array[i];
	        array[i] = array[minIdx];
	        array[minIdx] = temp;
	      }
	      return array;
	    }
	  }, {
	    key: 'insertionSort',
	    value: function insertionSort(array) {
	      var i = void 0,
	          len = array.length,
	          currentIndex = void 0,
	          j = void 0;
	      for (i = 1; i < len; i++) {
	        currentIndex = array[i];
	        j = i;
	        while (j > 0 && this.compare(currentIndex, array[j - 1])) {
	          array[j] = array[j - 1];
	          j--;
	        }
	        array[j] = currentIndex;
	      }
	      return array;
	    }
	  }, {
	    key: 'quickSort',
	    value: function quickSort(array, left, right) {
	      var len = array.length,
	          pivot = void 0,
	          partitionIndex = void 0;
	      if (left < right) {
	        pivot = right;
	        partitionIndex = this.quickSortPartition(array, pivot, left, right);
	        //sort left and right
	        this.quickSort(array, left, partitionIndex - 1);
	        this.quickSort(array, partitionIndex + 1, right);
	      }
	      return array;
	    }
	  }, {
	    key: 'quickSortPartition',
	    value: function quickSortPartition(array, pivot, left, right) {
	      var pivotValue = array[pivot],
	          partitionIndex = left;
	      for (var i = left; i < right; i++) {
	        if (this.compare(array[i], array[pivot])) {
	          this.quickSortSwap(array, i, partitionIndex);
	          partitionIndex++;
	        }
	      }
	
	      array, right, partitionIndex;
	      return partitionIndex;
	    }
	  }, {
	    key: 'quickSortSwap',
	    value: function quickSortSwap(array, i, j) {
	      var temp = array[i];
	      array[i] = array[j];
	      array[j] = temp;
	    }
	  }, {
	    key: 'mergeSort',
	    value: function mergeSort(array) {
	      var len = array.length;
	      if (len < 2) return array;
	      var mid = Math.floor(len / 2),
	          left = array.slice(0, mid),
	          right = array.slice(mid);
	      return this.merge(this.mergeSort(left), this.mergeSort(right));
	    }
	  }, {
	    key: 'merge',
	    value: function merge(left, right) {
	      var result = [];
	      var lLen = left.length;
	      var rLen = right.length;
	      var l = 0;
	      var r = 0;
	      while (l < lLen && r < rLen) {
	        if (this.compare(left[l], right[r])) {
	          result.push(left[l++]);
	        } else {
	          result.push(right[r++]);
	        }
	      }
	      return result.concat(left.slice(l)).concat(right.slice(r));
	    }
	  }, {
	    key: 'compareCount',
	    value: function compareCount() {
	      return this.comppareCount++;
	    }
	  }]);
	
	  return Sortify;
	}();
	
	exports.default = Sortify;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reflux = __webpack_require__(173);
	
	var _reflux2 = _interopRequireDefault(_reflux);
	
	var _builderActions = __webpack_require__(478);
	
	var _builderActions2 = _interopRequireDefault(_builderActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reflux2.default.createStore({
	  listenables: _builderActions2.default,
	  onPublishSettingsData: function onPublishSettingsData(settings) {
	    this.trigger(settings);
	  }
	});

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** frontend.js
 **/